import { j as s, $ as ui, a as pi, b as mi, c as gi, d as fi, e as bi, g as xi, h as yi, i as _i, n as E, O as Ci, k as Hs, l as Ws, w as Hn, Z as wi, H as vi, m as An, o as _t, p as lo, r as fr, q as Si, t as Ms, W as Ii, u as Di, A as ki, F as Ti, v as br, x as xr, y as zs, z as yr, B as Wn, C as ji, D as Ni, E as Fi, G as Pi, I as Ri, J as Ei, K as _r, L as Li, M as Ai } from "./vendor-1JFkz6lE.js";
import f from "classnames";
import { I as N, T as A, r as Ns, B as at, a as sn, e as $i } from "./emoji-r42FS_um.js";
import { E as ET, b as LT, d as AT, i as $T } from "./emoji-r42FS_um.js";
import { memo as qn, forwardRef as $, PureComponent as D, useState as V, useCallback as F, useEffect as J, cloneElement as cn, isValidElement as Dt, createContext as kt, Component as ft, Children as Lt, createRef as B, useRef as Y, useMemo as q, useContext as Xt, Fragment as Wt, useImperativeHandle as Fe, createElement as Oi, lazy as Bi, Suspense as Hi, useReducer as Wi } from "react";
import { useKey as Cr, useMount as Pe, useUnmount as Jt, useUpdateEffect as Zt, useToggle as Mi, useSetState as zi, useClickAway as wr, useEvent as dn, usePrevious as on, useDebounce as Vi } from "react-use";
import j from "moment-timezone";
import { v4 as rn } from "uuid";
import { noop as Ki } from "ts-essentials";
import Ui from "react-dom";
const qi = "h-button--button__root", Gi = "h-button--button__normal", Yi = "h-button--button__large", Xi = "h-button--button__primary", Qi = "h-button--button__active", Zi = "h-button--button__label", Ji = "h-button--button__secondary", ta = "h-button--button__tertiary", ea = "h-button--button__danger", na = "h-button--button__disabled", sa = "h-button--button__loading", oa = "h-button--button__withLabel", ra = "h-button--button__slot", ia = "h-button--button__content", Ct = {
  root: qi,
  normal: Gi,
  large: Yi,
  primary: Xi,
  active: Qi,
  label: Zi,
  secondary: Ji,
  tertiary: ta,
  danger: ea,
  disabled: na,
  loading: sa,
  withLabel: oa,
  slot: ra,
  content: ia
}, Q = qn(
  $(function({
    children: t,
    className: e,
    type: n = "button",
    variant: o = "primary",
    size: r = "normal",
    icon: a,
    slotStart: l,
    slotEnd: c,
    active: d = !1,
    isLoading: h = !1,
    loadingIndicator: u = /* @__PURE__ */ s.jsx(A.Paragraph, { as: "span", variant: "3", wrap: "nowrap", color: "inherit", children: "Loading..." }),
    label: p,
    styleText: m = !0,
    disabled: g = !1,
    onClick: b,
    ...x
  }, C) {
    const _ = f(
      {
        [Ct.root]: !0,
        [Ct[o]]: !0,
        [Ct[r]]: !0,
        [Ct.active]: d,
        [Ct.disabled]: g,
        [Ct.loading]: h,
        [Ct.withLabel]: !c && !!p
      },
      e
    );
    return /* @__PURE__ */ s.jsx(
      "button",
      {
        ...x,
        type: n,
        className: _,
        onClick: g ? void 0 : b,
        disabled: g,
        ref: C,
        children: h ? u : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          (l || a) && /* @__PURE__ */ s.jsx("span", { className: Ct.slot, children: a ? /* @__PURE__ */ s.jsx(N, { name: a }) : l }),
          (m || t) && /* @__PURE__ */ s.jsx("span", { className: Ct.content, children: m ? /* @__PURE__ */ s.jsx(
            A.Paragraph,
            {
              as: "span",
              variant: "3",
              wrap: "nowrap",
              color: "inherit",
              children: t
            }
          ) : t }),
          p && /* @__PURE__ */ s.jsx(
            A.Paragraph,
            {
              as: "span",
              variant: "4",
              wrap: "nowrap",
              color: "inherit",
              className: Ct.label,
              children: p
            }
          ),
          c && /* @__PURE__ */ s.jsx("span", { className: Ct.slot, children: c })
        ] })
      }
    );
  })
), aa = "h-button-navigationButton--navigationButton__root", la = {
  root: aa
}, kk = ({
  className: i,
  navigate: t,
  onClick: e,
  ...n
}) => {
  const o = (r) => {
    e?.(r), t();
  };
  return /* @__PURE__ */ s.jsx(
    Q,
    {
      ...n,
      variant: n.variant ?? "tertiary",
      onClick: o,
      className: f(i, la.root)
    }
  );
}, ca = "h-spinner--spinner__root", da = {
  root: ca
};
class Gn extends D {
  render() {
    const { className: t, size: e, color: n, trackColor: o, bgColor: r, ...a } = this.props, l = f(
      {
        [da.root]: !0
      },
      t
    ), c = typeof e == "number" ? e : 32, d = typeof e == "number" ? `${c}px` : "32px", h = `${Math.max(Math.floor(c / 8), 1)}px`, u = {
      height: d,
      width: d,
      borderWidth: h
    };
    return o && o.length && (u.borderColor = o), n && n.length && (u.borderTopColor = n), r && r.length && (u.backgroundColor = r), /* @__PURE__ */ s.jsx("div", { ...a, style: u, className: l });
  }
}
const ha = "h-iconButton--iconButton__root", ua = {
  root: ha
}, K = qn(
  $(function({
    children: t,
    className: e,
    icon: n,
    iconProps: o,
    iconSize: r,
    variant: a = "primary",
    ...l
  }, c) {
    return /* @__PURE__ */ s.jsx(
      Q,
      {
        ref: c,
        "aria-label": n,
        ...l,
        variant: a,
        className: f(ua.root, e),
        loadingIndicator: /* @__PURE__ */ s.jsx(Gn, { size: 16 }),
        styleText: !1,
        slotStart: /* @__PURE__ */ s.jsx(N, { size: r || 16, name: n, ...o })
      }
    );
  })
), pa = "h-tooltip--tooltip__content", ma = "h-tooltip--tooltip__contentLight", ga = "h-tooltip--tooltip__contentHasHead", fa = "h-tooltip--tooltip__body", ba = "h-tooltip--tooltip__head", xa = "h-tooltip--tooltip__arrow", he = {
  content: pa,
  contentLight: ma,
  contentHasHead: ga,
  body: fa,
  head: ba,
  arrow: xa
}, ya = 400;
function st({
  children: i,
  content: t,
  onOpenChange: e,
  side: n = "top",
  className: o,
  head: r,
  defaultOpen: a,
  alwaysShow: l,
  disabled: c,
  delayDuration: d = ya,
  align: h,
  "aria-label": u,
  wrap: p = "span",
  wrapProps: m,
  requireClick: g,
  light: b,
  ...x
}) {
  const [C, _] = V(
    g ? !1 : void 0
  ), w = F(() => {
    _(!1), window.removeEventListener("click", w);
  }, []);
  J(() => () => {
    window.removeEventListener("click", w);
  }, [w]);
  const S = ui();
  if (c || !t)
    return /* @__PURE__ */ s.jsx(s.Fragment, { children: i });
  const y = (I) => {
    I.stopPropagation(), window[C ? "removeEventListener" : "addEventListener"](
      "click",
      w
    ), _(!C);
  }, v = f(
    he.content,
    {
      [he.contentHasHead]: !!r,
      [he.contentLight]: b
    },
    o
  );
  return /* @__PURE__ */ s.jsx(pi, { children: /* @__PURE__ */ s.jsxs(
    mi,
    {
      open: C ?? (l ? !0 : void 0),
      defaultOpen: a,
      delayDuration: d,
      "aria-label": u,
      onOpenChange: e,
      children: [
        /* @__PURE__ */ s.jsx(gi, { asChild: !0, children: p !== "none" ? /* @__PURE__ */ s.jsx(
          p,
          {
            onClick: g ? y : void 0,
            ...m,
            ...x,
            children: i
          }
        ) : g && Dt(i) ? cn(i, { onClick: y }) : i }),
        /* @__PURE__ */ s.jsx(fi, { children: /* @__PURE__ */ s.jsx(
          bi,
          {
            id: S,
            side: n,
            sideOffset: 4,
            align: h,
            className: v,
            style: { zIndex: 2147483647 },
            children: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              r && /* @__PURE__ */ s.jsx("div", { className: he.head, children: r }),
              /* @__PURE__ */ s.jsx("div", { className: he.body, children: t }),
              /* @__PURE__ */ s.jsx(xi, { className: he.arrow })
            ] })
          }
        ) })
      ]
    }
  ) });
}
const _a = "h-attachment--attachment__root", Ca = "h-attachment--attachment__icon", wa = "h-attachment--attachment__name", va = "h-attachment--attachment__buttons", gn = {
  root: _a,
  icon: Ca,
  name: wa,
  buttons: va
}, co = {
  /* images */
  jpg: "file-image",
  jpeg: "file-image",
  bmp: "file-image",
  gif: "file-image",
  tiff: "file-image",
  png: "file-image",
  /* video */
  mp4: "file-video",
  m4v: "file-video",
  mpeg: "file-video",
  mov: "file-video",
  avi: "file-video",
  wmv: "file-video",
  webm: "file-video",
  flv: "file-video",
  /* audio */
  wav: "file-audio",
  mp3: "file-audio",
  aiff: "file-audio",
  acc: "file-audio",
  ogg: "file-audio",
  wma: "file-audio",
  flac: "file-audio",
  alac: "file-audio",
  /* documents */
  pdf: "file-pdf",
  csv: "file-csv",
  doc: "file-word",
  docx: "file-word",
  xls: "file-excel",
  xlsx: "file-excel",
  ppt: "file-powerpoint",
  pptx: "file-powerpoint",
  /* archives */
  zip: "file-archive",
  rar: "file-archive",
  arc: "file-archive",
  "7z": "file-archive",
  s7z: "file-archive",
  tar: "file-archive",
  bz2: "file-archive",
  gz: "file-archive"
};
function Sa(i) {
  const t = i.split(".").pop()?.toLowerCase();
  return !t || !co[t] ? "file" : co[t];
}
const Tk = (i) => {
  const {
    className: t,
    nameClassName: e,
    fileName: n,
    label: o,
    onDownload: r,
    onPreview: a,
    isPreviewLoading: l,
    isDownloadLoading: c,
    extraButtons: d,
    ...h
  } = i, u = f(
    {
      [gn.root]: !0
    },
    t
  );
  return /* @__PURE__ */ s.jsxs("div", { ...h, className: u, children: [
    /* @__PURE__ */ s.jsx(
      N,
      {
        className: gn.icon,
        name: Sa(n),
        size: 24,
        color: "neutral.700"
      }
    ),
    /* @__PURE__ */ s.jsx(
      st,
      {
        content: o || n,
        wrap: "div",
        wrapProps: { className: f(gn.name, e) },
        children: /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "4", color: "secondary", children: o || n })
      }
    ),
    /* @__PURE__ */ s.jsxs("div", { className: gn.buttons, children: [
      a && /* @__PURE__ */ s.jsx(
        K,
        {
          isLoading: l,
          variant: "secondary",
          icon: "eye",
          onClick: l ? void 0 : a
        }
      ),
      r && /* @__PURE__ */ s.jsx(
        K,
        {
          isLoading: c,
          variant: "secondary",
          icon: "download",
          onClick: c ? void 0 : r
        }
      ),
      d
    ] })
  ] });
}, Ia = {
  onError(i, t) {
    console.error(i, t);
  }
}, Da = kt(Ia), ho = { error: null };
class Re extends ft {
  static getDerivedStateFromError(t) {
    return { error: t };
  }
  constructor(t) {
    super(t), this.state = ho, this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.resetInternally = this.resetInternally.bind(this);
  }
  componentDidCatch(t, e) {
    this.props.onError?.(t, e), this.context?.onError?.(t, e);
  }
  static contextType = Da;
  resetErrorBoundary(...t) {
    this.props.onReset?.(...t), this.resetInternally();
  }
  resetInternally() {
    this.setState(ho);
  }
  hasError(t) {
    return t !== null;
  }
  ensureErrorHandlerExists() {
    const { fallback: t, fallbackRender: e } = this.props, n = this.hasFallbackElement(t), o = this.hasFallbackRenderer(e);
    if (!n && !o)
      throw new Error(
        `${Re.name} requires either a fallback component or a fallback renderer`
      );
  }
  hasFallbackRenderer(t) {
    return typeof t == "function";
  }
  hasFallbackElement(t) {
    return t === null || typeof t == "string" || Dt(t);
  }
  render() {
    const { error: t } = this.state, { fallbackRender: e, fallback: n } = this.props;
    if (this.ensureErrorHandlerExists(), !this.hasError(t))
      return this.props.children;
    if (this.hasFallbackElement(n))
      return n;
    if (this.hasFallbackRenderer(e))
      return e({
        error: t,
        resetErrorBoundary: this.resetErrorBoundary
      });
  }
}
function hn(i, t) {
  const e = i.displayName || i.name || "Unknown";
  return yi(
    class extends ft {
      static displayName = `withErrorBoundary(${e})`;
      static defaultProps = i.defaultProps;
      render() {
        const o = i;
        return /* @__PURE__ */ s.jsx(Re, { ...t, children: /* @__PURE__ */ s.jsx(o, { ...this.props }) });
      }
    },
    i
  );
}
const ka = "h-avatar--avatar__root", $n = {
  root: ka,
  "avatar-24": "h-avatar--avatar__avatar-24",
  "avatar-32": "h-avatar--avatar__avatar-32",
  "avatar-40": "h-avatar--avatar__avatar-40"
}, Ta = {
  24: 16,
  32: 20,
  40: 24
}, ja = ({
  icon: i,
  size: t,
  color: e = "inherit"
}) => /* @__PURE__ */ s.jsx(N, { name: i, size: Ta[t], color: e }), Na = "h-image--image__image", Fa = "h-image--image__error", Pa = "h-image--image__complete", is = {
  image: Na,
  error: Fa,
  complete: Pa
};
class Vs extends ft {
  static defaultProps;
  mounted;
  constructor(t) {
    super(t), this.state = {
      imageSrc: "",
      loadingError: !1,
      loadingComplete: !1
    }, this.onLoad = this.onLoad.bind(this), this.onError = this.onError.bind(this), this.mounted = !0;
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { src: t } = this.props;
    this.handleSource(t);
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(t) {
    const { src: e } = this.props;
    t.src !== e && this.handleSource(t.src);
  }
  componentWillUnmount() {
    this.mounted = !1;
  }
  handleSource(t) {
    typeof t == "string" ? this.setState({
      imageSrc: t
    }) : t().then((e) => {
      this.mounted && typeof e == "string" && this.setState({
        imageSrc: e
      });
    }).catch(() => {
      this.mounted && this.setState({
        loadingError: !0
      });
    });
  }
  onLoad(t) {
    this.setState({
      loadingComplete: !0,
      loadingError: !1
    }), this.props.onLoad?.(t);
  }
  onError(t) {
    this.setState({
      loadingError: !0,
      loadingComplete: !1
    }), this.props.onError?.(t);
  }
  render() {
    const { className: t, src: e, alt: n, ...o } = this.props, { imageSrc: r } = this.state, { loadingError: a, loadingComplete: l } = this.state, c = f(
      {
        [is.image]: !0,
        [is.error]: !!a,
        [is.complete]: !!l
      },
      t
    );
    return /* @__PURE__ */ s.jsx(
      "img",
      {
        ...o,
        className: c,
        onError: this.onError,
        onLoad: this.onLoad,
        src: r,
        alt: n || ""
      }
    );
  }
}
Vs.defaultProps = {
  className: "",
  alt: ""
};
const Ra = "h-avatar--imageAvatar__root", Ea = {
  root: Ra
}, La = ({
  src: i,
  alt: t = "avatar"
}) => /* @__PURE__ */ s.jsx(Vs, { src: i, alt: t, className: Ea.root }), Aa = "h-avatar--textAvatar__root", On = {
  root: Aa,
  "avatar-24": "h-avatar--textAvatar__avatar-24",
  "avatar-32": "h-avatar--textAvatar__avatar-32",
  "avatar-40": "h-avatar--textAvatar__avatar-40"
}, $a = {
  24: On["avatar-24"],
  32: On["avatar-32"],
  40: On["avatar-40"]
}, Oa = ({ text: i = "", size: t }) => /* @__PURE__ */ s.jsx("div", { className: f(On.root, $a[t]), children: i.trim().split(" ").map(
  (e, n, o) => o.length === 1 ? e : e[0]
).join("").slice(0, 2) }), Ba = [
  {
    contentColor: "var(--dixa-avatar-content-green)",
    backgroundColor: "var(--dixa-avatar-background-green)"
  },
  {
    contentColor: "var(--dixa-avatar-content-purple)",
    backgroundColor: "var(--dixa-avatar-background-purple)"
  },
  {
    contentColor: "var(--dixa-avatar-content-blue)",
    backgroundColor: "var(--dixa-avatar-background-blue)"
  },
  {
    contentColor: "var(--dixa-avatar-content-orange)",
    backgroundColor: "var(--dixa-avatar-background-orange)"
  },
  {
    contentColor: "var(--dixa-avatar-content-red)",
    backgroundColor: "var(--dixa-avatar-background-red)"
  }
];
class Ha {
  constructor(t) {
    this.colors = t, this.colors = t;
  }
  generate(t) {
    const e = this.getRandomIndex(t);
    return this.colors[e];
  }
  getRandomIndex(t) {
    const e = _i(t);
    return Math.floor(e() * this.colors.length);
  }
}
var et = /* @__PURE__ */ ((i) => (i.Icon = "Icon", i.Image = "Image", i.Text = "Text", i))(et || {});
function ue(i) {
  return i.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, "");
}
function wt(i) {
  return !!i && i.trim().length !== 0;
}
function Wa(i) {
  if (i.icon)
    return {
      type: et.Icon,
      icon: i.icon,
      backgroundColor: i.color?.backgroundColor,
      iconColor: i.color?.contentColor
    };
  const { user: t } = i;
  if (!t)
    return {
      type: et.Icon,
      icon: "user-slash"
    };
  if (wt(t.avatar_url))
    return {
      type: et.Image,
      src: t.avatar_url,
      alt: t.name || t.display_name || t.email || t.phone_number || t.given_name || t.family_name || ""
    };
  if (wt(t.name)) {
    const e = ue(t.name.trim()).split(" ");
    if (e.length === 1)
      return {
        type: et.Text,
        text: e[0]?.[0] ?? ""
      };
    const n = e[0], o = e[e.length - 1];
    return {
      type: et.Text,
      text: (n?.[0] ?? "") + (o?.[0] ?? "")
    };
  }
  if (wt(t.display_name))
    return {
      type: et.Text,
      text: ue(t.display_name.trim())
    };
  if (wt(t.given_name) && wt(t.family_name))
    return {
      type: et.Text,
      text: ue(t.given_name.trim())[0] + ue(t.family_name.trim())[0]
    };
  if (wt(t.given_name) && !wt(t.family_name))
    return {
      type: et.Text,
      text: ue(t.given_name.trim())[0]
    };
  if (!wt(t.given_name) && wt(t.family_name))
    return {
      type: et.Text,
      text: ue(t.family_name.trim())[0]
    };
  if (wt(t.email)) {
    const [e] = t.email.split("@");
    return {
      type: et.Text,
      text: e.trim()
    };
  }
  return wt(t.phone_number) ? {
    type: et.Text,
    text: t.phone_number.slice(-2)
  } : t.id ? {
    type: et.Icon,
    icon: "user-secret"
  } : {
    type: et.Icon,
    icon: "user-slash"
  };
}
const vt = {
  backgroundColor: "var(--dixa-color-neutral-200)",
  contentColor: "var(--dixa-color-neutral-700)"
}, uo = {
  shopify: {
    backgroundColor: "rgba(148, 190, 69, 0.1)",
    // this is the same as the content color but has opacity
    contentColor: "#94BE45"
  },
  agillic: {
    ...vt,
    contentColor: "#000"
  },
  magento: {
    backgroundColor: "rgba(193, 72, 0, 0.1)",
    contentColor: "#C14800"
  },
  salesforce: {
    backgroundColor: "rgba(3, 161, 224, 0.1)",
    contentColor: "#03A1E0"
  },
  busylight: {
    backgroundColor: "rgba(27, 190, 246, 0.1)",
    contentColor: "#1BBEF6"
  },
  podio: {
    backgroundColor: "rgba(80, 145, 189, 0.1)",
    contentColor: "#5091BD"
  },
  "user-secret": vt,
  "user-slash": vt,
  "map-pin": vt,
  "web-form": vt,
  code: vt,
  history: vt,
  smile: vt,
  key: vt,
  webhooks: vt,
  plug: vt
}, Ma = {
  24: $n["avatar-24"],
  32: $n["avatar-32"],
  40: $n["avatar-40"]
};
class za extends D {
  static defaultProps = {
    size: "32",
    colorGenerator: new Ha(Ba)
  };
  getAvatarChild(t, e) {
    if (t.type === et.Icon)
      return /* @__PURE__ */ s.jsx(
        ja,
        {
          size: e,
          icon: t.icon,
          color: t.iconColor
        }
      );
    if (t.type === et.Image)
      return /* @__PURE__ */ s.jsx(La, { src: t.src, alt: t.alt });
    if (t.type === et.Text)
      return /* @__PURE__ */ s.jsx(Oa, { size: e, text: t.text });
  }
  calculateColor(t) {
    if (t.type === et.Icon) {
      if (t.backgroundColor && t.iconColor)
        return {
          backgroundColor: t.backgroundColor,
          contentColor: t.iconColor
        };
      if (uo[t.icon])
        return uo[t.icon];
    }
    return t.type === et.Image ? {
      backgroundColor: "transparent",
      contentColor: "initial"
    } : this.props.user?.id ? this.props.colorGenerator.generate(this.props.user.id.toString()) : this.props.icon ? this.props.colorGenerator.generate(this.props.icon) : t.type === et.Text ? this.props.colorGenerator.generate(t.text) : this.props.colorGenerator.generate();
  }
  render() {
    const { className: t, size: e } = this.props, n = Wa(this.props), o = this.getAvatarChild(n, e), r = this.calculateColor(n);
    return /* @__PURE__ */ s.jsx(
      "div",
      {
        style: {
          backgroundColor: r.backgroundColor,
          color: r.contentColor
        },
        className: f(
          $n.root,
          Ma[e],
          t
        ),
        children: o
      }
    );
  }
}
const vr = hn(za, {
  fallback: null
}), Va = "h-badge--badge__badge", Ka = "h-badge--badge__badgeSmall", Ua = "h-badge--badge__badgeMedium", qa = "h-badge--badge__badgePrimary", Ga = "h-badge--badge__badgeSecondary", Ya = "h-badge--badge__badgeSuccess", Xa = "h-badge--badge__badgeInfo", Qa = "h-badge--badge__badgeWarning", Za = "h-badge--badge__badgeError", Ht = {
  badge: Va,
  badgeSmall: Ka,
  badgeMedium: Ua,
  badgePrimary: qa,
  badgeSecondary: Ga,
  badgeSuccess: Ya,
  badgeInfo: Xa,
  badgeWarning: Qa,
  badgeError: Za
}, Ja = {
  small: Ht.badgeSmall,
  medium: Ht.badgeMedium
}, tl = {
  primary: Ht.badgePrimary,
  secondary: Ht.badgeSecondary,
  success: Ht.badgeSuccess,
  info: Ht.badgeInfo,
  warning: Ht.badgeWarning,
  error: Ht.badgeError
}, el = "badge";
function Nk(i) {
  const { className: t, size: e, variant: n, children: o, ...r } = i, a = f(
    Ht.badge,
    Ja[e],
    tl[n],
    t
  );
  return /* @__PURE__ */ s.jsx("span", { className: a, ...r, "data-testid": el, children: o });
}
const H = $(function({
  flexWrap: t,
  flexDirection: e,
  justifyItems: n,
  justifyContent: o,
  alignItems: r,
  alignContent: a,
  gap: l,
  style: c,
  children: d,
  ...h
}, u) {
  const p = {
    ...t && { flexWrap: t },
    ...e && { flexDirection: e },
    ...n && { justifyItems: n },
    ...o && { justifyContent: o },
    ...r && { alignItems: r },
    ...a && { alignContent: a },
    ...l && { gap: Ns(l) },
    display: "flex",
    ...c
  };
  return /* @__PURE__ */ s.jsx(at, { ...h, style: p, ref: u, children: d });
}), nl = "h-banner--banner__root", sl = "h-banner--banner__rootWithClose", ol = "h-banner--banner__iconContainer", rl = "h-banner--banner__closeIcon", il = "h-banner--banner__headline", al = "h-banner--banner__rootInfo", ll = "h-banner--banner__icon", cl = "h-banner--banner__description", dl = "h-banner--banner__rootWarning", hl = "h-banner--banner__rootAnnouncement", ul = "h-banner--banner__rootSuccess", pl = "h-banner--banner__rootFail", yt = {
  root: nl,
  rootWithClose: sl,
  iconContainer: ol,
  closeIcon: rl,
  headline: il,
  rootInfo: al,
  icon: ll,
  description: cl,
  rootWarning: dl,
  rootAnnouncement: hl,
  rootSuccess: ul,
  rootFail: pl
}, ml = (i, t) => {
  if (t !== void 0)
    return t;
  switch (i) {
    case "info":
    case "announcement":
      return "info";
    case "warning":
      return "exclamation-triangle-filled";
    case "success":
      return "check-circle-filled";
    default:
      return "close-circle-filled";
  }
}, Fk = ({
  actionSlot: i,
  className: t,
  description: e,
  headline: n,
  icon: o,
  variant: r,
  onClose: a
}) => {
  const l = f(yt.root, t, {
    [yt.rootInfo]: r === "info",
    [yt.rootAnnouncement]: r === "announcement",
    [yt.rootWarning]: r === "warning",
    [yt.rootSuccess]: r === "success",
    [yt.rootFail]: r === "fail",
    [yt.rootWithClose]: a
  }), c = ml(r, o);
  return /* @__PURE__ */ s.jsxs("div", { className: l, children: [
    /* @__PURE__ */ s.jsxs(H, { justifyContent: "center", children: [
      c && /* @__PURE__ */ s.jsx("span", { className: yt.iconContainer, children: /* @__PURE__ */ s.jsx(N, { name: c, size: 16, className: yt.icon }) }),
      /* @__PURE__ */ s.jsxs(H, { flexDirection: "column", children: [
        n && /* @__PURE__ */ s.jsx(
          A.Heading,
          {
            as: "span",
            variant: "heading-3",
            className: yt.headline,
            children: n
          }
        ),
        cn(e, {
          className: yt.description
        })
      ] })
    ] }),
    i ? /* @__PURE__ */ s.jsx(H, { gap: "250", margin: "0 0 0 250", children: i }) : a && /* @__PURE__ */ s.jsx(
      K,
      {
        icon: "close",
        variant: "tertiary",
        className: yt.closeIcon,
        onClick: a
      }
    )
  ] });
}, gl = "h-buttonGroup--buttonGroup__root", fl = "h-buttonGroup--buttonGroup__button", bl = "h-buttonGroup--buttonGroup__buttonWithBorder", xl = "h-buttonGroup--buttonGroup__buttonWithoutBorder", fn = {
  root: gl,
  button: fl,
  buttonWithBorder: bl,
  buttonWithoutBorder: xl
}, Pk = ({
  className: i,
  children: t,
  variant: e,
  size: n,
  disabled: o
}) => {
  const r = f(fn.root, i);
  return /* @__PURE__ */ s.jsx("div", { className: r, role: "group", children: Lt.map(t, (a) => {
    if (!Dt(a))
      return null;
    const l = (e ?? a.props.variant) === "secondary", c = f(a.props.className, {
      [fn.button]: !0,
      [fn.buttonWithBorder]: l,
      [fn.buttonWithoutBorder]: !l
    });
    return cn(a, {
      className: c,
      disabled: o ?? a.props.disabled,
      variant: e ?? a.props.variant,
      size: n
    });
  }) });
}, yl = "h-divider--divider__root", _l = "h-divider--divider__withChildren", Cl = "h-divider--divider__horizontal", wl = "h-divider--divider__vertical", as = {
  root: yl,
  withChildren: _l,
  horizontal: Cl,
  vertical: wl
}, Yn = $(function({
  className: t,
  children: e,
  as: n,
  orientation: o = "horizontal",
  color: r,
  margin: a,
  padding: l,
  ...c
}, d) {
  const h = n ?? (e ? "div" : "hr"), u = f(
    as.root,
    as[o],
    {
      [as.withChildren]: !!e
    },
    t
  ), p = {
    ...c.style,
    ...r ? { "--divider-color": sn(r) } : {},
    ...a ? { margin: Ns(a) } : {},
    ...l ? { padding: Ns(l) } : {}
  };
  return /* @__PURE__ */ s.jsx(
    h,
    {
      ...c,
      ref: d,
      className: u,
      style: p,
      children: typeof e == "string" ? /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: e }) : e
    }
  );
}), vl = "h-buttonList--buttonList__buttonList", Sl = "h-buttonList--buttonList__inner", po = {
  buttonList: vl,
  inner: Sl
};
let Il = class extends D {
  render() {
    const { children: t, className: e, ...n } = this.props;
    return /* @__PURE__ */ s.jsx(Yn, { as: "li", color: "tertiary", padding: "200 250", ...n, children: t });
  }
};
const Dl = "h-buttonList--item__item", kl = "h-buttonList--item__icon", Tl = "h-buttonList--item__button", jl = "h-buttonList--item__buttonDisabled", Nl = "h-buttonList--item__buttonCentered", Fl = "h-buttonList--item__checkmark", Pl = "h-buttonList--item__buttonLoading", Rl = "h-buttonList--item__buttonContent", Mt = {
  item: Dl,
  icon: kl,
  button: Tl,
  buttonDisabled: jl,
  buttonCentered: Nl,
  checkmark: Fl,
  buttonLoading: Pl,
  buttonContent: Rl
}, El = function({
  icon: t,
  children: e,
  className: n,
  isSelected: o,
  isCentered: r,
  isLoading: a,
  isDisabled: l,
  buttonClassName: c,
  buttonProps: d,
  onClick: h,
  ...u
}, p) {
  const m = f(
    {
      [Mt.item]: !0
    },
    n
  ), g = f(
    Mt.button,
    {
      [Mt.buttonCentered]: r,
      [Mt.buttonLoading]: a,
      [Mt.buttonDisabled]: l
    },
    c
  ), b = l ? { tabIndex: -1 } : {};
  return /* @__PURE__ */ s.jsx("li", { ref: p, ...u, className: m, children: /* @__PURE__ */ s.jsxs(
    "button",
    {
      ...b,
      ...d,
      className: g,
      onClick: h,
      children: [
        /* @__PURE__ */ s.jsxs("span", { className: Mt.buttonContent, children: [
          t && /* @__PURE__ */ s.jsx(N, { className: Mt.icon, name: t }),
          /* @__PURE__ */ s.jsx(A.Paragraph, { variant: o ? "1" : "2", children: e })
        ] }),
        o && /* @__PURE__ */ s.jsx(
          N,
          {
            name: "done",
            size: 20,
            color: "neutral.700",
            className: Mt.checkmark
          }
        )
      ]
    }
  ) });
}, Ll = $(El);
class mo extends D {
  static get Item() {
    return Ll;
  }
  static get Header() {
    return Il;
  }
  static get Divider() {
    return Al;
  }
  render() {
    const { children: t, className: e, ...n } = this.props, o = f(
      {
        [po.buttonList]: !0
      },
      e
    );
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: /* @__PURE__ */ s.jsx("ul", { className: po.inner, children: t }) });
  }
}
const Al = () => /* @__PURE__ */ s.jsx(Yn, { as: "li", margin: "100 0" }), $l = "h-checkbox--checkbox__root", Ol = "h-checkbox--checkbox__rootDisabled", Bl = "h-checkbox--checkbox__rootChecked", Hl = "h-checkbox--checkbox__rootIndeterminate", Wl = "h-checkbox--checkbox__checkbox", Ml = "h-checkbox--checkbox__input", pe = {
  root: $l,
  rootDisabled: Ol,
  rootChecked: Bl,
  rootIndeterminate: Hl,
  checkbox: Wl,
  input: Ml
};
class un extends D {
  inputRef;
  constructor(t) {
    super(t), this.inputRef = B();
  }
  componentDidMount() {
    const t = this.inputRef.current;
    t && (t.indeterminate = !!this.props.indeterminate);
  }
  componentDidUpdate(t) {
    const e = this.inputRef.current;
    e && t.indeterminate !== this.props.indeterminate && (e.indeterminate = !!this.props.indeterminate);
  }
  render() {
    const {
      className: t,
      onChange: e,
      id: n,
      name: o,
      checked: r,
      indeterminate: a,
      disabled: l,
      tabIndex: c,
      ...d
    } = this.props, h = f(
      {
        [pe.root]: !0,
        [pe.rootDisabled]: l,
        [pe.rootChecked]: r,
        [pe.rootIndeterminate]: a
      },
      t
    );
    return /* @__PURE__ */ s.jsxs("span", { className: h, "data-testid": "habla-checkbox", ...d, children: [
      /* @__PURE__ */ s.jsx(
        "span",
        {
          role: "checkbox",
          "aria-checked": a ? "mixed" : r,
          className: pe.checkbox
        }
      ),
      /* @__PURE__ */ s.jsx(
        "input",
        {
          id: n,
          type: "checkbox",
          "aria-hidden": "true",
          name: o,
          className: pe.input,
          onChange: e || E,
          checked: r,
          disabled: l,
          ref: this.inputRef,
          tabIndex: c
        }
      )
    ] });
  }
}
const zl = "h-collapseCard--collapseCard__card", Vl = {
  card: zl
}, Ks = kt({
  isOpen: !1,
  onToggle: E
}), Kl = "h-collapseCard--content__content", Ul = "h-collapseCard--content__contentIsOpen", go = {
  content: Kl,
  contentIsOpen: Ul
};
class ql extends D {
  static displayName = "CollapseCard.Content";
  getRootClassName(t) {
    return f(go.content, this.props.className, {
      [go.contentIsOpen]: t
    });
  }
  render() {
    const { children: t, className: e, ...n } = this.props;
    return /* @__PURE__ */ s.jsx(Ks.Consumer, { children: ({ isOpen: o }) => o ? /* @__PURE__ */ s.jsx(
      "ul",
      {
        ...n,
        className: this.getRootClassName(o),
        "data-testid": "content",
        children: t
      }
    ) : null });
  }
}
function Xn(i) {
  return {
    role: "button",
    onClick: i,
    onKeyDown: (t) => {
      t.key === "Enter" && i(t);
    }
  };
}
const Gl = [
  "ArrowLeft",
  "ArrowUp",
  "ArrowRight",
  "ArrowDown",
  " "
], Yl = ["Escape", "Esc"], Qn = (i) => Gl.includes(i), Ee = (i) => Yl.includes(i), Xl = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]",
  '[tabindex]:not([tabindex="-1"]):not([disabled])'
], fo = Xl.join(
  ':not([hidden]):not([tabindex="-1"]),'
), Sr = qn(function({
  containerRef: t,
  children: e,
  isActive: n,
  autoFocus: o,
  restoreFocus: r,
  onActiveStateChange: a,
  bringInFocusOnTab: l
}) {
  const c = n !== void 0, d = n === void 0 || n, h = Y(null), u = Y(
    // type null is needed to make ref mutable.
    d ? document.activeElement : null
  ), p = t || h;
  Cr(
    "Tab",
    (b) => {
      if (!d)
        return;
      const x = p.current?.querySelectorAll(fo), C = !p.current?.contains(
        b.target instanceof Element ? b.target : null
      );
      if (!x)
        return;
      const _ = x[0], w = x[x.length - 1];
      if (!b.shiftKey && document.activeElement === w || !b.shiftKey && l && C)
        return _?.focus(), b.preventDefault();
      (b.shiftKey && document.activeElement === _ || b.shiftKey && l && C) && (w?.focus(), b.preventDefault());
    },
    void 0,
    [d]
  );
  const m = () => {
    setTimeout(() => {
      o && (o === !0 ? p.current?.querySelector(fo)?.focus() : o.current && o.current.focus());
    });
  }, g = () => {
    document.activeElement !== document.body && !p.current?.contains(document.activeElement) || setTimeout(() => {
      r && (r === !0 ? u.current?.focus() : r.current && r.current.focus());
    });
  };
  return Pe(() => {
    c || (m(), a?.(!0));
  }), Jt(() => {
    c || (g(), a?.(!1));
  }), Zt(() => {
    n === !0 ? (u.current = document.activeElement, m()) : n === !1 && g(), a?.(!!n);
  }, [n]), t ? /* @__PURE__ */ s.jsx(s.Fragment, { children: e }) : /* @__PURE__ */ s.jsx("div", { ref: h, children: e });
}), Ql = "h-dropdown--dropdown__dropdown", Zl = "h-dropdown--dropdown__dropdownOpen", Jl = "h-dropdown--dropdown__dropdownFromRight", tc = "h-dropdown--dropdown__dropdownFromBottom", ec = "h-dropdown--dropdown__dropdownAnimating", nc = "h-dropdown--dropdown__dropdownFixed", sc = "h-dropdown--dropdown__loader", oc = "h-dropdown--dropdown__error", rc = "h-dropdown--dropdown__errorIcon", $t = {
  dropdown: Ql,
  dropdownOpen: Zl,
  dropdownFromRight: Jl,
  dropdownFromBottom: tc,
  dropdownAnimating: ec,
  dropdownFixed: nc,
  loader: sc,
  error: oc,
  errorIcon: rc
};
class te extends D {
  dropdownRef;
  timeoutAnimationStart;
  timeoutAnimationEnd;
  win;
  static defaultProps = {
    onClose: () => {
    },
    closeOnBlur: !0
  };
  constructor(t) {
    super(t), this.state = {
      fromRight: !1,
      fromBottom: !1,
      fromTop: !1,
      width: null,
      height: null,
      animating: !1
    }, this.timeoutAnimationStart = void 0, this.timeoutAnimationEnd = void 0, this.dropdownRef = B(), this.win = window, this.handleClickOutsideDropdown = this.handleClickOutsideDropdown.bind(this), this.handleFixedScroll = this.handleFixedScroll.bind(this), this.handleOnClose = this.handleOnClose.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this);
  }
  componentDidMount() {
    this.win = this.getWindow(), this.calculatePosition();
  }
  getSnapshotBeforeUpdate() {
    if (this.dropdownRef.current) {
      const t = this.dropdownRef.current.getBoundingClientRect();
      return {
        oldWidth: t.width,
        oldHeight: t.height
      };
    }
    return null;
  }
  componentDidUpdate(t, e, n) {
    const { isOpen: o, isLoading: r, errorMessage: a, fixed: l, closeOnBlur: c } = this.props;
    if (n && (r !== t.isLoading || a !== t.errorMessage)) {
      const d = r !== t.isLoading && r;
      this.animate(n.oldWidth, n.oldHeight, d);
    }
    o && this.calculatePosition(), o !== t.isOpen && (this.win[o ? "addEventListener" : "removeEventListener"](
      "click",
      this.handleClickOutsideDropdown
    ), c && this.win[o ? "addEventListener" : "removeEventListener"](
      "blur",
      this.handleOnClose
    ), l && this.win[o ? "addEventListener" : "removeEventListener"](
      "scroll",
      this.handleFixedScroll,
      !0
    ));
  }
  getWindow() {
    return this.dropdownRef.current?.ownerDocument?.defaultView ?? window;
  }
  componentWillUnmount() {
    this.win.removeEventListener("click", this.handleClickOutsideDropdown), this.win.removeEventListener("scroll", this.handleFixedScroll), this.win.removeEventListener("blur", this.handleOnClose), this.win.clearInterval(this.timeoutAnimationStart), this.win.clearInterval(this.timeoutAnimationEnd);
  }
  handleOnClose() {
    const { onClose: t } = this.props;
    t();
  }
  animate(t, e, n) {
    if (this.dropdownRef.current) {
      const o = this.dropdownRef.current.getBoundingClientRect();
      this.setState({
        width: t,
        height: e,
        animating: !n
      }), this.timeoutAnimationStart = this.win.setTimeout(() => {
        this.setState({
          width: o.width,
          height: o.height
        }), this.timeoutAnimationEnd = this.win.setTimeout(() => {
          this.setState({
            width: null,
            height: null,
            animating: !1
          });
        }, 200);
      });
    }
  }
  handleClickOutsideDropdown(t) {
    if (!this.dropdownRef || !t.target) return;
    const e = t.target, { onClose: n } = this.props;
    this.dropdownRef.current && e !== this.dropdownRef.current && !this.dropdownRef.current.contains(e) && n();
  }
  handleDropdownClick(t) {
    t.stopPropagation();
  }
  handleFixedScroll() {
    this.forceUpdate();
  }
  calculatePosition() {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      const t = this.dropdownRef.current.parentElement.getBoundingClientRect(), e = t.left + t.width / 2, n = t.top + t.height / 2, o = this.getWindow(), r = o.innerWidth / 2, a = o.innerHeight / 2;
      this.setState({
        fromRight: e > r,
        fromBottom: n > a,
        fromTop: n <= a
      });
    }
  }
  getFixedPosition() {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      const { fromRight: t, fromBottom: e, fromTop: n } = this.state, o = this.dropdownRef.current.parentElement.getBoundingClientRect(), r = {}, a = this.getWindow();
      return t ? r.right = `${a.innerWidth - o.right}px` : r.left = `${o.left}px`, e && (r.bottom = `${a.innerHeight - o.top}px`), n && (r.top = `${o.top + o.height}px`), r;
    }
    return {};
  }
  render() {
    const {
      className: t,
      children: e,
      onClose: n,
      isOpen: o,
      isLoading: r,
      closeOnBlur: a,
      errorMessage: l,
      fixed: c,
      style: d,
      autoFocus: h,
      restoreFocus: u,
      bringInFocusOnTab: p,
      ...m
    } = this.props, { fromRight: g, fromBottom: b, animating: x, width: C, height: _ } = this.state, w = f(
      {
        [$t.dropdown]: !0,
        [$t.dropdownOpen]: o,
        [$t.dropdownFromRight]: g,
        [$t.dropdownFromBottom]: b,
        [$t.dropdownAnimating]: x,
        [$t.dropdownFixed]: c
      },
      t
    );
    let S = { ...d };
    C && _ && (S.width = `${C}px`, S.height = `${_}px`), c && (S = { ...S, ...this.getFixedPosition() });
    const y = !r && !l;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...m,
        className: w,
        ref: this.dropdownRef,
        style: S,
        onClick: this.handleDropdownClick,
        role: "menu",
        "aria-expanded": o,
        children: [
          r && /* @__PURE__ */ s.jsx("div", { className: $t.loader }),
          !!l && !r && /* @__PURE__ */ s.jsxs("div", { className: $t.error, children: [
            /* @__PURE__ */ s.jsx(N, { className: $t.errorIcon, name: "exclamation" }),
            /* @__PURE__ */ s.jsx("span", { children: l })
          ] }),
          y && /* @__PURE__ */ s.jsx(
            Sr,
            {
              containerRef: this.dropdownRef,
              isActive: o,
              autoFocus: h,
              restoreFocus: u,
              bringInFocusOnTab: p,
              children: e
            }
          )
        ]
      }
    );
  }
}
const ic = "h-dropdownButton--dropdownButton__root", ac = "h-dropdownButton--dropdownButton__wrapper", ls = {
  root: ic,
  wrapper: ac
}, pn = kt({
  toggleDropdown: E,
  openDropdown: E,
  closeDropdown: E,
  dropdownOpen: !1
});
class ce extends ft {
  buttonWrapperRef;
  buttonRef;
  contextState;
  timeoutId;
  win;
  static defaultProps = {
    allowEscClose: !0
  };
  constructor(t) {
    super(t);
    const e = t.show ?? !1;
    this.state = {
      dropdownOpen: e,
      pristine: !0,
      fromBottom: !1
    }, this.timeoutId = null, this.win = window, this.buttonWrapperRef = B(), this.buttonRef = B(), this.handleDropdownToggle = this.handleDropdownToggle.bind(this), this.close = this.close.bind(this), this.open = this.open.bind(this), this.toggle = this.toggle.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.contextState = {
      toggleDropdown: this.toggle,
      openDropdown: this.open,
      closeDropdown: this.close,
      dropdownOpen: e
    };
  }
  getWindow() {
    return this.buttonWrapperRef.current?.ownerDocument?.defaultView ?? window;
  }
  componentDidMount() {
    this.win = this.getWindow(), this.props.allowEscClose && this.props.show && this.win.addEventListener("keydown", this.handleKeyDown, !0), this.setState({ fromBottom: this.shouldDropdownBeAboveButton() });
  }
  componentDidUpdate(t) {
    this.toggleDropdownIfNeeded(t);
  }
  componentWillUnmount() {
    this.props.allowEscClose && this.win.removeEventListener("keydown", this.handleKeyDown, !0), this.timeoutId && this.win.clearTimeout(this.timeoutId);
  }
  shouldToggleDropdown(t) {
    return t.show !== this.props.show;
  }
  handleKeyDown(t) {
    Ee(t.key) && this.state.dropdownOpen && (t.stopPropagation(), this.close());
  }
  toggleDropdownIfNeeded(t) {
    this.shouldToggleDropdown(t) && (this.props.show ? this.open() : this.close());
  }
  /**
   * HACK: To get around node and dom types not being compatible and both
   * overloading setTimeout
   *
   * @param callback
   * @param delay
   * @returns
   */
  setTimeout(t, e = 0) {
    return this.win.setTimeout(t, e);
  }
  handleDropdownToggle() {
    const { dropdownOpen: t } = this.state, e = () => {
      this.timeoutId = this.setTimeout(() => {
        this.toggle(!t);
      });
    }, n = this.shouldDropdownBeAboveButton();
    t ? e() : this.setState(
      { fromBottom: n },
      e
    );
  }
  close() {
    this.toggle(!1);
  }
  open() {
    this.toggle(!0);
  }
  toggle(t) {
    const { allowEscClose: e, onToggle: n } = this.props, { pristine: o, dropdownOpen: r } = this.state, a = t ?? !r;
    this.contextState = { ...this.contextState, dropdownOpen: a }, this.setState({ dropdownOpen: a, pristine: !1 }), e && (a ? this.win.addEventListener.bind(this.win) : this.win.removeEventListener.bind(this.win))("keydown", this.handleKeyDown, !0), n?.(a, o);
  }
  shouldDropdownBeAboveButton() {
    const t = this.buttonWrapperRef.current?.getBoundingClientRect();
    return t ? t.bottom > this.getWindow().innerHeight / 2 : !1;
  }
  renderTheTriggerButton() {
    const {
      icon: t,
      buttonProps: e,
      children: n,
      noArrow: o,
      noStyle: r,
      onMouseEnter: a,
      onMouseLeave: l
    } = this.props, { fromBottom: c } = this.state;
    return r ? /* @__PURE__ */ s.jsx(
      "div",
      {
        ref: this.buttonRef,
        className: e?.className,
        ...e,
        onMouseEnter: a,
        onMouseLeave: l,
        ...Xn(this.handleDropdownToggle),
        children: n
      }
    ) : t && !n ? /* @__PURE__ */ s.jsx(
      K,
      {
        ref: this.buttonRef,
        icon: t,
        variant: "secondary",
        onMouseEnter: a,
        onMouseLeave: l,
        ...e,
        onClick: this.handleDropdownToggle
      }
    ) : /* @__PURE__ */ s.jsx(
      Q,
      {
        ref: this.buttonRef,
        icon: t,
        variant: "secondary",
        onMouseEnter: a,
        onMouseLeave: l,
        ...e,
        onClick: this.handleDropdownToggle,
        slotEnd: o ? void 0 : /* @__PURE__ */ s.jsx(N, { name: c ? "angle-up" : "angle-down" }),
        children: n
      }
    );
  }
  render() {
    const {
      className: t,
      children: e,
      icon: n,
      dropdown: o,
      buttonProps: r,
      dropdownProps: a,
      noArrow: l,
      noStyle: c,
      show: d,
      onToggle: h,
      isLoading: u,
      errorMessage: p,
      fixed: m,
      onMouseEnter: g,
      onMouseLeave: b,
      allowEscClose: x,
      destroyOnClose: C,
      ..._
    } = this.props, { dropdownOpen: w, pristine: S } = this.state, y = f({ [ls.root]: ls.root }, t);
    return /* @__PURE__ */ s.jsx(pn.Provider, { value: this.contextState, children: /* @__PURE__ */ s.jsx("div", { ..._, className: y, ref: this.buttonWrapperRef, children: /* @__PURE__ */ s.jsxs("div", { className: ls.wrapper, children: [
      this.renderTheTriggerButton(),
      /* @__PURE__ */ s.jsx(
        te,
        {
          restoreFocus: this.buttonRef,
          ...a,
          isOpen: w,
          onClose: this.close,
          isLoading: u,
          errorMessage: p,
          fixed: m,
          children: (w || !S && !C) && o
        }
      )
    ] }) }) });
  }
}
const lc = "h-collapseCard--header__header", cc = "h-collapseCard--header__headerOpen", dc = "h-collapseCard--header__headerHasDropdown", hc = "h-collapseCard--header__titleWrapper", uc = "h-collapseCard--header__title", me = {
  header: lc,
  headerOpen: cc,
  headerHasDropdown: dc,
  titleWrapper: hc,
  title: uc
};
class pc extends D {
  // It's important to keep the displayName because it's used by the collapseCard
  // To determine the type of it's children
  static displayName = "CollapseCard.Header";
  static defaultProps = {
    title: ""
  };
  getRootClassName(t) {
    const { dropdown: e, className: n } = this.props;
    return f(
      me.header,
      { [me.headerOpen]: t, [me.headerHasDropdown]: !!e },
      n
    );
  }
  render() {
    const {
      children: t,
      className: e,
      title: n,
      avatar: o,
      dropdown: r,
      onDropdownToggle: a,
      dropdownTrigger: l,
      slotBeforeTitle: c,
      slotAfterTitle: d,
      wrap: h = "nowrap",
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(Ks.Consumer, { children: ({ isOpen: p, onToggle: m }) => {
      const g = this.getRootClassName(p);
      return /* @__PURE__ */ s.jsxs(
        "div",
        {
          ...u,
          onClick: m,
          className: g,
          "data-testid": "header",
          children: [
            /* @__PURE__ */ s.jsxs(
              H,
              {
                alignItems: "center",
                padding: "400 0",
                className: me.titleWrapper,
                children: [
                  c,
                  o,
                  /* @__PURE__ */ s.jsx(
                    "div",
                    {
                      className: me.titleWrapper,
                      onMouseDown: (b) => b.stopPropagation(),
                      children: /* @__PURE__ */ s.jsx(
                        A.Paragraph,
                        {
                          variant: "1",
                          wrap: h,
                          className: me.title,
                          children: t
                        }
                      )
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ s.jsxs(H, { alignItems: "center", children: [
              d,
              !!r && /* @__PURE__ */ s.jsx(
                ce,
                {
                  onClick: (b) => b.stopPropagation(),
                  icon: l ? void 0 : "dots-h",
                  dropdown: r,
                  buttonProps: { variant: "tertiary" },
                  onToggle: a,
                  children: l
                }
              ),
              /* @__PURE__ */ s.jsx(
                K,
                {
                  icon: p ? "angle-down" : "angle-right",
                  variant: "tertiary"
                }
              )
            ] })
          ]
        }
      );
    } });
  }
}
const mc = "h-collapseCard--line__line", gc = "h-collapseCard--line__lineHasLabel", fc = "h-collapseCard--line__value", bc = "h-collapseCard--line__lineHideOverflow", bn = {
  line: mc,
  lineHasLabel: gc,
  value: fc,
  lineHideOverflow: bc
};
class xc extends D {
  render() {
    const { label: t, children: e, className: n, hideOverflow: o, ...r } = this.props, a = f(
      {
        [bn.line]: !0,
        [bn.lineHasLabel]: !!t,
        [bn.lineHideOverflow]: o
      },
      n
    );
    return /* @__PURE__ */ s.jsxs("li", { ...r, className: a, children: [
      t && /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", subdued: !0, wrap: "nowrap", children: t }),
      t ? /* @__PURE__ */ s.jsx("span", { className: bn.value, children: e }) : e
    ] });
  }
}
const yc = "h-collapseCard--readMore__readMore", _c = {
  readMore: yc
};
class Cc extends D {
  render() {
    const { onClick: t, url: e, children: n, className: o, ...r } = this.props, a = f({ [_c.readMore]: !0 }, o);
    return e ? /* @__PURE__ */ s.jsx(A.ExternalLink, { ...r, href: e, className: a, children: n }) : /* @__PURE__ */ s.jsx(
      Q,
      {
        variant: "secondary",
        ...r,
        onClick: t,
        className: a,
        children: n
      }
    );
  }
}
const wc = "h-collapseCard--status__status", vc = {
  status: wc
};
class Sc extends D {
  render() {
    const { children: t, className: e, ...n } = this.props, o = f({ [vc.status]: !0 }, e);
    return /* @__PURE__ */ s.jsx("li", { ...n, className: o, children: t });
  }
}
class Ic extends D {
  static defaultProps = {
    isOpen: !1
  };
  constructor(t) {
    super(t), this.handleToggle = this.handleToggle.bind(this);
  }
  static Line = xc;
  static Header = pc;
  static Content = ql;
  static ReadMore = Cc;
  static Status = Sc;
  handleToggle() {
    this.props.onToggle(!this.props.isOpen);
  }
  isHeader(t) {
    return t?.type?.displayName === "CollapseCard.Header" && Dt(t);
  }
  isContent(t) {
    return t?.type?.displayName === "CollapseCard.Content" && Dt(t);
  }
  getHeaderChildren() {
    return Lt.toArray(this.props.children).filter(this.isHeader);
  }
  getContentChildren() {
    return Lt.toArray(this.props.children).filter(this.isContent);
  }
  getRootClassName() {
    const { className: t } = this.props;
    return f(Vl.card, t);
  }
  render() {
    const {
      className: t,
      onToggle: e,
      isOpen: n,
      children: o,
      containerRef: r,
      ...a
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      Ks.Provider,
      {
        value: { isOpen: n, onToggle: this.handleToggle },
        children: /* @__PURE__ */ s.jsxs(
          "div",
          {
            ...a,
            ref: r,
            className: this.getRootClassName(),
            children: [
              this.getHeaderChildren(),
              this.getContentChildren()
            ]
          }
        )
      }
    );
  }
}
const Ek = hn(Ic, {
  fallback: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: "Something went wrong" }) })
}), Dc = "h-collapsible--collapsible__root", kc = "h-collapsible--collapsible__collapsible", Tc = "h-collapsible--collapsible__children", cs = {
  root: Dc,
  collapsible: kc,
  children: Tc
};
class Lk extends D {
  childrenRef;
  resizeObserver = null;
  constructor(t) {
    super(t), this.childrenRef = B(), this.measureChildrenHeight = this.measureChildrenHeight.bind(this), this.state = {
      childrenHeight: t.isOpen ? "auto" : 0
    };
  }
  componentDidMount() {
    this.measureChildrenHeight(), this.setupResizeObserver();
  }
  componentDidUpdate(t) {
    t.isOpen !== this.props.isOpen && this.measureChildrenHeight(), this.setupResizeObserver();
  }
  componentWillUnmount() {
    this.disconnectResizeObserver();
  }
  setupResizeObserver() {
    this.childrenRef.current && !this.resizeObserver && (this.resizeObserver = new ResizeObserver(() => {
      this.measureChildrenHeight();
    }), this.resizeObserver.observe(this.childrenRef.current));
  }
  disconnectResizeObserver() {
    this.resizeObserver && (this.resizeObserver.disconnect(), this.resizeObserver = null);
  }
  measureChildrenHeight() {
    const t = this.childrenRef.current;
    t && this.setState({
      childrenHeight: t.offsetHeight
    });
  }
  render() {
    const { className: t, header: e, isOpen: n, children: o, ...r } = this.props, { childrenHeight: a } = this.state, l = f(
      {
        [cs.root]: !0
      },
      t
    ), c = {
      maxHeight: n ? a : 0
    };
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: l, children: [
      /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx("div", { children: e }) }),
      !!o && /* @__PURE__ */ s.jsx("div", { style: c, className: cs.collapsible, children: /* @__PURE__ */ s.jsx("span", { className: cs.children, ref: this.childrenRef, children: o }) })
    ] });
  }
}
const jc = "h-colorPicker--colorPicker__root", Nc = {
  root: jc
}, Fc = "h-inputWrapper--inputWrapper__root", Pc = "h-inputWrapper--inputWrapper__rootDisabled", Rc = "h-inputWrapper--inputWrapper__rootActive", Ec = "h-inputWrapper--inputWrapper__rootHasError", Lc = "h-inputWrapper--inputWrapper__rootHasWarning", Ac = "h-inputWrapper--inputWrapper__rootHasSuccess", $c = "h-inputWrapper--inputWrapper__inputWrapper", Oc = "h-inputWrapper--inputWrapper__rootWithPrefix", Bc = "h-inputWrapper--inputWrapper__rootWithSuffix", Hc = "h-inputWrapper--inputWrapper__suffixesContainer", Wc = "h-inputWrapper--inputWrapper__prefix", Mc = "h-inputWrapper--inputWrapper__suffix", zc = "h-inputWrapper--inputWrapper__prefixDropdownButton", Vc = "h-inputWrapper--inputWrapper__suffixDropdownButton", Kc = "h-inputWrapper--inputWrapper__prefixButton", Uc = "h-inputWrapper--inputWrapper__suffixButton", qc = "h-inputWrapper--inputWrapper__icon", lt = {
  root: Fc,
  rootDisabled: Pc,
  rootActive: Rc,
  rootHasError: Ec,
  rootHasWarning: Lc,
  rootHasSuccess: Ac,
  inputWrapper: $c,
  rootWithPrefix: Oc,
  rootWithSuffix: Bc,
  suffixesContainer: Hc,
  prefix: Wc,
  suffix: Mc,
  prefixDropdownButton: zc,
  suffixDropdownButton: Vc,
  prefixButton: Kc,
  suffixButton: Uc,
  icon: qc
}, Fs = kt({
  position: null,
  disabled: !1,
  active: !1,
  status: "success"
}), Gc = "inputWrapper";
class Yc extends D {
  renderIcon() {
    const { icon: t } = this.props;
    return t ? /* @__PURE__ */ s.jsx(N, { className: lt.icon, name: t }) : null;
  }
  isButtonAddon(t) {
    return !!t && "type" in t && t.type === "button";
  }
  isCustomAddon(t) {
    return !!t && "type" in t && (!t.type || t.type === "custom");
  }
  renderAddon(t) {
    const e = this.props[t], { disabled: n } = this.props;
    if (!e)
      return null;
    let o;
    if (typeof e != "object" || !("type" in e))
      o = /* @__PURE__ */ s.jsx("div", { className: f(lt[t]), children: e });
    else if (this.isCustomAddon(e))
      o = e.noWrap ? e.value : /* @__PURE__ */ s.jsx("div", { className: lt[t], children: e.value });
    else if (this.isButtonAddon(e)) {
      const {
        className: r,
        disabled: a,
        ...l
      } = e.button;
      o = /* @__PURE__ */ s.jsx(
        K,
        {
          className: f(
            {
              [lt[t]]: !e.noStyle,
              [lt[`${t}Button`]]: !e.noStyle
            },
            r
          ),
          disabled: n || a,
          ...l
        }
      );
    }
    return o;
  }
  getContextValue(t) {
    const { disabled: e, active: n, status: o } = this.props;
    return {
      position: t,
      disabled: !!e,
      active: !!n,
      status: o || "success"
    };
  }
  render() {
    const {
      className: t,
      disabled: e,
      active: n,
      status: o,
      prefix: r,
      suffix: a,
      icon: l,
      children: c,
      innerRef: d,
      ...h
    } = this.props, u = f(
      lt.root,
      {
        [lt.rootActive]: n,
        [lt.rootDisabled]: e,
        [lt.rootHasError]: o === "error",
        [lt.rootHasWarning]: o === "warning",
        [lt.rootHasSuccess]: o === "success",
        [lt.rootWithPrefix]: !!r,
        [lt.rootWithSuffix]: !!a
      },
      t
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Gc,
        className: u,
        ref: d,
        ...h,
        children: [
          /* @__PURE__ */ s.jsx(Fs.Provider, { value: this.getContextValue("prefix"), children: this.renderAddon("prefix") }),
          /* @__PURE__ */ s.jsx("div", { className: lt.inputWrapper, children: c }),
          /* @__PURE__ */ s.jsxs("span", { className: lt.suffixesContainer, children: [
            this.renderIcon(),
            /* @__PURE__ */ s.jsx(Fs.Provider, { value: this.getContextValue("suffix"), children: this.renderAddon("suffix") })
          ] })
        ]
      }
    );
  }
}
const At = $(function(t, e) {
  return /* @__PURE__ */ s.jsx(Yc, { innerRef: e, ...t, children: t.children });
}), Xc = "h-colorPicker-input--colorPickerInput__input", Qc = {
  input: Xc
}, Zc = ({
  className: i,
  ...t
}) => /* @__PURE__ */ s.jsx(At, { prefix: "#", children: /* @__PURE__ */ s.jsx(
  Ci,
  {
    className: f(Qc.input, i),
    "aria-label": "Enter hex value",
    placeholder: "Hex value",
    ...t
  }
) }), Jc = "h-colorPicker-presets--colorPickerPresets__root", td = {
  root: Jc
}, ed = "h-colorPicker-presets-preset--colorPickerPreset__root", nd = "h-colorPicker-presets-preset--colorPickerPreset__rootIsSelected", sd = "h-colorPicker-presets-preset--colorPickerPreset__rootAlpha", od = "h-colorPicker-presets-preset--colorPickerPreset__preset", xn = {
  root: ed,
  rootIsSelected: nd,
  rootAlpha: sd,
  preset: od
}, rd = ({
  color: i,
  onSelect: t,
  isSelected: e,
  alpha: n,
  className: o
}) => /* @__PURE__ */ s.jsx(
  "li",
  {
    className: f(xn.root, o, {
      [xn.rootIsSelected]: e,
      [xn.rootAlpha]: n
    }),
    children: /* @__PURE__ */ s.jsx(
      "button",
      {
        type: "button",
        "aria-label": i,
        className: xn.preset,
        style: { backgroundColor: i },
        onClick: () => {
          t?.(i);
        }
      }
    )
  }
);
Hs([Ws]);
const id = ({
  presets: i,
  className: t,
  onChange: e,
  color: n,
  alpha: o,
  ...r
}) => /* @__PURE__ */ s.jsx(
  H,
  {
    as: "ul",
    gap: "200",
    flexWrap: "wrap",
    className: f(td.root, t),
    ...r,
    children: i.map((a) => /* @__PURE__ */ s.jsx(
      rd,
      {
        onSelect: e,
        color: a,
        isSelected: n === (a.startsWith("#") ? a : Hn(a).toHex()),
        alpha: o
      },
      a
    ))
  }
);
Hs([Ws]);
const ad = ({
  onChange: i,
  color: t,
  alpha: e,
  className: n,
  ...o
}) => {
  const r = F((a) => {
    setTimeout(() => {
      i?.(Hn(a).toHex());
    });
  }, []);
  return e ? /* @__PURE__ */ s.jsx(
    vi,
    {
      className: n,
      color: Hn(t ?? "").toRgbString(),
      onChange: r,
      ...o
    }
  ) : /* @__PURE__ */ s.jsx(
    wi,
    {
      className: n,
      color: t,
      onChange: i,
      ...o
    }
  );
};
Hs([Ws]);
const ld = "colorPickerTestId", Zn = ({
  className: i,
  color: t,
  onChange: e,
  alpha: n,
  children: o,
  ...r
}) => {
  const [a, l] = V();
  return q(() => {
    const c = t?.startsWith("#") ? t : Hn(t ?? "").toHex();
    l(c);
  }, [t]), /* @__PURE__ */ s.jsx(
    H,
    {
      flexDirection: "column",
      gap: "250",
      className: f(Nc.root, i),
      "data-testid": ld,
      ...r,
      children: Lt.map(
        o,
        (c) => Dt(c) && cn(c, {
          onChange: e,
          color: a,
          alpha: n,
          ...c.props
        })
      )
    }
  );
};
Zn.Input = Zc;
Zn.Sliders = ad;
Zn.Presets = id;
const cd = "h-columns--columns__root", dd = {
  root: cd
}, hd = "1fr", ud = $(function({ as: t = "div", children: e, className: n, style: o, ...r }, a) {
  const c = Lt.toArray(e).map((d) => d.props.size ?? hd).join(" ");
  return /* @__PURE__ */ s.jsx(
    t,
    {
      ...r,
      ref: a,
      className: f(dd.root, n),
      style: { ...o, gridTemplateColumns: c },
      children: e
    }
  );
}), pd = "h-columns-column--column__root", md = {
  root: pd
}, gd = "h-columns-column-row--columnRow__root", fd = "h-columns-column-row--columnRow__noMinHeight", bd = "h-columns-column-row--columnRow__noVerticalPadding", xd = "h-columns-column-row--columnRow__noHorizontalPadding", yd = "h-columns-column-row--columnRow__borderTop", _d = "h-columns-column-row--columnRow__borderBottom", Cd = "h-columns-column-row--columnRow__scrollable", wd = "h-columns-column-row--columnRow__slottable", zt = {
  root: gd,
  noMinHeight: fd,
  noVerticalPadding: bd,
  noHorizontalPadding: xd,
  borderTop: yd,
  borderBottom: _d,
  scrollable: Cd,
  slottable: wd
}, vd = 1, Sd = $(function({
  as: t = "div",
  children: e,
  className: n,
  noVerticalPadding: o,
  noHorizontalPadding: r,
  noMinHeight: a,
  borderTop: l,
  borderBottom: c,
  scrollable: d,
  size: h,
  slottable: u,
  style: p,
  ...m
}, g) {
  const b = f(n, zt.root, {
    [zt.slottable]: u,
    [zt.noVerticalPadding]: u ?? o,
    [zt.noHorizontalPadding]: r,
    [zt.borderTop]: l,
    [zt.borderBottom]: c,
    [zt.scrollable]: d,
    [zt.noMinHeight]: a
  });
  return /* @__PURE__ */ s.jsx(
    t,
    {
      ...m,
      ref: g,
      className: b,
      style: {
        ...p,
        flexGrow: h ?? d ? vd : void 0
      },
      children: e
    }
  );
}), Id = "h-columns-column-slot--columnSlot__root", Dd = "h-columns-column-slot--columnSlot__noVerticalPadding", bo = {
  root: Id,
  noVerticalPadding: Dd
}, kd = ({
  children: i,
  className: t,
  noVerticalPadding: e,
  placement: n = "start"
}) => {
  const o = f(bo.root, t, {
    [bo.noVerticalPadding]: e
  });
  return /* @__PURE__ */ s.jsx(
    H,
    {
      alignItems: "center",
      alignSelf: "stretch",
      justifySelf: n,
      className: o,
      children: i
    }
  );
}, mt = ({
  as: i,
  children: t,
  className: e
}) => /* @__PURE__ */ s.jsx(
  H,
  {
    as: i,
    flexDirection: "column",
    className: f(md.root, e),
    children: t
  }
);
mt.Row = Sd;
mt.Slot = kd;
const Td = "h-copyToClipboard--copyToClipboard__copyToClipboard", jd = "h-copyToClipboard--copyToClipboard__copyToClipboardTooltip", xo = {
  copyToClipboard: Td,
  copyToClipboardTooltip: jd
};
class Nd extends ft {
  timerHandle;
  static defaultProps = {
    tooltip: !0,
    disabled: !1,
    transitionDuration: 2e3,
    clickedProps: {}
  };
  constructor(t) {
    super(t), this.state = { clicked: !1 }, this.handleClick = this.handleClick.bind(this);
  }
  componentWillUnmount() {
    this.timerHandle && clearTimeout(this.timerHandle);
  }
  executeCopy(t) {
    const e = document.body;
    if (!t || !document.body)
      return;
    const n = document.createElement("textarea");
    n.value = t, n.setAttribute("readonly", ""), n.style.position = "absolute", n.style.left = "-9999px", e.appendChild(n), n.select(), document.execCommand("copy"), e.removeChild(n);
  }
  handleClick(t) {
    const { disabled: e, textToCopy: n, transitionDuration: o, onClick: r } = this.props;
    e || (typeof r == "function" && r(t), this.executeCopy(n), this.setState({ clicked: !0 }, () => {
      this.timerHandle = setTimeout(() => {
        this.setState({ clicked: !1 });
      }, o);
    }));
  }
  render() {
    const { className: t, children: e, clickedProps: n, tooltip: o } = this.props, { clicked: r } = this.state, a = f(
      xo.copyToClipboard,
      { [xo.copyToClipboardTooltip]: r && o },
      t
    );
    return /* @__PURE__ */ s.jsx("div", { className: a, children: Lt.map(e, (l) => Dt(l) ? cn(l, {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      onClick: this.handleClick.bind(this),
      ...r ? n : {}
    }) : l) });
  }
}
class Ak extends D {
  render() {
    const { buttonProps: t, ...e } = this.props;
    return /* @__PURE__ */ s.jsx(Nd, { ...e, children: /* @__PURE__ */ s.jsx(K, { icon: "copy", variant: "secondary", ...t }) });
  }
}
const Fd = "h-simplePagination--simplePagination__paginationButton", yo = {
  paginationButton: Fd
}, Pd = "simplePaginationTestId", Rd = ({
  nextButtonClick: i = E,
  previousButtonClick: t = E,
  nextButtonText: e = "Next page",
  previousButtonText: n = "Previous page",
  nextButtonDisabled: o = !1,
  previousButtonDisabled: r = !1,
  nextButtonHidden: a = !1,
  previousButtonHidden: l = !1,
  nextButtonExtraProps: c,
  previousButtonExtraProps: d,
  loading: h = !1,
  loadingText: u = "Loading...",
  ...p
}) => /* @__PURE__ */ s.jsxs("div", { "data-testid": Pd, ...p, children: [
  !l && /* @__PURE__ */ s.jsx(
    Q,
    {
      disabled: r || h,
      onClick: t,
      variant: "secondary",
      ...d,
      className: f(
        yo.paginationButton,
        d?.className
      ),
      children: h ? u : n
    }
  ),
  !a && /* @__PURE__ */ s.jsx(
    Q,
    {
      disabled: o || h,
      onClick: i,
      variant: "secondary",
      ...c,
      className: f(
        yo.paginationButton,
        c?.className
      ),
      children: h ? u : e
    }
  )
] }), Jn = kt(
  void 0
);
var dt = /* @__PURE__ */ ((i) => (i.Foot = "table-foot", i.Body = "table-body", i.Head = "table-head", i.Row = "table-row", i.PaginationRow = "table-pagination-row", i.Td = "table-body-cell", i.Th = "table-header-cell", i.RowExpansionTrigger = "table-row-expansion-trigger", i.LoadingRow = "table-loading-row", i.LoadingFailedRow = "table-loading-failed-row", i.EmptyRow = "table-empty-row", i))(dt || {});
const Ed = "h-table-tfoot--tfoot__root", Ld = "h-table-tfoot--tfoot__rootIsLoading", _o = {
  root: Ed,
  rootIsLoading: Ld
}, Ir = kt(
  void 0
), Co = ({ className: i, children: t, ...e }, n) => /* @__PURE__ */ s.jsx(Jn.Consumer, { children: (o) => o?.status.loading && ["spinner"].includes(o?.loading.loadingStrategy) ? null : /* @__PURE__ */ s.jsx(Ir.Provider, { value: { isTableFoot: !0 }, children: /* @__PURE__ */ s.jsx(
  "tfoot",
  {
    ...e,
    ref: n,
    className: f(
      {
        [_o.rootIsLoading]: o?.status.loading
      },
      _o.root,
      i
    ),
    "data-testid": dt.Foot,
    children: t
  }
) }) }), Ad = Object.assign($(Co), { name: Co.name }), $d = "h-table-thead--thead__root", Od = "h-table-thead--thead__rootIsLoading", wo = {
  root: $d,
  rootIsLoading: Od
}, Dr = kt(
  void 0
), vo = ({ className: i, ...t }, e) => /* @__PURE__ */ s.jsx(Jn.Consumer, { children: (n) => {
  const o = f(wo.root, i, {
    [wo.rootIsLoading]: n?.status.loading
  });
  return /* @__PURE__ */ s.jsx(Dr.Provider, { value: { isTableHead: !0 }, children: /* @__PURE__ */ s.jsx(
    "thead",
    {
      ...t,
      ref: e,
      className: o,
      "data-testid": dt.Head
    }
  ) });
} }), Bd = Object.assign($(vo), { name: vo.name }), Le = (i) => {
  const t = Xt(Jn);
  if (!t)
    throw new Error(
      "TableContext not accessible. Make sure <TableContextReader> is a child of <Table>"
    );
  const e = Xt(Dr) || {
    isTableHead: !1
  }, n = Xt(Ir) || {
    isTableFoot: !1
  };
  return i.children({
    ...t,
    ...e,
    ...n
  });
}, Hd = "h-table-tableFooter--tableFooter__root", Wd = "h-table-tableFooter--tableFooter__rootIsLoading", So = {
  root: Hd,
  rootIsLoading: Wd
}, Io = ({ children: i, className: t, ...e }, n) => /* @__PURE__ */ s.jsx(Le, { children: ({ status: o }) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ref: n,
    className: f(
      {
        [So.rootIsLoading]: o.loading
      },
      So.root,
      t
    ),
    ...e,
    children: i
  }
) }), Us = Object.assign($(Io), {
  name: Io.name
});
function Md(i) {
  return Lt.toArray(i).reduce(
    (t, e) => {
      const n = e;
      return n.type === Us ? t.footers.push(n) : t.children.push(n), t;
    },
    { children: [], footers: [] }
  );
}
var Mn = /* @__PURE__ */ ((i) => (i.PageNumber = "page-number", i.PrevPageButton = "prev-page-button", i.NextPageButton = "next-page-button", i))(Mn || {});
const zd = "h-pagination--pageNumber__button", Vd = "h-pagination--pageNumber__text", Kd = "h-pagination--pageNumber__textSelected", ds = {
  button: zd,
  text: Vd,
  textSelected: Kd
}, Ud = ({
  number: i,
  isSelected: t = !1,
  onClick: e
}) => {
  const n = f(ds.text, {
    [ds.textSelected]: t
  });
  return /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
    Q,
    {
      styleText: !1,
      variant: "tertiary",
      onClick: () => e(i),
      "data-testid": Mn.PageNumber,
      className: ds.button,
      children: /* @__PURE__ */ s.jsx("span", { className: n, children: i })
    }
  ) });
}, qd = "h-pagination--pagination__root", Gd = "h-pagination--pagination__pageNumberSeparatorWrapper", Do = {
  root: qd,
  pageNumberSeparatorWrapper: Gd
};
class Yd extends ft {
  static defaultProps = {
    pageRangeDisplayed: 6
  };
  constructor(t) {
    super(t), this.handlePageSelect = this.handlePageSelect.bind(this), this.goToPrevPage = this.goToPrevPage.bind(this), this.goToNextPage = this.goToNextPage.bind(this);
  }
  arePropsValid() {
    const { currentPage: t, pageCount: e, pageRangeDisplayed: n } = this.props, o = (r) => !Number.isNaN(r) && Number.isInteger(r) && r > 0;
    return [t, e, n].every(
      o
    );
  }
  thereIsEnoughPagesToRender() {
    return this.props.pageCount > 1;
  }
  getBoundaries() {
    return {
      canGoToPrevPage: this.props.currentPage > 1,
      canGoToNextPage: this.props.currentPage < this.props.pageCount
    };
  }
  goToPrevPage() {
    this.getBoundaries().canGoToPrevPage && this.handlePageSelect(this.props.currentPage - 1);
  }
  goToNextPage() {
    this.getBoundaries().canGoToNextPage && this.handlePageSelect(this.props.currentPage + 1);
  }
  handlePageSelect(t) {
    const { currentPage: e, onPageChange: n } = this.props;
    t !== e && n(t);
  }
  areAllPagedDisplayable() {
    const { pageCount: t, pageRangeDisplayed: e } = this.props;
    return e >= t;
  }
  leadingTruncationIsNeeded() {
    const { start: e } = this.calculateMiddlePagesRange();
    return e - 1 > 1;
  }
  trailingTruncationIsNeeded() {
    const { pageCount: t } = this.props, { start: e, length: n } = this.calculateMiddlePagesRange(), o = e - 1 + n;
    return t - o > 1;
  }
  getMiddlePagesLength() {
    const { pageRangeDisplayed: t } = this.props;
    return t - 2;
  }
  calculateMiddlePagesRange(t) {
    const { pageCount: e, currentPage: n } = this.props, o = Math.max(
      this.getMiddlePagesLength() - (t?.extraPadding ?? 0),
      1
    ), r = o % 2 === 0 ? o / 2 - 1 : Math.floor(o / 2);
    return { start: An(
      n - r,
      2,
      e - o
    ), length: o };
  }
  createPageNumbers(t, e = 1) {
    return Array.from({ length: t }, (n, o) => o + e);
  }
  renderPageNumbers(t, e = 1) {
    return this.createPageNumbers(t, e).map(
      (n) => this.renderSinglePageNumber(n)
    );
  }
  renderSinglePageNumber(t) {
    const { currentPage: e } = this.props, n = t === e;
    return /* @__PURE__ */ s.jsx(
      Ud,
      {
        number: t,
        isSelected: n,
        onClick: this.handlePageSelect
      },
      t
    );
  }
  renderAllPages() {
    return this.renderPageNumbers(this.props.pageCount);
  }
  renderGap(t = 0) {
    return /* @__PURE__ */ s.jsx("li", { className: Do.pageNumberSeparatorWrapper, children: /* @__PURE__ */ s.jsx(N, { name: "dots-h" }) }, `gap-${t}`);
  }
  renderLeadingTruncation() {
    return this.leadingTruncationIsNeeded() ? [this.renderSinglePageNumber(1), this.renderGap()] : this.renderSinglePageNumber(1);
  }
  renderTrailingTruncation() {
    const { pageCount: t } = this.props;
    return this.trailingTruncationIsNeeded() ? [this.renderGap(), this.renderSinglePageNumber(t)] : this.renderSinglePageNumber(t);
  }
  renderMiddlePageNumbers() {
    if (this.leadingTruncationIsNeeded() && this.trailingTruncationIsNeeded()) {
      const { start: n, length: o } = this.calculateMiddlePagesRange({
        extraPadding: 1
      });
      return this.renderPageNumbers(o, n);
    }
    const { start: t, length: e } = this.calculateMiddlePagesRange();
    return this.renderPageNumbers(e, t);
  }
  renderPages() {
    return this.areAllPagedDisplayable() ? this.renderAllPages() : [
      this.renderLeadingTruncation(),
      this.renderMiddlePageNumbers(),
      this.renderTrailingTruncation()
    ];
  }
  warnAboutBadProps() {
    console.error("Pagination can not render due to bad props", this.props);
  }
  render() {
    const { className: t } = this.props;
    return this.thereIsEnoughPagesToRender() ? this.arePropsValid() ? /* @__PURE__ */ s.jsxs("ul", { className: f(Do.root, t), children: [
      /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
        K,
        {
          icon: "angle-left",
          variant: "tertiary",
          onClick: this.goToPrevPage,
          disabled: !this.getBoundaries().canGoToPrevPage,
          "data-testid": Mn.PrevPageButton
        }
      ) }),
      this.renderPages(),
      /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
        K,
        {
          icon: "angle-right",
          variant: "tertiary",
          onClick: this.goToNextPage,
          disabled: !this.getBoundaries().canGoToNextPage,
          "data-testid": Mn.NextPageButton
        }
      ) })
    ] }) : (this.warnAboutBadProps(), null) : null;
  }
}
const ko = ({ children: i, ...t }, e) => /* @__PURE__ */ s.jsx(Le, { children: ({ pagination: n }) => !n.paginated || n.pageCount <= 1 ? null : /* @__PURE__ */ s.jsx(Us, { children: /* @__PURE__ */ s.jsx("div", { ref: e, ...t, "data-testid": dt.PaginationRow, children: /* @__PURE__ */ s.jsx(H, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
  Yd,
  {
    currentPage: n.selectedPage,
    pageCount: n.pageCount,
    onPageChange: n.onPageChange,
    pageRangeDisplayed: n.pageRangeDisplayed
  }
) }) }) }) }), Xd = Object.assign($(ko), {
  name: ko.name
}), Qd = "h-table-tbody--tbody__root", Zd = "h-table-tbody--tbody__rootIsLoading", Jd = "h-table-tbody--tbody__rootIsLoadingFade", hs = {
  root: Qd,
  rootIsLoading: Zd,
  rootIsLoadingFade: Jd
}, th = "h-emptyState--emptyState__textWrapper", eh = "h-emptyState--emptyState__rootSmall", nh = "h-emptyState--emptyState__rootLarge", us = {
  textWrapper: th,
  rootSmall: eh,
  rootLarge: nh
}, sh = ({
  className: i,
  title: t,
  description: e,
  icon: n = "info",
  iconColor: o = "neutral.500",
  size: r = "large",
  buttonProps: a
}) => {
  const l = f(
    {
      [us.rootSmall]: r === "small",
      [us.rootLarge]: r === "large"
    },
    i
  );
  return /* @__PURE__ */ s.jsxs(
    H,
    {
      flexDirection: "column",
      alignItems: "center",
      gap: "300",
      className: l,
      children: [
        n && /* @__PURE__ */ s.jsx(N, { name: n, size: 20, color: sn(o) }),
        /* @__PURE__ */ s.jsxs(
          H,
          {
            flexDirection: "column",
            alignItems: "center",
            gap: "100",
            className: us.textWrapper,
            children: [
              /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "1", children: t }),
              /* @__PURE__ */ s.jsx(
                A.Paragraph,
                {
                  variant: "2",
                  as: typeof e == "string" ? "p" : "div",
                  children: e
                }
              )
            ]
          }
        ),
        a?.children && /* @__PURE__ */ s.jsx(Q, { ...a })
      ]
    }
  );
};
function oh(i) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": dt.EmptyRow, children: /* @__PURE__ */ s.jsx("td", { colSpan: 100, children: /* @__PURE__ */ s.jsx(H, { justifyContent: "center", alignItems: "center", padding: "500", children: /* @__PURE__ */ s.jsx(sh, { ...i }) }) }) });
}
function rh({
  onRetry: i,
  ...t
}) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": dt.LoadingFailedRow, ...t, children: /* @__PURE__ */ s.jsx("td", { colSpan: 100, children: /* @__PURE__ */ s.jsxs(
    H,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "500",
      children: [
        /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: "Something went wrong..." }),
        i && /* @__PURE__ */ s.jsx(Q, { variant: "tertiary", onClick: i, children: "Try again" })
      ]
    }
  ) }) });
}
function ih({
  ...i
}) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": dt.LoadingRow, ...i, children: /* @__PURE__ */ s.jsx("td", { align: "center", colSpan: 100, children: /* @__PURE__ */ s.jsxs(
    H,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "500",
      children: [
        /* @__PURE__ */ s.jsx(Gn, {}),
        /* @__PURE__ */ s.jsx(at, { margin: "300", children: /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: "Loading..." }) })
      ]
    }
  ) }) });
}
const To = ({ children: i, className: t, ...e }, n) => /* @__PURE__ */ s.jsx(Le, { children: ({
  status: { loading: o, loadingFailed: r, onLoadingRetry: a, emptyState: l },
  loading: { loadingStrategy: c }
}) => {
  const d = r && !o, h = ["spinner"].includes(c) ? !o && !d : !d;
  return /* @__PURE__ */ s.jsxs(
    "tbody",
    {
      ...e,
      "data-testid": dt.Body,
      ref: n,
      className: f(
        {
          [hs.rootIsLoading]: o,
          [hs.rootIsLoadingFade]: o && c === "fade"
        },
        hs.root,
        t
      ),
      children: [
        c === "spinner" && o && /* @__PURE__ */ s.jsx(ih, {}),
        d && /* @__PURE__ */ s.jsx(rh, { onRetry: a }),
        l && /* @__PURE__ */ s.jsx(oh, { ...l }),
        h && i
      ]
    }
  );
} }), ah = Object.assign($(To), { name: To.name }), lh = "h-table-td--td__root", ch = "h-table-td--td__rootExtraPaddingForFirstChild", dh = "h-table-td--td__rootStickyFooterTd", ps = {
  root: lh,
  rootExtraPaddingForFirstChild: ch,
  rootStickyFooterTd: dh
}, jo = ({ className: i, children: t, ...e }, n) => /* @__PURE__ */ s.jsx(Le, { children: ({ rows: o, presentation: r, isTableFoot: a }) => {
  const l = f(
    ps.root,
    {
      [ps.rootExtraPaddingForFirstChild]: !o.expandableRows,
      [ps.rootStickyFooterTd]: r.stickyFooter === !0 && a === !0
    },
    i
  );
  return /* @__PURE__ */ s.jsx(
    at,
    {
      as: "td",
      ref: n,
      className: l,
      ...e,
      "data-testid": dt.Td,
      children: t
    }
  );
} }), ie = Object.assign($(jo), { name: jo.name }), hh = "h-table-th--th__root", uh = "h-table-th--th__rootSticky", ph = "h-table-th--th__rootShowBG", mh = "h-table-th--th__rootClickable", gh = "h-table-th--th__icon", fh = "h-table-th--th__contentWrapper", bh = "h-table-th--th__tooltip", ee = {
  root: hh,
  rootSticky: uh,
  rootShowBG: ph,
  rootClickable: mh,
  icon: gh,
  contentWrapper: fh,
  tooltip: bh
};
class No extends D {
  context = void 0;
  columnIsInSortableColumns() {
    return this.context?.sorting.sortableColumns?.some(
      (t) => t === this.props.columnId
    ) ?? !0;
  }
  getContextualInfo() {
    const { columnId: t } = this.props, { context: e } = this;
    return {
      sortByThisColumn: e?.sorting.sortStatus?.sortBy === t,
      sortDirection: e?.sorting.sortStatus?.direction,
      columnIsSortable: e?.sorting.sortable && !_t(t) ? this.columnIsInSortableColumns() : !1
    };
  }
  getTheNewSortDirection(t) {
    const { sortByThisColumn: e, sortDirection: n } = this.getContextualInfo(), o = {
      sortBy: t,
      direction: "asc"
    };
    if (!e)
      return o;
    switch (n) {
      // not sorted => make it asc
      case void 0:
        return o;
      // desc sorted => not sorted
      case "desc":
        return null;
      // asc sorted => make it desc
      case "asc":
        return {
          sortBy: t,
          direction: "desc"
        };
      default:
        return o;
    }
  }
  getClickHandler() {
    const { onClick: t } = this.props, { context: e } = this;
    return (n) => {
      const { columnIsSortable: o } = this.getContextualInfo(), { columnId: r } = this.props;
      t?.(n), o && !_t(r) && e?.sorting.onSortChange(this.getTheNewSortDirection(r));
    };
  }
  renderIcon(t) {
    return t ? /* @__PURE__ */ s.jsx(
      N,
      {
        className: ee.icon,
        name: t === "asc" ? "sort-up" : "sort-down"
      }
    ) : null;
  }
  warnAboutNoColumnIdProps() {
    console.error(`
      <Table.Th> needs a 'columnId' prop when table is sortable.
      Pass 'columndId: null' prop if you want that column not to be sortable.
    `);
  }
  render() {
    return /* @__PURE__ */ s.jsx(Le, { children: (t) => {
      this.context = t;
      const { sorting: e, presentation: n } = t;
      e.sortable && this.props.columnId === void 0 && this.warnAboutNoColumnIdProps();
      const {
        className: o,
        children: r,
        tooltip: a,
        columnId: l,
        thRef: c,
        ...d
      } = this.props, { sortByThisColumn: h, columnIsSortable: u, sortDirection: p } = this.getContextualInfo(), m = f(
        ee.root,
        {
          [ee.rootClickable]: u,
          [ee.rootSticky]: n.stickyHeader,
          [ee.rootShowBG]: n.headerWithBackground
        },
        o
      ), g = f({
        [ee.tooltip]: a
      });
      return /* @__PURE__ */ s.jsx(
        at,
        {
          as: "th",
          ...d,
          ref: c,
          className: m,
          onClick: this.getClickHandler(),
          "data-testid": dt.Th,
          children: /* @__PURE__ */ s.jsxs("span", { className: ee.contentWrapper, children: [
            /* @__PURE__ */ s.jsx(st, { content: a, disabled: !a, children: /* @__PURE__ */ s.jsx("span", { className: g, children: r }) }),
            h && this.renderIcon(p)
          ] })
        }
      );
    } });
  }
}
const Ps = Object.assign(
  $(
    function(t, e) {
      return /* @__PURE__ */ s.jsx(No, { ...t, thRef: e });
    }
  ),
  { name: No.name }
), xh = (i) => i === !1, yh = "h-table-tr--tr__trHoverable", _h = "h-table-tr--tr__expansionTriggerWrapper", Ch = "h-table-tr--tr__expansionTriggerWrapperExpanded", wh = "h-table-tr--tr__checkboxCell", vh = "h-table-tr--tr__checkboxCellExpanded", Sh = "h-table-tr--tr__expandedRowContentWrapper", St = {
  trHoverable: yh,
  expansionTriggerWrapper: _h,
  expansionTriggerWrapperExpanded: Ch,
  checkboxCell: wh,
  checkboxCellExpanded: vh,
  expandedRowContentWrapper: Sh
}, Ih = ({
  rowId: i,
  isExpandable: t,
  isExpanded: e,
  onExpansionToggle: n,
  expandableContent: o,
  isSelectable: r,
  isSelected: a,
  onSelect: l,
  isHoverable: c,
  children: d,
  trRef: h,
  ...u
}) => {
  const p = f(u.className, {
    [St.trHoverable]: c
  }) || void 0;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(
      "tr",
      {
        ...u,
        ref: h,
        className: p,
        "data-testid": dt.Row,
        children: [
          t && /* @__PURE__ */ s.jsx(
            ie,
            {
              className: f(St.expansionTriggerWrapper, {
                [St.expansionTriggerWrapperExpanded]: e
              }),
              children: o && /* @__PURE__ */ s.jsx(
                K,
                {
                  variant: "tertiary",
                  icon: e ? "angle-down" : "angle-right",
                  "data-testid": dt.RowExpansionTrigger,
                  onClick: () => {
                    _t(i) || n(i);
                  }
                }
              )
            }
          ),
          r && /* @__PURE__ */ s.jsx(
            ie,
            {
              className: f(St.checkboxCell, {
                [St.checkboxCellExpanded]: e
              }),
              children: /* @__PURE__ */ s.jsx(H, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
                un,
                {
                  checked: a,
                  name: `selection-trigger-${i}`,
                  id: `selection-trigger-${i}`,
                  onChange: () => {
                    _t(i) || l(i);
                  }
                }
              ) })
            }
          ),
          d
        ]
      }
    ),
    t && e && /* @__PURE__ */ s.jsxs("tr", { "data-testid": dt.Row, children: [
      /* @__PURE__ */ s.jsx(ie, { className: St.expansionTriggerWrapper }),
      r && /* @__PURE__ */ s.jsx(ie, { className: St.checkboxCell }),
      /* @__PURE__ */ s.jsx(
        ie,
        {
          colSpan: Number.MAX_SAFE_INTEGER,
          className: St.expandedRowContentWrapper,
          children: o
        }
      )
    ] })
  ] });
}, Dh = ({
  isExpandable: i,
  children: t,
  trRef: e,
  ...n
}) => /* @__PURE__ */ s.jsxs("tr", { ...n, ref: e, "data-testid": dt.Row, children: [
  i && /* @__PURE__ */ s.jsx(ie, { className: St.expansionTriggerWrapper, children: /* @__PURE__ */ s.jsx("span", {}) }),
  t
] }), kh = ({
  isExpandable: i,
  isSelectable: t,
  allRowsSelected: e,
  allRowsSelectedIndeterminate: n,
  onAllRowsSelect: o,
  children: r,
  trRef: a,
  ...l
}) => /* @__PURE__ */ s.jsxs("tr", { ...l, ref: a, "data-testid": dt.Row, children: [
  i && /* @__PURE__ */ s.jsx(Ps, { className: St.expansionTriggerWrapper, columnId: null, children: /* @__PURE__ */ s.jsx("span", {}) }),
  t && /* @__PURE__ */ s.jsx(Ps, { className: St.checkboxCell, columnId: null, children: /* @__PURE__ */ s.jsx(H, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
    un,
    {
      checked: e,
      indeterminate: n,
      onChange: o,
      name: "all-rows-selector",
      id: "all-rows-selector"
    }
  ) }) }),
  r
] });
class Fo extends D {
  context = void 0;
  isRowExpanded(t, e) {
    return t.includes(e);
  }
  hasSelectableRow() {
    const { rowId: t } = this.props;
    return this.context?.rows.selectableRows === !0 && !_t(t);
  }
  hasExpandableRow() {
    const { expandableContent: t, rowId: e } = this.props;
    return this.context?.rows.expandableRows === !0 && !_t(t) && !_t(e);
  }
  shouldRenderRegularTr() {
    return [this.hasExpandableRow(), this.hasSelectableRow()].every(xh);
  }
  rowIdIsPresent(t) {
    return !_t(t);
  }
  render() {
    const { children: t, expandableContent: e, rowId: n, ...o } = this.props;
    return /* @__PURE__ */ s.jsx(Le, { children: (r) => {
      this.context = r;
      const { rows: a } = r;
      if (r.isTableHead)
        return /* @__PURE__ */ s.jsx(
          kh,
          {
            ...o,
            isExpandable: a.expandableRows,
            isSelectable: a.selectableRows,
            allRowsSelected: a.allRowsSelected,
            allRowsSelectedIndeterminate: a.allRowsSelectedIndeterminate,
            onAllRowsSelect: a.onAllRowsSelect,
            children: t
          }
        );
      if (r.isTableFoot)
        return /* @__PURE__ */ s.jsx(Dh, { ...o, isExpandable: a.expandableRows, children: t });
      const l = _t(n) ? !1 : this.isRowExpanded(a.expandedRows, n), c = _t(n) ? !1 : a.selectedRowIds.includes(n);
      return /* @__PURE__ */ s.jsx(
        Ih,
        {
          ...o,
          rowId: n,
          isExpanded: l,
          isSelected: c,
          onSelect: a.onRowSelect,
          isExpandable: a.expandableRows,
          expandableContent: e,
          isSelectable: a.selectableRows,
          onExpansionToggle: a.onExpansionToggle,
          isHoverable: r.presentation.hoverable,
          children: t
        }
      );
    } });
  }
}
const Th = Object.assign(
  $(function(t, e) {
    return /* @__PURE__ */ s.jsx(Fo, { ...t, trRef: e });
  }),
  { name: Fo.name }
), jh = "h-table--table__wrapper", Nh = "h-table--table__wrapperIsFramed", Fh = "h-table--table__wrapperIsLoading", Ph = "h-table--table__innerWrapper", Rh = "h-table--table__wrapperIsDisabled", Eh = "h-table--table__table", ge = {
  wrapper: jh,
  wrapperIsFramed: Nh,
  wrapperIsLoading: Fh,
  innerWrapper: Ph,
  wrapperIsDisabled: Rh,
  table: Eh
};
class zn extends D {
  static defaultProps = {
    headerWithBackground: !0,
    stickyHeader: !1,
    stickyFooter: !1,
    framed: !0,
    hoverable: !1,
    loadingStrategy: "spinner"
  };
  constructor(t) {
    super(t), this.state = {
      expandedRows: t.expandableRowsProps?.initiallyExpandedRows ?? []
    }, this.handleExpansionToggle = this.handleExpansionToggle.bind(this);
  }
  static fallback = /* @__PURE__ */ s.jsx(
    H,
    {
      justifyContent: "center",
      alignItems: "center",
      style: { minHeight: "10vh" },
      children: /* @__PURE__ */ s.jsx(A.Paragraph, { children: "Oops! something went wrong..." })
    }
  );
  handleExpansionToggle(t) {
    this.state.expandedRows.includes(t) ? this.setState(({ expandedRows: e }) => ({
      expandedRows: e.filter((n) => n !== t)
    })) : this.setState(({ expandedRows: e }) => ({
      expandedRows: [...e, t]
    }));
  }
  getContextValue() {
    const {
      props: {
        headerWithBackground: t,
        stickyHeader: e,
        stickyFooter: n,
        sortingProps: o,
        paginationProps: r,
        selectableRowsProps: a,
        expandableRowsProps: l,
        loading: c,
        loadingFailed: d,
        onLoadingRetry: h,
        emptyState: u,
        loadingStrategy: p,
        hoverable: m
      }
    } = this;
    return {
      status: {
        loading: c ?? !1,
        loadingFailed: d ?? !1,
        onLoadingRetry: h,
        emptyState: u
      },
      presentation: {
        headerWithBackground: !!t,
        stickyHeader: !!e,
        stickyFooter: !!n,
        hoverable: !!m
      },
      sorting: {
        sortable: !!o,
        sortableColumns: o?.sortableColumns,
        sortStatus: o?.sortStatus ?? null,
        onSortChange: o?.onSortChange ?? E
      },
      pagination: {
        paginated: !!r,
        selectedPage: r?.selectedPage ?? 1,
        pageCount: r?.pageCount ?? 1,
        onPageChange: r?.onPageChange ?? E,
        pageRangeDisplayed: r?.pageRangeDisplayed
      },
      rows: {
        expandableRows: l?.expandableRows ?? !1,
        expandedRows: this.state.expandedRows,
        onExpansionToggle: this.handleExpansionToggle,
        selectableRows: !!a,
        selectedRowIds: a?.selectedRowIds ?? [],
        onRowSelect: a?.onRowSelect ?? E,
        onAllRowsSelect: a?.onAllRowsSelect ?? E,
        allRowsSelected: a?.allRowsSelected ?? !1,
        allRowsSelectedIndeterminate: a?.allRowsSelectedIndeterminate ?? !1
      },
      loading: {
        loadingStrategy: p ?? "spinner"
      }
    };
  }
  render() {
    const {
      framed: t,
      className: e,
      children: n,
      wrapperProps: o,
      wrapperRef: r,
      innerWrapperClassName: a,
      nativeProps: l,
      tableRef: c
    } = this.props, d = Md(n), h = f(ge.wrapper, o?.className, {
      [ge.wrapperIsFramed]: t,
      [ge.wrapperIsLoading]: this.props.loading,
      [ge.wrapperIsDisabled]: this.props.loading && this.props.loadingStrategy && ["fade", "disabled"].includes(this.props.loadingStrategy)
    }), u = f(
      {
        [ge.innerWrapper]: !0
      },
      a
    ), p = f(ge.table, e), m = this.getContextValue();
    return /* @__PURE__ */ s.jsx(Re, { fallback: zn.fallback, children: /* @__PURE__ */ s.jsx(Jn.Provider, { value: m, children: /* @__PURE__ */ s.jsxs("div", { ...o, className: h, children: [
      /* @__PURE__ */ s.jsx("div", { className: u, ref: r, children: /* @__PURE__ */ s.jsx("table", { ...l, ref: c, className: p, children: d.children }) }),
      m.pagination.paginated && /* @__PURE__ */ s.jsx(Xd, {}),
      !m.pagination.paginated && d.footers
    ] }) }) });
  }
}
const gt = Object.assign(
  $(
    function(t, e) {
      return /* @__PURE__ */ s.jsx(zn, { ...t, tableRef: e });
    }
  ),
  {
    name: zn.name,
    Thead: Bd,
    Tbody: ah,
    Tfoot: Ad,
    Tr: Th,
    Th: Ps,
    Td: ie,
    Footer: Us
  }
), Lh = "h-helpIcon--helpIcon__infoIcon", Ah = {
  infoIcon: Lh
};
class qs extends D {
  render() {
    const {
      side: t,
      text: e,
      title: n,
      disabled: o,
      requireClick: r,
      className: a,
      alwaysShow: l,
      tooltipClassName: c,
      ...d
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      st,
      {
        head: n,
        content: e,
        disabled: o,
        side: t,
        requireClick: r,
        alwaysShow: l,
        className: c,
        wrap: "none",
        ...d,
        children: /* @__PURE__ */ s.jsx("span", { className: f(Ah.infoIcon, a), children: /* @__PURE__ */ s.jsx(N, { name: "info" }) })
      }
    );
  }
}
const kr = ({
  columns: i
}) => /* @__PURE__ */ s.jsx(s.Fragment, { children: i.map(({ label: t, style: e, helpIcon: n, columnId: o }, r) => /* @__PURE__ */ s.jsxs(gt.Th, { columnId: o || t, style: e, children: [
  t,
  n?.title && n?.text && /* @__PURE__ */ s.jsx(qs, { side: "bottom", ...n })
] }, t || r)) }), $h = ({
  columns: i,
  data: t
}) => /* @__PURE__ */ s.jsxs(gt, { headerWithBackground: !1, framed: !1, children: [
  /* @__PURE__ */ s.jsx(gt.Thead, { children: /* @__PURE__ */ s.jsx(gt.Tr, { children: /* @__PURE__ */ s.jsx(kr, { columns: i }) }) }),
  /* @__PURE__ */ s.jsx(gt.Tbody, { children: t.map((e, n) => /* @__PURE__ */ s.jsx(gt.Tr, { children: i.map(({ selector: o }, r) => /* @__PURE__ */ s.jsx(gt.Td, { children: o(e) }, r)) }, n)) })
] }), Oh = ({
  data: i,
  rowId: t,
  columns: e,
  subTableColumns: n,
  subTableDataSelector: o
}) => /* @__PURE__ */ s.jsx(
  gt.Tr,
  {
    expandableContent: !!(n && o) && /* @__PURE__ */ s.jsx(
      $h,
      {
        data: o(i),
        columns: n
      }
    ),
    rowId: t,
    children: e.map(({ selector: r }, a) => /* @__PURE__ */ s.jsx(gt.Td, { children: r(i) }, a))
  }
), $k = ({
  columns: i,
  subTableColumns: t,
  data: e,
  subTableDataSelector: n,
  tableWrapperProps: o,
  tableInnerWrapperClassName: r,
  paginationProps: a,
  sortingProps: l,
  selectableRowsProps: c,
  tableStyleProps: d,
  tableStatusProps: h,
  tableRowIdSelector: u,
  tableLoadingStrategy: p,
  tableWrapperRef: m
}) => {
  const g = i.filter((b) => b.sortable).reduce(
    (b, x) => x.columnId ? [...b, x.columnId] : b,
    []
  );
  return g.length && l && (l.sortableColumns = g), /* @__PURE__ */ s.jsxs(
    gt,
    {
      stickyHeader: !0,
      wrapperProps: o,
      innerWrapperClassName: r,
      expandableRowsProps: {
        expandableRows: !!(t && n)
      },
      sortingProps: l,
      selectableRowsProps: c,
      loadingStrategy: p,
      wrapperRef: m,
      ...d,
      ...h,
      children: [
        /* @__PURE__ */ s.jsx(gt.Thead, { children: /* @__PURE__ */ s.jsx(gt.Tr, { children: /* @__PURE__ */ s.jsx(kr, { columns: i }) }) }),
        /* @__PURE__ */ s.jsx(gt.Tbody, { children: e.map((b, x) => /* @__PURE__ */ s.jsx(
          Oh,
          {
            rowId: u ? u(b) : x,
            data: b,
            columns: i,
            subTableDataSelector: n,
            subTableColumns: t
          },
          x
        )) }),
        a && /* @__PURE__ */ s.jsx(gt.Footer, { children: /* @__PURE__ */ s.jsx(Rd, { ...a }) })
      ]
    }
  );
}, Bh = "h-datePickerOld--datePickerDay__root", Hh = "h-datePickerOld--datePickerDay__rootActive", Wh = "h-datePickerOld--datePickerDay__rootDisabled", Mh = "h-datePickerOld--datePickerDay__rootDim", zh = "h-datePickerOld--datePickerDay__label", We = {
  root: Bh,
  rootActive: Hh,
  rootDisabled: Wh,
  rootDim: Mh,
  label: zh
};
class Vh extends D {
  render() {
    const {
      className: t,
      dim: e,
      active: n,
      disabled: o,
      children: r,
      onClick: a,
      ...l
    } = this.props, c = f(
      {
        [We.root]: !0,
        [We.rootDim]: e,
        [We.rootActive]: n,
        [We.rootDisabled]: !n && o
      },
      t
    );
    return /* @__PURE__ */ s.jsx(
      "button",
      {
        ...l,
        onClick: a,
        className: c,
        disabled: o,
        children: /* @__PURE__ */ s.jsx("span", { className: We.label, children: r })
      }
    );
  }
}
const Kh = "h-datePickerOld--datePickerOld__grid", Uh = "h-datePickerOld--datePickerOld__gridItem", qh = "h-datePickerOld--datePickerOld__day", Gh = "h-datePickerOld--datePickerOld__month", Yh = "h-datePickerOld--datePickerOld__timeButtonContainerLeft", Xh = "h-datePickerOld--datePickerOld__timeButtonContainerRight", Qh = "h-datePickerOld--datePickerOld__arrowTime", Zh = "h-datePickerOld--datePickerOld__arrow", Jh = "h-datePickerOld--datePickerOld__dayNames", tu = "h-datePickerOld--datePickerOld__dayName", eu = "h-datePickerOld--datePickerOld__time", nu = "h-datePickerOld--datePickerOld__timeDisplay", X = {
  grid: Kh,
  gridItem: Uh,
  day: qh,
  month: Gh,
  timeButtonContainerLeft: Yh,
  timeButtonContainerRight: Xh,
  arrowTime: Qh,
  arrow: Zh,
  dayNames: Jh,
  dayName: tu,
  time: eu,
  timeDisplay: nu
}, Ok = (i) => [0, 6].indexOf(i.getDay()) !== -1;
class en extends D {
  static defaultProps;
  static getDateValue(t) {
    const e = t.value instanceof Date ? t.value : /* @__PURE__ */ new Date();
    return new Date(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes()
    );
  }
  constructor(t) {
    super(t);
    const e = en.getDateValue(t.input);
    this.state = {
      selectedDate: e,
      showDate: e
    };
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(t) {
    const { input: e } = this.props;
    t.input !== e && this.setState({
      selectedDate: en.getDateValue(t.input)
    });
  }
  generateGrid() {
    const { selectedDate: t, showDate: e } = this.state, { input: n, disabled: o, minDate: r, maxDate: a } = this.props, l = [], c = new Date(
      e.getFullYear(),
      e.getMonth(),
      1,
      t.getHours(),
      t.getMinutes()
    ), d = c.getDay() || 7, h = new Date(
      c.getFullYear(),
      c.getMonth() + 1,
      1
    );
    d < 3 && c.setDate(c.getDate() - 7), c.setDate(c.getDate() - (d - 1));
    const u = en.getDateValue(n).getTime();
    let p = 0;
    for (; c < h || c.getDay() !== 1 || p < 6; ) {
      const m = c.getTime(), g = new Date(m);
      l.push({
        date: g,
        label: c.getDate().toString(),
        isThisMonth: c.getMonth() === e.getMonth(),
        selected: m === u,
        disabled: o(c) || !!(a && g > a) || !!(r && g < r)
      }), c.getDay() === 1 && (p += 1), c.setDate(c.getDate() + 1);
    }
    return l;
  }
  goToMonth(t) {
    const { showDate: e } = this.state, n = new Date(e.getTime());
    n.setMonth(e.getMonth() + t), this.setState({
      showDate: n
    });
  }
  nextMonth = (t) => {
    t.preventDefault(), this.goToMonth(1);
  };
  prevMonth = (t) => {
    t.preventDefault(), this.goToMonth(-1);
  };
  handleDateClick(t, e) {
    t.preventDefault();
    const {
      input: { onChange: n }
    } = this.props, { showDate: o } = this.state, r = {
      ...this.state,
      selectedDate: e
    };
    o.getMonth() !== e.getMonth() && (r.showDate = e), this.setState(r), n(e);
  }
  goToTime(t, e, n = "hours") {
    const o = n === "minutes" ? "setMinutes" : "setHours", r = n === "minutes" ? "getMinutes" : "getHours", {
      input: { onChange: a }
    } = this.props, { selectedDate: l } = this.state, c = new Date(l.getTime());
    c[o](c[r]() + e), this.setState({
      selectedDate: c
    }), a(c);
  }
  nextMinutes = (t) => {
    t.preventDefault(), this.goToTime(t, 15, "minutes");
  };
  prevMinutes = (t) => {
    t.preventDefault(), this.goToTime(t, -15, "minutes");
  };
  nextHour = (t) => {
    t.preventDefault(), this.goToTime(t, 1);
  };
  prevHour = (t) => {
    t.preventDefault(), this.goToTime(t, -1);
  };
  canGoPrevMonth() {
    const { minDate: t } = this.props, { showDate: e } = this.state;
    if (t === null) return !0;
    const n = new Date(
      e.getFullYear(),
      e.getMonth(),
      1
    );
    return t < n;
  }
  canGoNextMonth() {
    const { maxDate: t } = this.props, { showDate: e } = this.state;
    if (t === null) return !0;
    const n = new Date(
      e.getFullYear(),
      e.getMonth() + 1,
      1,
      0,
      0,
      0,
      -1
    );
    return t > n;
  }
  canGoDirection(t = "hours", e) {
    const n = t === "minutes" ? "setMinutes" : "setHours", o = t === "minutes" ? "getMinutes" : "getHours", { maxDate: r } = this.props, { selectedDate: a } = this.state, l = new Date(a.getTime());
    return l[n](l[o]() + e), !(l.getDate() !== a.getDate()) && (r === null || r >= l);
  }
  render() {
    const {
      className: t,
      input: e,
      hasTime: n,
      disabled: o,
      minDate: r,
      maxDate: a,
      ...l
    } = this.props, { selectedDate: c, showDate: d } = this.state, h = f({}, t), u = this.generateGrid(), p = {
      month: "long",
      year: "numeric"
    };
    let m = null;
    try {
      m = d.toLocaleDateString("en-US", p);
    } catch (g) {
      m = `${d.getMonth() + 1} / ${d.getFullYear()}`, console.warn("toLocaleDateString exception", g);
    }
    return /* @__PURE__ */ s.jsxs("div", { ...l, className: h, children: [
      /* @__PURE__ */ s.jsxs("div", { className: X.month, children: [
        /* @__PURE__ */ s.jsx(
          "button",
          {
            className: X.arrow,
            disabled: !this.canGoPrevMonth(),
            onClick: this.prevMonth,
            "aria-label": "Previous month",
            children: /* @__PURE__ */ s.jsx(N, { name: "angle-left", className: "icon-vertical-fix" })
          }
        ),
        m,
        /* @__PURE__ */ s.jsx(
          "button",
          {
            className: X.arrow,
            disabled: !this.canGoNextMonth(),
            onClick: this.nextMonth,
            "aria-label": "Next month",
            children: /* @__PURE__ */ s.jsx(N, { name: "angle-right", className: "icon-vertical-fix" })
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: X.dayNames, children: [
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Mon" }),
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Tue" }),
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Wed" }),
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Thu" }),
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Fri" }),
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Sat" }),
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Sun" })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: X.grid, children: u.map((g) => /* @__PURE__ */ s.jsx("div", { className: X.gridItem, children: /* @__PURE__ */ s.jsx(
        Vh,
        {
          onClick: (b) => this.handleDateClick(b, g.date),
          dim: !g.isThisMonth,
          active: g.selected,
          disabled: g.disabled,
          className: X.day,
          children: g.label
        }
      ) }, g.date.getTime())) }),
      n && /* @__PURE__ */ s.jsxs("div", { className: X.time, children: [
        /* @__PURE__ */ s.jsxs("div", { className: X.timeButtonContainerLeft, children: [
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: X.arrowTime,
              disabled: !this.canGoDirection("hours", -1),
              onClick: this.prevHour,
              "aria-label": "Previous hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-double-left", className: "icon-vertical-fix" })
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: X.arrowTime,
              disabled: !this.canGoDirection("minutes", -15),
              onClick: this.prevMinutes,
              "aria-label": "Previous hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-left", className: "icon-vertical-fix" })
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: X.timeDisplay, children: `${lo(
          c.getHours().toString(),
          2,
          "0"
        )}:${lo(c.getMinutes().toString(), 2, "0")}` }),
        /* @__PURE__ */ s.jsxs("div", { className: X.timeButtonContainerRight, children: [
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: X.arrowTime,
              disabled: !this.canGoDirection("minutes", 15),
              onClick: this.nextMinutes,
              "aria-label": "Next hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-right", className: "icon-vertical-fix" })
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: X.arrowTime,
              disabled: !this.canGoDirection("hours", 1),
              onClick: this.nextHour,
              "aria-label": "Next hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-double-right", className: "icon-vertical-fix" })
            }
          )
        ] })
      ] })
    ] });
  }
}
en.defaultProps = {
  /* eslint-disable react/default-props-match-prop-types */
  disabled: () => !1,
  minDate: null,
  maxDate: null,
  hasTime: !1
};
function su(i) {
  return Math.abs(i.diff(j())) < 25e3 ? "just now" : i.fromNow();
}
function Rs(i) {
  return j(i, j.ISO_8601).isValid();
}
function Te(i) {
  return !!j.tz.zone(i ?? "");
}
const Rt = "HH:mm", Tr = fr(24), jr = fr(0, 60, 15), Nr = (i) => j("1995-12-25").format(i);
function Fr(i) {
  if (i < 0 || i > 23)
    throw new Error("Hour must be between 0 and 23.");
}
function Pr(i) {
  if (i < 0 || i > 59)
    throw new Error("Minute must be between 0 and 59.");
}
function Rr({
  hour: i,
  minute: t,
  timeFormat: e
}) {
  const n = j({ hour: i, minute: t });
  return {
    id: n.format(Rt),
    name: n.format(e)
  };
}
function ou(i, t) {
  return t?.map(({ hour: e, minute: n }) => (Fr(e), Pr(n), Rr({ hour: e, minute: n, timeFormat: i }))) || [];
}
function Er({
  hours: i,
  minutes: t,
  overrides: e,
  timeFormat: n
}) {
  return Si(
    i.reduce(
      (o, r, a) => [
        ...o,
        ...t.map((l, c) => (c === 0 && Fr(r), a === 0 && Pr(l), Rr({ hour: r, minute: l, timeFormat: n })))
      ],
      []
    ).concat(ou(n, e)),
    ["id"]
  );
}
const ru = "h-datePicker--datePicker__root", iu = "h-datePicker--datePicker__navigationButton", au = "h-datePicker--datePicker__nextMonthButton", lu = "h-datePicker--datePicker__prevMonthButton", ke = {
  root: ru,
  navigationButton: iu,
  nextMonthButton: au,
  prevMonthButton: lu
}, Vn = {
  previousMonth({ ariaLabel: i, ...t }) {
    const e = f(
      ke.navigationButton,
      ke.prevMonthButton
    );
    return /* @__PURE__ */ s.jsx("div", { className: e, children: /* @__PURE__ */ s.jsx(N, { ...t, "aria-label": i, size: 24, name: "angle-left" }) });
  },
  nextMonth({ ariaLabel: i, ...t }) {
    const e = f(
      ke.navigationButton,
      ke.nextMonthButton
    );
    return /* @__PURE__ */ s.jsx("div", { className: e, children: /* @__PURE__ */ s.jsx(N, { ...t, "aria-label": i, size: 24, name: "angle-right" }) });
  }
}, Lr = (i) => /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
  /* @__PURE__ */ s.jsx("span", { className: "date-number-container", children: i.date() }),
  /* @__PURE__ */ s.jsx("span", { className: "day-complimentary-highlight" })
] }), Ar = ({ month: i }) => /* @__PURE__ */ s.jsx("span", { children: i.format("MMMM YYYY") }), $r = (i) => {
  const { value: t, presets: e, onSelect: n } = i, o = F(
    (r) => {
      n(r.key === t ? null : r);
    },
    [n, t]
  );
  return /* @__PURE__ */ s.jsxs(Wt, { children: [
    /* @__PURE__ */ s.jsx(Yn, { orientation: "vertical" }),
    /* @__PURE__ */ s.jsx(mo, { children: e.map((r) => /* @__PURE__ */ s.jsx(
      mo.Item,
      {
        isSelected: r.key === t,
        onClick: () => o(r),
        children: r.label
      },
      r.key
    )) })
  ] });
}, cu = "h-fieldLabel--fieldLabel__root", du = "h-fieldLabel--fieldLabel__label", hu = "h-fieldLabel--fieldLabel__labelChildren", uu = "h-fieldLabel--fieldLabel__rootRequired", pu = "h-fieldLabel--fieldLabel__helpIcon", Me = {
  root: cu,
  label: du,
  labelChildren: hu,
  rootRequired: uu,
  helpIcon: pu
}, mu = "fieldLabel";
class Gs extends D {
  render() {
    const { required: t, helpIcon: e, className: n, children: o, ...r } = this.props, a = f(Me.root, n, {
      [Me.rootRequired]: t
    });
    return /* @__PURE__ */ s.jsxs("div", { className: a, "data-testid": mu, children: [
      /* @__PURE__ */ s.jsx("label", { className: Me.label, ...r, children: /* @__PURE__ */ s.jsx("div", { className: Me.labelChildren, children: o }) }),
      !!e?.text && /* @__PURE__ */ s.jsx(
        qs,
        {
          ...e,
          className: f(Me.helpIcon, e.className)
        }
      )
    ] });
  }
}
const gu = "h-dropdownSelect--dropdownInfinite__item", fu = "h-dropdownSelect--dropdownInfinite__list", bu = "h-dropdownSelect--dropdownInfinite__listEmpty", ms = {
  item: gu,
  list: fu,
  listEmpty: bu
};
class Po extends D {
  render() {
    const {
      item: t,
      itemComponent: e,
      tooltip: n,
      onSelect: o,
      onChange: r,
      onKeyDown: a,
      clearSearch: l,
      checked: c,
      disabled: d,
      isLoading: h,
      active: u,
      id: p
    } = this.props, m = /* @__PURE__ */ s.jsx(
      e,
      {
        item: t,
        onSelect: o,
        onChange: r,
        onKeyDown: a,
        clearSearch: l,
        checked: c,
        disabled: d,
        isLoading: h,
        active: u,
        tabIndex: u ? 0 : -1,
        id: p,
        role: "option",
        "aria-disabled": d,
        "aria-selected": c
      }
    );
    return n ? /* @__PURE__ */ s.jsx(st, { ...n, children: m }, t.id) : m;
  }
}
const xu = 6, yu = 48;
class Ys extends D {
  listRef;
  infiniteListRef;
  static defaultProps = {
    selectedItems: [],
    disabledItems: [],
    tooltipItems: {},
    activeItem: null
  };
  constructor(t) {
    super(t), this.isItemLoaded = this.isItemLoaded.bind(this), this.listRef = B(), this.infiniteListRef = B();
  }
  componentDidUpdate(t) {
    const { activeItem: e, items: n, pagination: o } = this.props, r = typeof t.activeItem == "object" && t.activeItem ? t.activeItem.id : t.activeItem, a = typeof e == "object" && e ? e.id : e;
    if (r !== a && a !== null) {
      const l = n.findIndex(
        (c) => c.id === a
      );
      if (l >= 0) {
        if (typeof o == "object" && o.infinite && this.infiniteListRef.current)
          this.infiniteListRef.current.scrollToItem(l, "smart");
        else if (this.listRef.current) {
          const c = this.listRef.current.children[l];
          c && c.scrollIntoView({ block: "nearest" });
        }
      }
    }
  }
  isItemLoaded(t) {
    const { items: e } = this.props;
    return t < e.length;
  }
  isItemActive(t) {
    if (!t) return !1;
    const { activeItem: e } = this.props;
    return e ? typeof e == "object" && "id" in e ? t.id === e.id : t.id === e : !1;
  }
  isItemChecked(t) {
    if (!t) return !1;
    const { selectedItems: e } = this.props;
    return (e?.findIndex((o) => typeof o == "object" ? o.id === t.id : o === t.id) ?? -1) > -1;
  }
  isItemDisabled(t) {
    return t ? (this.props.disabledItems?.indexOf(t.id) ?? -1) >= 0 : !0;
  }
  getTooltip(t) {
    const { tooltipItems: e } = this.props;
    return !t || Ms(e?.[t.id]) ? null : e?.[t.id] ?? null;
  }
  goToTop() {
    this.infiniteListRef.current && this.infiniteListRef.current.scrollToItem(0), this.listRef.current && (this.listRef.current.scrollTop = 0);
  }
  focusActiveItem() {
    const { items: t, activeItem: e } = this.props;
    if (!e || !this.listRef.current) return;
    const n = typeof e == "object" && "id" in e ? e.id : e, o = t.findIndex((r) => r.id === n);
    if (o >= 0 && this.listRef.current.children[o]) {
      const r = this.listRef.current.children[o];
      (r.querySelector('[tabindex="0"]') || r)?.focus();
    }
  }
  getItemId(t) {
    const { id: e } = this.props;
    return e ? `${e}-option-${t}` : void 0;
  }
  /**
   * This attribute is supposed to be a React component. The FixedSizeList
   * component expects a component is a child.
   *
   * @see https://react-window.vercel.app/#/examples/list/fixed-size
   */
  ListItem = ({
    index: t,
    style: e
  }) => {
    const { items: n, itemComponent: o, onSelect: r, onChange: a, clearSearch: l } = this.props, c = this.isItemLoaded(t), d = t === n.length - 1, h = c ? n[t] : { id: rn(), name: "Loading..." }, u = this.props.pagination ? this.props.pagination.nextEnable : !1;
    return /* @__PURE__ */ s.jsxs("div", { style: e, className: ms.item, children: [
      /* @__PURE__ */ s.jsx(
        Po,
        {
          id: this.getItemId(t),
          checked: this.isItemChecked(h),
          clearSearch: l,
          disabled: this.isItemDisabled(h),
          isLoading: !c,
          item: h,
          itemComponent: o,
          onChange: a,
          onSelect: r,
          tooltip: this.getTooltip(h),
          active: this.isItemActive(h)
        }
      ),
      d && u && c && /* @__PURE__ */ s.jsx(Ii, { onEnter: this.loadMoreItems })
    ] });
  };
  loadMoreItems = async () => {
    this.props.pagination && await this.props.pagination.onNext?.();
  };
  render() {
    const {
      items: t,
      pagination: e,
      itemComponent: n,
      onSelect: o,
      onChange: r,
      onKeyDown: a,
      clearSearch: l,
      itemsDisplayCount: c = xu,
      itemHeight: d = yu,
      id: h,
      ariaLabelledby: u
    } = this.props;
    if (!e || !e.infinite || !e.onNext)
      return /* @__PURE__ */ s.jsx(
        "div",
        {
          style: { maxHeight: `${c * d}px` },
          className: f({
            [ms.list]: !0,
            [ms.listEmpty]: t.length === 0
          }),
          ref: this.listRef,
          role: "listbox",
          id: h,
          "aria-labelledby": u,
          children: t.map((C, _) => {
            const w = Di(C) ? C : C.id.toString() || C.name.toString() || C.toString();
            return /* @__PURE__ */ s.jsx(
              Po,
              {
                id: this.getItemId(_),
                checked: this.isItemChecked(C),
                clearSearch: l,
                disabled: this.isItemDisabled(C),
                item: C,
                itemComponent: n,
                onChange: r,
                onSelect: o,
                onKeyDown: a,
                tooltip: this.getTooltip(C),
                active: this.isItemActive(C)
              },
              w
            );
          })
        }
      );
    const { nextEnable: p, itemCount: m } = e, g = m || (p ? t.length + c : t.length), b = {
      items: t,
      selectedItems: this.props.selectedItems,
      disabledItems: this.props.disabledItems,
      tooltipItems: this.props.tooltipItems,
      activeItem: this.props.activeItem,
      pagination: this.props.pagination
    }, x = Math.min(
      g * d,
      c * d
    );
    return /* @__PURE__ */ s.jsx(ki, { disableHeight: !0, doNotBailOutOnEmptyChildren: !0, children: ({ width: C }) => /* @__PURE__ */ s.jsx(
      Ti,
      {
        ...b,
        ref: this.infiniteListRef,
        width: C,
        height: x,
        itemCount: g,
        itemSize: d,
        "aria-labelledby": u,
        children: this.ListItem
      }
    ) });
  }
}
const _u = "h-selectItems-checkableBaseItem--checkableBaseItem__root", Cu = "h-selectItems-checkableBaseItem--checkableBaseItem__rootActive", wu = "h-selectItems-checkableBaseItem--checkableBaseItem__rootDisabled", vu = "h-selectItems-checkableBaseItem--checkableBaseItem__checkbox", Su = "h-selectItems-checkableBaseItem--checkableBaseItem__content", ze = {
  root: _u,
  rootActive: Cu,
  rootDisabled: wu,
  checkbox: vu,
  content: Su
};
class Xs extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  handleChange() {
    const { onChange: t, item: e, checked: n } = this.props;
    typeof t == "function" && t(e, !n);
  }
  handleKeyDown(t) {
    const { disabled: e, onKeyDown: n } = this.props;
    (t.key === "Enter" || t.key === " ") && !e && (t.preventDefault(), this.handleChange()), n && n(t);
  }
  noop(t) {
    t.preventDefault();
  }
  render() {
    const {
      item: t,
      onChange: e,
      clearSearch: n,
      checked: o,
      disabled: r,
      isLoading: a,
      children: l,
      active: c,
      tabIndex: d,
      onKeyDown: h,
      ...u
    } = this.props, p = f(ze.root, {
      [ze.rootDisabled]: r,
      [ze.rootActive]: c
    }), m = r ? E : this.handleChange;
    return /* @__PURE__ */ s.jsxs(
      "label",
      {
        ...u,
        className: p,
        tabIndex: d,
        onKeyDown: this.handleKeyDown,
        children: [
          /* @__PURE__ */ s.jsx(
            un,
            {
              id: t?.id,
              name: "",
              className: ze.checkbox,
              checked: o,
              onChange: m,
              tabIndex: -1
            }
          ),
          /* @__PURE__ */ s.jsx("div", { className: ze.content, children: l })
        ]
      }
    );
  }
}
const Iu = "h-selectItems-emptySelectItem--emptySelectItem__root", Du = "h-selectItems-emptySelectItem--emptySelectItem__name", Ro = {
  root: Iu,
  name: Du
};
class mn extends D {
  render() {
    const { label: t, ...e } = this.props;
    return /* @__PURE__ */ s.jsx("div", { ...e, className: Ro.root, children: /* @__PURE__ */ s.jsx("div", { className: Ro.name, children: t }) });
  }
}
const ku = "h-selectItems-selectItem--selectItem__root", Tu = "h-selectItems-selectItem--selectItem__rootActive", ju = "h-selectItems-selectItem--selectItem__name", Nu = "h-selectItems-selectItem--selectItem__nameBold", Fu = "h-selectItems-selectItem--selectItem__nameWithDescription", Pu = "h-selectItems-selectItem--selectItem__description", Ru = "h-selectItems-selectItem--selectItem__icon", ne = {
  root: ku,
  rootActive: Tu,
  name: ju,
  nameBold: Nu,
  nameWithDescription: Fu,
  description: Pu,
  icon: Ru
};
class Or extends ft {
  static defaultProps = {
    checked: !1
  };
  render() {
    const {
      item: t,
      onSelect: e,
      clearSearch: n,
      checked: o,
      disabled: r,
      active: a,
      isLoading: l,
      ...c
    } = this.props, { description: d, name: h, icon: u, iconSize: p } = t, m = f(ne.root, {
      [ne.rootActive]: a
    }), g = f(ne.name, {
      [ne.nameBold]: o,
      [ne.nameWithDescription]: !!d
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...c,
        type: "button",
        "aria-current": a,
        className: m,
        disabled: r,
        onClick: () => {
          e(t);
        },
        children: [
          u ? /* @__PURE__ */ s.jsx(N, { className: ne.icon, name: u, size: p ?? 16 }) : null,
          /* @__PURE__ */ s.jsxs(H, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
            /* @__PURE__ */ s.jsx("span", { className: g, "data-testid": "name", children: h }),
            d && /* @__PURE__ */ s.jsx("span", { className: ne.description, "data-testid": "description", children: d })
          ] }),
          o && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" })
        ]
      }
    );
  }
}
const Eu = "h-selectItems-checkableSelectItem--checkableSelectItem__name", Lu = {
  name: Eu
};
class Bk extends D {
  render() {
    const { item: t, isLoading: e } = this.props, { name: n } = e ? { name: "Loading..." } : t;
    return /* @__PURE__ */ s.jsx(Xs, { ...this.props, children: /* @__PURE__ */ s.jsx("span", { className: Lu.name, children: n }) });
  }
}
const Au = "h-selectItems-tagSelectItem--tagSelectItem__root", $u = "h-selectItems-tagSelectItem--tagSelectItem__rootActive", Ou = "h-selectItems-tagSelectItem--tagSelectItem__name", Bu = "h-selectItems-tagSelectItem--tagSelectItem__nameBold", Hu = "h-selectItems-tagSelectItem--tagSelectItem__dotContainer", Wu = "h-selectItems-tagSelectItem--tagSelectItem__dot", fe = {
  root: Au,
  rootActive: $u,
  name: Ou,
  nameBold: Bu,
  dotContainer: Hu,
  dot: Wu
};
class Hk extends D {
  static defaultProps = {
    checked: !1
  };
  render() {
    const {
      item: t,
      onSelect: e,
      clearSearch: n,
      checked: o,
      disabled: r,
      isLoading: a,
      active: l,
      ...c
    } = this.props, { name: d, color: h = "#000" } = t, u = f(fe.root, {
      [fe.rootActive]: l
    }), p = f(fe.name, {
      [fe.nameBold]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...c,
        type: "button",
        "aria-current": l,
        className: u,
        onClick: () => {
          e(t), n();
        },
        tabIndex: 0,
        title: typeof d == "string" ? d : d.toString(),
        disabled: r,
        children: [
          /* @__PURE__ */ s.jsx("div", { className: fe.dotContainer, children: /* @__PURE__ */ s.jsx(
            "div",
            {
              className: fe.dot,
              style: { backgroundColor: h ?? void 0 }
            }
          ) }),
          /* @__PURE__ */ s.jsx("div", { className: p, children: d }),
          o && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" }),
          r && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" })
        ]
      }
    );
  }
}
const Mu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__name", zu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dotContainer", Vu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dot", Ku = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__nameContainer", yn = {
  name: Mu,
  dotContainer: zu,
  dot: Vu,
  nameContainer: Ku
};
class Wk extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this);
  }
  handleChange() {
    const { onChange: t, item: e, checked: n } = this.props;
    typeof t == "function" && t(e, !n);
  }
  render() {
    const { item: t, isLoading: e, disabled: n } = this.props, { name: o, color: r } = e ? { name: "Loading...", color: "#000" } : t;
    return /* @__PURE__ */ s.jsx(
      Xs,
      {
        ...this.props,
        disabled: this.props.checked ? !1 : n,
        children: /* @__PURE__ */ s.jsxs("div", { className: yn.nameContainer, children: [
          r && /* @__PURE__ */ s.jsx("div", { className: yn.dotContainer, children: /* @__PURE__ */ s.jsx("div", { className: yn.dot, style: { backgroundColor: r } }) }),
          /* @__PURE__ */ s.jsx("span", { className: yn.name, children: o }),
          n && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" })
        ] })
      }
    );
  }
}
const Uu = "h-selectItems-avatarSelectItem--avatarSelectItem__root", qu = "h-selectItems-avatarSelectItem--avatarSelectItem__rootActive", Gu = "h-selectItems-avatarSelectItem--avatarSelectItem__names", Yu = "h-selectItems-avatarSelectItem--avatarSelectItem__primaryName", Xu = "h-selectItems-avatarSelectItem--avatarSelectItem__secondaryName", Qu = "h-selectItems-avatarSelectItem--avatarSelectItem__namesBold", Zu = "h-selectItems-avatarSelectItem--avatarSelectItem__container", Ju = "h-selectItems-avatarSelectItem--avatarSelectItem__containerCheckable", Vt = {
  root: Uu,
  rootActive: qu,
  names: Gu,
  primaryName: Yu,
  secondaryName: Xu,
  namesBold: Qu,
  container: Zu,
  containerCheckable: Ju
};
class tp extends D {
  static defaultProps = {
    checked: !1
  };
  getNames(t) {
    const e = /* @__PURE__ */ new Set();
    typeof t.name == "string" && e.add(t.name), typeof t.name != "string" && typeof t.display_name == "string" && e.add(t.display_name), typeof t.phone_number == "string" && e.add(t.phone_number), typeof t.email == "string" && e.add(t.email);
    const n = Array.from(e);
    return {
      primaryName: n.length > 0 ? n[0] : "No name",
      secondaryName: n.length > 1 ? n[1] : null
    };
  }
  getAvatar(t) {
    return typeof t.icon == "string" ? /* @__PURE__ */ s.jsx(N, { name: t.icon, size: 16 }) : /* @__PURE__ */ s.jsx(vr, { user: t });
  }
  renderContent() {
    const t = this.props.isLoading ? {
      id: "",
      name: "Loading..."
    } : this.props.item, e = this.getAvatar(t), n = this.getNames(t), o = f(Vt.container, {
      [Vt.containerCheckable]: this.props.checkable
    }), r = f(Vt.names, {
      [Vt.namesBold]: this.props.checked
    });
    return /* @__PURE__ */ s.jsxs("div", { className: o, children: [
      e,
      /* @__PURE__ */ s.jsxs("div", { className: r, children: [
        /* @__PURE__ */ s.jsx("div", { className: Vt.primaryName, children: n.primaryName }),
        n.secondaryName !== null && /* @__PURE__ */ s.jsx("div", { className: Vt.secondaryName, children: n.secondaryName })
      ] })
    ] });
  }
  render() {
    const t = this.renderContent(), { checkable: e, ...n } = this.props;
    if (e) {
      const m = n;
      return /* @__PURE__ */ s.jsx(Xs, { ...m, children: t });
    }
    const o = n, { item: r, disabled: a, onSelect: l, active: c, checked: d, isLoading: h, ...u } = o, p = f(Vt.root, {
      [Vt.rootActive]: c
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...u,
        type: "button",
        className: p,
        disabled: a,
        onClick: () => {
          l(r);
        },
        "aria-current": c,
        children: [
          t,
          d && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" })
        ]
      }
    );
  }
}
class Mk extends D {
  render() {
    return /* @__PURE__ */ s.jsx(tp, { checkable: !0, ...this.props });
  }
}
const ep = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__root", np = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__rootActive", sp = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__suggestion", op = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__icon", _n = {
  root: ep,
  rootActive: np,
  suggestion: sp,
  icon: op
};
class zk extends ft {
  static defaultProps = {
    searchSuggestion: (t, e) => t.find((n) => n.name.toLowerCase() === e.toLowerCase()),
    renderSuggestion: (t) => `Add "${t}" tag`
  };
  constructor(t) {
    super(t), this.state = {}, this.onSuggest = this.onSuggest.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  componentDidUpdate(t) {
    const { searched: e, active: n } = this.props;
    e !== t.searched && this.searchItem(), n !== t.active && (n ? window.addEventListener("keydown", this.handleKeyDown) : window.removeEventListener("keydown", this.handleKeyDown));
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }
  searchItem() {
    const { items: t, searched: e, searchSuggestion: n } = this.props;
    this.setState({ searching: !0 }, async () => {
      try {
        const o = await n?.(t, e);
        this.setState({ item: o });
      } catch (o) {
        console.error(o);
      } finally {
        this.setState({ searching: !1 });
      }
    });
  }
  onSuggest() {
    const { searched: t, onSuggest: e, clearSearch: n, triggerClose: o } = this.props;
    o?.(), e?.(t), n();
  }
  handleKeyDown(t) {
    this.props.active && t.key === "Enter" && this.onSuggest();
  }
  render() {
    const {
      className: t,
      triggerClose: e,
      onSuggest: n,
      searched: o,
      items: r,
      active: a,
      renderSuggestion: l,
      searchSuggestion: c,
      clearSearch: d,
      ...h
    } = this.props, { item: u, searching: p } = this.state;
    if (!o || p || u)
      return null;
    const m = f(t, _n.root, {
      [_n.rootActive]: a
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...h,
        type: "button",
        "aria-current": a,
        className: m,
        onClick: this.onSuggest,
        tabIndex: 0,
        children: [
          /* @__PURE__ */ s.jsx("div", { className: _n.suggestion, children: l?.(o) }),
          /* @__PURE__ */ s.jsx("div", { className: _n.icon, children: /* @__PURE__ */ s.jsx(N, { name: "plus" }) })
        ]
      }
    );
  }
}
const rp = "h-selectItems-deselectItem--deselectItem__root", ip = "h-selectItems-deselectItem--deselectItem__rootDisabled", ap = "h-selectItems-deselectItem--deselectItem__name", lp = "h-selectItems-deselectItem--deselectItem__icon", Cn = {
  root: rp,
  rootDisabled: ip,
  name: ap,
  icon: lp
};
class cp extends D {
  render() {
    const { item: t, onSelect: e, clearSearch: n, disabled: o, ...r } = this.props, { name: a } = t, l = f(Cn.root, {
      [Cn.rootDisabled]: o
    });
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: l, children: [
      /* @__PURE__ */ s.jsx("div", { className: Cn.name, children: a }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: Cn.icon,
          onClick: () => {
            e(t);
          },
          disabled: o,
          children: /* @__PURE__ */ s.jsx(N, { name: "close" })
        }
      )
    ] });
  }
}
const dp = "h-selectItems-tagDeselectItem--tagDeselectItem__root", hp = "h-selectItems-tagDeselectItem--tagDeselectItem__name", up = "h-selectItems-tagDeselectItem--tagDeselectItem__icon", pp = "h-selectItems-tagDeselectItem--tagDeselectItem__dotContainer", mp = "h-selectItems-tagDeselectItem--tagDeselectItem__dot", Ve = {
  root: dp,
  name: hp,
  icon: up,
  dotContainer: pp,
  dot: mp
};
class Vk extends D {
  render() {
    const { item: t, onSelect: e, clearSearch: n, disabled: o, isLoading: r, ...a } = this.props, { name: l, color: c } = t, d = f(Ve.root);
    return /* @__PURE__ */ s.jsxs("div", { ...a, className: d, children: [
      /* @__PURE__ */ s.jsx("div", { className: Ve.dotContainer, children: /* @__PURE__ */ s.jsx(
        "div",
        {
          className: Ve.dot,
          style: { backgroundColor: c ?? void 0 }
        }
      ) }),
      /* @__PURE__ */ s.jsx("div", { className: Ve.name, children: l }),
      o && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: Ve.icon,
          onClick: () => {
            e(t);
          },
          children: /* @__PURE__ */ s.jsx(N, { name: "close" })
        }
      )
    ] });
  }
}
const gp = "h-chip--chip__root", fp = "h-chip--chip__rootLight", bp = "h-chip--chip__rootNoBorder", xp = "h-chip--chip__rootDisabled", yp = "h-chip--chip__rootInteractable", Ke = {
  root: gp,
  rootLight: fp,
  rootNoBorder: bp,
  rootDisabled: xp,
  rootInteractable: yp
}, _p = ({
  className: i,
  children: t,
  onClick: e,
  light: n,
  noBorder: o,
  disabled: r,
  ...a
}) => {
  const l = f(
    {
      [Ke.root]: !0,
      [Ke.rootLight]: n,
      [Ke.rootNoBorder]: o,
      [Ke.rootDisabled]: r,
      [Ke.rootInteractable]: typeof e == "function" && !r
    },
    i
  ), c = typeof e == "function" ? "button" : "div";
  return /* @__PURE__ */ s.jsx(at, { ...a, as: c, className: l, onClick: e, children: t });
}, Cp = "h-tag--tag__tagName", wp = "h-tag--tag__tagNameTruncated", vp = "h-tag--tag__icon", Sp = "h-tag--tag__deleteButton", Ip = "h-tag--tag__deleteButtonDisabled", Dp = "h-tag--tag__deleteIcon", be = {
  tagName: Cp,
  tagNameTruncated: wp,
  icon: vp,
  deleteButton: Sp,
  deleteButtonDisabled: Ip,
  deleteIcon: Dp
}, je = ({
  className: i,
  tagNameClassName: t,
  children: e,
  onDelete: n,
  color: o,
  light: r,
  noBorder: a,
  noTruncation: l = !1,
  disabled: c,
  ...d
}) => {
  const h = f(
    {
      [be.tagName]: !0,
      [be.tagNameTruncated]: !l
    },
    t
  ), u = f(be.deleteButton, {
    [be.deleteButtonDisabled]: c
  });
  return /* @__PURE__ */ s.jsxs(
    _p,
    {
      ...d,
      className: i,
      light: r,
      noBorder: a,
      disabled: c,
      children: [
        o && /* @__PURE__ */ s.jsx(
          "span",
          {
            className: be.icon,
            style: { backgroundColor: sn(o) ?? void 0 }
          }
        ),
        /* @__PURE__ */ s.jsx("span", { className: h, children: e }),
        !!n && !c && /* @__PURE__ */ s.jsx("button", { className: u, type: "button", onClick: n, children: /* @__PURE__ */ s.jsx(N, { name: "close", className: be.deleteIcon }) })
      ]
    }
  );
}, kp = "h-select--select__root", Tp = "h-select--select__rootDisabled", jp = "h-select--select__inputWrapper", Np = "h-select--select__control", Fp = "h-select--select__rootHasIcon", Pp = "h-select--select__selection", Rp = "h-select--select__selectionItem", Ep = "h-select--select__tag", Lp = "h-select--select__tagName", Ap = "h-select--select__tagLimiter", $p = "h-select--select__text", Op = "h-select--select__rootSearchable", Bp = "h-select--select__rootDropdownOpen", Hp = "h-select--select__rootIsSearching", Wp = "h-select--select__search", Mp = "h-select--select__rootSingle", zp = "h-select--select__indicators", Vp = "h-select--select__spinner", Kp = "h-select--select__clearIndicator", Up = "h-select--select__dropdownIndicator", qp = "h-select--select__dropdown", Gp = "h-select--select__dropdownFixed", Yp = "h-select--select__pagination", G = {
  root: kp,
  rootDisabled: Tp,
  inputWrapper: jp,
  control: Np,
  rootHasIcon: Fp,
  selection: Pp,
  selectionItem: Rp,
  tag: Ep,
  tagName: Lp,
  tagLimiter: Ap,
  text: $p,
  rootSearchable: Op,
  rootDropdownOpen: Bp,
  rootIsSearching: Hp,
  search: Wp,
  rootSingle: Mp,
  indicators: zp,
  spinner: Vp,
  clearIndicator: Kp,
  dropdownIndicator: Up,
  dropdown: qp,
  dropdownFixed: Gp,
  pagination: Yp
};
class Ne extends D {
  controlRef;
  searchRef;
  listRef;
  static defaultProps = {
    id: br("select"),
    selectedItems: [],
    disabledItems: [],
    itemComponent: Or,
    emptyComponent: mn,
    emptyMessage: "No options",
    placeholder: "",
    disabled: !1,
    loading: !1,
    multiple: !1,
    searchable: !1,
    clearable: !1,
    keepOpen: !1,
    hideSelectedItems: !1,
    hasDropDownIndicator: !0
  };
  constructor(t) {
    super(t), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSearch = this.handleSearch.bind(this), this.handleDropdown = this.handleDropdown.bind(this), this.handleClickOutside = this.handleClickOutside.bind(this), this.handleSelect = this.handleSelect.bind(this), this.handleChange = this.handleChange.bind(this), this.handleRemove = this.handleRemove.bind(this), this.handleClear = this.handleClear.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this), this.resolveItem = this.resolveItem.bind(this), this.resetSearch = this.resetSearch.bind(this), this.controlRef = B(), this.searchRef = B(), this.listRef = B();
    const e = this.initSelectedItems(), n = this.initHighlightedIndex(e);
    this.state = {
      dropdownOpen: !1,
      search: "",
      selectedItems: e,
      highlightedIndex: n
    }, !Ne.isSuggestionComponentWarningShown && this.props.suggestionComponent && !this.props.searchable && (console.warn(
      "SuggestionComponent can only be shown on searchable select components. You should either remove suggestionComponent prop or add searchable prop"
    ), Ne.isSuggestionComponentWarningShown = !0);
  }
  componentDidUpdate(t, e) {
    const { dropdownOpen: n } = this.state;
    if (n !== e.dropdownOpen)
      if (window[n ? "addEventListener" : "removeEventListener"](
        "click",
        this.handleClickOutside
      ), n) {
        this.searchRef.current?.focus();
        const o = this.initHighlightedIndex();
        this.highlightIndex(o, "auto");
      } else
        this.searchRef.current?.blur();
    xr(t.selectedItems, this.props.selectedItems) || this.setState({ selectedItems: this.initSelectedItems() });
  }
  componentWillUnmount() {
    const { dropdownOpen: t } = this.state;
    t && window.removeEventListener("click", this.handleClickOutside);
  }
  static isSuggestionComponentWarningShown = !1;
  get a11y() {
    const { id: t } = this.props, { highlightedIndex: e } = this.state, n = `${t}-label`, o = `${t}-dropdown`, r = e !== null ? `${o}-option-${e}` : "";
    return { label: n, dropdown: o, option: r };
  }
  isItemIdType(t) {
    return typeof t == "string" || typeof t == "number";
  }
  initSelectedItems() {
    const { selectedItems: t = [] } = this.props;
    return t.map(this.resolveItem).filter(Boolean);
  }
  initHighlightedIndex(t = this.state.selectedItems) {
    const { multiple: e, items: n, hideSelectedItems: o } = this.props;
    if (!e && !o && t.length) {
      const r = this.resolveItem(t[0]);
      return n.indexOf(r);
    }
    return null;
  }
  resolveItem(t) {
    return this.isItemIdType(t) ? this.props.items.find((n) => n.id === t) : t;
  }
  resetSearch() {
    this.state.search && (this.setState({ search: "" }), this.searchRef.current?.focus());
  }
  handleSearch(t) {
    const { onSearch: e } = this.props, { value: n } = t.target;
    this.setState({ search: n }, () => {
      e?.(n), n && (this.highlightIndex(this.hasSuggestionComponent() ? -1 : 0), this.listRef.current?.goToTop());
    });
  }
  handleDropdown(t = "toggle") {
    const { dropdownOpen: e } = this.state, { keepOpen: n, onToggle: o } = this.props;
    if (n)
      return this.setState({ dropdownOpen: !0 });
    if (t === "toggle")
      return o?.(!e), this.controlRef.current?.focus(), this.setState({ dropdownOpen: !e });
    if (t === "open")
      return o?.(!0), this.setState({ dropdownOpen: !0 });
    if (t === "close" && e)
      return o?.(!1), this.controlRef.current?.blur(), this.setState({
        dropdownOpen: !1,
        search: ""
      });
  }
  handleClickOutside(t) {
    if (!this.controlRef || !(t.target instanceof Node)) return;
    const e = this.controlRef.current, { target: n } = t;
    n && n !== e && !e?.contains(n) && this.handleDropdown("close");
  }
  highlightIndex(t, e = "smooth") {
    this.setState({ highlightedIndex: t }, () => {
      if (t === null || t === -1) return;
      (this.listRef.current?.listRef.current?.children ?? [])[t]?.scrollIntoView({
        behavior: e,
        block: "nearest",
        inline: "start"
      });
    });
  }
  handleKeyDown(t) {
    const { search: e, dropdownOpen: n, highlightedIndex: o, selectedItems: r } = this.state, { multiple: a, hideSelectedItems: l } = this.props, c = this.getAvailableItems(), d = t.key === "Escape", h = t.key === "Enter", u = t.key === "ArrowUp", p = t.key === "ArrowDown", m = t.key === "Backspace";
    if ((h || u || p) && t.preventDefault(), p && !n)
      return t.preventDefault(), this.handleDropdown("open");
    if (d && (n && t.stopPropagation(), this.handleDropdown("close")), m && a && !e) {
      const g = r[r.length - 1];
      g && this.handleRemove(g);
    }
    if (this.hasSuggestionComponent()) {
      if (p && (o === null || o === c.length - 1 || o === 0 && c.length === 0))
        return this.highlightIndex(-1);
      if (u && o === 0)
        return this.highlightIndex(-1);
      if (h && o === -1) {
        this.props.onSuggest?.(e), this.resetSearch();
        return;
      }
    }
    if (p && o === null)
      return this.highlightIndex(0);
    if (o !== null) {
      if (p && o === c.length - 1)
        return this.highlightIndex(0);
      if (p)
        return this.highlightIndex(o + 1);
      if (u && o > 0)
        return this.highlightIndex(o - 1);
      if (u && o <= 0)
        return this.highlightIndex(c.length - 1);
      if (h) {
        const g = c[o], b = g && this.isItemDisabled(g);
        if (g && !b) {
          this.handleSelect(g);
          const x = Math.min(
            l ? o : o + 1,
            c.length - 2
          );
          this.highlightIndex(x);
        }
      }
    }
  }
  handleSelect(t) {
    const { multiple: e, keepOpen: n, onSelect: o } = this.props;
    if (e) {
      const r = this.isItemSelected(t);
      this.handleChange(t, !r);
    } else
      this.setState({
        selectedItems: [t],
        dropdownOpen: n ?? !1
      }), this.resetSearch(), o?.(t);
  }
  handleChange(t, e) {
    const { onChange: n } = this.props, { selectedItems: o } = this.state;
    this.setState({
      selectedItems: e ? [...o, t] : o.filter((r) => r.id !== t.id)
    }), this.resetSearch(), n?.(t, e);
  }
  handleRemove(t, e) {
    e && (e.preventDefault(), e.stopPropagation()), this.handleChange(t, !1);
  }
  handleClear(t) {
    t.stopPropagation();
    const { onClear: e } = this.props;
    e?.(), this.setState({ selectedItems: [] });
  }
  handleDropdownClick(t) {
    t.stopPropagation();
  }
  getPlaceholder() {
    return this.state.selectedItems.length ? "" : this.props.placeholder;
  }
  getInputSize() {
    return this.state.search ? this.state.search.length : this.state.selectedItems?.length ? 5 : this.props.placeholder?.length || 5;
  }
  getItemName(t) {
    return t.name.toString().trim();
  }
  getAvailableItems() {
    const { search: t } = this.state, { items: e, hideSelectedItems: n, onSearch: o, searchBy: r } = this.props, a = new RegExp(zs(t), "i");
    return e.filter((c) => {
      const d = [];
      return t && !o && (r && typeof r == "function" ? d.push(r(c, t)) : r && r instanceof Array ? d.push(
        r.some((h) => {
          const u = c[h];
          return (typeof u == "string" || typeof u == "number") && a.test(u.toString().trim());
        })
      ) : d.push(a.test(this.getItemName(c)))), n && d.push(!this.isItemSelected(c)), d.every((h) => h);
    });
  }
  isItemSelected(t) {
    return this.state.selectedItems.some(
      (e) => e.id === t.id
    );
  }
  isItemDisabled(t) {
    return this.props.disabledItems?.includes(t.id);
  }
  isEmpty() {
    return this.state.selectedItems.length === 0;
  }
  hasSuggestionComponent(t) {
    return !!this.state.search && typeof this.props.suggestionComponent == "function";
  }
  renderHiddenItems() {
    const { limit: t } = this.props, { selectedItems: e } = this.state;
    if (t && t > 0)
      return /* @__PURE__ */ s.jsx(H, { flexDirection: "column", children: e?.slice(t).map((n) => /* @__PURE__ */ s.jsxs(
        H,
        {
          alignItems: "center",
          justifyContent: "space-between",
          "data-testid": "select-hidden-item",
          children: [
            /* @__PURE__ */ s.jsx(at, { margin: "0 400 0 0", children: this.getItemName(n) }),
            /* @__PURE__ */ s.jsx(
              K,
              {
                icon: "close",
                variant: "tertiary",
                onClick: (o) => this.handleRemove(n, o)
              }
            )
          ]
        },
        n.id
      )) });
  }
  renderSelection(t) {
    return this.props.renderSelection?.(t) ?? this.getItemName(t);
  }
  renderMultipleSelection() {
    const { selectedItems: t } = this.state, e = this.props.limit || t.length, n = e < t.length, o = t?.slice(0, e).map((r) => {
      const a = this.renderSelection(r);
      return /* @__PURE__ */ s.jsx(
        "div",
        {
          onClick: (l) => l.stopPropagation(),
          "data-testid": "select-selection",
          className: G.selectionItem,
          children: /* @__PURE__ */ s.jsx(
            je,
            {
              className: G.tag,
              tagNameClassName: G.tagName,
              onDelete: (l) => this.handleRemove(r, l),
              color: r.color,
              noTruncation: !0,
              "data-testid": "select-tag",
              children: a
            }
          )
        },
        r.id
      );
    });
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      o,
      n && /* @__PURE__ */ s.jsx("div", { onClick: (r) => r.stopPropagation(), children: /* @__PURE__ */ s.jsx(
        st,
        {
          content: this.renderHiddenItems(),
          requireClick: !0,
          "data-testid": "select-limiter",
          light: !0,
          children: /* @__PURE__ */ s.jsxs(
            je,
            {
              className: f(G.tag, G.tagLimiter),
              noTruncation: !0,
              children: [
                "+",
                t.length - e
              ]
            }
          )
        }
      ) })
    ] });
  }
  renderSingleSelection() {
    const { search: t, selectedItems: e } = this.state, n = e[0], o = /* @__PURE__ */ s.jsx("span", { style: { width: 0 }, "data-testid": "select-selection-empty", children: " " });
    return n ? /* @__PURE__ */ s.jsx(
      "span",
      {
        className: G.text,
        "aria-hidden": !!t,
        "data-testid": "select-selection",
        children: this.renderSelection(n)
      }
    ) : o;
  }
  renderSearch() {
    const { searchable: t } = this.props;
    return !t && !this.isEmpty() ? null : /* @__PURE__ */ s.jsx(
      "input",
      {
        className: G.search,
        ref: this.searchRef,
        tabIndex: -1,
        onFocus: (e) => e.stopPropagation(),
        value: this.state.search,
        size: this.getInputSize(),
        onChange: this.handleSearch,
        placeholder: this.getPlaceholder(),
        autoComplete: "off",
        readOnly: !t,
        "aria-autocomplete": "list",
        "aria-controls": this.a11y.dropdown,
        "aria-labelledby": this.a11y.label,
        "data-testid": "select-input"
      }
    );
  }
  renderDropdown() {
    const { dropdownOpen: t, highlightedIndex: e, search: n } = this.state, {
      disabledItems: o,
      tooltipItems: r,
      emptyComponent: a,
      suggestionComponent: l,
      emptyMessage: c,
      pagination: d,
      dropdownProps: h,
      searchSuggestion: u,
      renderSuggestion: p,
      onSuggest: m,
      multiple: g
    } = this.props, b = f(
      {
        [G.dropdown]: !0,
        [G.dropdownFixed]: h?.fixed ?? !1
      },
      h?.className
    ), x = this.getAvailableItems(), C = x[e ?? -1] ?? null, _ = !x.length;
    return /* @__PURE__ */ s.jsxs(
      te,
      {
        onClick: this.handleDropdownClick,
        ...h,
        className: b,
        isOpen: t,
        "data-testid": "select-dropdown",
        children: [
          _ && typeof a == "function" && /* @__PURE__ */ s.jsx(
            a,
            {
              label: c ?? "No options",
              "data-testid": "select-dropdown-empty"
            }
          ),
          this.hasSuggestionComponent(l) && /* @__PURE__ */ s.jsx(
            l,
            {
              searched: n,
              onSuggest: m,
              triggerClose: g ? void 0 : () => this.handleDropdown("close"),
              items: x,
              active: e === -1,
              clearSearch: this.resetSearch,
              searchSuggestion: u,
              renderSuggestion: p
            }
          ),
          !_ && /* @__PURE__ */ s.jsx(
            Ys,
            {
              id: this.a11y.dropdown,
              ariaLabelledby: this.a11y.label,
              ref: this.listRef,
              pagination: d,
              items: x,
              clearSearch: this.resetSearch,
              onSelect: this.handleSelect,
              onChange: this.handleChange,
              onKeyDown: this.handleKeyDown,
              selectedItems: this.state.selectedItems,
              disabledItems: o,
              tooltipItems: r,
              activeItem: C,
              itemComponent: this.props.itemComponent
            }
          ),
          !!d && !d.infinite && /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: G.pagination,
              "data-testid": "select-dropdown-pagination",
              children: [
                /* @__PURE__ */ s.jsx(
                  Q,
                  {
                    variant: "secondary",
                    disabled: !d.previousEnable,
                    onClick: d.onPrevious,
                    children: "Prev page"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  Q,
                  {
                    variant: "secondary",
                    disabled: !d.nextEnable,
                    onClick: d.onNext,
                    children: "Next page"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
  render() {
    const {
      className: t,
      disabled: e,
      hasDropDownIndicator: n,
      loading: o,
      multiple: r,
      searchable: a,
      clearable: l,
      prefix: c,
      suffix: d,
      icon: h,
      status: u
    } = this.props, { search: p, dropdownOpen: m } = this.state, g = f(
      {
        [G.root]: !0,
        [G.rootSingle]: !r,
        [G.rootDisabled]: e,
        [G.rootSearchable]: a,
        [G.rootDropdownOpen]: m,
        [G.rootIsSearching]: !!p,
        [G.rootHasIcon]: !!h
      },
      t
    ), b = p ? void 0 : () => this.handleDropdown("toggle");
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: g,
        role: "combobox",
        "aria-expanded": m,
        "aria-owns": this.a11y.dropdown,
        "aria-haspopup": "listbox",
        "data-testid": "select-root",
        children: [
          /* @__PURE__ */ s.jsx(
            At,
            {
              prefix: c,
              suffix: d,
              icon: h,
              status: u,
              active: m,
              disabled: e,
              className: G.inputWrapper,
              children: /* @__PURE__ */ s.jsxs(
                "div",
                {
                  className: G.control,
                  ref: this.controlRef,
                  onKeyDown: this.handleKeyDown,
                  onClick: b,
                  tabIndex: e ? -1 : 0,
                  "aria-activedescendant": this.a11y.option,
                  "data-testid": "select-control",
                  children: [
                    /* @__PURE__ */ s.jsxs("div", { className: G.selection, children: [
                      r ? this.renderMultipleSelection() : this.renderSingleSelection(),
                      this.renderSearch()
                    ] }),
                    /* @__PURE__ */ s.jsxs("div", { className: G.indicators, children: [
                      o && /* @__PURE__ */ s.jsx(
                        Gn,
                        {
                          className: G.spinner,
                          size: 16,
                          "aria-label": "Loading",
                          "data-testid": "select-loading"
                        }
                      ),
                      !this.isEmpty() && l && /* @__PURE__ */ s.jsx(
                        K,
                        {
                          tabIndex: -1,
                          className: G.clearIndicator,
                          icon: "close",
                          variant: "tertiary",
                          onClick: this.handleClear,
                          "aria-label": "Clear",
                          "data-testid": "select-clear"
                        }
                      ),
                      n && /* @__PURE__ */ s.jsx(
                        K,
                        {
                          tabIndex: -1,
                          className: G.dropdownIndicator,
                          icon: m ? "angle-up" : "angle-down",
                          variant: "tertiary",
                          onClick: (x) => {
                            x.stopPropagation(), this.handleDropdown("toggle");
                          },
                          "aria-label": m ? "Close" : "Open",
                          "data-testid": "select-toggle"
                        }
                      )
                    ] })
                  ]
                }
              )
            }
          ),
          !e && m && this.renderDropdown()
        ]
      }
    );
  }
}
function Xp(i) {
  return /* @__PURE__ */ s.jsx(
    Re,
    {
      fallback: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: "Something went wrong" }) }),
      children: /* @__PURE__ */ s.jsx(Ne, { ...i })
    }
  );
}
const Qp = "h-datePicker-timezoneSelector--timezoneSelector__root", Zp = "h-datePicker-timezoneSelector--timezoneSelector__label", Eo = {
  root: Qp,
  label: Zp
}, Br = ({
  disabled: i,
  tooltipProps: t,
  selectedTimezone: e,
  onChange: n
}) => {
  const o = j.tz.guess(!0), r = F((h, u) => {
    const [p, m] = j.tz(h).format("Z").split(":"), [g, b] = j.tz(u).format("Z").split(":");
    return +parseInt(p) * 60 + parseInt(m) - (+parseInt(g) * 60 + parseInt(b));
  }, []), a = (h) => `(GMT${j.tz(h).format("Z")})`, l = (h) => `${a(h)} ${h}`, c = q(() => {
    const h = j.tz.names().filter((m) => m !== o), u = {
      id: o,
      name: `Default ${a(o)}`
    }, p = h.sort(r).map((m) => ({ id: m, name: l(m) }));
    return [u, ...p];
  }, [r]), d = ({ id: h }) => {
    n(h);
  };
  return /* @__PURE__ */ s.jsxs("div", { className: Eo.root, children: [
    /* @__PURE__ */ s.jsx(Gs, { className: Eo.label, children: "Time zone" }),
    /* @__PURE__ */ s.jsx(st, { ...t, side: "top", children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
      Xp,
      {
        disabled: i,
        items: c,
        onSelect: d,
        selectedItems: [
          Te(e) ? e : o
        ],
        searchable: !0
      }
    ) }) })
  ] });
}, Jp = "h-fieldAlert--fieldAlert__root", tm = "h-fieldAlert--fieldAlert__alert", em = "h-fieldAlert--fieldAlert__icon", gs = {
  root: Jp,
  alert: tm,
  icon: em
}, nm = "h-fieldAlert-fieldAlertButton--fieldAlertButton__root", sm = {
  root: nm
};
function om({
  className: i,
  variant: t = "tertiary",
  ...e
}) {
  return /* @__PURE__ */ s.jsx(
    Q,
    {
      ...e,
      variant: t,
      className: f(i, sm.root)
    }
  );
}
const rm = {
  error: "exclamation-circle-filled",
  warning: "exclamation-triangle-filled",
  success: "check-circle-filled",
  title: null
};
function ts({
  children: i,
  className: t,
  ...e
}) {
  const n = e.variant || "title", o = f(gs.root, t), [r, a] = V(!1), l = rm[n], c = F(
    (d) => {
      if (!d) return;
      const { offsetWidth: h, scrollWidth: u } = d;
      a(h < u);
    },
    [i]
  );
  return /* @__PURE__ */ s.jsxs(A.Input, { ...e, variant: n, className: o, children: [
    !!l && /* @__PURE__ */ s.jsx(N, { className: gs.icon, name: l }),
    /* @__PURE__ */ s.jsx("div", { className: gs.alert, ref: c, children: r ? /* @__PURE__ */ s.jsx(st, { content: i, children: i }) : i })
  ] });
}
ts.Button = om;
const wn = (i, t = 0) => {
  if (!i)
    return t;
  if (typeof i == "number")
    return i;
  const e = parseFloat(i);
  return isNaN(e) ? t : e;
}, im = "h-inputText-inputNumberArrows--inputNumberArrows__root", am = "h-inputText-inputNumberArrows--inputNumberArrows__button", lm = "h-inputText-inputNumberArrows--inputNumberArrows__buttonUp", cm = "h-inputText-inputNumberArrows--inputNumberArrows__buttonDown", dm = "h-inputText-inputNumberArrows--inputNumberArrows__spacer", xe = {
  root: im,
  button: am,
  buttonUp: lm,
  buttonDown: cm,
  spacer: dm
}, hm = 50, Lo = 300, um = "inputNumberArrowsTestId";
class pm extends D {
  intervalId;
  timeoutId;
  constructor(t) {
    super(t), this.intervalId = null, this.timeoutId = null, this.increaseValue = this.increaseValue.bind(this), this.decreaseValue = this.decreaseValue.bind(this), this.startIncreaseValue = this.startIncreaseValue.bind(this), this.startDecreaseValue = this.startDecreaseValue.bind(this), this.stopChangeValue = this.stopChangeValue.bind(this);
  }
  componentDidMount() {
    window.addEventListener("mouseup", this.stopChangeValue);
  }
  componentWillUnmount() {
    window.removeEventListener("mouseup", this.stopChangeValue);
  }
  getNewValue(t) {
    const {
      step: e,
      min: n,
      max: o,
      inputRef: { current: r }
    } = this.props;
    if (!r)
      return 0;
    const a = wn(r.value), l = wn(e, 1), c = wn(n, Number.MIN_SAFE_INTEGER), d = wn(o, Number.MAX_SAFE_INTEGER);
    return t == "decrease" ? Math.max(a - l, c) : Math.min(a + l, d);
  }
  startIncreaseValue() {
    this.timeoutId = setTimeout(
      () => this.startChangeValue("increase"),
      Lo
    );
  }
  startDecreaseValue() {
    this.timeoutId = setTimeout(
      () => this.startChangeValue("decrease"),
      Lo
    );
  }
  startChangeValue(t) {
    this.intervalId || (this.intervalId = setInterval(
      () => this.triggerInputChange(t),
      hm
    ));
  }
  stopChangeValue() {
    this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = null), this.intervalId && (clearInterval(this.intervalId), this.intervalId = null);
  }
  increaseValue(t) {
    t.preventDefault(), this.triggerInputChange("increase");
  }
  decreaseValue(t) {
    t.preventDefault(), this.triggerInputChange("decrease");
  }
  triggerInputChange(t) {
    const {
      inputRef: { current: e },
      readOnly: n
    } = this.props;
    if (!e || n)
      return;
    const o = this.getNewValue(t), r = new Event("input", { bubbles: !0 }), a = Object.getPrototypeOf(e);
    Object.getOwnPropertyDescriptor(
      a,
      "value"
    )?.set?.call(e, o), e.dispatchEvent(r), e.focus();
  }
  render() {
    return /* @__PURE__ */ s.jsxs("div", { className: xe.root, "data-testid": um, children: [
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: f(xe.button, xe.buttonUp),
          tabIndex: -1,
          onClick: this.increaseValue,
          onMouseDown: this.startIncreaseValue,
          children: /* @__PURE__ */ s.jsx(N, { name: "angle-up" })
        }
      ),
      /* @__PURE__ */ s.jsx("span", { className: xe.spacer }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: f(xe.button, xe.buttonDown),
          tabIndex: -1,
          onClick: this.decreaseValue,
          onMouseDown: this.startDecreaseValue,
          children: /* @__PURE__ */ s.jsx(N, { name: "angle-down" })
        }
      )
    ] });
  }
}
const mm = "h-inputText--inputText__rootReadOnly", gm = "h-inputText--inputText__container", fm = "h-inputText--inputText__rootHasIcon", bm = "h-inputText--inputText__rootTypeNumber", xm = "h-inputText--inputText__input", Ue = {
  rootReadOnly: mm,
  container: gm,
  rootHasIcon: fm,
  rootTypeNumber: bm,
  input: xm
}, ym = "inputText", Yt = $(function(t, e) {
  const n = Y(null);
  Fe(e, () => n.current);
  const {
    className: o,
    disabled: r,
    readOnly: a,
    type: l = "text",
    name: c,
    prefix: d,
    suffix: h,
    icon: u,
    status: p,
    min: m,
    max: g,
    step: b,
    hideNumberArrows: x = !1,
    active: C = !1,
    ..._
  } = t, w = f(o, {
    [Ue.rootTypeNumber]: l === "number",
    [Ue.rootHasIcon]: !!u,
    [Ue.rootReadOnly]: a
  });
  return /* @__PURE__ */ s.jsx(
    At,
    {
      className: w,
      status: p,
      disabled: r,
      active: C,
      prefix: d,
      suffix: h,
      icon: u,
      children: /* @__PURE__ */ s.jsxs("div", { className: Ue.container, children: [
        /* @__PURE__ */ s.jsx(
          "input",
          {
            "data-testid": ym,
            dir: "auto",
            id: c,
            name: c,
            ref: n,
            ..._,
            min: m,
            max: g,
            step: b,
            type: l,
            disabled: r,
            readOnly: a,
            className: Ue.input
          }
        ),
        l === "number" && !x && /* @__PURE__ */ s.jsx(
          pm,
          {
            min: m,
            max: g,
            step: b,
            inputRef: n,
            readOnly: a
          }
        )
      ] })
    }
  );
}), _m = "hmm A", Cm = (i, t) => {
  const e = `${i}`.padStart(2, "0"), n = `${t}`.padStart(2, "0");
  return `${e}:${n}`;
}, Ao = (i, t) => {
  const e = i.hours(), n = i.minutes();
  return {
    id: Cm(e, n),
    name: i.format(t)
  };
}, an = ({
  hasDropDownIndicator: i = !0,
  allowCustomTimeInput: t = !1,
  timeOptions: e,
  overrides: n,
  selectedItems: o,
  selectableHours: r = Tr,
  selectableMinutes: a = jr,
  timeFormat: l = j.localeData().longDateFormat("LT"),
  onSelect: c,
  onIsCustomTimeValid: d,
  ...h
}) => {
  const [u] = o || [], [p, m] = V(
    () => typeof u == "object" ? u?.id : u || null
  ), [g, b] = V(""), x = q(
    () => e || Er({
      hours: r,
      minutes: a,
      overrides: n,
      timeFormat: l
    }),
    [
      e,
      r,
      a,
      n,
      l
    ]
  ), C = q(() => {
    const S = j(
      g || (typeof u == "object" ? u.id : u) || p,
      [l, _m]
    );
    if (!S.isValid())
      return null;
    const v = S.hours(), I = S.minutes();
    if (!d || d(v, I))
      return Ao(S, l);
    const T = v <= 12, P = v + 12, L = d(P, I);
    return T && L ? Ao(j({ hours: P, minutes: I }), l) : null;
  }, [u, g]), _ = q(() => {
    if (!t)
      return x;
    const S = p ? x.filter(({ name: v }) => v !== C?.name) : x.filter(
      ({ name: v }) => v.startsWith(g) && v !== C?.name
    );
    if (!C)
      return S;
    const y = p !== C.id ? 0 : S.findIndex(
      (v) => j(v.id, [l]) > j(C.id, [l])
    );
    return S.splice(
      // If it's -1 then there was no later time, so add it to the end.
      y === -1 ? S.length : y,
      0,
      C
    ), S;
  }, [C, g, p, x]), w = F(
    (S) => {
      S?.id !== C?.id && b(""), c(S?.id || null), m(S?.id || null);
    },
    [C]
  );
  return J(() => {
    u ? (b(""), m(
      typeof u == "object" ? u.id : u
    )) : m(null);
  }, [u]), /* @__PURE__ */ s.jsx(
    Ne,
    {
      searchable: !0,
      placeholder: Nr(l),
      ...h,
      selectedItems: o,
      hasDropDownIndicator: i,
      items: t ? _ : x,
      onChange: E,
      onClear: w,
      onSelect: w,
      ...t && { onSearch: b }
    }
  );
}, wm = "h-timePicker-range--timeRangePicker__root", vm = "h-timePicker-range--timeRangePicker__timePickerFrom", Sm = "h-timePicker-range--timeRangePicker__timePickerTo", Im = "h-timePicker-range--timeRangePicker__arrowContainer", Dm = "h-timePicker-range--timeRangePicker__arrowContainerHasError", km = "h-timePicker-range--timeRangePicker__arrowContainerHasWarning", Tm = "h-timePicker-range--timeRangePicker__arrowContainerHasSuccess", se = {
  root: wm,
  timePickerFrom: vm,
  timePickerTo: Sm,
  arrowContainer: Im,
  arrowContainerHasError: Dm,
  arrowContainerHasWarning: km,
  arrowContainerHasSuccess: Tm
}, jm = ({
  className: i,
  disabled: t,
  endTime: e,
  onSelect: n,
  overrides: o,
  placeholder: r,
  selectableHours: a = Tr,
  selectableMinutes: l = jr,
  status: c,
  startTime: d,
  allowCustomTimeInput: h = !1,
  timeFormat: u = j.localeData().longDateFormat("LT"),
  ...p
}) => {
  const [{ startTime: m, endTime: g }, b] = V({
    startTime: d || null,
    endTime: e || null
  }), x = q(
    () => Er({
      hours: a,
      minutes: l,
      overrides: o,
      timeFormat: u
    }),
    [a, l, o, u]
  ), C = q(() => {
    const y = x.map(
      ({ id: T }) => j(T, [u])
    ), v = j(m, [u]), I = m && y.findIndex(
      (T) => T > v
    ) || 0;
    return x.slice(I);
  }, [x, m, u]);
  J(() => {
    const y = typeof d == "string", v = typeof d == "string";
    (y && d !== m || v && e !== g) && b((I) => ({
      ...I,
      ...y && { startTime: d },
      ...v && { endTime: e }
    }));
  });
  const _ = F(
    (y) => (v) => void b((I) => {
      const T = j(v, [u]), P = j(I.startTime, [u]), L = j(I.endTime, [u]), k = x.map(
        ({ id: nt }) => j(nt, [u])
      ), R = k.findIndex(
        (nt) => nt >= T
      ) || -1, O = y === "startTime" ? R : k.findIndex(
        (nt) => nt >= P
      ), U = y === "endTime" ? -1 : k.findIndex(
        (nt) => nt >= L
      ), ot = {
        ...I,
        [y]: v,
        ...I.endTime !== null && y !== "endTime" && O >= U && {
          endTime: x[R + 1]?.id || null
        }
      };
      return n(ot), ot;
    }),
    [n]
  ), w = F(
    (y, v) => {
      const I = j(m, [u]);
      if (!I.isValid())
        return !0;
      const P = I.hours(), L = I.minutes();
      return P < y || P === y && L < v;
    },
    [m, u]
  ), S = (y) => r?.[y] || r || Nr(u);
  return /* @__PURE__ */ s.jsxs(at, { className: f(se.root, i), children: [
    /* @__PURE__ */ s.jsx(
      an,
      {
        className: se.timePickerFrom,
        searchable: !0,
        ...p,
        disabled: t,
        hasDropDownIndicator: !1,
        timeOptions: x,
        onSelect: _("startTime"),
        placeholder: S("startTime"),
        allowCustomTimeInput: h,
        selectedItems: m ? [m] : [],
        status: c
      }
    ),
    /* @__PURE__ */ s.jsx(
      at,
      {
        className: f(se.arrowContainer, {
          [se.arrowContainerHasError]: c === "error",
          [se.arrowContainerHasWarning]: c === "warning",
          [se.arrowContainerHasSuccess]: c === "success"
        }),
        children: /* @__PURE__ */ s.jsx(N, { name: "arrow-right" })
      }
    ),
    /* @__PURE__ */ s.jsx(
      an,
      {
        className: se.timePickerTo,
        searchable: !0,
        disabled: t || !m,
        ...p,
        hasDropDownIndicator: !1,
        timeOptions: C,
        onSelect: _("endTime"),
        placeholder: S("endTime"),
        ...h && {
          allowCustomTimeInput: h,
          onIsCustomTimeValid: w
        },
        selectedItems: g ? [g] : [],
        status: c
      }
    )
  ] });
};
class Gt {
  constructor(t, e, n) {
    this.dateFormat = t, this.dateParser = e, this.dateRangeConstraint = n, this.dateFormat = t, this.dateParser = e, this.dateRangeConstraint = n;
  }
  static validationOK = { isValid: !0, error: null };
  isValidDate(t) {
    try {
      return this.dateParser(t).isValid();
    } catch {
      return !1;
    }
  }
  isSingleDateValid(t) {
    if (!this.isValidDate(t))
      return {
        isValid: !1,
        error: "Date is not valid"
      };
    const { minDate: e, maxDate: n } = this.dateRangeConstraint, o = this.dateParser(t);
    return o.isBefore(e, "day") ? {
      isValid: !1,
      error: `Date must be after ${e.format(this.dateFormat)}`
    } : o.isAfter(n, "day") ? {
      isValid: !1,
      error: `Date must be before ${n.format(this.dateFormat)}`
    } : Gt.validationOK;
  }
  /**
   * Mind that this is dependant on end date as well because it's a range
   */
  isStartDateValid({
    startDateInputValue: t,
    endDateInputValue: e
  }) {
    const { minDate: n, maxDate: o } = this.dateRangeConstraint;
    if (!this.isValidDate(t))
      return {
        isValid: !1,
        error: "From date is not valid"
      };
    const r = this.dateParser(t), a = this.dateParser(e);
    return r.isBefore(n, "day") ? {
      isValid: !1,
      error: `From date must be after ${n.format(this.dateFormat)}`
    } : e && this.isValidDate(e) && r.isAfter(a, "day") ? {
      isValid: !1,
      error: `From date must be before ${a.format(
        this.dateFormat
      )}`
    } : r.isAfter(o, "day") ? {
      isValid: !1,
      error: `From date must be before ${o.format(this.dateFormat)}`
    } : Gt.validationOK;
  }
  /**
   * Mind that this is dependant on start date as well because it's a range
   */
  isEndDateValid({
    startDateInputValue: t,
    endDateInputValue: e
  }) {
    const { minDate: n, maxDate: o } = this.dateRangeConstraint;
    if (!this.isValidDate(e))
      return {
        isValid: !1,
        error: "To date is not valid"
      };
    const r = this.dateParser(t), a = this.dateParser(e);
    return a.isAfter(o, "day") ? {
      isValid: !1,
      error: `To date must be before ${o.format(this.dateFormat)}`
    } : t && this.isValidDate(t) && a.isBefore(r, "day") ? {
      isValid: !1,
      error: `To date must be after ${r.format(
        this.dateFormat
      )}`
    } : a.isBefore(n, "day") ? {
      isValid: !1,
      error: `To date must be after ${n.format(this.dateFormat)}`
    } : Gt.validationOK;
  }
  isTimeOrderValid({
    startDate: t,
    endDate: e
  }) {
    return !t || !e ? Gt.validationOK : t.isAfter(e) ? {
      isValid: !1,
      error: "From time should be before to time"
    } : Gt.validationOK;
  }
}
const Nm = "h-datePicker-range-inputFields--dateRangePickerInputFields__root", Fm = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTop", Pm = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTopWithTimezoneSelector", Rm = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementBottom", Em = "h-datePicker-range-inputFields--dateRangePickerInputFields__fields", Lm = "h-datePicker-range-inputFields--dateRangePickerInputFields__input", Am = "h-datePicker-range-inputFields--dateRangePickerInputFields__alert", Kt = {
  root: Nm,
  rootPlacementTop: Fm,
  rootPlacementTopWithTimezoneSelector: Pm,
  rootPlacementBottom: Rm,
  fields: Em,
  input: Lm,
  alert: Am
};
Array(24).fill(0).map((i, t) => t);
class Qs extends D {
  dateRangeValidators;
  timeOptions;
  instanceId;
  constructor(t) {
    super(t);
    const { dateFormat: e } = t;
    this.state = {
      startDateInputValue: this.props.startDate?.format(e) ?? "",
      startDateError: null,
      endDateInputValue: this.props.endDate?.format(e) ?? "",
      endDateError: null,
      timeOrderError: null
    }, this.timeOptions = [], this.instanceId = Qs.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateStartDateChangeEvent = this.propagateStartDateChangeEvent.bind(this), this.propagateEndDateChangeEvent = this.propagateEndDateChangeEvent.bind(this), this.dateRangeValidators = new Gt(
      t.dateFormat,
      this.parseDateString,
      { maxDate: t.maxDate, minDate: t.minDate }
    );
  }
  componentDidUpdate(t) {
    this.syncStartDateWithProps(t), this.syncEndDateWithProps(t), this.validateTimesOrder();
  }
  static instanceCount = 0;
  validateTimesOrder() {
    const { startDate: t, endDate: e } = this.props, { isValid: n, error: o } = this.dateRangeValidators.isTimeOrderValid({
      startDate: t,
      endDate: e
    });
    n ? this.setState({ timeOrderError: null }) : this.setState({
      timeOrderError: o
    });
  }
  syncEndDateWithProps(t) {
    const { endDate: e, timeRoundingStrategy: n } = this.props;
    if (!(e === t.endDate || e?.isSame(t.endDate, n)))
      return this.props.endDate ? this.setState({
        endDateError: null,
        endDateInputValue: this.props.endDate.format(this.props.dateFormat)
      }) : this.setState({
        endDateError: null,
        endDateInputValue: ""
      });
  }
  syncStartDateWithProps(t) {
    const { startDate: e, timeRoundingStrategy: n } = this.props;
    if (!(e === t.startDate || e?.isSame(t.startDate, n)))
      return this.props.startDate ? this.setState({
        startDateError: null,
        startDateInputValue: this.props.startDate.format(this.props.dateFormat)
      }) : this.setState({
        startDateError: null,
        startDateInputValue: ""
      });
  }
  handleInputValueChange(t, e) {
    const n = t.target.value;
    switch (e) {
      case "startDate":
        this.setState(
          { startDateInputValue: this.ensureValidChars(n) },
          this.propagateStartDateChangeEvent
        );
        break;
      case "endDate":
        this.setState(
          { endDateInputValue: this.ensureValidChars(n) },
          this.propagateEndDateChangeEvent
        );
        break;
    }
  }
  propagateStartDateChangeEvent() {
    const { startDateInputValue: t, endDateInputValue: e } = this.state;
    if (t === "") {
      this.props.onStartDateChange(null);
      return;
    }
    const { isValid: n, error: o } = this.dateRangeValidators.isStartDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    });
    if (!n) {
      this.setState({ startDateError: o });
      return;
    }
    const { isValid: r, error: a } = this.dateRangeValidators.isEndDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    }), l = e !== "" && !r ? a : null;
    this.setState(
      {
        startDateError: null,
        endDateError: l
      },
      () => this.props.onStartDateChange(this.parseDateString(t))
    );
  }
  propagateEndDateChangeEvent() {
    const { startDateInputValue: t, endDateInputValue: e } = this.state;
    if (e === "") {
      this.props.onEndDateChange(null);
      return;
    }
    const { isValid: n, error: o } = this.dateRangeValidators.isEndDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    });
    if (!n) {
      this.setState({ endDateError: o });
      return;
    }
    const { isValid: r, error: a } = this.dateRangeValidators.isStartDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    }), l = t !== "" && !r ? a : null;
    this.setState(
      {
        endDateError: null,
        startDateError: l
      },
      () => this.props.onEndDateChange(this.parseDateString(e))
    );
  }
  parseDateString(t) {
    return j(t, this.props.dateFormat, !0);
  }
  ensureValidChars(t) {
    return t.replace(/[^0-9/]/g, "");
  }
  getOverrides(t) {
    if (t !== "startTime")
      return [
        {
          hour: 23,
          minute: 59
        }
      ];
  }
  renderFields(t, e, n, o, r, a, l) {
    const {
      dateFormat: c,
      disabled: d,
      focusedInput: h,
      onFocusChange: u,
      onTimeChange: p,
      timeFormat: m,
      withTimePicker: g,
      withDateInput: b
    } = this.props, { timeOrderError: x } = this.state;
    return /* @__PURE__ */ s.jsxs("div", { children: [
      /* @__PURE__ */ s.jsx(Gs, { children: t === "startDate" ? "From" : "To" }),
      b && /* @__PURE__ */ s.jsx(
        Yt,
        {
          className: Kt.input,
          placeholder: c.toLowerCase(),
          name: `input__${t}__${this.instanceId}`,
          value: r,
          onChange: (C) => this.handleInputValueChange(C, t),
          onFocus: () => u(t),
          autoComplete: "off",
          status: a ? "error" : void 0,
          disabled: d,
          active: h === t
        }
      ),
      g && /* @__PURE__ */ s.jsx("div", { className: Kt.input, children: /* @__PURE__ */ s.jsx(
        st,
        {
          content: "Please select a date first.",
          disabled: !!n || d,
          side: "right",
          children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
            an,
            {
              disabled: !n,
              overrides: this.getOverrides(e),
              selectedItems: o ? [o] : void 0,
              status: x ? "error" : void 0,
              ...l,
              timeFormat: m,
              onSelect: (C) => p(e, C)
            }
          ) })
        }
      ) })
    ] });
  }
  getError() {
    const { startDateError: t, endDateError: e, timeOrderError: n } = this.state;
    return t || e || n || null;
  }
  renderErrors() {
    const t = this.getError();
    return /* @__PURE__ */ s.jsx(
      ts,
      {
        className: Kt.alert,
        variant: t ? "error" : void 0,
        children: t
      }
    );
  }
  render() {
    const {
      startDate: t,
      startTime: e,
      endDate: n,
      endTime: o,
      timePickerProps: r = { start: {}, end: {} },
      hasTimezoneSelector: a
    } = this.props, {
      startDateInputValue: l,
      startDateError: c,
      endDateInputValue: d,
      endDateError: h
    } = this.state, { placement: u } = this.props, p = f(Kt.root, {
      [Kt.rootPlacementTop]: u === "top",
      [Kt.rootPlacementTopWithTimezoneSelector]: u === "top" && a,
      [Kt.rootPlacementBottom]: u === "bottom"
    });
    return /* @__PURE__ */ s.jsxs("div", { className: p, children: [
      /* @__PURE__ */ s.jsxs("div", { className: Kt.fields, children: [
        this.renderFields(
          "startDate",
          "startTime",
          t,
          e,
          l,
          c,
          r.start
        ),
        this.renderFields(
          "endDate",
          "endTime",
          n,
          o,
          d,
          h,
          r.end
        )
      ] }),
      this.renderErrors()
    ] });
  }
}
const $m = "dateRangePickerTestId";
class Om extends D {
  static defaultProps = {
    withDateInput: !0,
    withTimePicker: !1,
    timePickerProps: { start: {}, end: {} },
    inputsPlacement: "bottom",
    timeRoundingStrategy: "day"
  };
  constructor(t) {
    super(t);
    const {
      startDate: e,
      endDate: n,
      timezone: o,
      presetKey: r,
      presets: a,
      focusedInput: l = "startDate"
    } = t;
    this.state = {
      startTime: e ? j(e).format(Rt) : null,
      endTime: n ? j(n).format(Rt) : null,
      timezone: Te(o) ? o : j.tz.guess(!0),
      presetKey: a?.find(({ key: c }) => c === r)?.key ?? null,
      focusedInput: l,
      dateRangePickerKey: 0
    }, this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onDatesChange = this.onDatesChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.handleFocusChange = this.handleFocusChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onStartDateChange = this.onStartDateChange.bind(this), this.onEndDateChange = this.onEndDateChange.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
  }
  componentDidUpdate(t) {
    this.updateTimeOnDateChange(t), this.recalculateDatePickerKey(t), this.updateTimezoneFromProps(t), this.updatePresetKey(t);
  }
  visibleCalendarMonthRef = B();
  updatePresetKey(t) {
    const { presetKey: e } = this.props;
    t.presetKey !== e && this.setState({
      presetKey: this.props.presets?.find(({ key: n }) => n === e)?.key ?? null
    });
  }
  updateTimezoneFromProps(t) {
    const { timezone: e } = this.props;
    t.timezone !== e && Te(e) && this.setState({ timezone: e });
  }
  getDateConstraints() {
    const { maxDate: t, minDate: e } = this.props, n = this.dateFormat;
    return {
      minDate: e ? j(e, n) : j("0001-01-01"),
      maxDate: t ? j(t, n) : j("9999-12-31")
    };
  }
  onTimezoneChange(t) {
    const { startDate: e, endDate: n } = this.props, { presetKey: o } = this.state;
    this.setState(
      { timezone: t },
      () => this.onDatesChange({ startDate: e, endDate: n }, o)
    );
  }
  onStartDateChange(t) {
    this.onDatesChange({ startDate: t, endDate: this.props.endDate });
  }
  onEndDateChange(t) {
    this.onDatesChange({ endDate: t, startDate: this.props.startDate });
  }
  onDatesChange(t, e = null) {
    const { startTime: n, endTime: o, timezone: r } = this.state, { timeRoundingStrategy: a } = this.props, l = this.addTimezoneToDate(
      t.startDate,
      r
    ), c = this.addTimezoneToDate(
      t.endDate,
      r
    );
    let d = l?.clone().startOf(a) || null, h = c?.clone().endOf(a) || null, u = t.startDate?.clone().startOf(a) || null, p = t.endDate?.clone().endOf(a) || null;
    if (this.setState({ presetKey: e }), e) {
      this.setState(
        {
          startTime: t.startDate?.clone().startOf(a).format(Rt) ?? null,
          endTime: t.endDate?.clone().startOf(a).format(Rt) ?? null
        },
        () => {
          this.props.onChange({
            startDate: d,
            localStartDate: u,
            endDate: h,
            localEndDate: p,
            timezone: r,
            localTimezone: j.tz.guess(!0),
            presetKey: e
          });
        }
      );
      return;
    }
    n && (d = this.addTimeToDate(
      l,
      n,
      "startDate"
    ), u = this.addTimeToDate(
      t.startDate,
      n,
      "startDate"
    )), o && (h = this.addTimeToDate(c, o, "endDate"), p = this.addTimeToDate(t.endDate, o, "endDate")), this.props.onChange({
      startDate: d,
      localStartDate: u,
      endDate: h,
      localEndDate: p,
      timezone: r,
      localTimezone: j.tz.guess(!0)
    });
  }
  onPresetSelect(t) {
    if (!t)
      this.onDatesChange({ startDate: null, endDate: null });
    else {
      const { startDate: e, endDate: n, key: o } = t;
      this.onDatesChange({ startDate: e, endDate: n }, o);
    }
    this.handleFocusChange("startDate");
  }
  handleTimeChange(t, e) {
    const { startDate: n, endDate: o } = this.props;
    this.setState(
      (r) => ({
        ...r,
        [t]: e
      }),
      () => this.onDatesChange({ startDate: n, endDate: o })
    );
  }
  addTimezoneToDate(t, e) {
    if (!t) return null;
    const { timeRoundingStrategy: n } = this.props;
    return Te(e) ? t.clone().tz(e, !0) : t.clone().startOf(n);
  }
  handleFocusChange(t) {
    this.setState({ focusedInput: t ?? "startDate" });
  }
  addTimeToDate(t, e, n) {
    if (!t)
      return null;
    const { timeRoundingStrategy: o } = this.props, [r, a] = e.split(":");
    return !r || !a ? n === "startDate" ? t.clone().startOf(o) : t.clone().endOf(o) : t.clone().set({
      hours: parseInt(r, 10),
      minutes: parseInt(a, 10),
      seconds: 0,
      milliseconds: 0
    });
  }
  isDateOutsideOfSelectableRange(t) {
    if (this.props.disabled)
      return !0;
    const { timeRoundingStrategy: e } = this.props, { minDate: n, maxDate: o } = this.getDateConstraints();
    return !t.isBetween(n, o, e);
  }
  updateTimeOnDateChange({
    startDate: t,
    endDate: e
  }) {
    const { startDate: n, endDate: o } = this.props;
    n?.isSame(t) || this.setState({
      startTime: n ? j(n).format(Rt) : null
    }), o?.isSame(e) || this.setState({
      endTime: o ? j(o).format(Rt) : null
    });
  }
  recalculateDatePickerKey({
    startDate: t,
    endDate: e
  }) {
    const { startDate: n, endDate: o } = this.props;
    if (e && t && !n && !o)
      return this.setState({ dateRangePickerKey: this.generateRandomKey() });
    if (!(!o && !e) && !(!o && e)) {
      if (o && !e) {
        const r = this.visibleCalendarMonthRef.current?.state.currentMonth;
        if (this.visibleCalendarMonthRef.current && o.isSame(r, "month"))
          return;
        this.setState({ dateRangePickerKey: this.generateRandomKey() });
      }
      if (o && e) {
        if (o.isSame(e, "month"))
          return;
        this.setState({ dateRangePickerKey: this.generateRandomKey() });
      }
    }
  }
  generateRandomKey() {
    return Math.floor(Math.random() * 1e8);
  }
  get dateFormat() {
    const { dateFormat: t } = this.props;
    return t || j.localeData().longDateFormat("L");
  }
  renderTimezoneSelector() {
    const {
      startDate: t,
      endDate: e,
      disabled: n,
      withTimezoneSelector: o,
      timezoneSelectorProps: r
    } = this.props, { timezone: a } = this.state;
    if (!o)
      return null;
    const l = !!t || !!e, c = !l && !n, d = !l || n || r?.disabled;
    return /* @__PURE__ */ s.jsx(
      Br,
      {
        disabled: d,
        tooltipProps: {
          content: "Please select a date first",
          disabled: !c,
          ...r?.tooltipProps
        },
        onChange: this.onTimezoneChange,
        selectedTimezone: a
      }
    );
  }
  renderInputFields(t) {
    const {
      withDateInput: e,
      withTimePicker: n,
      withTimezoneSelector: o,
      timePickerProps: r,
      disabled: a,
      startDate: l,
      endDate: c,
      selectableMinutes: d,
      selectableHours: h,
      inputsPlacement: u,
      timeFormat: p,
      timeRoundingStrategy: m
    } = this.props;
    if (u !== t || !e && !n)
      return null;
    const { startTime: g, endTime: b, focusedInput: x } = this.state, { minDate: C, maxDate: _ } = this.getDateConstraints();
    return /* @__PURE__ */ s.jsx(
      Qs,
      {
        dateFormat: this.dateFormat,
        timeFormat: p,
        onStartDateChange: this.onStartDateChange,
        onEndDateChange: this.onEndDateChange,
        onTimeChange: this.handleTimeChange,
        onFocusChange: this.handleFocusChange,
        startDate: l,
        endDate: c,
        startTime: g,
        endTime: b,
        minDate: C,
        maxDate: _,
        disabled: a,
        withDateInput: e,
        withTimePicker: n,
        hasTimezoneSelector: o,
        timePickerProps: r,
        selectableMinutes: d,
        selectableHours: h,
        placement: t,
        timeRoundingStrategy: m,
        focusedInput: x
      }
    );
  }
  renderPresets() {
    const { presets: t } = this.props, { presetKey: e } = this.state;
    return t?.length ? /* @__PURE__ */ s.jsx(
      $r,
      {
        value: e,
        presets: t,
        onSelect: this.onPresetSelect
      }
    ) : null;
  }
  render() {
    const { className: t, calendarProps: e, disabled: n, startDate: o, endDate: r } = this.props, a = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Vn.previousMonth, l = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Vn.nextMonth;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": $m,
        className: f(ke.root, t),
        children: [
          /* @__PURE__ */ s.jsxs(H, { flexDirection: "column", alignItems: "center", children: [
            this.renderTimezoneSelector(),
            this.renderInputFields("top"),
            /* @__PURE__ */ s.jsx(
              yr.DayPickerRangeController,
              {
                ref: this.visibleCalendarMonthRef,
                startDate: o,
                endDate: r,
                onDatesChange: this.onDatesChange,
                onFocusChange: this.handleFocusChange,
                focusedInput: this.state.focusedInput,
                isOutsideRange: this.isDateOutsideOfSelectableRange,
                numberOfMonths: 1,
                hideKeyboardShortcutsPanel: !0,
                noBorder: !0,
                renderDayContents: Lr,
                daySize: 32,
                minimumNights: 0,
                disabled: n,
                renderNavPrevButton: a,
                renderNavNextButton: l,
                renderMonthElement: Ar,
                initialVisibleMonth: () => o || r || j(),
                transitionDuration: 0,
                ...e
              },
              this.state.dateRangePickerKey
            ),
            this.renderInputFields("bottom")
          ] }),
          this.renderPresets()
        ]
      }
    );
  }
}
const Bm = "h-datePicker-single-inputFields--datePickerInputFields__root", Hm = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTop", Wm = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTopWithTimezoneSelector", Mm = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementBottom", zm = "h-datePicker-single-inputFields--datePickerInputFields__input", Vm = "h-datePicker-single-inputFields--datePickerInputFields__alert", oe = {
  root: Bm,
  rootPlacementTop: Hm,
  rootPlacementTopWithTimezoneSelector: Wm,
  rootPlacementBottom: Mm,
  input: zm,
  alert: Vm
};
class Zs extends D {
  dateValidators;
  instanceId;
  constructor(t) {
    super(t);
    const { dateFormat: e } = t;
    this.state = {
      dateInputValue: this.props.date?.format(e) ?? "",
      dateError: null
    }, this.instanceId = Zs.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateDateChangeEvent = this.propagateDateChangeEvent.bind(this), this.dateValidators = new Gt(
      t.dateFormat,
      this.parseDateString,
      { maxDate: t.maxDate, minDate: t.minDate }
    );
  }
  componentDidUpdate(t) {
    this.syncDateWithProps(t);
  }
  static instanceCount = 0;
  syncDateWithProps(t) {
    const { date: e, timeRoundingStrategy: n } = this.props, o = j(e);
    if (!(e === t.date || o?.isSame(j(t.date), n)))
      return this.props.date ? this.setState({
        dateError: null,
        dateInputValue: o.format(this.props.dateFormat)
      }) : this.setState({
        dateError: null,
        dateInputValue: ""
      });
  }
  handleInputValueChange(t) {
    const e = this.ensureValidChars(t.target.value);
    this.setState({ dateInputValue: e }, this.propagateDateChangeEvent);
  }
  propagateDateChangeEvent() {
    const { dateInputValue: t } = this.state;
    if (t === "") {
      this.props.onDateChange(null);
      return;
    }
    const { isValid: e, error: n } = this.dateValidators.isSingleDateValid(t);
    if (!e) {
      this.setState({ dateError: n });
      return;
    }
    this.setState(
      {
        dateError: null
      },
      () => this.props.onDateChange(this.parseDateString(t))
    );
  }
  parseDateString(t) {
    return j(t, this.props.dateFormat, !0);
  }
  ensureValidChars(t) {
    return t.replace(/[^0-9/]/g, "");
  }
  renderDateInput() {
    const { disabled: t, dateFormat: e, withDateInput: n } = this.props, { dateInputValue: o, dateError: r } = this.state;
    return n ? /* @__PURE__ */ s.jsx(
      Yt,
      {
        className: oe.input,
        required: !0,
        name: `date__input__${this.instanceId}`,
        value: o,
        onChange: this.handleInputValueChange,
        autoComplete: "off",
        placeholder: e.toLowerCase(),
        disabled: t,
        status: r ? "error" : void 0
      }
    ) : null;
  }
  renderTimeInput() {
    const {
      date: t,
      time: e,
      withTimePicker: n,
      timePickerProps: o = {},
      disabled: r,
      onTimeChange: a,
      timeFormat: l
    } = this.props;
    if (!n)
      return null;
    const c = !t && !r, d = !t || r;
    return /* @__PURE__ */ s.jsx(
      st,
      {
        content: "Please select a date first.",
        disabled: !c,
        side: "right",
        children: /* @__PURE__ */ s.jsx("div", { className: oe.input, children: /* @__PURE__ */ s.jsx(
          an,
          {
            disabled: d,
            onSelect: a,
            selectedItems: e ? [e] : void 0,
            ...o,
            timeFormat: l
          }
        ) })
      }
    );
  }
  renderErrors() {
    const { dateError: t } = this.state;
    return /* @__PURE__ */ s.jsx(
      ts,
      {
        className: oe.alert,
        variant: t ? "error" : void 0,
        children: this.state.dateError
      }
    );
  }
  render() {
    const { hasTimezoneSelector: t, placement: e } = this.props, n = f(oe.root, {
      [oe.rootPlacementTop]: e === "top",
      [oe.rootPlacementTopWithTimezoneSelector]: e === "top" && t,
      [oe.rootPlacementBottom]: e === "bottom"
    });
    return /* @__PURE__ */ s.jsxs("div", { className: n, children: [
      this.renderDateInput(),
      this.renderTimeInput(),
      this.renderErrors()
    ] });
  }
}
const Km = "datePickerTestId";
class Um extends D {
  static defaultProps = {
    dateFormat: j.localeData().longDateFormat("L"),
    withDateInput: !1,
    withTimePicker: !1,
    timePickerProps: {},
    inputsPlacement: "bottom",
    timeRoundingStrategy: "day"
  };
  constructor(t) {
    super(t);
    const { date: e, timezone: n, presets: o, presetKey: r } = t;
    this.state = {
      time: e ? j(e).format(Rt) : null,
      timezone: Te(n) ? n : j.tz.guess(!0),
      presetKey: o?.find(({ key: a }) => a === r)?.key ?? null,
      datePickerKey: 0
    }, this.onDateChange = this.onDateChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
  }
  componentDidUpdate(t) {
    this.updateTimeOnDateChange(t), this.recalculateDatePickerKey();
  }
  visibleCalendarMonthRef = B();
  getDateConstraints() {
    const { maxDate: t, minDate: e } = this.props;
    return {
      minDate: e || j("0001-01-01"),
      maxDate: t || j("9999-12-31")
    };
  }
  onTimezoneChange(t) {
    const { date: e } = this.props, { presetKey: n } = this.state;
    this.setState({ timezone: t }, () => this.onDateChange(e, n));
  }
  onDateChange(t, e = null) {
    const { time: n, timezone: o } = this.state, { timeRoundingStrategy: r } = this.props, a = this.addTimezoneToDate(t, o);
    let l = a?.clone().startOf(r) || null, c = t?.clone().startOf(r) || null;
    if (this.setState({ presetKey: e }), e) {
      this.setState(
        {
          time: t?.clone().startOf(r).format(Rt) ?? null
        },
        () => {
          this.props.onChange({
            date: l,
            localDate: c,
            timezone: o,
            localTimezone: j.tz.guess(!0),
            presetKey: e
          });
        }
      );
      return;
    }
    n && (l = this.addTimeToDate(a, n), c = this.addTimeToDate(t, n)), this.props.onChange({
      date: l,
      localDate: c,
      timezone: o,
      localTimezone: j.tz.guess(!0)
    });
  }
  onPresetSelect(t) {
    t ? this.onDateChange(t.date, t.key) : this.onDateChange(null);
  }
  handleTimeChange(t) {
    const { date: e } = this.props;
    this.setState(
      (n) => ({
        ...n,
        time: t
      }),
      () => this.onDateChange(e)
    );
  }
  addTimezoneToDate(t, e) {
    if (!t) return null;
    const { timeRoundingStrategy: n } = this.props;
    return Te(e) ? j(t).clone().tz(e, !0) : t.clone().startOf(n);
  }
  addTimeToDate(t, e) {
    if (!t) return null;
    const { timeRoundingStrategy: n } = this.props, [o, r] = e.split(":");
    return !o || !r ? t.clone().startOf(n) : t.clone().set({
      hours: parseInt(o, 10),
      minutes: parseInt(r, 10),
      seconds: 0,
      milliseconds: 0
    });
  }
  isDateOutsideOfSelectableRange(t) {
    const { disabled: e, timeRoundingStrategy: n } = this.props;
    if (e)
      return !0;
    const { minDate: o, maxDate: r } = this.getDateConstraints();
    return !t.isBetween(o, r, n);
  }
  updateTimeOnDateChange(t) {
    const { date: e } = this.props;
    t.date?.isSame(e) || this.setState({
      time: e ? j(e).format(Rt) : null
    });
  }
  recalculateDatePickerKey() {
    const { date: t } = this.props, e = this.visibleCalendarMonthRef.current?.state.currentMonth;
    if (e && t && !t.isSame(e, "month"))
      return this.setState({ datePickerKey: this.generateRandomKey() });
  }
  generateRandomKey() {
    return Math.floor(Math.random() * 1e8);
  }
  renderTimezoneSelector() {
    const { date: t, disabled: e, withTimezoneSelector: n, timezoneSelectorProps: o } = this.props, { timezone: r } = this.state;
    if (!n)
      return null;
    const a = !!t, l = !a && !e, c = !a || e || o?.disabled;
    return /* @__PURE__ */ s.jsx(
      Br,
      {
        disabled: c,
        tooltipProps: {
          content: "Please select a date first",
          disabled: !l,
          ...o?.tooltipProps
        },
        onChange: this.onTimezoneChange,
        selectedTimezone: r,
        ...o
      }
    );
  }
  renderInputFields(t) {
    const {
      dateFormat: e,
      timeFormat: n,
      withDateInput: o,
      withTimePicker: r,
      withTimezoneSelector: a,
      timePickerProps: l,
      selectableMinutes: c,
      selectableHours: d,
      disabled: h,
      date: u,
      inputsPlacement: p,
      timeRoundingStrategy: m
    } = this.props;
    if (p !== t || !o && !r)
      return null;
    const { time: g } = this.state, { minDate: b, maxDate: x } = this.getDateConstraints();
    return /* @__PURE__ */ s.jsx(
      Zs,
      {
        dateFormat: e,
        timeFormat: n,
        onDateChange: this.onDateChange,
        onTimeChange: this.handleTimeChange,
        time: g,
        date: u,
        minDate: b,
        maxDate: x,
        disabled: h,
        withDateInput: o,
        withTimePicker: r,
        hasTimezoneSelector: a,
        timePickerProps: l,
        selectableMinutes: c,
        selectableHours: d,
        placement: t,
        timeRoundingStrategy: m
      }
    );
  }
  renderPresets() {
    const { presets: t } = this.props, { presetKey: e } = this.state;
    return t?.length ? /* @__PURE__ */ s.jsx(
      $r,
      {
        value: e,
        presets: t,
        onSelect: this.onPresetSelect
      }
    ) : null;
  }
  render() {
    const { className: t, calendarProps: e, disabled: n, date: o } = this.props, { datePickerKey: r } = this.state, a = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Vn.previousMonth, l = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Vn.nextMonth;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Km,
        className: f(ke.root, t),
        children: [
          /* @__PURE__ */ s.jsxs(H, { flexDirection: "column", alignItems: "center", children: [
            this.renderTimezoneSelector(),
            this.renderInputFields("top"),
            /* @__PURE__ */ s.jsx(
              yr.DayPickerSingleDateController,
              {
                ref: this.visibleCalendarMonthRef,
                date: o,
                onDateChange: this.onDateChange,
                isOutsideRange: this.isDateOutsideOfSelectableRange,
                numberOfMonths: 1,
                hideKeyboardShortcutsPanel: !0,
                noBorder: !0,
                renderDayContents: Lr,
                daySize: 32,
                renderNavPrevButton: a,
                renderNavNextButton: l,
                renderMonthElement: Ar,
                initialVisibleMonth: () => o || j(),
                onFocusChange: E,
                focused: !0,
                transitionDuration: 0,
                ...e
              },
              r
            ),
            this.renderInputFields("bottom")
          ] }),
          this.renderPresets()
        ]
      }
    );
  }
}
const qm = "h-dialer--dialer__dialer", Gm = "h-dialer--dialer__number", Ym = "h-dialer--dialer__letters", Xm = "h-dialer--dialer__asterisk", Bn = {
  dialer: qm,
  number: Gm,
  letters: Ym,
  asterisk: Xm
}, Qm = [
  { value: "1", letters: " " },
  { value: "2", letters: "abc" },
  { value: "3", letters: "def" },
  { value: "4", letters: "ghi" },
  { value: "5", letters: "jkl" },
  { value: "6", letters: "mno" },
  { value: "7", letters: "pqrs" },
  { value: "8", letters: "tuv" },
  { value: "9", letters: "wxyz" },
  { value: "*", letters: null, classNames: Bn.asterisk },
  { value: "0", letters: null },
  { value: "#", letters: null }
];
class Kk extends D {
  render() {
    const { className: t, onInput: e, ...n } = this.props, o = f(Bn.dialer, t);
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: Qm.map((r) => /* @__PURE__ */ Oi(
      "div",
      {
        className: f(Bn.number),
        ...Xn(() => e(r.value)),
        key: r.value
      },
      /* @__PURE__ */ s.jsx(A.Heading, { variant: "heading-1", color: "neutral.700", children: /* @__PURE__ */ s.jsx("span", { className: r.classNames ?? "", children: r.value }) }),
      /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "1", color: "neutral.700", children: !!r.letters && /* @__PURE__ */ s.jsx("span", { className: Bn.letters, children: r.letters }) })
    )) });
  }
}
const Zm = "h-fieldWrapper--fieldWrapper__root", Jm = "h-fieldWrapper--fieldWrapper__rootDisabled", tg = "h-fieldWrapper--fieldWrapper__label", eg = "h-fieldWrapper--fieldWrapper__alert", vn = {
  root: Zm,
  rootDisabled: Jm,
  label: tg,
  alert: eg
}, ng = "fieldWrapper";
class z extends D {
  static hasStatus(t, e) {
    return t?.[e] ? t?.touched === void 0 || t.touched === !0 : !1;
  }
  static getStatusMessage(t, e) {
    if (this.hasStatus(t, e))
      return t?.[e];
  }
  static getStatus(t) {
    return z.hasStatus(t, "error") ? "error" : z.hasStatus(t, "warning") ? "warning" : z.hasStatus(t, "success") ? "success" : void 0;
  }
  renderAlerts() {
    const { meta: t, description: e } = this.props;
    let n = e, o;
    return z.hasStatus(t, "error") ? (n = z.getStatusMessage(t, "error"), o = "error") : z.hasStatus(t, "warning") ? (n = z.getStatusMessage(t, "warning"), o = "warning") : z.hasStatus(t, "success") && (n = z.getStatusMessage(t, "success"), o = "success"), /* @__PURE__ */ s.jsx(ts, { variant: o, className: vn.alert, children: n });
  }
  render() {
    const {
      className: t,
      labelFor: e,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      noAlert: c,
      noLabel: d,
      children: h,
      ...u
    } = this.props, p = f(
      vn.root,
      {
        [vn.rootDisabled]: a
      },
      t
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": ng,
        ...u,
        className: p,
        children: [
          !d && /* @__PURE__ */ s.jsx(
            Gs,
            {
              required: r,
              htmlFor: e,
              helpIcon: l,
              className: vn.label,
              children: n
            }
          ),
          h,
          !c && this.renderAlerts()
        ]
      }
    );
  }
}
class Es extends D {
  render() {
    const {
      className: t,
      input: e,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noLabel: d,
      noAlert: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: n,
        labelFor: e.name,
        meta: o,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noLabel: d,
        noAlert: h,
        children: /* @__PURE__ */ s.jsx(
          Yt,
          {
            status: z.getStatus(o),
            disabled: a,
            required: r,
            ...e,
            ...u
          }
        )
      }
    );
  }
}
const sg = "h-dropdownSelect--dropdownSelectContainer__search", og = "h-dropdownSelect--dropdownSelectContainer__pagination", rg = "h-dropdownSelect--dropdownSelectContainer__selectionActions", ig = "h-dropdownSelect--dropdownSelectContainer__extra", Sn = {
  search: sg,
  pagination: og,
  selectionActions: rg,
  extra: ig
}, ag = "DROP_SEARCH_INPUT";
class Hr extends ft {
  listRef;
  searchRef;
  static getDerivedStateFromProps(t, e) {
    const { dropdownOpen: n } = t, o = { ...e };
    return n || (o.searchValue = "", o.activeItemIndex = 0), o;
  }
  constructor(t) {
    super(t), this.state = {
      searchValue: "",
      activeItemIndex: 0
    }, this.search = this.search.bind(this), this.searchKeyDown = this.searchKeyDown.bind(this), this.handleItemKeyDown = this.handleItemKeyDown.bind(this), this.onSelect = this.onSelect.bind(this), this.onChange = this.onChange.bind(this), this.listRef = B(), this.searchRef = B();
  }
  componentDidMount() {
    this.onOpen();
  }
  componentDidUpdate(t) {
    const { dropdownOpen: e } = this.props;
    !t.dropdownOpen && e && this.onOpen();
  }
  getInput() {
    const { searchValue: t } = this.state;
    return {
      name: ag,
      value: t,
      onChange: this.search,
      onKeyDown: this.searchKeyDown,
      autoComplete: "off",
      "aria-label": "Search"
    };
  }
  searchKeyDown(t) {
    const { key: e } = t, { searchValue: n, activeItemIndex: o } = this.state, { triggerClose: r, items: a, disabledItems: l = [] } = this.props, c = a.map((h, u) => ({ item: h, index: u })).filter(({ item: h }) => !l.includes(h.id)).map(({ index: h }) => h), d = c.indexOf(o);
    if (e === "Escape")
      n === "" ? r() : this.clearSearch();
    else if (e === "ArrowDown") {
      if (t.preventDefault(), c.length > 0) {
        const h = d < c.length - 1 ? d + 1 : 0;
        this.setState(
          { activeItemIndex: c[h] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (e === "ArrowUp") {
      if (t.preventDefault(), c.length > 0) {
        const h = d > 0 ? d - 1 : c.length - 1;
        this.setState(
          { activeItemIndex: c[h] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (e === "Home")
      t.preventDefault(), c.length > 0 && this.setState(
        { activeItemIndex: c[0] },
        () => this.listRef.current?.focusActiveItem()
      );
    else if (e === "End")
      t.preventDefault(), c.length > 0 && this.setState(
        {
          activeItemIndex: c[c.length - 1]
        },
        () => this.listRef.current?.focusActiveItem()
      );
    else if (e === "Enter") {
      t.preventDefault();
      const h = a[o];
      if (h && !l.includes(h.id)) {
        const { onChange: u, selectedItems: p = [] } = this.props;
        if (u) {
          const m = p.some((g) => (typeof g == "object" ? g.id : g) === h.id);
          this.onChange(h, !m);
        } else
          this.onSelect(h);
      }
    }
  }
  handleItemKeyDown(t) {
    const { key: e } = t, { activeItemIndex: n } = this.state, { triggerClose: o, items: r, disabledItems: a = [] } = this.props, l = r.map((d, h) => ({ item: d, index: h })).filter(({ item: d }) => !a.includes(d.id)).map(({ index: d }) => d), c = l.indexOf(n);
    if (e === "Escape")
      o();
    else if (e === "ArrowDown") {
      if (t.preventDefault(), l.length > 0) {
        const d = c < l.length - 1 ? c + 1 : 0;
        this.setState(
          { activeItemIndex: l[d] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (e === "ArrowUp") {
      if (t.preventDefault(), l.length > 0) {
        const d = c > 0 ? c - 1 : l.length - 1;
        this.setState(
          { activeItemIndex: l[d] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else e === "Home" ? (t.preventDefault(), l.length > 0 && this.setState(
      { activeItemIndex: l[0] },
      () => this.listRef.current?.focusActiveItem()
    )) : e === "End" && (t.preventDefault(), l.length > 0 && this.setState(
      {
        activeItemIndex: l[l.length - 1]
      },
      () => this.listRef.current?.focusActiveItem()
    ));
  }
  search(t) {
    const { onSearch: e } = this.props, { value: n } = t.target;
    typeof e == "function" && e(n), n && this.listRef.current && this.listRef.current.goToTop(), this.setState({
      searchValue: n,
      activeItemIndex: 0
    });
  }
  onSelect(t) {
    const { onSelect: e, keepOpen: n, triggerClose: o } = this.props;
    typeof e == "function" && e(t), n && this.focusSearch(), !n && typeof o == "function" && o();
  }
  onChange(t, e) {
    const { onChange: n, keepOpen: o, triggerClose: r } = this.props;
    typeof n == "function" && n(t, e), o && this.focusSearch(), !o && typeof r == "function" && r();
  }
  onOpen() {
    const { hasSearch: t } = this.props;
    t ? this.focusSearch() : setTimeout(() => {
      this.listRef.current?.focusActiveItem();
    }, 0);
  }
  focusSearch() {
    const { hasSearch: t } = this.props;
    if (t && this.searchRef.current) {
      const e = this.searchRef.current.querySelector("input");
      e && e.focus();
    }
  }
  clearSearch = () => {
    const { onSearch: t } = this.props, { searchValue: e } = this.state;
    e && (typeof t == "function" && t(""), this.setState({ searchValue: "" }));
  };
  render() {
    const {
      className: t,
      itemComponent: e,
      emptyComponent: n,
      suggestionComponent: o,
      optionComponent: r,
      items: a,
      hasSearch: l,
      searchPlaceholder: c,
      pagination: d,
      keepOpen: h,
      onSelect: u,
      onSearch: p,
      onSuggest: m,
      onChange: g,
      onClear: b,
      onClearText: x,
      triggerClose: C,
      dropdownOpen: _,
      emptyMessage: w,
      selectedItems: S,
      disabledItems: y,
      tooltipItems: v,
      activeItem: I,
      itemsDisplayCount: T,
      itemHeight: P,
      renderSuggestion: L,
      searchSuggestion: k,
      ...R
    } = this.props;
    if (!_)
      return null;
    const { searchValue: O, activeItemIndex: U } = this.state, ot = a.length === 0, nt = a[U] ?? I ?? a[0] ?? null, W = f(t);
    return /* @__PURE__ */ s.jsxs("div", { ...R, className: W, children: [
      l && /* @__PURE__ */ s.jsx("div", { className: Sn.search, ref: this.searchRef, children: /* @__PURE__ */ s.jsx(
        Es,
        {
          input: this.getInput(),
          meta: { error: null, touched: !0 },
          icon: "search",
          noAlert: !0,
          noLabel: !0,
          placeholder: c
        }
      ) }),
      !!(l && o || r) && /* @__PURE__ */ s.jsxs("div", { className: Sn.extra, children: [
        r,
        l && typeof o == "function" && /* @__PURE__ */ s.jsx(
          o,
          {
            searched: O,
            onSuggest: m,
            triggerClose: h ? void 0 : C,
            clearSearch: this.clearSearch,
            items: a,
            searchSuggestion: k,
            renderSuggestion: L
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("div", { children: [
        !ot && /* @__PURE__ */ s.jsx(
          Ys,
          {
            ref: this.listRef,
            pagination: d,
            items: a,
            onSelect: this.onSelect,
            onChange: this.onChange,
            onKeyDown: this.handleItemKeyDown,
            clearSearch: this.clearSearch,
            selectedItems: S,
            disabledItems: y,
            itemComponent: e,
            tooltipItems: v,
            itemsDisplayCount: T,
            itemHeight: P,
            activeItem: nt
          }
        ),
        ot && typeof n == "function" && /* @__PURE__ */ s.jsx(n, { label: w || "" })
      ] }),
      typeof b == "function" && /* @__PURE__ */ s.jsx("div", { className: Sn.selectionActions, children: /* @__PURE__ */ s.jsx(
        Q,
        {
          variant: "secondary",
          disabled: S?.length === 0,
          onClick: b,
          children: x || "Clear"
        }
      ) }),
      !!d && !d.infinite && /* @__PURE__ */ s.jsxs("div", { className: Sn.pagination, children: [
        /* @__PURE__ */ s.jsx(
          Q,
          {
            variant: "secondary",
            disabled: !d.previousEnable,
            onClick: d.onPrevious,
            children: "Prev page"
          }
        ),
        /* @__PURE__ */ s.jsx(
          Q,
          {
            variant: "secondary",
            disabled: !d.nextEnable,
            onClick: d.onNext,
            children: "Next page"
          }
        )
      ] })
    ] });
  }
}
class Js extends D {
  static defaultProps = {
    className: "",
    buttonProps: {},
    dropdownProps: {},
    containerProps: {},
    noArrow: !0,
    hasSearch: !1,
    searchPlaceholder: "Search...",
    pagination: !1,
    keepOpen: !1,
    onSearch: () => {
    },
    onSuggest: () => {
    },
    onChange: () => {
    },
    onSelect: () => {
    },
    onToggle: () => {
    },
    onKeyDown: () => {
    },
    emptyComponent: mn,
    emptyMessage: "No items found",
    selectedItems: [],
    disabledItems: [],
    tooltipItems: {},
    activeItem: null
  };
  render() {
    const {
      className: t,
      items: e,
      onSelect: n,
      onChange: o,
      onSearch: r,
      onClear: a,
      onClearText: l,
      onKeyDown: c,
      hasSearch: d,
      searchPlaceholder: h = "Search...",
      onSuggest: u,
      keepOpen: p,
      itemComponent: m,
      suggestionComponent: g,
      children: b,
      buttonProps: x,
      dropdownProps: C,
      containerProps: _,
      pagination: w,
      emptyComponent: S,
      emptyMessage: y,
      selectedItems: v,
      disabledItems: I,
      tooltipItems: T,
      activeItem: P,
      itemsDisplayCount: L,
      itemHeight: k,
      optionComponent: R,
      renderSuggestion: O,
      searchSuggestion: U,
      ...ot
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      ce,
      {
        ...ot,
        className: t,
        buttonProps: { variant: "secondary", ...x },
        dropdownProps: C,
        dropdown: /* @__PURE__ */ s.jsx(pn.Consumer, { children: ({ toggleDropdown: nt, dropdownOpen: W }) => /* @__PURE__ */ s.jsx(
          Hr,
          {
            ..._,
            items: e,
            itemComponent: m,
            hasSearch: d,
            searchPlaceholder: h,
            suggestionComponent: g,
            onSuggest: u,
            keepOpen: p,
            onSearch: r,
            onSelect: n,
            onChange: o,
            onClear: a,
            onClearText: l,
            onKeyDown: c,
            triggerClose: nt,
            dropdownOpen: W,
            pagination: w,
            emptyComponent: S,
            emptyMessage: y,
            selectedItems: v,
            disabledItems: I,
            tooltipItems: T,
            activeItem: P,
            itemsDisplayCount: L,
            itemHeight: k,
            optionComponent: R,
            renderSuggestion: O,
            searchSuggestion: U
          }
        ) }),
        children: b
      }
    );
  }
}
const lg = "h-dropdownSelectMultiple--dropdownSelectMultiple__items", cg = "h-dropdownSelectMultiple--dropdownSelectMultiple__moreItemsDropdown", dg = "h-dropdownSelectMultiple--dropdownSelectMultiple__tagName", fs = {
  items: lg,
  moreItemsDropdown: cg,
  tagName: dg
};
class hg extends ft {
  static defaultProps = {
    noArrow: !0,
    hasSearch: !1,
    searchPlaceholder: "Search...",
    keepOpen: !1,
    onSearch: () => {
    },
    onSuggest: () => {
    },
    onChange: () => {
    },
    onSelect: () => {
    },
    emptyComponent: mn,
    emptyMessage: "No items found",
    buttonText: "+Select item",
    selectedItems: []
  };
  getItems() {
    const { items: t } = this.props;
    return t;
  }
  render() {
    const {
      items: t,
      itemComponent: e,
      onSelect: n,
      onChange: o,
      onSearch: r,
      onClear: a,
      hasSearch: l,
      searchPlaceholder: c,
      onSuggest: d,
      suggestionComponent: h,
      emptyComponent: u,
      emptyMessage: p,
      keepOpen: m,
      containerProps: g,
      buttonText: b,
      selectedItems: x,
      optionComponent: C,
      ..._
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      Js,
      {
        ..._,
        containerProps: g,
        items: this.getItems(),
        itemComponent: e,
        hasSearch: l,
        searchPlaceholder: c,
        suggestionComponent: h,
        onSuggest: d,
        keepOpen: m,
        onSearch: r,
        onSelect: n,
        onChange: o,
        onClear: a,
        emptyComponent: u,
        emptyMessage: p,
        selectedItems: x,
        optionComponent: C,
        children: b
      }
    );
  }
}
class Uk extends ft {
  static defaultProps = {
    MoreItemsItemComponent: cp,
    hideSelectedItems: !1,
    disabledItems: [],
    tooltipItems: {}
  };
  constructor(t) {
    super(t), this.getListItem = this.getListItem.bind(this), this.getListMoreItem = this.getListMoreItem.bind(this);
  }
  resolveItem(t) {
    if (typeof t == "object")
      return t;
    const e = this.props.items.find((n) => n.id === t);
    return e || { id: br(), name: "Unknown" };
  }
  getItemName(t) {
    return t.name.toString().trim();
  }
  isItemDisabled(t) {
    return this.props.disabledItems ? this.props.disabledItems.indexOf(t.id) >= 0 : !1;
  }
  getTooltip(t) {
    const { tooltipItems: e } = this.props;
    return !e || Ms(e[t.id]) ? null : e[t.id];
  }
  getListItem(t, e) {
    const { onRemove: n } = this.props, o = this.resolveItem(t), r = this.getItemName(o), a = this.getTooltip(o), l = /* @__PURE__ */ s.jsx(
      je,
      {
        className: fs.tagName,
        onDelete: () => n(o),
        color: o.color,
        disabled: this.isItemDisabled(o),
        children: r
      },
      o.id
    );
    return a ? /* @__PURE__ */ s.jsx(st, { ...a, children: l }, e) : l;
  }
  getListMoreItem(t) {
    const { MoreItemsItemComponent: e, onRemove: n } = this.props, o = this.resolveItem(t), r = this.getTooltip(o), a = /* @__PURE__ */ s.jsx(
      e,
      {
        item: o,
        onSelect: n,
        disabled: this.isItemDisabled(o),
        clearSearch: E,
        isLoading: !1,
        checked: !1
      },
      o.id
    );
    return r ? /* @__PURE__ */ s.jsx(st, { ...r, children: a }, o.id) : a;
  }
  getPreviewItems() {
    const {
      selectedItems: t,
      previewItemsNumber: e,
      moreItemsDropdownProps: n = {}
    } = this.props;
    let o = [], r = [], a = "";
    if (e && t) {
      if (t.length > 0 && t.length < e)
        o = t.map(this.getListItem);
      else if (t.length >= e) {
        const h = t.slice(0, e), u = t.slice(
          e,
          t.length
        );
        o = h.map(this.getListItem), r = u.map(this.getListMoreItem), a = u.length.toString();
      }
    } else
      o = t.map(this.getListItem);
    const { className: l, ...c } = n, d = /* @__PURE__ */ s.jsx(
      "div",
      {
        ...c,
        className: f(fs.moreItemsDropdown, l),
        children: r
      }
    );
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      o,
      e && t.length > e ? /* @__PURE__ */ s.jsxs(
        ce,
        {
          noArrow: !0,
          buttonProps: { variant: "tertiary" },
          dropdown: d,
          children: [
            "+ ",
            a,
            /* @__PURE__ */ s.jsx("span", { children: " selected" })
          ]
        }
      ) : null
    ] });
  }
  render() {
    const {
      items: t,
      selectedItems: e,
      previewItemsNumber: n,
      className: o,
      onSelect: r,
      onChange: a,
      onSearch: l,
      hasSearch: c,
      searchPlaceholder: d,
      onSuggest: h,
      onRemove: u,
      keepOpen: p,
      itemComponent: m,
      suggestionComponent: g,
      pagination: b,
      emptyComponent: x,
      emptyMessage: C,
      containerProps: _,
      moreItemsDropdownProps: w,
      MoreItemsItemComponent: S,
      hideSelectedItems: y,
      disabledItems: v,
      tooltipItems: I,
      optionComponent: T,
      ...P
    } = this.props, L = f(
      {
        [fs.items]: !0
      },
      o
    );
    return /* @__PURE__ */ s.jsxs("div", { className: L, children: [
      /* @__PURE__ */ s.jsx(
        hg,
        {
          items: t,
          itemComponent: m,
          hasSearch: c,
          searchPlaceholder: d,
          suggestionComponent: g,
          onSuggest: h,
          keepOpen: p,
          onSearch: l,
          onSelect: r,
          onChange: a,
          pagination: b,
          emptyComponent: x,
          emptyMessage: C,
          containerProps: _,
          selectedItems: e,
          disabledItems: v,
          tooltipItems: I,
          optionComponent: T,
          ...P
        }
      ),
      !y && this.getPreviewItems()
    ] });
  }
}
const ug = "h-fieldButton--fieldButton__button", pg = {
  button: ug
}, qk = $(
  function({
    className: t,
    buttonClassName: e,
    label: n,
    meta: o,
    disabled: r,
    helpIcon: a,
    description: l,
    noAlert: c,
    noLabel: d,
    children: h,
    ...u
  }, p) {
    const m = f(e, pg.button);
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: n,
        meta: o,
        disabled: r,
        helpIcon: a,
        description: l,
        noAlert: c,
        noLabel: d,
        children: /* @__PURE__ */ s.jsx(
          Q,
          {
            ref: p,
            disabled: r,
            ...u,
            className: m,
            children: h
          }
        )
      }
    );
  }
), mg = "h-inputDatePicker--inputDatePicker__root", gg = "h-inputDatePicker--inputDatePicker__inputContainer", fg = "h-inputDatePicker--inputDatePicker__input", bg = "h-inputDatePicker--inputDatePicker__rootReadOnly", xg = "h-inputDatePicker--inputDatePicker__iconsContainer", yg = "h-inputDatePicker--inputDatePicker__rootHasClearIcon", _g = "h-inputDatePicker--inputDatePicker__rootHasWrapperIcon", Cg = "h-inputDatePicker--inputDatePicker__calendarIcon", wg = "h-inputDatePicker--inputDatePicker__clearIcon", Ot = {
  root: mg,
  inputContainer: gg,
  input: fg,
  rootReadOnly: bg,
  iconsContainer: xg,
  rootHasClearIcon: yg,
  rootHasWrapperIcon: _g,
  calendarIcon: Cg,
  clearIcon: wg
}, vg = "inputDatePickerTestId";
class Sg extends D {
  inputRef;
  rootRef;
  datePickerContainerRef;
  static defaultProps = {
    dateFormat: j.localeData().longDateFormat("L"),
    name: Math.floor(Math.random() * 1e8).toString()
  };
  constructor(t) {
    super(t), this.inputRef = B(), this.rootRef = B(), this.datePickerContainerRef = B(), this.state = {
      isDropdownOpen: !1,
      shouldRerenderDatePicker: !0
    }, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDateChange = this.handleDateChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
  }
  componentDidUpdate(t, e) {
    const { isDropdownOpen: n } = this.state;
    n !== e.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown)), n && this.focusDatePickerInput());
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
  }
  focusDatePickerInput() {
    this.datePickerContainerRef.current?.querySelector('input[type="text"]')?.focus();
  }
  handleWindowClick(t) {
    this.rootRef.current?.contains(t.target) || this.hideDropdown();
  }
  handleWindowKeyDown(t) {
    Ee(t.key) && this.state.isDropdownOpen && (t.stopPropagation(), this.hideDropdown());
  }
  handleDateChange(t) {
    const { onChange: e, value: n } = this.props;
    typeof e == "function" && e(t), (n ?? t !== null) && this.inputRef.current?.focus();
  }
  handleClearIconClick() {
    this.handleDateChange({
      date: null,
      localDate: null,
      timezone: null,
      localTimezone: null
    });
  }
  showDropdown() {
    this.setState({
      isDropdownOpen: !0,
      shouldRerenderDatePicker: !1
    });
  }
  hideDropdown() {
    this.setState({ isDropdownOpen: !1 });
  }
  handleInputFocus() {
    const { readOnly: t } = this.props;
    t || this.showDropdown();
  }
  handleInputBlur(t) {
    this.rootRef.current?.contains(t.target) || this.hideDropdown();
  }
  handleInputClick(t) {
    const { readOnly: e } = this.props;
    e || (t.stopPropagation(), this.showDropdown());
  }
  handleInputKeydown({ key: t }) {
    Qn(t) && this.showDropdown();
  }
  handleCalendarIconClick(t) {
    const { readOnly: e } = this.props;
    e || (t.stopPropagation(), this.showDropdown());
  }
  renderInputAndIcons() {
    const {
      className: t,
      name: e,
      value: n,
      onChange: o,
      dateFormat: r,
      dropdownProps: a,
      prefix: l,
      suffix: c,
      icon: d,
      status: h,
      placeholder: u,
      disabled: p,
      datePickerProps: m,
      clearable: g,
      minDate: b,
      maxDate: x,
      readOnly: C,
      ..._
    } = this.props, { isDropdownOpen: w } = this.state;
    return /* @__PURE__ */ s.jsx(
      At,
      {
        prefix: l,
        suffix: c,
        disabled: p,
        icon: d,
        active: w,
        status: h,
        children: /* @__PURE__ */ s.jsxs("div", { className: Ot.inputContainer, children: [
          /* @__PURE__ */ s.jsx(
            "input",
            {
              ..._,
              id: e,
              name: e,
              className: Ot.input,
              ref: this.inputRef,
              onClick: this.handleInputClick,
              onFocus: this.handleInputFocus,
              onBlur: this.handleInputBlur,
              onKeyDown: this.handleInputKeydown,
              disabled: p,
              placeholder: u || r?.toLowerCase(),
              autoComplete: "off",
              value: Wn(n) ? void 0 : n?.format(r) ?? "",
              onChange: Wn(n) ? void 0 : E,
              readOnly: !0
            }
          ),
          /* @__PURE__ */ s.jsxs("div", { className: Ot.iconsContainer, children: [
            this.renderClearIcon(),
            this.renderCalendarIcon()
          ] })
        ] })
      }
    );
  }
  renderCalendarIcon() {
    const { disabled: t } = this.props;
    return /* @__PURE__ */ s.jsx(
      K,
      {
        className: Ot.calendarIcon,
        icon: "calendar",
        variant: "tertiary",
        onClick: this.handleCalendarIconClick,
        tabIndex: -1,
        disabled: t
      }
    );
  }
  renderClearIcon() {
    const { clearable: t, value: e, disabled: n } = this.props;
    return !t || !e ? null : /* @__PURE__ */ s.jsx(
      K,
      {
        className: Ot.clearIcon,
        variant: "tertiary",
        icon: "close",
        disabled: n,
        onClick: this.handleClearIconClick
      }
    );
  }
  renderDropdown() {
    const {
      value: t,
      minDate: e,
      maxDate: n,
      timezone: o,
      datePickerProps: r,
      disabled: a,
      dropdownProps: l,
      dateFormat: c
    } = this.props, { isDropdownOpen: d, shouldRerenderDatePicker: h } = this.state;
    return /* @__PURE__ */ s.jsx(te, { ...l, isOpen: d, children: /* @__PURE__ */ s.jsx("div", { ref: this.datePickerContainerRef, children: /* @__PURE__ */ s.jsx(
      Um,
      {
        disabled: a,
        ...r,
        dateFormat: c,
        date: t ?? null,
        timezone: o,
        onChange: this.handleDateChange,
        minDate: e,
        maxDate: n
      },
      h.toString()
    ) }) });
  }
  render() {
    const { className: t, value: e, clearable: n, readOnly: o, icon: r } = this.props, a = f(Ot.root, t, {
      [Ot.rootHasClearIcon]: n && e,
      [Ot.rootHasWrapperIcon]: !!r,
      [Ot.rootReadOnly]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": vg,
        ref: this.rootRef,
        className: a,
        children: [
          this.renderInputAndIcons(),
          this.renderDropdown()
        ]
      }
    );
  }
}
class Gk extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this);
  }
  handleChange(t) {
    const {
      input: { onChange: e }
    } = this.props;
    e?.({
      date: t?.date ? t.date.toISOString() : "",
      localDate: t?.localDate ? t.localDate.toISOString() : "",
      timezone: t?.timezone || "",
      localTimezone: t?.localTimezone || ""
    });
  }
  render() {
    const {
      className: t,
      input: { value: e, name: n, onChange: o, ...r },
      label: a,
      meta: l,
      required: c,
      disabled: d,
      helpIcon: h,
      description: u,
      noLabel: p,
      noAlert: m,
      ...g
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: a,
        labelFor: n,
        meta: l,
        required: c,
        disabled: d,
        helpIcon: h,
        description: u,
        noLabel: p,
        noAlert: m,
        children: /* @__PURE__ */ s.jsx(
          Sg,
          {
            name: n,
            value: Rs(e?.localDate) ? j(e.localDate, j.ISO_8601) : null,
            timezone: e?.timezone,
            onChange: this.handleChange,
            ...r,
            status: z.getStatus(l),
            disabled: d,
            required: c,
            ...g
          }
        )
      }
    );
  }
}
const Ig = "h-inputDateRangePicker--inputDateRangePicker__root", Dg = "h-inputDateRangePicker--inputDateRangePicker__inputsContainer", kg = "h-inputDateRangePicker--inputDateRangePicker__arrowContainer", Tg = "h-inputDateRangePicker--inputDateRangePicker__inputContainer", jg = "h-inputDateRangePicker--inputDateRangePicker__input", Ng = "h-inputDateRangePicker--inputDateRangePicker__rootReadOnly", Fg = "h-inputDateRangePicker--inputDateRangePicker__iconsContainer", Pg = "h-inputDateRangePicker--inputDateRangePicker__rootStartDateHasClearIcon", Rg = "h-inputDateRangePicker--inputDateRangePicker__startDateIconsContainer", Eg = "h-inputDateRangePicker--inputDateRangePicker__rootEndDateHasClearIcon", Lg = "h-inputDateRangePicker--inputDateRangePicker__endDateIconsContainer", Ag = "h-inputDateRangePicker--inputDateRangePicker__rootHasWrapperIcon", $g = "h-inputDateRangePicker--inputDateRangePicker__calendarIcon", Og = "h-inputDateRangePicker--inputDateRangePicker__clearIcon", ut = {
  root: Ig,
  inputsContainer: Dg,
  arrowContainer: kg,
  inputContainer: Tg,
  input: jg,
  rootReadOnly: Ng,
  iconsContainer: Fg,
  rootStartDateHasClearIcon: Pg,
  startDateIconsContainer: Rg,
  rootEndDateHasClearIcon: Eg,
  endDateIconsContainer: Lg,
  rootHasWrapperIcon: Ag,
  calendarIcon: $g,
  clearIcon: Og
}, Bg = "inputDateRangePickerTestId";
class ln extends D {
  inputsRef;
  rootRef;
  dateRangePickerContainerRef;
  static getInputName(t, e) {
    return t[e] || `${t}__${e}`;
  }
  static defaultProps = {
    name: {
      startDate: Math.floor(Math.random() * 1e8).toString(),
      endDate: Math.floor(Math.random() * 1e8).toString()
    }
  };
  constructor(t) {
    super(t), this.inputsRef = {
      startDate: B(),
      endDate: B()
    }, this.rootRef = B(), this.dateRangePickerContainerRef = B(), this.state = {
      isDropdownOpen: !1,
      focusedInput: "startDate",
      shouldRerenderDateRangePicker: !0
    }, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDatesChange = this.handleDatesChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
  }
  componentDidUpdate(t, e) {
    const { isDropdownOpen: n, focusedInput: o } = this.state;
    n !== e.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown))), (n !== e.isDropdownOpen || o !== e.focusedInput) && this.focusDateRangePickerInput();
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
  }
  focusDateRangePickerInput() {
    const { focusedInput: t } = this.state, e = this.dateRangePickerContainerRef.current?.querySelectorAll(
      'input[type="text"]'
    );
    t === "startDate" ? e?.[0]?.focus() : e?.[1]?.focus();
  }
  handleWindowClick(t) {
    this.rootRef.current?.contains(t.target) || this.hideDropdown();
  }
  handleWindowKeyDown(t) {
    Ee(t.key) && this.state.isDropdownOpen && (t.stopPropagation(), this.hideDropdown());
  }
  handleDatesChange(t) {
    const { onChange: e, value: n } = this.props, { focusedInput: o } = this.state;
    typeof e == "function" && e(t), (n?.[o] ?? t[o] !== null) && this.inputsRef[o].current?.focus();
  }
  handleClearIconClick(t, e) {
    const { value: n, timezone: o, localTimezone: r } = this.props, a = {
      startDate: e === "startDate" ? null : n?.startDate ?? null,
      localStartDate: e === "startDate" ? null : n?.localStartDate ?? null,
      endDate: e === "endDate" ? null : n?.endDate ?? null,
      localEndDate: e === "endDate" ? null : n?.localEndDate ?? null,
      timezone: o || null,
      localTimezone: r || null
    };
    this.handleDatesChange(a);
  }
  showDropdown(t) {
    this.setState({
      isDropdownOpen: !0,
      focusedInput: t,
      shouldRerenderDateRangePicker: !1
    });
  }
  hideDropdown() {
    this.setState({ isDropdownOpen: !1 });
  }
  handleInputFocus(t, e) {
    const { readOnly: n } = this.props;
    n || this.showDropdown(e);
  }
  handleInputBlur(t) {
    this.rootRef.current?.contains(t.target) || this.hideDropdown();
  }
  handleInputKeydown({ key: t }, e) {
    Qn(t) && this.showDropdown(e);
  }
  handleInputClick(t, e) {
    const { readOnly: n } = this.props;
    n || (t.stopPropagation(), this.showDropdown(e));
  }
  handleCalendarIconClick(t, e) {
    const { readOnly: n } = this.props;
    n || (t.stopPropagation(), this.showDropdown(e));
  }
  get dateFormat() {
    const { dateFormat: t } = this.props;
    return t || j.localeData().longDateFormat("L");
  }
  renderInputLayout() {
    const { prefix: t, suffix: e, icon: n, status: o, disabled: r } = this.props, { isDropdownOpen: a } = this.state;
    return /* @__PURE__ */ s.jsx(
      At,
      {
        prefix: t,
        suffix: e,
        disabled: r,
        icon: n,
        active: a,
        status: o,
        children: /* @__PURE__ */ s.jsxs("div", { className: ut.inputsContainer, children: [
          this.renderInputAndIcons("startDate"),
          /* @__PURE__ */ s.jsx("div", { className: ut.arrowContainer, children: /* @__PURE__ */ s.jsx(N, { name: "arrow-right" }) }),
          this.renderInputAndIcons("endDate", -1)
        ] })
      }
    );
  }
  renderInputAndIcons(t, e) {
    const {
      className: n,
      clearable: o,
      dateFormat: r,
      dateRangePickerProps: a,
      disabled: l,
      dropdownProps: c,
      icon: d,
      localTimezone: h,
      maxDate: u,
      minDate: p,
      name: m,
      onChange: g,
      placeholder: b,
      prefix: x,
      readOnly: C,
      status: _,
      suffix: w,
      tabIndex: S,
      timezone: y,
      value: v,
      ...I
    } = this.props;
    return /* @__PURE__ */ s.jsxs("div", { className: ut.inputContainer, children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ...I,
          id: ln.getInputName(m, t),
          name: ln.getInputName(m, t),
          className: ut.input,
          ref: this.inputsRef[t],
          onClick: (T) => this.handleInputClick(T, t),
          onFocus: (T) => this.handleInputFocus(T, t),
          onBlur: (T) => this.handleInputBlur(T),
          onKeyDown: (T) => this.handleInputKeydown(T, t),
          disabled: l,
          placeholder: b?.[t] || b || this.dateFormat?.toLowerCase(),
          autoComplete: "off",
          value: v && j(v[t]).isValid() ? j(v[t]).format(this.dateFormat) : "",
          onChange: Wn(v) ? void 0 : E,
          tabIndex: e ?? S,
          readOnly: !0
        }
      ),
      /* @__PURE__ */ s.jsxs(
        "div",
        {
          className: f(ut.iconsContainer, {
            [ut.startDateIconsContainer]: t === "startDate",
            [ut.endDateIconsContainer]: t === "endDate"
          }),
          children: [
            this.renderClearIcon(t),
            this.renderCalendarIcon(t)
          ]
        }
      )
    ] });
  }
  renderCalendarIcon(t) {
    const { disabled: e } = this.props;
    return /* @__PURE__ */ s.jsx(
      K,
      {
        className: ut.calendarIcon,
        icon: "calendar",
        variant: "tertiary",
        onClick: (n) => this.handleCalendarIconClick(n, t),
        tabIndex: -1,
        disabled: e
      }
    );
  }
  renderClearIcon(t) {
    const { clearable: e, value: n, disabled: o } = this.props;
    return !e || !n?.[t] ? null : /* @__PURE__ */ s.jsx(
      K,
      {
        className: ut.clearIcon,
        variant: "tertiary",
        icon: "close",
        disabled: o,
        onClick: (r) => this.handleClearIconClick(r, t)
      }
    );
  }
  renderDropdown() {
    const {
      value: t,
      minDate: e,
      maxDate: n,
      timezone: o,
      dateRangePickerProps: r,
      disabled: a,
      dropdownProps: l
    } = this.props, { isDropdownOpen: c, focusedInput: d, shouldRerenderDateRangePicker: h } = this.state;
    return /* @__PURE__ */ s.jsx(te, { ...l, isOpen: c, children: /* @__PURE__ */ s.jsx("div", { ref: this.dateRangePickerContainerRef, children: /* @__PURE__ */ s.jsx(
      Om,
      {
        disabled: a,
        ...r,
        dateFormat: this.dateFormat,
        onChange: this.handleDatesChange,
        startDate: t?.startDate ?? null,
        endDate: t?.endDate ?? null,
        timezone: o ?? null,
        minDate: e,
        maxDate: n,
        focusedInput: d
      },
      h.toString()
    ) }) });
  }
  render() {
    const { className: t, value: e, clearable: n, readOnly: o, icon: r } = this.props, a = f(ut.root, t, {
      [ut.rootStartDateHasClearIcon]: n && e?.startDate,
      [ut.rootEndDateHasClearIcon]: n && e?.endDate,
      [ut.rootHasWrapperIcon]: !!r,
      [ut.rootReadOnly]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Bg,
        ref: this.rootRef,
        className: a,
        children: [
          this.renderInputLayout(),
          this.renderDropdown()
        ]
      }
    );
  }
}
class Yk extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this);
  }
  handleChange(t) {
    const {
      input: { onChange: e }
    } = this.props;
    e?.({
      startDate: t?.startDate ? t.startDate.toISOString() : "",
      localStartDate: t?.localStartDate ? t.localStartDate.toISOString() : "",
      endDate: t?.endDate ? t.endDate.toISOString() : "",
      localEndDate: t?.localEndDate ? t.localEndDate.toISOString() : "",
      timezone: t?.timezone ?? "",
      localTimezone: t?.localTimezone ?? ""
    });
  }
  getDateRange({
    localStartDate: t,
    localEndDate: e
  }) {
    const n = Rs(t) ? j(t, j.ISO_8601) : null, o = Rs(e) ? j(e, j.ISO_8601) : null;
    return {
      startDate: n,
      endDate: o
    };
  }
  render() {
    const {
      className: t,
      input: { name: e, value: n, onChange: o, ...r },
      label: a,
      meta: l,
      required: c,
      disabled: d,
      description: h,
      helpIcon: u,
      noLabel: p,
      noAlert: m,
      ...g
    } = this.props, { timezone: b, localTimezone: x } = n;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: a,
        labelFor: ln.getInputName(e, "startDate"),
        meta: l,
        required: c,
        disabled: d,
        helpIcon: u,
        description: h,
        noLabel: p,
        noAlert: m,
        children: /* @__PURE__ */ s.jsx(
          ln,
          {
            name: e,
            value: this.getDateRange(n),
            timezone: b,
            localTimezone: x,
            onChange: this.handleChange,
            ...r,
            status: z.getStatus(l),
            disabled: d,
            required: c,
            ...g
          }
        )
      }
    );
  }
}
const Hg = [
  "link",
  "bold",
  "italic",
  "unorderedList",
  "orderedList",
  "format",
  "inlineCode",
  "blockquote"
], le = (i) => ji(i), to = (i, t = window) => t.getComputedStyle(i).display === "block", Qt = /(Mac|iPhone|iPod|iPad)/i.test(
  navigator.userAgent
);
function bs(i, t) {
  const e = {
    ctrlKey: [
      "Control",
      ...Qt ? ["$controlOrAlt"] : ["$metaOrCtrl"]
    ],
    shiftKey: ["Shift"],
    altKey: ["Alt", ...Qt ? [] : ["$controlOrAlt"]],
    metaKey: ["Meta", "OS", ...Qt ? ["$metaOrCtrl"] : []]
  };
  return i.some((n) => {
    if (t.code !== n[1])
      return !1;
    const o = n[0] ?? [];
    return Object.entries(e).every(
      ([r, a]) => {
        const l = Ni(
          a,
          o
        ).length;
        return t[r] ? l > 0 : l === 0;
      }
    );
  });
}
const Wg = (i, t, e) => {
  if (!i || t < 0 || e < 0) return !1;
  const n = i?.textContent?.length ?? 0;
  return !(t > n || e > n);
}, Mg = (i, t) => i.document.queryCommandState(t), zg = (i) => i.document.queryCommandValue("formatBlock"), Vg = (i) => i.type.indexOf("image/") === 0, $o = (i, t) => {
  const e = rn();
  return {
    src: (i.URL || i.webkitURL).createObjectURL(t),
    uid: e
  };
}, Kg = (i) => {
  i && i.querySelectorAll("td").forEach((t) => {
    t.style.border = "1px solid currentColor";
  });
}, Ls = (i) => {
  i.setAttribute("dir", "auto");
  const t = window.getComputedStyle(i).direction;
  i.setAttribute("dir", t);
}, Oo = (i) => {
  i && i.childNodes.forEach((t) => {
    t.nodeType !== Node.ELEMENT_NODE && t.nodeType !== Node.TEXT_NODE || le(t) && to(t) && Ls(t);
  });
}, eo = (i, t = !0) => {
  const e = document.createElement("div");
  return e.style.display = "none", e.innerHTML = i, document.body.appendChild(e), e.childNodes.forEach((n) => {
    if (!(n.nodeType !== Node.ELEMENT_NODE && n.nodeType !== Node.TEXT_NODE)) {
      if (le(n) && to(n))
        n.innerHTML = eo(n.innerHTML, !1), Ls(n);
      else if (t) {
        const o = document.createElement("div");
        o.appendChild(n.cloneNode(!0)), n.replaceWith(o), Ls(o);
      }
    }
  }), document.body.removeChild(e), e.innerHTML;
}, Bo = (i, t = { side: "both" }) => {
  const { side: e } = t, n = i.split(""), o = " ", r = "&nbsp;";
  let a = 0, l = n.length - 1;
  if (e === "both" || e === "start")
    for (; n[a] === o; )
      n[a++] = r;
  if (e === "both" || e === "end")
    for (; n[l] === o; )
      n[l--] = r;
  return n.join("");
}, Kn = (i, t) => i.split(/\r\n|\r|\n/g).map((e, n) => e ? t.inline && n === 0 ? Bo(e, { side: "end" }) : `<div>${Bo(e)}</div>` : "<br />").join("");
function Ug(i) {
  const t = "&nbsp;", o = qg(i.anchorNode), r = Gg(i.anchorNode);
  if (i.anchorNode?.nodeType === Node.TEXT_NODE && o.endsWith(t)) {
    const { focusOffset: a, anchorOffset: l } = i, c = Array.prototype.indexOf.call(
      i.anchorNode.parentElement?.childNodes,
      i.anchorNode
    ), d = r.replaceAll(t, " ").replace(/.$/, " "), h = document.createTextNode(d);
    if (i.anchorNode.parentElement?.childNodes[c].replaceWith(h), i?.rangeCount && i?.rangeCount > 0 && Wg(h, a, l)) {
      const u = i.getRangeAt(0);
      u.setStart(h, a), u.setEnd(h, l);
    }
  }
}
function qg(i) {
  if (!i)
    return "";
  if (i instanceof Element)
    return i.innerHTML;
  const t = document.createElement("span");
  return t.appendChild(i.cloneNode()), t.innerHTML;
}
function Gg(i) {
  return !i || !i.textContent ? "" : i.textContent;
}
const Yg = "h-inputRichText-addonTrigger--addonTrigger__root", Xg = {
  root: Yg
};
function Qg(i) {
  if (!i)
    return null;
  const { focusOffset: t, anchorOffset: e, anchorNode: n } = i;
  return t !== e || !n || n.nodeName !== "#text" ? null : n?.textContent?.slice(0, t) || null;
}
const In = (i, t) => {
  const e = Wr(i, t);
  return e && i.triggers.isAddonTrigger(e.matchedTrigger) ? e.matchedTrigger : null;
}, Dn = (i, t) => {
  const e = Wr(i, t);
  return e ? e.match : null;
}, Wr = (i, t) => t ? i.triggers.test(t) : null, Ho = "input-rich-text-addon-trigger", Zg = (i, t) => {
  const e = i.selection.recreate();
  if (!e || !t) return null;
  const n = e.getRangeAt(0).getBoundingClientRect();
  return i.ref.current && n && e?.rangeCount && e?.rangeCount > 0 ? e.getRangeAt(0).getBoundingClientRect() : null;
}, Jg = (i, t) => {
  if (i.ref.current && t) {
    const e = i.ref.current.getBoundingClientRect();
    return {
      left: `${t.x - e.x}px`,
      top: `${t.y - e.y}px`,
      height: "0",
      width: `${t.width}px`,
      position: "absolute"
    };
  }
  return {};
}, Ut = (i) => Qg(i.selection.recreate()) || "", xs = (i, t) => !!t && i.triggers.isAddonTrigger(t), ys = (i) => i?.nodeType === Node.ELEMENT_NODE, As = (i, t) => i.dataset.testid === t ? i : i.parentElement ? As(i.parentElement, t) : null, ye = {};
class tf extends EventTarget {
  /**
   * A map of event listeners for each event type.
   *
   * Since it can be tricky to register/unregister event listeners as data
   * changes in the consumer, we store the event listeners in a map to be able
   * to clear them easily, in order to avoid memory leaks.
   */
  callbacks = {
    focus: [],
    insert: [],
    up: [],
    down: []
  };
  addEventListener(t, e, n) {
    super.addEventListener(t, e, n), e && this.callbacks[t].push(e);
  }
  /** Clear all event listeners for a given event type. */
  clearEventListeners(t) {
    this.callbacks[t].forEach((e) => {
      this.removeEventListener(t, e);
    }), this.callbacks[t] = [];
  }
}
const Ie = new tf(), ef = kt({
  matchText: "",
  insertContent: () => {
  },
  eventEmitter: Ie
});
var nf = /* @__PURE__ */ ((i) => (i.FOCUS = "focus", i.INSERT = "insert", i.UP = "up", i.DOWN = "down", i))(nf || {});
const sf = (i) => {
  const { editor: t } = i, [e, n] = V(null), [o, r] = V(null), [a, l] = V(null), [c, d] = V(!1), h = Jg(t, a), [u] = V(rn()), { dismissText: p } = ye[u] ?? { dismissText: "" }, m = e?.[0] ?? "", g = p && /**
  * Replaces trailing spaces with regular spaces. If a text was dismissed
  * with trailing space, editor uses non-breaking space (U+00A0) instead of
  * regular ` ` space, which results in isDismissed being `false` where it
  * should be `true`.
  */
  m?.replace(/\s+$/, " ").startsWith(p.replace(/\s+$/, " ")) || !1, b = F(() => {
    const v = In(t, Ut(t)), I = Dn(t, Ut(t)), T = Zg(t, v);
    xs(t, v) && v?.shouldHandleSelectionChange?.() !== !1 ? (r(v), n(I), l(T)) : (r(null), n(null), l(null)), d(!0);
  }, [t]), x = F(() => {
    const v = In(t, Ut(t)), I = Dn(t, Ut(t))?.[0];
    return xs(t, v) && !!I;
  }, [t]), C = F(() => {
    const v = In(t, Ut(t)), I = Dn(t, Ut(t))?.[0], T = ye[u]?.dismissText || "", P = T ? I?.startsWith(T) : !1;
    return xs(t, v) && !!I && !P;
  }, [t, u]), _ = F(() => {
    t.hotkeys.add([
      {
        keybindings: [[[], "Tab"]],
        condition: C,
        callback: () => {
          Ie.dispatchEvent(new Event(
            "focus"
            /* FOCUS */
          ));
        }
      },
      {
        keybindings: [[[], "Enter"]],
        condition: C,
        callback: () => {
          Ie.dispatchEvent(new Event(
            "insert"
            /* INSERT */
          ));
        }
      },
      {
        keybindings: [[[], "ArrowUp"]],
        condition: C,
        callback: () => {
          Ie.dispatchEvent(new Event(
            "up"
            /* UP */
          ));
        }
      },
      {
        keybindings: [[[], "ArrowDown"]],
        condition: C,
        callback: () => {
          Ie.dispatchEvent(new Event(
            "down"
            /* DOWN */
          ));
        }
      },
      {
        keybindings: [[[], "Escape"]],
        condition: C,
        callback: (v, I) => {
          const T = Dn(t, Ut(t))?.[0];
          if (!T) {
            ye[u] = {
              dismissText: ""
            };
            return;
          }
          In(t, Ut(t))?.persistOnEsc === !1 && (I.stopPropagation(), r(null), n(null), l(null)), ye[u] = {
            dismissText: (T.trim().length === 1 ? "" : T) ?? ""
          };
        }
      }
    ]);
  }, [t, C, u]);
  J(() => {
    x() && p !== m && // If persistOnEsc is non-false - preserve existing behavior and reset trigger if the match text changes.
    (g && o?.persistOnEsc !== !1 || // If trigger has been dismissed with Esc and persistOnEsc is false
    // reset dismissText when text is being removed, but preserve dismissText when characters are only added.
    !g && o?.persistOnEsc === !1) && (ye[u] = {
      dismissText: ""
    });
  }, [p, g, x, m, u, o]);
  const w = F((v) => {
    const I = v.nativeEvent.relatedTarget, T = ys(I) && As(I, Yr), P = ys(I) && As(I, Ho);
    (!ys(I) || !T && !P) && d(!1);
  }, []), S = F(
    (v, { inline: I } = {}) => {
      const T = t.selection.recreate();
      if (!T || !o)
        return;
      const L = !!T.anchorNode?.textContent?.match(
        `^${o?.trigger.source}`
      ) && !I ? (
        // Adjust each lines direction if it's been added to a new line
        eo(
          Kn(v, { inline: !1 })
        )
      ) : (
        // Or concatenate to the end of the current line without changing direction
        Kn(v, { inline: !0 })
      );
      T?.rangeCount && T?.rangeCount > 0 && t.content.insert(
        // template is sanitized
        // eslint-disable-next-line no-unsanitized/method
        T.getRangeAt(0).createContextualFragment(L),
        {
          getSelection: () => {
            const k = t.selection.recreate();
            if (!k)
              return null;
            const { focusOffset: R } = k, ot = o.trigger.exec(m)?.[1]?.length ?? 0, nt = m.length - ot;
            return k?.anchorNode && k.extend(
              k.anchorNode,
              R - nt
            ), k;
          }
        }
      );
    },
    [t, m, o]
  );
  if (Pe(() => {
    _(), t.selection.onUpdate(b), t.events.onBlur(w);
  }), Jt(() => {
    delete ye[u];
  }), !o || !c || !m || g)
    return null;
  const y = o.customContainer?.current || t.ref.current?.ownerDocument?.body || window.document.body;
  return /* @__PURE__ */ s.jsx("div", { style: h, children: /* @__PURE__ */ s.jsxs(Fi, { open: !0, children: [
    /* @__PURE__ */ s.jsx(Pi, {}),
    /* @__PURE__ */ s.jsx(Ri, { container: y, children: /* @__PURE__ */ s.jsx(
      Ei,
      {
        onOpenAutoFocus: (v) => v.preventDefault(),
        "data-testid": Ho,
        className: Xg.root,
        side: o.popoverContent?.side ?? "top",
        align: o.popoverContent?.align ?? "start",
        children: /* @__PURE__ */ s.jsx(
          ef.Provider,
          {
            value: { matchText: m, insertContent: S, eventEmitter: Ie },
            children: o.component
          }
        )
      }
    ) })
  ] }) });
}, of = "h-inputRichText-toolbarButton--toolbarButton__root", rf = "h-inputRichText-toolbarButton--toolbarButton__rootDisabled", af = "h-inputRichText-toolbarButton--toolbarButton__rootActive", lf = "h-inputRichText-toolbarButton--toolbarButton__rootWithBadge", cf = "h-inputRichText-toolbarButton--toolbarButton__rootWithText", _e = {
  root: of,
  rootDisabled: rf,
  rootActive: af,
  rootWithBadge: lf,
  rootWithText: cf
};
function Et({
  className: i,
  isActive: t,
  icon: e,
  disabled: n,
  showBadge: o,
  text: r,
  tooltip: a,
  tabIndex: l = -1,
  ...c
}) {
  const d = f(
    {
      [_e.root]: _e.root,
      [_e.rootActive]: t,
      [_e.rootDisabled]: n,
      [_e.rootWithBadge]: o,
      [_e.rootWithText]: r
    },
    i
  ), h = /* @__PURE__ */ s.jsx(
    "button",
    {
      tabIndex: l,
      type: "button",
      ...c,
      className: d,
      disabled: n,
      children: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx("span", { children: /* @__PURE__ */ s.jsx(N, { name: e }) }),
        r && /* @__PURE__ */ s.jsx("span", { children: /* @__PURE__ */ s.jsx(A.Paragraph, { as: "span", variant: "3", wrap: "nowrap", color: "inherit", children: r }) })
      ] })
    }
  );
  return a ? /* @__PURE__ */ s.jsx(st, { content: a, side: "top", wrap: "none", children: h }) : h;
}
const df = "h-inputRichText-attachmentButton--attachmentButton__dropzone", hf = "h-inputRichText-attachmentButton--attachmentButton__fileInput", uf = "h-inputRichText-attachmentButton--attachmentButton__dropdown", pf = "h-inputRichText-attachmentButton--attachmentButton__dropzoneIcon", kn = {
  dropzone: df,
  fileInput: hf,
  dropdown: uf,
  dropzoneIcon: pf
};
let mf = class extends D {
  static displayName = "AttachmentButtonDropzone";
  constructor(t) {
    super(t), this.state = {
      fileHover: !1
    };
  }
  handleDragEnter = (t) => {
    t.preventDefault();
    const { allowAttachments: e } = this.props;
    !e || !t.dataTransfer?.types?.includes("Files") || this.setState({
      fileHover: !0
    });
  };
  handleDragLeave = (t) => {
    t.preventDefault(), this.setState({
      fileHover: !1
    });
  };
  handleAttachmentDrop = (t) => {
    t.preventDefault();
    const { onAddAttachment: e } = this.props;
    t.dataTransfer && e(t.dataTransfer.files), this.setState({
      fileHover: !1
    });
  };
  render() {
    const {
      className: t,
      children: e,
      isAttachmentsUploading: n,
      allowAttachments: o,
      allowInline: r,
      onAddAttachment: a,
      ...l
    } = this.props, { fileHover: c } = this.state, d = f(t), h = c || n;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...l,
        className: d,
        onDragEnter: this.handleDragEnter,
        onDragOver: this.handleDragEnter,
        onDragLeave: this.handleDragLeave,
        onDrop: this.handleAttachmentDrop,
        children: [
          e,
          h && /* @__PURE__ */ s.jsx(Wt, { children: n ? "Uploading..." : "Drop to add an attachment" }),
          !h && "Drop the file or click to upload"
        ]
      }
    );
  }
};
const gf = [
  {
    name: "addAttachment",
    label: "Add attachment",
    keybindings: [[["$metaOrCtrl"], "KeyU"]]
  }
];
class ff extends D {
  unsubscribeAddAttachment;
  fileInputRef;
  constructor(t) {
    super(t), this.fileInputRef = B(), this.unsubscribeAddAttachment = Ki;
  }
  componentDidMount() {
    this.unsubscribeAddAttachment = this.props.editor.events.subscribe(
      "addAttachment",
      () => {
        this.props.disabled || this.fileInputRef.current?.click();
      }
    );
  }
  componentWillUnmount() {
    this.unsubscribeAddAttachment?.();
  }
  openFileBrowser = (t) => {
    t.preventDefault();
    const { current: e } = this.fileInputRef;
    e && e.click();
  };
  handleFileChanged = (t) => {
    const { onAttachFiles: e, editorWindow: n } = this.props, o = t.target;
    o !== null && o instanceof n.HTMLInputElement && (e(o.files), o.value = "");
  };
  renderDropdown() {
    const { isAttachmentsUploading: t, attachments: e, onAttachFiles: n, children: o } = this.props;
    return /* @__PURE__ */ s.jsxs("div", { className: kn.dropdown, children: [
      /* @__PURE__ */ s.jsx(
        mf,
        {
          className: kn.dropzone,
          onAddAttachment: n,
          attachments: e,
          isAttachmentsUploading: t,
          allowInline: !1,
          onClick: this.openFileBrowser,
          allowAttachments: !0,
          children: /* @__PURE__ */ s.jsx(N, { name: "paperclip", className: kn.dropzoneIcon })
        }
      ),
      o
    ] });
  }
  preventDefault = (t) => {
    t.preventDefault();
  };
  render() {
    const {
      className: t,
      attachments: e,
      onAttachFiles: n,
      onDetachFile: o,
      isAttachmentsUploading: r,
      dropdownRef: a,
      editorWindow: l,
      disabled: c,
      disabledTooltip: d,
      fixed: h,
      ...u
    } = this.props, p = /* @__PURE__ */ s.jsx(
      Et,
      {
        onMouseDown: this.preventDefault,
        icon: "paperclip",
        showBadge: e.length > 0,
        disabled: c,
        tooltip: "Insert attachment"
      }
    );
    return c ? /* @__PURE__ */ s.jsx(st, { content: d, disabled: !d, children: p }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ref: this.fileInputRef,
          type: "file",
          className: kn.fileInput,
          onChange: this.handleFileChanged,
          multiple: !0
        }
      ),
      /* @__PURE__ */ s.jsx(
        ce,
        {
          ...u,
          className: t,
          noStyle: !0,
          fixed: h,
          ref: a,
          dropdown: this.renderDropdown(),
          children: p
        }
      )
    ] });
  }
}
const bf = "h-inputRichText-dropzone--dropzone__root", xf = "h-inputRichText-dropzone--dropzone__inlineDropzone", yf = "h-inputRichText-dropzone--dropzone__attachmentDropzone", _f = "h-inputRichText-dropzone--dropzone__rootDual", Cf = "h-inputRichText-dropzone--dropzone__icon", Ce = {
  root: bf,
  inlineDropzone: xf,
  attachmentDropzone: yf,
  rootDual: _f,
  icon: Cf
};
class wf extends D {
  static displayName = "InputRichTextDropzone";
  internalDrag = !1;
  constructor(t) {
    super(t), this.state = {
      fileHover: !1,
      overDropzone: !1
    };
  }
  handleDragStart = () => {
    this.internalDrag = !0;
  };
  handleDragEnd = () => {
    this.internalDrag = !1;
  };
  handleDragEnter = (t) => {
    t.preventDefault();
    const { allowInlineAttachments: e, allowAttachments: n } = this.props;
    if (!e && !n || this.internalDrag) return;
    const o = t.dataTransfer?.types, r = o?.includes("Files"), a = o?.includes("text/uri-list");
    !r && !a || this.setState({
      fileHover: !0
    });
  };
  handleDragLeave = (t) => {
    t.preventDefault(), this.setState({
      fileHover: !1
    });
  };
  handleEnterDropzone = (t) => {
    t.preventDefault(), this.setState({
      overDropzone: !0
    });
  };
  handleLeaveDropzone = (t) => {
    t.preventDefault(), this.setState({
      overDropzone: !1
    });
  };
  async fetchDroppedUrl(t, e) {
    if (t.files.length > 0) {
      e(t.files);
      return;
    }
    const n = t.getData("text/uri-list");
    if (n) {
      try {
        const o = new URL(n);
        if (o.protocol !== "http:" && o.protocol !== "https:") return;
      } catch {
        return;
      }
      try {
        const o = await fetch(n);
        if (!o.ok) return;
        const r = await o.blob(), a = n.split("/").pop()?.split("?")[0] || "dropped-image", l = new File([r], a, { type: r.type }), c = new DataTransfer();
        c.items.add(l), e(c.files);
      } catch {
      }
    }
  }
  handleInlineDrop = (t) => {
    t.preventDefault();
    const { onAddInline: e } = this.props;
    t.dataTransfer && typeof e == "function" && this.fetchDroppedUrl(t.dataTransfer, e), this.setState({
      overDropzone: !1,
      fileHover: !1
    });
  };
  handleAttachmentDrop = (t) => {
    t.preventDefault();
    const { onAddAttachment: e } = this.props;
    t.dataTransfer && typeof e == "function" && this.fetchDroppedUrl(t.dataTransfer, e), this.setState({
      overDropzone: !1,
      fileHover: !1
    });
  };
  render() {
    const {
      className: t,
      children: e,
      allowInlineAttachments: n,
      allowAttachments: o,
      onAddInline: r,
      onMouseDown: a,
      attachments: l,
      onAddAttachment: c,
      ...d
    } = this.props, { fileHover: h, overDropzone: u } = this.state, p = f(
      {
        [Ce.root]: !0,
        [Ce.rootDual]: n && o
      },
      t
    ), m = n || o, g = {};
    return a && (g.onClick = a), m && (g.onDragStart = this.handleDragStart, g.onDragEnd = this.handleDragEnd, g.onDragEnter = this.handleDragEnter, g.onDragOver = this.handleDragEnter, g.onDragLeave = this.handleDragLeave), /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...d,
        tabIndex: -1,
        className: p,
        ...g,
        children: [
          e,
          (h || u) && /* @__PURE__ */ s.jsxs(Wt, { children: [
            n && /* @__PURE__ */ s.jsxs(
              "div",
              {
                onDragEnter: this.handleEnterDropzone,
                onDragLeave: this.handleLeaveDropzone,
                onDrop: this.handleInlineDrop,
                className: Ce.inlineDropzone,
                children: [
                  /* @__PURE__ */ s.jsx(N, { name: "upload", size: 24, className: Ce.icon }),
                  "Drop to add inline"
                ]
              }
            ),
            o && /* @__PURE__ */ s.jsxs(
              "div",
              {
                onDragEnter: this.handleEnterDropzone,
                onDragLeave: this.handleLeaveDropzone,
                onDrop: this.handleAttachmentDrop,
                className: Ce.attachmentDropzone,
                children: [
                  /* @__PURE__ */ s.jsx(N, { name: "paperclip", size: 24, className: Ce.icon }),
                  "Drop to add an attachment"
                ]
              }
            )
          ] })
        ]
      }
    );
  }
}
const Mr = (i, t) => i.split(new RegExp(`(${zs(t)})`, "gi")).map(
  (e, n) => e.toLowerCase() === t.toLowerCase() ? /* @__PURE__ */ s.jsx("span", { children: e }, n) : e
), vf = "h-inputRichText-emoji--emoji__root", Sf = "h-inputRichText-emoji--emoji__decorator", If = "h-inputRichText-emoji--emoji__suggestion", Df = "h-inputRichText-emoji--emoji__suggestionActive", kf = "h-inputRichText-emoji--emoji__suggestionName", nn = {
  root: vf,
  decorator: Sf,
  suggestion: If,
  suggestionActive: Df,
  suggestionName: kf
}, Tf = Bi(
  () => import("./emoji-r42FS_um.js").then((i) => i.c).then((i) => ({
    default: i.EmojiPicker
  }))
), Un = {};
$i.emojis.forEach((i) => {
  i.forEach(
    (t) => {
      t.shortNames && t.shortNames.forEach((e) => {
        Un[e.replace(/:/g, "")] = t.emoji;
      });
    }
  );
});
const jf = (i) => {
  const { active: t, item: e, match: n, onSelect: o } = i, r = n ? Mr(e, n) : e;
  return /* @__PURE__ */ s.jsxs(
    "button",
    {
      onClick: () => o(e),
      type: "button",
      "aria-current": t,
      className: f(nn.suggestion, {
        [nn.suggestionActive]: t
      }),
      children: [
        Un[e],
        /* @__PURE__ */ s.jsx("span", { className: nn.suggestionName, children: r })
      ]
    }
  );
};
class Nf extends D {
  constructor(t) {
    super(t), this.insertEmoji = this.insertEmoji.bind(this), this.insertContent = this.insertContent.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.triggers.add({
      trigger: /(^|\s):/,
      minChars: 2,
      allowSpaces: !1,
      getSuggestions: this.getSuggestions,
      suggestionComponent: jf,
      insertContent: this.insertContent
    });
  }
  insertContent(t, e = "", n) {
    this.insertEmoji(Un[t], e, n);
  }
  insertEmoji(t, e, n) {
    const { editor: o } = this.props, r = document.createElement("span");
    r.classList.add(nn.decorator), r.innerHTML = t, o.content.insert(r, {
      getSelection: () => {
        const a = o.selection.recreate();
        return e && a?.anchorNode && a.extend(a.anchorNode, n), a;
      }
    });
  }
  getSuggestions = (t) => Object.keys(Un).filter((n) => n.indexOf(t) !== -1);
  // eslint-disable-next-line no-undef
  preventDefault = (t) => {
    t.preventDefault();
  };
  renderDropdown = () => /* @__PURE__ */ s.jsx(Hi, { fallback: /* @__PURE__ */ s.jsx("div", { children: "Loading..." }), children: /* @__PURE__ */ s.jsx(pn.Consumer, { children: ({ toggleDropdown: t }) => /* @__PURE__ */ s.jsx(
    Tf,
    {
      onSelect: (e) => {
        this.insertEmoji(e), t();
      }
    }
  ) }) });
  render() {
    const { className: t, fixed: e } = this.props, n = f(
      {
        [nn.root]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsx("div", { className: n, children: /* @__PURE__ */ s.jsx(
      ce,
      {
        icon: "smile",
        dropdown: this.renderDropdown(),
        noStyle: !0,
        fixed: e,
        children: /* @__PURE__ */ s.jsx(
          Et,
          {
            icon: "smile",
            tooltip: "Emojis",
            onMouseDown: this.preventDefault
          }
        )
      }
    ) });
  }
}
const Ff = "h-inputRichText--inputRichText__inputWrapper", Pf = "h-inputRichText--inputRichText__root", Rf = "h-inputRichText--inputRichText__toolbar", Ef = "h-inputRichText--inputRichText__toolbarHint", Lf = "h-inputRichText--inputRichText__toolbarHintVisible", Af = "h-inputRichText--inputRichText__toolbarHintHidden", $f = "h-inputRichText--inputRichText__editorWrap", Of = "h-inputRichText--inputRichText__placeholder", Bf = "h-inputRichText--inputRichText__editor", Hf = "h-inputRichText--inputRichText__editorDisabled", Wf = "h-inputRichText--inputRichText__fileInput", Mf = "h-inputRichText--inputRichText__uiBlocker", bt = {
  inputWrapper: Ff,
  root: Pf,
  toolbar: Rf,
  toolbarHint: Ef,
  toolbarHintVisible: Lf,
  toolbarHintHidden: Af,
  editorWrap: $f,
  placeholder: Of,
  editor: Bf,
  editorDisabled: Hf,
  fileInput: Wf,
  uiBlocker: Mf
};
function no(i) {
  if (!i || i.length === 0)
    return "";
  const [t = [], e = ""] = i[0];
  if (!e)
    return "";
  const n = t.map((r) => zf(r)).filter(Boolean), o = Vf(e);
  return Qt ? [...n, o].join("") : [...n, o].join("+");
}
function zf(i) {
  if (Qt)
    switch (i) {
      case "$metaOrCtrl":
      case "Meta":
        return "⌘";
      case "Control":
      case "$controlOrAlt":
        return "⌃";
      case "Shift":
        return "⇧";
      case "Alt":
        return "⌥";
      default:
        return i;
    }
  switch (i) {
    case "$metaOrCtrl":
    case "Control":
      return "Ctrl";
    case "$controlOrAlt":
    case "Alt":
      return "Alt";
    case "Shift":
      return "Shift";
    case "Meta":
      return "Win";
    default:
      return i;
  }
}
function Vf(i) {
  if (i.startsWith("Key"))
    return i.slice(3);
  if (i.startsWith("Digit"))
    return i.slice(5);
  switch (i) {
    case "Backslash":
      return "\\";
    case "Slash":
      return "/";
    case "Enter":
      return Qt ? "↵" : "Enter";
    case "Escape":
      return "Esc";
    case "Space":
      return "Space";
    case "Backspace":
      return Qt ? "⌫" : "Backspace";
    case "Delete":
      return Qt ? "⌦" : "Del";
    case "ArrowUp":
      return "↑";
    case "ArrowDown":
      return "↓";
    case "ArrowLeft":
      return "←";
    case "ArrowRight":
      return "→";
    default:
      return i;
  }
}
const Kf = "h-inputRichText-linkButton--linkButton__linkOpener", Uf = "h-inputRichText-linkButton--linkButton__dropdownContainer", Wo = {
  linkOpener: Kf,
  dropdownContainer: Uf
}, qf = "h-inputRichText-linkButton--linkMenu__root", Gf = "h-inputRichText-linkButton--linkMenu__field", _s = {
  root: qf,
  field: Gf
};
class Yf extends D {
  constructor(t) {
    super(t);
    const { initialText: e, initialUrl: n } = t;
    this.state = {
      textValue: e,
      urlValue: n
    };
  }
  componentDidUpdate(t) {
    const { initialText: e, initialUrl: n } = this.props;
    (e !== t.initialText || n !== t.initialUrl) && this.setState({
      textValue: e,
      urlValue: n
    });
  }
  handleTextChange = (t) => {
    t && this.setState({
      textValue: t.target.value
    });
  };
  handleUrlChange = (t) => {
    t && this.setState({
      urlValue: t.target.value
    });
  };
  handleAddLink = (t) => {
    t?.preventDefault();
    const { onAddLink: e, toggleDropdown: n } = this.props, { textValue: o, urlValue: r } = this.state;
    r && (e(o || void 0, r), n());
  };
  handleUnlink = (t) => {
    t.preventDefault();
    const { onUnlink: e, toggleDropdown: n } = this.props;
    e(), n();
  };
  handleKeyDown = (t) => {
    t.key === "Enter" && (t.preventDefault(), this.handleAddLink());
  };
  render() {
    const {
      className: t,
      initialText: e,
      initialUrl: n,
      onAddLink: o,
      toggleDropdown: r,
      onUnlink: a,
      ...l
    } = this.props, { textValue: c, urlValue: d } = this.state, h = f({ [_s.root]: !0 }, t);
    return /* @__PURE__ */ s.jsxs("div", { ...l, className: h, children: [
      /* @__PURE__ */ s.jsx(
        Es,
        {
          label: "Link title",
          noAlert: !0,
          className: _s.field,
          input: {
            value: c,
            name: "pleasedontautofillthis",
            onChange: this.handleTextChange
          },
          onKeyDown: this.handleKeyDown
        }
      ),
      /* @__PURE__ */ s.jsx(
        Es,
        {
          label: "Link URL",
          noAlert: !0,
          className: _s.field,
          input: {
            value: d,
            name: "link_url",
            onChange: this.handleUrlChange
          },
          onKeyDown: this.handleKeyDown,
          autoFocus: !0
        }
      ),
      /* @__PURE__ */ s.jsxs(H, { gap: "200", children: [
        /* @__PURE__ */ s.jsx(Q, { variant: "primary", onClick: this.handleAddLink, children: "Add" }),
        !!d && /* @__PURE__ */ s.jsx(Q, { variant: "secondary", onClick: this.handleUnlink, children: "Remove link" })
      ] })
    ] });
  }
}
const zr = [
  {
    name: "hyperlink",
    label: "Link: insert",
    keybindings: [[["$metaOrCtrl", "Shift"], "KeyK"]]
  },
  {
    name: "removeHyperlink",
    label: "Link: remove",
    keybindings: [],
    callback: (i) => i.command.run("unlink")
  }
], Xf = ({ editor: i }) => {
  const [t, e] = Wi((_) => _ + 1, 0), [n, o] = Mi(!1), r = Y(null), a = Y(), [
    { hoverLinkBounds: l, hoverLinkHref: c, selectedLink: d, selectedText: h },
    u
  ] = zi({
    selectedLink: "",
    selectedText: "",
    hoverLinkHref: null,
    hoverLinkBounds: null
  });
  Pe(() => {
    i.events.onMouseOver((_) => {
      m(_);
    }), a.current = i.events.subscribe("hyperlink", () => {
      o(!0);
    }), i.selection.onUpdate(() => {
      p();
    });
  }), Jt(() => {
    a.current?.();
  });
  const p = () => {
    const _ = i.selection.recreate();
    if (!_)
      return;
    const { anchorNode: w, focusNode: S } = _;
    if (w && S === w && w.parentElement?.nodeName === "A") {
      const { href: y, innerText: v } = w.parentElement;
      u({
        selectedLink: y,
        selectedText: v
      });
    } else
      u({
        selectedLink: "",
        selectedText: _.toString()
      });
  }, m = F(
    (_) => {
      const { target: w } = _, { current: S } = i.ref;
      if (S && w && w instanceof HTMLAnchorElement) {
        const y = S.getBoundingClientRect(), v = w.getBoundingClientRect();
        u({
          hoverLinkHref: w.getAttribute("href"),
          hoverLinkBounds: {
            top: v.top - y.top,
            left: v.left - y.left,
            width: v.width
          }
        });
      } else
        u({
          hoverLinkHref: null,
          hoverLinkBounds: null
        });
    },
    [i.ref, u]
  ), g = F(() => {
    const _ = i.selection.recreate();
    if (!_)
      return;
    const { anchorNode: w, focusNode: S } = _;
    if (w && w === S && w.parentElement?.nodeName === "A") {
      const y = document.createRange();
      y.selectNodeContents(w.parentElement), _.removeAllRanges(), _.addRange(y);
    }
  }, [i.selection]), b = F(
    (_, w) => {
      w && (g(), i.command.run("insertHTML", `<a href="${w}">${_ || w}</a>`), e());
    },
    [i.command, g]
  ), x = F(() => {
    g(), i.command.run("unlink");
  }, [i.command, g]), C = F((_) => {
    _.preventDefault();
  }, []);
  return wr(r, () => {
    o(!1);
  }), Cr("Escape", () => {
    o(!1), g();
  }), /* @__PURE__ */ s.jsxs(Wt, { children: [
    /* @__PURE__ */ s.jsxs("div", { ref: r, className: Wo.dropdownContainer, children: [
      /* @__PURE__ */ s.jsx(
        Et,
        {
          isActive: !!d,
          icon: "link",
          onMouseDown: C,
          onClick: () => o(),
          tooltip: `Insert link (${no(zr[0].keybindings)})`
        }
      ),
      n && /* @__PURE__ */ s.jsx(te, { isOpen: n, children: /* @__PURE__ */ s.jsx(
        Yf,
        {
          onAddLink: b,
          toggleDropdown: o,
          initialUrl: d,
          initialText: h,
          onUnlink: x
        }
      ) })
    ] }),
    !!l && !!c && /* @__PURE__ */ s.jsx(
      "a",
      {
        className: Wo.linkOpener,
        href: c,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
          top: `${l.top}px`,
          left: `${l.left + l.width}px`
        },
        children: /* @__PURE__ */ s.jsx(N, { className: "icon-vertical-fix", name: "external-link" })
      }
    )
  ] });
}, Qf = "h-tabs--tabs__root", Zf = "h-tabs--tabs__tabs", Jf = "h-tabs--tabs__tab", tb = "h-tabs--tabs__tabTop", eb = "h-tabs--tabs__tabTopActive", nb = "h-tabs--tabs__tabTopSelected", sb = "h-tabs--tabs__tabLeft", ob = "h-tabs--tabs__tabLeftActive", rb = "h-tabs--tabs__tabLeftSelected", ib = "h-tabs--tabs__tabBottom", ab = "h-tabs--tabs__tabBottomActive", lb = "h-tabs--tabs__tabBottomSelected", cb = "h-tabs--tabs__tabRight", db = "h-tabs--tabs__tabRightActive", hb = "h-tabs--tabs__tabRightSelected", ub = "h-tabs--tabs__tabDisabled", it = {
  root: Qf,
  tabs: Zf,
  tab: Jf,
  tabTop: tb,
  tabTopActive: eb,
  tabTopSelected: nb,
  tabLeft: sb,
  tabLeftActive: ob,
  tabLeftSelected: rb,
  tabBottom: ib,
  tabBottomActive: ab,
  tabBottomSelected: lb,
  tabRight: cb,
  tabRightActive: db,
  tabRightSelected: hb,
  tabDisabled: ub
}, pb = 13;
class mb extends D {
  constructor(t) {
    super(t), this.handleOnClick = this.handleOnClick.bind(this), this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
  }
  handleOnClick() {
    const { id: t, onChange: e, disabled: n } = this.props;
    n || e(t);
  }
  handleOnKeyDown(t) {
    t.keyCode === pb && this.handleOnClick();
  }
  getClassName() {
    const {
      selected: t,
      placement: e,
      className: n,
      disabled: o,
      active: r,
      selectedClassName: a
    } = this.props;
    let l = f(it.tab, n, {
      [it.tabDisabled]: o,
      [it.tabTop]: e === "top",
      [it.tabRight]: e === "right",
      [it.tabLeft]: e === "left",
      [it.tabBottom]: e === "bottom",
      [it.tabTopSelected]: e === "top" && t,
      [it.tabRightSelected]: e === "right" && t,
      [it.tabLeftSelected]: e === "left" && t,
      [it.tabBottomSelected]: e === "bottom" && t,
      [it.tabTopActive]: e === "top" && r,
      [it.tabRightActive]: e === "right" && r,
      [it.tabLeftActive]: e === "left" && r,
      [it.tabBottomActive]: e === "bottom" && r
    });
    return a && (l = f(l, { [a]: t })), l;
  }
  render() {
    const { id: t, label: e, icon: n, disabled: o, slotEnd: r, slotStart: a } = this.props;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        role: "tab",
        className: this.getClassName(),
        onClick: this.handleOnClick,
        onKeyDown: this.handleOnKeyDown,
        tabIndex: o ? -1 : 0,
        children: [
          a || !!n && /* @__PURE__ */ s.jsx(N, { name: n, className: "icon-vertical-fix" }),
          e,
          r
        ]
      },
      t
    );
  }
}
class so extends D {
  containerRef;
  static defaultProps = {
    tabsPlacement: "top"
  };
  constructor(t) {
    super(t), this.containerRef = B(), this.renderTab = this.renderTab.bind(this), this.renderTabs = this.renderTabs.bind(this);
  }
  renderTab({
    id: t,
    label: e,
    icon: n,
    disabled: o,
    slotEnd: r,
    slotStart: a
  }) {
    const {
      selectedId: l,
      activeId: c,
      onChange: d,
      tabsPlacement: h,
      tabClassName: u,
      tabSelectedClassName: p
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      mb,
      {
        selected: t === l,
        className: u,
        selectedClassName: p,
        id: t,
        label: e,
        icon: n,
        onChange: d,
        placement: h,
        disabled: o,
        active: t === c,
        slotEnd: r,
        slotStart: a
      },
      t
    );
  }
  renderTabs() {
    const { tabs: t } = this.props;
    return t.map(this.renderTab);
  }
  render() {
    const {
      className: t,
      tabClassName: e,
      tabSelectedClassName: n,
      tabs: o,
      selectedId: r,
      onChange: a,
      tabsPlacement: l,
      activeId: c,
      ...d
    } = this.props, h = f(it.root, t);
    return /* @__PURE__ */ s.jsx("div", { ref: this.containerRef, ...d, className: h, children: /* @__PURE__ */ s.jsx("div", { className: it.tabs, children: this.renderTabs() }) });
  }
}
const gb = hn(so, {
  fallback: null
}), fb = "h-inputRichText-quickResponseSelector--quickResponseItem__root", bb = "h-inputRichText-quickResponseSelector--quickResponseItem__rootActive", xb = "h-inputRichText-quickResponseSelector--quickResponseItem__name", qe = {
  root: fb,
  rootActive: bb,
  name: xb
};
class Cs extends D {
  constructor(t) {
    super(t), this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect() {
    const { isLoading: t, onSelect: e, item: n } = this.props;
    t || e(n);
  }
  render() {
    const {
      className: t,
      item: e,
      isLoading: n,
      onSelect: o,
      active: r,
      searchValue: a,
      clearSearch: l,
      ...c
    } = this.props, { name: d, content: h, matched: u } = !n && e ? e : {
      name: "Loading...",
      content: "",
      matched: ""
    }, p = f(
      {
        [qe.root]: qe.root,
        [qe.rootActive]: r
      },
      t
    ), m = u ? Mr(d, u) : d;
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        type: "button",
        "aria-current": r,
        ...c,
        className: p,
        onClick: this.handleSelect,
        title: d,
        children: [
          /* @__PURE__ */ s.jsx(A.Heading, { variant: "heading-3", className: qe.name, children: m }),
          /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "4", className: qe.name, subdued: !0, children: h })
        ]
      }
    );
  }
}
const yb = "h-inputRichText-quickResponseSelector--quickResponseSelector__container", _b = "h-inputRichText-quickResponseSelector--quickResponseSelector__dropdownButtonContainer", Cb = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdown", wb = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabs", vb = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabsContent", Sb = "h-inputRichText-quickResponseSelector--quickResponseSelector__regularDropdown", we = {
  container: yb,
  dropdownButtonContainer: _b,
  tabbedDropdown: Cb,
  tabbedDropdownTabs: wb,
  tabbedDropdownTabsContent: vb,
  regularDropdown: Sb
}, Mo = /(^|\s)=/, ws = "Quick responses";
class Ib extends ft {
  constructor(t) {
    super(t), this.state = {
      searchTerm: "",
      selectedTab: t.languages[0]?.code
    }, this.handleToggle = this.handleToggle.bind(this), this.handleNextPage = this.handleNextPage.bind(this), this.getPagination = this.getPagination.bind(this), this.normalizeSuggestion = this.normalizeSuggestion.bind(this), this.handleSearchChange = this.handleSearchChange.bind(this), this.handleTabChange = this.handleTabChange.bind(this), this.handleTabbedSearchChange = this.handleTabbedSearchChange.bind(this), this.getTabDefinitions = this.getTabDefinitions.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.triggers.add({
      trigger: Mo,
      minChars: 0,
      allowSpaces: !0,
      getSuggestions: this.handleSearchChange,
      suggestionComponent: Cs,
      getPagination: this.getPagination,
      getTabs: this.getTabDefinitions,
      insertContent: this.insertContent
    });
  }
  normalizeSuggestion(t) {
    const { quickResponsesApi: e } = this.props;
    return {
      id: t.name,
      matched: e.params.search ?? "",
      ...t
    };
  }
  getTabDefinitions() {
    const { languages: t } = this.props;
    return t.map((e) => ({
      id: e.code,
      label: e.label
    }));
  }
  handleNextPage() {
    const { quickResponsesApi: t } = this.props;
    return new Promise((e) => t.getItemsAsyncStatus === "loading" ? e(t.items.map(this.normalizeSuggestion)) : e(
      t.nextPage().then((n) => n.map(this.normalizeSuggestion)).catch((n) => {
        console.error(n);
      })
    ));
  }
  preventDefault = (t) => {
    t.preventDefault();
  };
  handleSelect = (t, e) => {
    this.insertContent(t)?.then(() => {
      e && e();
    });
  };
  insertContent = (t, e, n) => {
    const { renderQuickResponse: o, sanitize: r, editor: a } = this.props;
    return o(t).then((l) => {
      const c = a.selection.recreate();
      if (!c)
        return;
      const d = !!e, h = d && !!c.anchorNode?.textContent?.match(
        `^${Mo.source}`
      ) || !d && !c.anchorNode?.textContent;
      let u;
      h ? u = eo(
        Kn(r(l), { inline: !1 })
      ) : u = Kn(r(l), { inline: !0 }), c?.rangeCount && c?.rangeCount > 0 && a.content.insert(
        // template is sanitized
        // eslint-disable-next-line no-unsanitized/method
        c.getRangeAt(0).createContextualFragment(u),
        {
          getSelection: () => {
            const p = a.selection.recreate();
            return d && p?.anchorNode && p.extend(p.anchorNode, n), p;
          }
        }
      );
    });
  };
  handleToggle(t) {
    const { quickResponsesApi: e, languages: n } = this.props;
    t && (e.params.search !== "" || e.params.locale !== n[0]?.code) && this.setState({ searchTerm: "", selectedTab: n[0]?.code }, () => {
      const { searchTerm: o, selectedTab: r } = this.state;
      this.handleSearchChange(o, r, 0);
    });
  }
  getPagination() {
    const { quickResponsesApi: t } = this.props;
    return {
      nextEnable: t.hasNextPage,
      previousEnable: !1,
      infinite: !0,
      onNext: this.handleNextPage
    };
  }
  handleSearchChange(t, e, n) {
    const { quickResponsesApi: o } = this.props;
    return o.paramsChange({ search: t, locale: e }, n).then((r) => r.map(this.normalizeSuggestion));
  }
  handleTabbedSearchChange(t) {
    this.setState({ searchTerm: t }, () => {
      const { searchTerm: e, selectedTab: n } = this.state;
      this.handleSearchChange(e, n);
    });
  }
  handleTabChange(t) {
    this.setState({ selectedTab: t }, () => {
      const { searchTerm: e, selectedTab: n } = this.state;
      this.handleSearchChange(e, n, 0);
    });
  }
  renderIcon() {
    return /* @__PURE__ */ s.jsx(
      Et,
      {
        icon: this.props.iconName ?? "bolt",
        onMouseDown: this.preventDefault
      }
    );
  }
  renderItemsWithoutTabs() {
    const { className: t, quickResponsesApi: e } = this.props;
    return /* @__PURE__ */ s.jsx(st, { content: `${ws} (=)`, children: /* @__PURE__ */ s.jsx(
      Js,
      {
        className: t,
        dropdownProps: {
          className: we.regularDropdown
        },
        containerProps: { className: we.container },
        items: e.items.map(this.normalizeSuggestion),
        pagination: this.getPagination(),
        itemComponent: Cs,
        hasSearch: !0,
        noStyle: !0,
        onSearch: this.handleSearchChange,
        onSelect: this.handleSelect,
        onToggle: this.handleToggle,
        emptyMessage: e.getItemsAsyncStatus === "loading" ? "Loading..." : void 0,
        children: this.renderIcon()
      }
    ) });
  }
  renderItemsWithTabs() {
    const { className: t } = this.props, { selectedTab: e } = this.state;
    return /* @__PURE__ */ s.jsx("div", { className: we.dropdownButtonContainer, children: /* @__PURE__ */ s.jsx(st, { content: `${ws} (=)`, children: /* @__PURE__ */ s.jsx(
      ce,
      {
        className: t,
        noStyle: !0,
        onToggle: this.handleToggle,
        buttonProps: { title: ws },
        dropdown: /* @__PURE__ */ s.jsxs("div", { className: we.tabbedDropdown, children: [
          /* @__PURE__ */ s.jsx(
            so,
            {
              className: we.tabbedDropdownTabs,
              tabs: this.getTabDefinitions(),
              tabsPlacement: "left",
              selectedId: e,
              onChange: this.handleTabChange
            }
          ),
          /* @__PURE__ */ s.jsx("div", { className: we.tabbedDropdownTabsContent, children: this.renderTabItems() })
        ] }),
        children: this.renderIcon()
      }
    ) }) });
  }
  renderTabItems() {
    const { quickResponsesApi: t } = this.props;
    return /* @__PURE__ */ s.jsx(pn.Consumer, { children: ({ dropdownOpen: e, closeDropdown: n }) => /* @__PURE__ */ s.jsx(
      Hr,
      {
        dropdownOpen: e,
        triggerClose: n,
        hasSearch: !0,
        pagination: this.getPagination(),
        items: t.items.map(this.normalizeSuggestion),
        itemComponent: Cs,
        onSearch: this.handleTabbedSearchChange,
        onSelect: (o) => this.handleSelect(o, n),
        emptyComponent: mn,
        emptyMessage: t.getItemsAsyncStatus === "loading" ? "Loading..." : "No items found."
      }
    ) });
  }
  render() {
    const { languages: t } = this.props;
    return t?.length ? this.renderItemsWithTabs() : this.renderItemsWithoutTabs();
  }
}
const Db = "h-inputRichText-formatSelector--formatSelector__root", kb = "h-inputRichText-formatSelector--formatSelector__list", Tb = "h-inputRichText-formatSelector--formatSelector__selector", jb = "h-inputRichText-formatSelector--formatSelector__option", Nb = "h-inputRichText-formatSelector--formatSelector__optionActive", Fb = "h-inputRichText-formatSelector--formatSelector__button", ve = {
  root: Db,
  list: kb,
  selector: Tb,
  option: jb,
  optionActive: Nb,
  button: Fb
}, $s = [
  {
    name: "noHeading",
    label: "Normal",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "div"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h1",
    label: "Headline 1",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H1>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h2",
    label: "Headline 2",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H2>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h3",
    label: "Headline 3",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H3>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h4",
    label: "Headline 4",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H4>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h5",
    label: "Headline 5",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H5>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "quote",
    label: "Blockquote",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<BLOCKQUOTE>"),
    condition: (i) => i.allowFormatting.includes("format")
  }
], zo = {
  h1: { tag: "<H1>" },
  h2: { tag: "<H2>" },
  h3: { tag: "<H3>" },
  h4: { tag: "<H4>" },
  h5: { tag: "<H5>" },
  noHeading: { default: !0, tag: "div" },
  quote: { tag: "<BLOCKQUOTE>" }
};
class Pb extends D {
  preventDefault = (t) => {
    t.preventDefault();
  };
  renderDropdown() {
    const { editor: t } = this.props;
    return /* @__PURE__ */ s.jsx(pn.Consumer, { children: ({ closeDropdown: e }) => /* @__PURE__ */ s.jsx("ul", { className: ve.list, children: $s.map((n) => {
      const o = "condition" in n;
      if (!(!o || o && n.condition(t)))
        return;
      const a = zo[n.name];
      return /* @__PURE__ */ s.jsx(
        "li",
        {
          className: f(ve.option, {
            [ve.optionActive]: this.isActiveFormat(a)
          }),
          children: /* @__PURE__ */ s.jsx(
            "button",
            {
              type: "button",
              className: ve.button,
              onClick: () => {
                n.callback?.(t), e();
              },
              children: n.label
            }
          )
        },
        n.name
      );
    }).filter(Boolean) }) });
  }
  isActiveFormat(t) {
    const { formatBlock: e } = this.props;
    return !!(!e && t.default || t.tag === e || t.tag === `<${e.toUpperCase()}>`);
  }
  getCurrentFormatName() {
    return $s.find(
      (t) => this.isActiveFormat(zo[t.name])
    )?.label ?? "Normal";
  }
  render() {
    const { className: t, editor: e, formatBlock: n, ...o } = this.props, r = f(ve.root, t);
    return /* @__PURE__ */ s.jsx(
      ce,
      {
        className: r,
        ...o,
        dropdown: this.renderDropdown(),
        noStyle: !0,
        children: /* @__PURE__ */ s.jsxs("div", { className: ve.selector, children: [
          this.getCurrentFormatName(),
          /* @__PURE__ */ s.jsx(N, { className: "icon-vertical-fix", name: "angle-down" })
        ] })
      }
    );
  }
}
const Rb = "h-inputRichText-stylingMenu--stylingMenu__menu", Eb = "h-inputRichText-stylingMenu--stylingMenu__buttonsContainer", Vo = {
  menu: Rb,
  buttonsContainer: Eb
}, Vr = [
  {
    name: "bold",
    label: "Bold",
    icon: "bold",
    keybindings: [[["$metaOrCtrl"], "KeyB"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyB"]],
    callback: (i) => i.command.run("bold"),
    condition: (i) => i.allowFormatting.includes("bold")
  },
  {
    name: "italic",
    label: "Italic",
    icon: "italic",
    keybindings: [[["$metaOrCtrl"], "KeyI"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyI"]],
    callback: (i) => i.command.run("italic"),
    condition: (i) => i.allowFormatting.includes("italic")
  },
  {
    name: "orderedList",
    label: "List: ordered",
    icon: "list-ol",
    keybindings: [[["Control", "$controlOrAlt"], "Digit7"]],
    callback: (i) => i.command.run("insertOrderedList"),
    condition: (i) => i.allowFormatting.includes("orderedList")
  },
  {
    name: "unorderedList",
    label: "List: unordered",
    icon: "list-ul",
    keybindings: [[["Control", "$controlOrAlt"], "Digit8"]],
    callback: (i) => i.command.run("insertUnorderedList"),
    condition: (i) => i.allowFormatting.includes("unorderedList")
  },
  {
    name: "inlineCode",
    label: "Inline code",
    icon: "code",
    keybindings: [[["$metaOrCtrl"], "KeyE"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyE"]],
    callback: (i) => i.command.run("inlineCode"),
    condition: (i) => i.allowFormatting.includes("inlineCode")
  },
  {
    name: "blockquote",
    label: "Quote text",
    icon: "quote",
    keybindings: [[["Control", "$controlOrAlt"], "Digit9"]],
    callback: (i) => {
      const t = i.window.getSelection();
      if (!t) return;
      const e = t.anchorNode, o = !!(le(e) ? e : e?.parentElement)?.closest("blockquote");
      i.command.run("formatBlock", o ? "div" : "<BLOCKQUOTE>");
    },
    condition: (i) => i.allowFormatting.includes("blockquote")
  },
  {
    name: "noFormat",
    label: "Clear formatting",
    icon: "pen-slash",
    keybindings: [[["$metaOrCtrl"], "Backslash"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "Backslash"]],
    callback: (i) => i.command.run("removeFormat")
  }
], Kr = [...$s, ...Vr];
class Lb extends D {
  domRef;
  constructor(t) {
    super(t), this.state = {
      isOpen: !1,
      currentFormat: ""
    }, this.domRef = B(), this.handleToolbarButtonClick = this.handleToolbarButtonClick.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.selection.onUpdate(() => {
      this.updateCurrentFormat();
    });
  }
  componentDidUpdate(t, e) {
    const { isOpen: n } = this.state, { editorWindow: o } = this.props;
    n !== e.isOpen && o[n ? "addEventListener" : "removeEventListener"](
      "click",
      this.handleClickOutside,
      !0
    );
  }
  componentWillUnmount() {
    const { isOpen: t } = this.state, { editorWindow: e } = this.props;
    t && e.removeEventListener("click", this.handleClickOutside, !0);
  }
  updateCurrentFormat() {
    const { editorWindow: t } = this.props;
    this.setState({
      currentFormat: zg(t)
    });
  }
  handleClickOutside = (t) => {
    const { current: e } = this.domRef;
    e && t.target instanceof Element && t.target !== e && !e.contains(t.target) && this.setState({
      isOpen: !1
    });
  };
  handleClick = (t) => {
    t.preventDefault();
    const { isOpen: e } = this.state;
    this.setState({
      isOpen: !e
    });
  };
  handleToolbarButtonClick(t) {
    return (e) => {
      const { editor: n } = this.props;
      e.preventDefault(), t && (Kr.find(
        (r) => r.name === t
      )?.callback(n), this.forceUpdate());
    };
  }
  styleActive(t) {
    const { editor: e } = this.props;
    if (t === "blockquote") {
      const n = e.window.getSelection();
      if (!n) return !1;
      const o = n.anchorNode;
      return !!(le(o) ? o : o?.parentElement)?.closest("blockquote");
    }
    return e.command.active(t);
  }
  render() {
    const { className: t, isActive: e, editor: n, editorWindow: o, ...r } = this.props, { isOpen: a, currentFormat: l } = this.state, c = f(t);
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: c, ref: this.domRef, children: [
      a && /* @__PURE__ */ s.jsxs("div", { className: Vo.menu, children: [
        n.allowFormatting.includes("format") && /* @__PURE__ */ s.jsx(
          Pb,
          {
            formatBlock: l,
            editor: this.props.editor
          }
        ),
        /* @__PURE__ */ s.jsx("div", { className: Vo.buttonsContainer, children: Vr.map((d) => {
          const h = "condition" in d;
          if (!(!h || h && d.condition(n)))
            return;
          const p = no(d.keybindings), m = p ? `${d.label} (${p})` : d.label;
          return /* @__PURE__ */ s.jsx(
            Et,
            {
              isActive: this.styleActive(d.name),
              onMouseDown: this.handleToolbarButtonClick(d.name),
              icon: d.icon,
              tooltip: m
            },
            d.name
          );
        }).filter(Boolean) })
      ] }),
      /* @__PURE__ */ s.jsx(
        Et,
        {
          isActive: e,
          icon: "format",
          onClick: this.handleClick,
          tooltip: "Formatting"
        }
      )
    ] });
  }
}
const Ab = "h-inputRichText-suggestions--suggestions__dropdown", $b = "h-inputRichText-suggestions--suggestions__dropdownWithTabs", Ob = "h-inputRichText-suggestions--suggestions__dropdownWithoutTabs", Bb = "h-inputRichText-suggestions--suggestions__dropdownTabs", Hb = "h-inputRichText-suggestions--suggestions__dropdownTabsContent", Ge = {
  dropdown: Ab,
  dropdownWithTabs: $b,
  dropdownWithoutTabs: Ob,
  dropdownTabs: Bb,
  dropdownTabsContent: Hb
};
function Wb(i) {
  if (!i)
    return null;
  const { focusOffset: t, anchorOffset: e, anchorNode: n } = i;
  return t !== e || !n || n.nodeName !== "#text" ? null : n?.textContent?.slice(0, t);
}
class Mb extends D {
  dropdownRef;
  tabsRef;
  constructor(t) {
    super(t), this.state = {
      listenForSelectionChange: !0,
      suggestions: null,
      suggestionPosition: null,
      suggestionIndex: 0,
      suggestionExtendBy: 0,
      suggestionTrigger: null,
      suggestionMatchedString: "",
      selectedTab: null,
      selectionMode: "suggestion",
      tabIndex: 0
    }, this.dropdownRef = B(), this.tabsRef = B(), this.handleSuggestionClick = this.handleSuggestionClick.bind(this), this.handleSelectionChange = this.handleSelectionChange.bind(this), this.getPagination = this.getPagination.bind(this), this.handleBlur = this.handleBlur.bind(this), this.handleTabChange = this.handleTabChange.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.selection.onUpdate(this.handleSelectionChange), t.events.onBlur(this.handleBlur), t.hotkeys.add([
      {
        keybindings: [[[], "ArrowUp"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleArrowKey(-1)
      },
      {
        keybindings: [[[], "ArrowDown"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleArrowKey(1)
      },
      {
        keybindings: [[[], "Escape"]],
        condition: () => this.hasSuggestions() || this.hasTabs(),
        callback: (e, n) => this.handleEscapeKey(n)
      },
      {
        keybindings: [[[], "Enter"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleEnterKey()
      }
    ]);
  }
  componentDidUpdate(t, e) {
    const { suggestionIndex: n, tabIndex: o } = this.state;
    n !== e.suggestionIndex && this.updateSuggestionScroll(), o !== e.tabIndex && this.updateTabScroll();
  }
  shouldHandleKey() {
    const { selectionMode: t } = this.state;
    return t === "suggestion" && this.hasSuggestions() || t === "tab" && this.hasTabs();
  }
  handleArrowKey(t) {
    const { selectionMode: e } = this.state;
    e === "suggestion" && this.hasSuggestions() ? this.suggestionsNavigate(t) : e === "tab" && this.hasTabs() && this.tabsNavigate(t);
  }
  handleEscapeKey(t) {
    const { selectionMode: e } = this.state;
    this.shouldRenderDropdown() && t.stopPropagation(), e === "suggestion" && this.hasTabs() ? this.setState({
      selectionMode: "tab",
      tabIndex: this.getSelectedTabIndex()
    }) : this.clearSuggestions();
  }
  handleEnterKey() {
    const { selectionMode: t, tabIndex: e, suggestionTrigger: n } = this.state;
    if (t === "suggestion" && this.hasSuggestions())
      this.expandSuggestion();
    else if (t === "tab" && this.hasTabs()) {
      const o = n?.getTabs?.()[e];
      o && this.handleTabChange(o.id);
    }
  }
  handleBlur(t) {
    const {
      nativeEvent: { relatedTarget: e }
    } = t;
    e === null && this.clearSuggestions();
  }
  hasSuggestions() {
    const { suggestions: t } = this.state;
    return !!t?.length;
  }
  hasTabs() {
    return !!this.state.suggestionTrigger?.getTabs?.().length;
  }
  getSelectedTabIndex() {
    const { suggestionTrigger: t, selectedTab: e } = this.state;
    return this.hasTabs() ? t?.getTabs?.().findIndex((n) => n.id === e) : -1;
  }
  clearSuggestions() {
    this.setState({
      suggestions: null,
      suggestionPosition: null,
      selectedTab: null,
      selectionMode: "suggestion"
    });
  }
  suggestionsNavigate(t) {
    this.setState(({ suggestionIndex: e, suggestions: n }) => {
      if (n && n.length) {
        let o;
        return t < 0 ? o = e > 0 ? e - 1 : n.length - 1 : o = (e + 1) % n.length, {
          suggestionIndex: o
        };
      }
      return null;
    });
  }
  tabsNavigate(t) {
    this.setState(({ tabIndex: e, suggestionTrigger: n }) => {
      const o = n?.getTabs?.();
      if (o?.length) {
        let r;
        return t < 0 ? r = e > 0 ? e - 1 : o.length - 1 : r = (e + 1) % o.length, {
          tabIndex: r
        };
      }
      return null;
    });
  }
  lookForTriggers(t, e) {
    const { editor: n } = this.props, { selectedTab: o, selectionMode: r } = this.state, a = Wb(n.selection.recreate());
    if (a) {
      const l = n.triggers.test(a);
      if (l && n.triggers.isSuggestionTrigger(l.matchedTrigger)) {
        const { match: c, matchedTrigger: d } = l, h = d?.getTabs?.();
        if (h?.length) {
          let p = null;
          if (t ? p = {
            selectionMode: "suggestion",
            selectedTab: t,
            tabIndex: -1
          } : o ? t = o : p = {
            selectionMode: "tab",
            selectedTab: h[0].id,
            tabIndex: 0
          }, p && this.setState(p, () => {
            t || this.lookForTriggers();
          }), !t)
            return;
        } else r !== "suggestion" && this.setState({ selectionMode: "suggestion" });
        Promise.resolve(
          d.getSuggestions(c[1], t, e)
        ).then((p) => {
          this.updateSuggestions(c, d, p);
        });
        return;
      }
    }
    this.clearSuggestions();
  }
  findTriggerPosition(t, e) {
    this.setState(
      {
        listenForSelectionChange: !1
      },
      () => {
        const { onError: n, editor: o } = this.props, r = o.selection.recreate();
        if (r) {
          const { focusOffset: a, anchorNode: l } = r;
          if (l) {
            if (a - t >= 0)
              try {
                r.extend(l, a - t);
              } catch (c) {
                n?.(c);
              }
            if (r?.rangeCount && r?.rangeCount > 0) {
              const c = r.getRangeAt(0).getBoundingClientRect();
              r.collapseToEnd(), setTimeout(() => {
                e(c), this.setState({
                  listenForSelectionChange: !0
                });
              });
            }
          }
        }
      }
    );
  }
  updateSuggestions(t, e, n) {
    const { editor: o } = this.props;
    this.findTriggerPosition(t[0].length, (r) => {
      const a = o.selection.recreate();
      if (!a)
        return;
      const { focusOffset: l } = a, h = new RegExp(e.trigger).exec(t[0])?.[1]?.length ?? 0, u = t[0].length - h;
      this.setState({
        suggestions: n,
        suggestionTrigger: e,
        suggestionPosition: r,
        suggestionIndex: 0,
        suggestionMatchedString: t[1],
        suggestionExtendBy: l - u,
        listenForSelectionChange: !0
      });
    });
  }
  updateSuggestionScroll() {
    const { suggestionIndex: t } = this.state, { current: e } = this.dropdownRef;
    if (e) {
      if (e.infiniteListRef.current)
        e.infiniteListRef.current.scrollToItem(t);
      else if (e.listRef.current) {
        const n = e.listRef.current, r = e.listRef.current.children[t].getBoundingClientRect(), a = n.getBoundingClientRect();
        a.bottom < r.bottom ? n.scrollTop += r.bottom - a.bottom : a.top > r.top && (n.scrollTop -= a.top - r.top);
      }
    }
  }
  updateTabScroll() {
    const { tabIndex: t } = this.state, { current: e } = this.tabsRef;
    if (!(t < 0 || !e) && e.containerRef.current) {
      const n = e.containerRef.current, r = e.containerRef.current.children[0].children[t].getBoundingClientRect(), a = n.getBoundingClientRect();
      a.bottom < r.bottom ? n.scrollTop += r.bottom - a.bottom : a.top > r.top && (n.scrollTop -= a.top - r.top);
    }
  }
  expandSuggestion() {
    const {
      suggestions: t,
      suggestionIndex: e,
      suggestionExtendBy: n,
      suggestionTrigger: o
    } = this.state;
    if (!(!t || !t[e] || !o))
      return o.insertContent(
        t[e],
        o.trigger,
        n
      );
  }
  handleSelectionChange() {
    const { listenForSelectionChange: t } = this.state;
    t && this.lookForTriggers();
  }
  handleSuggestionClick(t) {
    this.setState(
      (e) => ({
        suggestionIndex: e.suggestions ? e.suggestions.indexOf(t) : 0
      }),
      () => {
        this.expandSuggestion();
      }
    );
  }
  calculateSuggestionBoxPosition() {
    const { suggestionPosition: t } = this.state, { editor: e } = this.props;
    if (e.ref.current && t) {
      const n = e.ref.current.getBoundingClientRect();
      return {
        bottom: n.bottom - t.bottom + t.height,
        left: t.x - n.x + t.width
      };
    }
    return {};
  }
  suggestionBoxStyle() {
    const { suggestionPosition: t } = this.state, { editor: e } = this.props;
    if (e.ref.current && t) {
      const n = e.ref.current.getBoundingClientRect();
      return {
        left: `${t.x - n.x}px`,
        top: `${t.y - n.y + t.height / 2}px`,
        //`${suggestionPosition.x}px`,
        height: 1,
        width: t.width,
        position: "absolute"
      };
    }
    return {};
  }
  getPagination() {
    const { suggestionTrigger: t } = this.state;
    if (!t || !t.getPagination)
      return !1;
    const e = t.getPagination();
    return !e || !e.onNext ? !1 : {
      ...e,
      onNext: () => e.onNext?.().then((n) => {
        this.setState({ suggestions: n });
      }) ?? Promise.resolve(void 0)
    };
  }
  handleTabChange(t) {
    this.lookForTriggers(t, 0);
  }
  renderEmptyState() {
    return /* @__PURE__ */ s.jsx(mn, { label: "No suggestions found" });
  }
  renderTabs() {
    const { suggestions: t, suggestionTrigger: e, selectedTab: n, tabIndex: o } = this.state, r = e?.getTabs?.() ?? [], a = !!t?.length;
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        so,
        {
          ref: this.tabsRef,
          className: Ge.dropdownTabs,
          tabs: r,
          tabsPlacement: "left",
          selectedId: n,
          activeId: r?.[o]?.id,
          onChange: this.handleTabChange
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: Ge.dropdownTabsContent, children: a ? this.renderItems() : this.renderEmptyState() })
    ] });
  }
  renderItems() {
    const { suggestions: t, suggestionIndex: e, suggestionTrigger: n, selectionMode: o } = this.state, r = n ? n.suggestionComponent : null;
    return /* @__PURE__ */ s.jsx(
      Ys,
      {
        ref: this.dropdownRef,
        pagination: this.getPagination(),
        items: t || void 0,
        onSelect: this.handleSuggestionClick,
        itemComponent: r,
        activeItem: o === "suggestion" ? t?.[e] : void 0
      }
    );
  }
  shouldRenderDropdown() {
    const { suggestionPosition: t, selectedTab: e, suggestions: n } = this.state;
    return !(!t || !this.hasTabs() && !n?.length || this.hasTabs() && !e);
  }
  render() {
    const { editor: t, onError: e, ...n } = this.props;
    if (!this.shouldRenderDropdown())
      return null;
    const o = f(Ge.dropdown, {
      [Ge.dropdownWithTabs]: this.hasTabs(),
      [Ge.dropdownWithoutTabs]: !this.hasTabs()
    });
    return /* @__PURE__ */ s.jsx("div", { ...n, children: /* @__PURE__ */ s.jsx("div", { style: this.suggestionBoxStyle(), children: /* @__PURE__ */ s.jsx(te, { className: o, isOpen: !0, children: this.hasTabs() ? this.renderTabs() : this.renderItems() }) }) });
  }
}
function zb({ children: i, className: t }) {
  const e = Y(null), [n, o] = V(0), r = () => e.current ? Array.from(
    e.current.querySelectorAll("button:not([disabled])")
  ).filter((l) => l.closest('[role="toolbar"]') === e.current) : [];
  J(() => {
    const l = r();
    l.length !== 0 && l.forEach((c, d) => {
      d === 0 ? c.setAttribute("tabindex", "0") : c.setAttribute("tabindex", n === d ? "0" : "-1");
    });
  }, [n]);
  const a = (l) => {
    const c = r();
    if (c.length === 0) return;
    const d = document.activeElement;
    if (!e.current?.contains(d)) return;
    let h = n;
    switch (l.key) {
      case "ArrowLeft":
      case "ArrowUp":
        l.preventDefault(), l.stopPropagation(), h = h <= 0 ? c.length - 1 : h - 1, o(h), c[h]?.focus();
        break;
      case "ArrowRight":
      case "ArrowDown":
        l.preventDefault(), l.stopPropagation(), h = h >= c.length - 1 ? 0 : h + 1, o(h), c[h]?.focus();
        break;
      case "Home":
        l.preventDefault(), l.stopPropagation(), o(0), c[0]?.focus();
        break;
      case "End":
        l.preventDefault(), l.stopPropagation();
        const u = c.length - 1;
        o(u), c[u]?.focus();
        break;
    }
  };
  return J(() => {
    const l = e.current;
    if (!l) return;
    const c = (h) => {
      const u = r(), p = h.target, m = u.indexOf(p);
      m !== -1 && o(m);
    }, d = (h) => {
      l.contains(h.relatedTarget) || o(0);
    };
    return l.addEventListener("focusin", c), l.addEventListener("focusout", d), () => {
      l.removeEventListener("focusin", c), l.removeEventListener("focusout", d);
    };
  }, []), /* @__PURE__ */ s.jsx(
    "div",
    {
      ref: e,
      className: t,
      role: "toolbar",
      "aria-label": "Text formatting",
      onKeyDown: a,
      children: i
    }
  );
}
function Ko(i) {
  return i instanceof RegExp ? i.source : i;
}
function Vb(i) {
  return i.replace(/\(/g, "(?:");
}
class Ur {
  storedTriggers;
  constructor() {
    this.storedTriggers = [];
  }
  get excludeTriggersRegex() {
    return this.storedTriggers.map(
      (t) => `(?!${Ko(t.trigger)})`
    ).join("");
  }
  add(t) {
    this.storedTriggers.push(t);
  }
  update(t) {
    const e = this.storedTriggers.findIndex(
      (n) => this.isAddonTrigger(n) && n.id === t.id
    );
    e !== -1 && (this.storedTriggers[e] = t);
  }
  test(t) {
    let e;
    for (let n = 0; n < this.storedTriggers.length; n += 1) {
      const o = this.storedTriggers[n], { trigger: r, allowSpaces: a, minChars: l } = o, c = Vb(
        Ko(r)
      ), d = this.excludeTriggersRegex, h = a ? "." : "\\S";
      if (e = new RegExp(`${c}((?:${d}${h})*)$`, "g").exec(t), e && (!l || e[1].length >= l))
        return {
          match: e,
          matchedTrigger: o
        };
    }
    return null;
  }
  isSuggestionTrigger(t) {
    return "getSuggestions" in t;
  }
  isAddonTrigger(t) {
    return !this.isSuggestionTrigger(t);
  }
}
function qr(i, t) {
  const e = i.getSelection();
  if (!e || e.rangeCount === 0) return !1;
  let n = e.anchorNode;
  const o = "CODE";
  for (; n; ) {
    if (n.nodeType === Node.ELEMENT_NODE && n.tagName === o)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
function Kb(i, t) {
  t?.();
  const e = i.getSelection();
  if (!e || e.rangeCount === 0) return;
  const n = e.getRangeAt(0);
  if (qr(i)) {
    Ub(i, "CODE");
    return;
  }
  const o = n.collapsed, r = i.document.createElement("code");
  if (o) {
    const a = i.document.createTextNode("​");
    r.appendChild(a), n.insertNode(r), n.setStart(r.firstChild, 1), n.setEnd(r.firstChild, 1);
  } else {
    const a = n.extractContents();
    r.appendChild(a), n.insertNode(r), n.setStartAfter(r), n.setEndAfter(r);
  }
  e.removeAllRanges(), e.addRange(n);
}
function Ub(i, t) {
  const e = i.getSelection();
  if (!e || e.rangeCount === 0) return;
  let n = e.anchorNode;
  for (; n; ) {
    if (n.nodeType === Node.ELEMENT_NODE) {
      const o = n;
      if (o.tagName === t) {
        const r = o.parentNode;
        if (r) {
          const a = i.document.createDocumentFragment();
          for (; o.firstChild; )
            a.appendChild(o.firstChild);
          r.replaceChild(a, o);
          const l = i.document.createRange();
          l.selectNodeContents(r), l.collapse(!1), e.removeAllRanges(), e.addRange(l);
        }
        return;
      }
    }
    n = n.parentNode;
  }
}
const Tn = 25;
let It = null, ae = null;
function qb(i, t) {
  const e = t.document.createElement("div");
  return e.className = `image-resize-handle image-resize-handle-${i}`, e.dataset.handle = i, e;
}
function Gb(i, t) {
  const e = t.document.createElement("div");
  return e.className = "image-resize-wrapper", e.contentEditable = "false", i.parentNode?.insertBefore(e, i), e.appendChild(i), ["nw", "ne", "se", "sw"].forEach((o) => {
    const r = qb(o, t);
    e.appendChild(r);
  }), e;
}
function Gr(i) {
  const t = i.querySelector("img");
  t && i.parentNode && (i.parentNode.insertBefore(t, i), i.remove());
}
function Yb(i, t, e) {
  const { startX: n, startWidth: o, handle: r, aspectRatio: a } = i, l = t - n;
  let c = o;
  switch (r) {
    case "se":
    case "ne":
      c = o + l;
      break;
    case "sw":
    case "nw":
      c = o - l;
      break;
  }
  let d = c / a;
  c < Tn && (c = Tn, d = Tn / a);
  const h = Tn / a;
  return d < h && (d = h, c = h * a), { width: c, height: d };
}
function oo(i) {
  if (!It) return;
  i.preventDefault(), i.stopPropagation();
  const { width: t } = Yb(
    It,
    i.clientX,
    i.clientY
  );
  It.img.style.width = `${t}px`, It.img.style.height = "auto";
}
function ro(i) {
  if (!It) return;
  i.preventDefault(), i.stopPropagation();
  const { img: t } = It, e = t.ownerDocument.defaultView;
  e.document.removeEventListener("mousemove", oo), e.document.removeEventListener("mouseup", ro), It = null;
  const n = new Event("input", { bubbles: !0 });
  t.closest('[contenteditable="true"]')?.dispatchEvent(n);
}
function Xb(i, t, e) {
  i.preventDefault(), i.stopPropagation();
  const n = t.ownerDocument.defaultView, o = t.closest(".image-resize-wrapper");
  if (!o) return;
  const r = t.naturalWidth, a = t.naturalHeight, l = r / a, c = t.getBoundingClientRect(), d = c.width, h = c.height;
  It = {
    img: t,
    originalWidth: r,
    originalHeight: a,
    aspectRatio: l,
    startX: i.clientX,
    startY: i.clientY,
    startWidth: d,
    startHeight: h,
    handle: e,
    wrapper: o
  }, n.document.addEventListener("mousemove", oo), n.document.addEventListener("mouseup", ro);
}
function Qb(i, t) {
  ae && (Gr(ae), ae = null);
  const e = Gb(i, t);
  ae = e, e.querySelectorAll(".image-resize-handle").forEach((o) => {
    const r = o.dataset.handle;
    o.addEventListener(
      "mousedown",
      (a) => Xb(a, i, r)
    );
  });
}
function vs() {
  if (ae && (Gr(ae), ae = null), It) {
    const i = It.img.ownerDocument.defaultView;
    i.document.removeEventListener("mousemove", oo), i.document.removeEventListener("mouseup", ro), It = null;
  }
}
function Zb(i) {
  return i ? i.classList.contains("image-resize-wrapper") || i.classList.contains("image-resize-handle") || i.closest(".image-resize-wrapper") !== null : !1;
}
function Uo(i) {
  if (!i) return i;
  const n = new DOMParser().parseFromString(`<div>${i}</div>`, "text/html").body.firstChild;
  return n ? (n.querySelectorAll(".image-resize-wrapper").forEach((r) => {
    const a = r.querySelector("img");
    a && r.parentNode && (r.parentNode.insertBefore(a, r), r.remove());
  }), n.innerHTML) : i;
}
const Yr = "input-rich-text-editor", Xr = [
  {
    name: "insertInlineAttachment",
    label: "Insert inline image",
    keybindings: [[["$metaOrCtrl"], "KeyM"]]
  }
], qo = [
  ...Xr,
  ...Kr,
  ...zr,
  ...gf
], Jb = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/\S*)?$/i, tx = kt({
  command: {
    run: E,
    active: () => !1
  },
  content: {
    insert: E,
    setUiBlocker: E
  },
  hotkeys: {
    add: E,
    updateKeybindings: E
  },
  selection: {
    recreate: () => null,
    getRange: () => null,
    isWithinEditor: () => !1,
    onUpdate: E
  },
  events: {
    subscribe: () => E,
    publish: E,
    onMouseOver: E,
    onBlur: E
  },
  allowFormatting: [],
  triggers: new Ur(),
  ref: B(),
  window,
  history: {
    canUndo: () => !1,
    undo: E,
    takeSnapshot: E,
    reset: E
  }
});
class io extends D {
  editor;
  editorRef;
  currentSuggestionRef;
  fileInputRef;
  attachmentDropdownButtonRef;
  unsubscribeInlineAttachment;
  isInserting;
  contentInsertionQueue;
  /**
   * Button that can be used in `toolbarAddons` to have same styles as the
   * buitlin buttons.
   */
  static ToolbarButton = Et;
  /** Context containing props and methods to interact with the editor. */
  static Context = tx;
  static defaultProps = {
    allowAttachments: !1,
    allowInlineAttachments: !1,
    allowEmoji: !0,
    languages: [],
    onTriggerSend() {
      console.warn("InputRichText: onTriggerSend callback missing in props");
    },
    onToggleSendOnEnter: E,
    sendOnEnter: !1,
    editorWindow: window,
    onMount: E,
    onUnmount: E,
    disabled: !1,
    hasAutocompleteSuggestionsFeature: !1
  };
  constructor(t) {
    super(t), this.editorRef = B(), this.currentSuggestionRef = B(), this.fileInputRef = B(), this.attachmentDropdownButtonRef = B(), this.unsubscribeInlineAttachment = E, this.isInserting = !1, this.contentInsertionQueue = [], this.state = {
      keyDownHandled: !1,
      keyCommands: qo,
      selectionUpdateListeners: [],
      mouseOverListeners: [],
      blurListeners: [],
      htmlOld: "",
      lastSelection: null,
      hasFocus: !1,
      selectedText: "",
      selectedLink: "",
      showHint: !1,
      pubsub: {},
      uiBlocker: t.uiBlocker,
      undoStack: []
    }, this.editor = {
      command: {
        run: this.commandRun.bind(this),
        active: this.commandActive.bind(this)
      },
      content: {
        insert: this.insertContent.bind(this),
        setUiBlocker: this.setUiBlocker.bind(this)
      },
      hotkeys: {
        add: this.addKeyCommands.bind(this),
        updateKeybindings: this.updateKeyCommandsKeybindings.bind(this)
      },
      selection: {
        onUpdate: this.addSelectionUpdateListener.bind(this),
        recreate: this.recreateSelection.bind(this),
        getRange: this.getSelectionRange.bind(this),
        isWithinEditor: this.isSelectionWithinEditor.bind(this)
      },
      events: {
        onMouseOver: this.addMouseOverListener.bind(this),
        onBlur: this.addBlurListener.bind(this),
        subscribe: this.subscribe.bind(this),
        publish: this.publish.bind(this)
      },
      allowFormatting: this.getAllowedFormattingOptions(),
      triggers: new Ur(),
      ref: this.editorRef,
      window: this.props.editorWindow ?? window,
      history: {
        undo: this.undo,
        canUndo: this.canUndo,
        reset: this.resetUndoStack,
        takeSnapshot: this.addCurrentContentToUndoStack
      }
    };
  }
  componentDidMount() {
    const { editorWindow: t = window, onMount: e } = this.props;
    t.document.execCommand(
      "defaultParagraphSeparator",
      !1,
      "div"
    );
    const { value: n } = this.props;
    n && !n.startsWith("<") ? this.setHtml(`<div>${n}</div>`) : n ? this.setHtml(n) : this.setHtml(""), this.unsubscribeInlineAttachment = this.editor.events.subscribe(
      "insertInlineAttachment",
      () => {
        this.props.allowInlineAttachments && this.openFileBrowser();
      }
    ), e(), this.updateKeyCommandsKeybindings(this.props.keybindings);
  }
  componentDidUpdate(t) {
    const { fileUploadStatuses: e, autocomplete: n, keybindings: o, uiBlocker: r } = this.props, { current: a } = this.editorRef;
    e && e !== t.fileUploadStatuses && a && (Object.keys(e).forEach((l) => {
      this.updateFileLoader(l, e[l]);
    }), this.handleSelectionChange()), n && n.showAutocompleteSuggestions !== t.autocomplete?.showAutocompleteSuggestions && this.setState({ showHint: !0 }, () => {
      setTimeout(() => {
        this.setState({ showHint: !1 });
      }, 1e3);
    }), xr(t.keybindings, o) || this.updateKeyCommandsKeybindings(o), t.uiBlocker !== r && this.setUiBlocker(r);
  }
  componentWillUnmount() {
    const { onUnmount: t } = this.props;
    this.unsubscribeInlineAttachment?.(), vs(), t(this.getSanitizedHtml());
  }
  getCommandsWithInputKeybindings() {
    const { keybindings: t } = this.props;
    return qo.map((e) => ({
      ...e,
      keybindings: t && e.name ? t[e.name] ?? [] : e.keybindings
    }));
  }
  subscribe(t, e) {
    return this.setState((n) => ({
      pubsub: {
        ...n.pubsub,
        [t]: [...n.pubsub[t] ?? [], e]
      }
    })), () => {
      this.setState((n) => _r(n, t));
    };
  }
  publish(t) {
    this.state.pubsub[t]?.forEach((e) => e(this.editor));
  }
  /**
   * The core update function, that triggers every time the selection is
   * changed, which will also trigger when the contents change.
   *
   * This method handles calling onChange prop.
   *
   * @returns {void | undefined} Description
   * @todo Test if onInput would be a better way of triggering onChange
   */
  handleSelectionChange = () => {
    const { onChange: t, onSelectionChange: e } = this.props, { htmlOld: n, selectionUpdateListeners: o } = this.state, { current: r } = this.editorRef;
    if (r) {
      this.forceUpdate();
      const a = this.extractEditorContent();
      a !== n && (this.setState({
        htmlOld: a
      }), t(a));
    }
    o.forEach((a) => {
      a();
    }), e && e();
  };
  /** Handle any mouse over events on the editor */
  handleMouseOver = (t) => {
    const { mouseOverListeners: e } = this.state;
    e.forEach((n) => {
      n(t);
    });
  };
  /** Handle click events on the editor to select images */
  handleEditorClick = (t) => {
    const e = t.target, { editorWindow: n = window } = this.props;
    if (le(e) && e.tagName === "IMG") {
      t.preventDefault();
      const o = n.getSelection();
      if (o) {
        const r = n.document.createRange();
        r.selectNode(e), o.removeAllRanges(), o.addRange(r), this.handleSelectionChange();
      }
      Qb(e, n);
    } else Zb(e) || vs();
  };
  /** Handle blur events on the editor */
  handleBlurListeners = (t) => {
    const { blurListeners: e } = this.state;
    e.forEach(
      (n) => {
        n(t);
      }
    );
  };
  handleKeyDown = (t) => {
    if (t.getModifierState(t.key))
      return;
    const { keyCommands: e } = this.state, { sendOnEnter: n, onKeyDown: o } = this.props;
    if (o?.(t), e.some(
      ({ preventDefaultKeybinding: a }) => a && bs(a, t)
    ) && t.preventDefault(), e.some(
      ({ name: a, keybindings: l, condition: c, callback: d }) => {
        if (bs(l, t) && (c === void 0 || c(this.editor)))
          return d?.(this.editor, t), a && this.editor.events.publish(a), !0;
      }
    )) {
      this.setKeyDownHandled(t), t.stopPropagation();
      return;
    }
    if (t.key === "Enter" && !t.shiftKey && !t.ctrlKey && !t.metaKey && !t.altKey && this.editor.allowFormatting.includes("blockquote")) {
      const { editorWindow: a = window } = this.props, l = a.getSelection();
      if (!l) return;
      const c = l.anchorNode, h = (le(c) ? c : c?.parentElement)?.closest("blockquote");
      if (h && this.editorRef.current?.contains(h)) {
        const u = a.document, p = u.createElement("div");
        p.appendChild(u.createElement("br")), h.after(p);
        const m = u.createRange();
        m.setStart(p, 0), m.collapse(!0), l.removeAllRanges(), l.addRange(m), this.setKeyDownHandled(t), this.handleSelectionChange();
        return;
      }
    }
    if (bs([[["$metaOrCtrl"], "Enter"]], t)) {
      const { onTriggerSend: a } = this.props;
      this.setKeyDownHandled(t), a();
    } else if (t.key === "Enter" && n && !t.shiftKey) {
      const { onTriggerSend: a } = this.props;
      this.setKeyDownHandled(t), a();
    }
    return null;
  };
  getBlockLevelParent = (t) => {
    const { editorWindow: e = window } = this.props;
    let n = le(t) ? t : t.parentElement;
    for (; !to(n, e); )
      n = n.parentElement;
    return n;
  };
  // Insert actual text direction into the html
  onInput = (t) => {
    const { current: e } = this.editorRef, n = t?.nativeEvent;
    if (!n)
      return;
    this.resetUndoStack();
    const { inputType: o } = n;
    if (o === "insertFromPaste" || !o) {
      Oo(e), Kg(e);
      return;
    }
    const a = document.getSelection()?.anchorNode;
    if (o === "insertText" && a && a.textContent?.length === 1) {
      const l = this.getBlockLevelParent(a);
      if (
        // if the parent element is `ol` or `ul`, and if it has direction, do not change it
        (l.tagName === "UL" || l.tagName === "OL") && l.hasAttribute("dir")
      )
        return;
      l.setAttribute("dir", "auto");
      const c = window.getComputedStyle(l).direction;
      l.setAttribute("dir", c), l.style.textAlign = "";
    }
  };
  handleKeyUp = () => {
    const { keyDownHandled: t } = this.state;
    t || this.handleSelectionChange(), this.setState({
      keyDownHandled: !1
    });
  };
  setKeyDownHandled = (t) => {
    t.preventDefault(), this.setState({
      keyDownHandled: !0
    });
  };
  addKeyCommands = (t) => {
    this.setState(({ keyCommands: e }) => ({
      keyCommands: [...e, ...t]
    }));
  };
  updateKeyCommandsKeybindings = (t) => {
    if (!t)
      return;
    const { keyCommands: e } = this.state;
    Object.entries(t).forEach(([n, o]) => {
      const r = e.findIndex(
        ({ name: a }) => a === n
      );
      r > -1 && o && (e[r].keybindings = o);
    });
  };
  addSelectionUpdateListener(t) {
    this.setState(({ selectionUpdateListeners: e }) => ({
      selectionUpdateListeners: [...e, t]
    }));
  }
  addMouseOverListener(t) {
    this.setState(({ mouseOverListeners: e }) => ({
      mouseOverListeners: [...e, t]
    }));
  }
  addBlurListener(t) {
    this.setState(({ blurListeners: e }) => ({
      blurListeners: [...e, t]
    }));
  }
  handlePaste = (t) => {
    const {
      onFileDropped: e,
      allowInlineAttachments: n,
      editorWindow: o = window,
      sanitize: r
    } = this.props, { clipboardData: a } = t;
    if (!a)
      return;
    let l = a.getData("text/html");
    const c = a.getData("text/plain"), d = a.files.item(0);
    if (l) {
      t.preventDefault(), this.commandRun("insertHTML", r?.(l));
      return;
    }
    if (c && Jb.test(c)) {
      t.preventDefault();
      const h = o.getSelection(), u = h && !h.isCollapsed ? h.toString() : "", p = u && this.editor.allowFormatting.includes("link") ? u : c;
      l = `<a href="${c}">${p}</a>`, this.commandRun("insertHTML", l);
      return;
    }
    if (d) {
      if (n && e) {
        const { src: h, uid: u } = $o(o, d);
        this.insertImageLoader(h, u), e(d, u);
      }
      t.preventDefault();
    }
  };
  commandRun(t, e = null) {
    setTimeout(() => {
      const { hasFocus: n } = this.state, { current: o } = this.editorRef, { editorWindow: r = window } = this.props;
      if (o) {
        if (n || this.recreateSelection(), t === "inlineCode") {
          Kb(r, this.addCurrentContentToUndoStack), this.handleSelectionChange();
          return;
        }
        r.document.execCommand(
          t,
          !1,
          // execCommand 3rd expects string | null, TS thinks it needs string | undefined
          e
        );
      }
    });
  }
  commandActive(t) {
    const { hasFocus: e } = this.state, { editorWindow: n = window } = this.props;
    return t === "inlineCode" ? !!(e && qr(n)) : !!(e && Mg(n, t));
  }
  getText = () => {
    const { current: t } = this.editorRef;
    return t && this.hasContent(this.extractEditorContent()) ? this.extractEditorContent() : "";
  };
  getSanitizedHtml = () => this.props.sanitize?.(this.getText());
  getPlainText = () => {
    const { current: t } = this.editorRef, e = (
      // innerHTML of <div></div> should count as empty
      t && this.hasContent(this.extractEditorContent()) ? t.innerText : ""
    );
    return e ? e.replace(/\n\n/g, `
`).trim() : "";
  };
  setHtml(t) {
    const { current: e } = this.editorRef, n = this.props.sanitize?.(t);
    e && (e.innerHTML = n || "", Oo(e)), this.setState({
      htmlOld: n
    }), this.handleSelectionChange();
  }
  handleInlineUpload = (t) => {
    if (t === null) return;
    const { onFileDropped: e, editorWindow: n = window } = this.props;
    t && e && Array.from(t).forEach((r) => {
      if (Vg(r)) {
        const { src: a, uid: l } = $o(n, r);
        this.insertImageLoader(a, l), e(r, l);
      } else {
        const a = rn();
        this.insertFileLoader(r.name, a), e(r, a);
      }
    });
  };
  handleAttachmentUpload = (t) => {
    const { onAttachmentsFile: e } = this.props, { current: n } = this.attachmentDropdownButtonRef;
    n && n.open(), t && typeof e == "function" && Array.from(t).forEach((r) => {
      const a = rn();
      e(r, a);
    });
  };
  handleDetachAttachmentFile = (t) => {
    const { onDetachAttacmentFile: e } = this.props;
    typeof e == "function" && e(t);
  };
  handleFileSelect = (t) => {
    const e = t.target;
    e?.ownerDocument?.defaultView && e instanceof e.ownerDocument.defaultView.HTMLInputElement && (this.handleInlineUpload(e.files), e.value = "");
  };
  openFileBrowser = (t) => {
    t?.preventDefault();
    const { current: e } = this.fileInputRef;
    e && e.click();
  };
  insertImageLoader(t, e) {
    const { editorWindow: n = window } = this.props, o = n.document.createElement("img");
    o.setAttribute("class", "async-loading"), o.setAttribute("data-uid", e), o.setAttribute("src", t), this.insertContent(o);
  }
  insertFileLoader(t, e) {
    const { editorWindow: n = window } = this.props, o = n.document.createElement("a");
    o.setAttribute("class", "async-loading"), o.setAttribute("data-uid", e), o.setAttribute("href", "#"), o.innerText = t, this.insertContent(o);
  }
  updateFileLoader(t, { link: e, status: n, filename: o }) {
    const { current: r } = this.editorRef;
    if (r) {
      const a = r.querySelector(`[data-uid="${t}"]`);
      a && (n === "failed" && a.parentElement ? a.parentElement.removeChild(a) : (a.classList.remove(
        "async-loading",
        "async-succeeded",
        "async-failed"
      ), a.classList.add(`async-${n}`), e && a.tagName === "IMG" && (a.src = e, o && (a.title = o)), e && a.tagName === "A" && (a.href = e)));
    }
  }
  handleToggleSendOnEnter = (t) => {
    t.preventDefault();
    const { onToggleSendOnEnter: e } = this.props;
    e();
  };
  handleToggleAutocompleteSuggestions = (t) => {
    t.preventDefault();
    const { autocomplete: e } = this.props;
    e && e.onToggleShowAutocompleteSuggestions();
  };
  isSelectionWithinEditor(t) {
    const { anchorNode: e } = t;
    let { parentElement: n = null } = e || {};
    const o = `.${bt.editor}`;
    let r = e !== null && e.nodeType === Node.ELEMENT_NODE ? e.matches(o) : !1;
    for (; !r && n !== null; ) {
      if (n.matches(o)) {
        r = !0;
        break;
      }
      n = n.parentElement;
    }
    return r;
  }
  insertContent = (t, e) => {
    this.contentInsertionQueue.push(t), e?.getSelection ? this.processContentInsertionQueue(e.getSelection()) : this.isInserting || (this.isInserting = !0, this.editor.window.requestAnimationFrame(() => {
      this.processContentInsertionQueue(this.recreateSelection()), this.isInserting = !1;
    }));
  };
  processContentInsertionQueue = (t) => {
    if (!(!t || !this.isSelectionWithinEditor(t))) {
      if (Ug(t), t?.rangeCount && t?.rangeCount > 0) {
        const e = t.getRangeAt(0);
        if (t.isCollapsed || e.deleteContents(), this.contentInsertionQueue.length === 1)
          e.insertNode(this.contentInsertionQueue[0]);
        else if (this.contentInsertionQueue.length > 1) {
          const n = document.createElement("span");
          this.contentInsertionQueue.forEach((o) => {
            n.appendChild(o);
          }), e.insertNode(n);
        }
      }
      this.contentInsertionQueue = [], this.editor.window.requestAnimationFrame(() => {
        t.collapseToEnd();
      }), this.handleSelectionChange();
    }
  };
  setUiBlocker(t) {
    this.setState({ uiBlocker: t });
  }
  getSelectionRange() {
    const { editorWindow: t = window } = this.props;
    if (t.document.activeElement === this.editorRef.current) {
      const e = t.document.getSelection();
      return e?.rangeCount && e?.rangeCount > 0 ? e.getRangeAt(0) : null;
    }
    return this.state.lastSelection;
  }
  recreateSelection() {
    const { current: t } = this.editorRef, { hasFocus: e, lastSelection: n } = this.state, { editorWindow: o = window } = this.props, r = o.getSelection();
    return t && !e && (t.focus(), n && r && (r.removeAllRanges(), r.addRange(n))), r;
  }
  handleFocus = () => {
    const { editorWindow: t = window } = this.props;
    this.setState({
      hasFocus: !0
    }), t.document.addEventListener(
      "selectionchange",
      this.handleSelectionChange
    );
  };
  handleBlur = (t) => {
    const { editorWindow: e = window } = this.props, n = e.getSelection(), o = () => n?.rangeCount && n?.rangeCount > 0 ? n.getRangeAt(0) : null;
    vs(), this.setState({
      lastSelection: o(),
      hasFocus: !1
    }), e.document.removeEventListener(
      "selectionchange",
      this.handleSelectionChange
    ), this.handleBlurListeners(t);
  };
  focus = () => {
    const { current: t } = this.editorRef, { hasFocus: e } = this.state;
    t && (e || t.focus());
  };
  moveCursorToEnd = () => {
    const { current: t } = this.editorRef, { editorWindow: e = window } = this.props;
    if (!t) return;
    const n = e.getSelection();
    if (n) {
      const o = e.document.createRange();
      o.selectNodeContents(t), o.collapse(!1), n.removeAllRanges(), n.addRange(o);
    }
  };
  hasContent(t) {
    return t?.length ? !t.match(/^\s*<br>\s*$|^<div[^>]*>\s*(<br>\s*)?<\/div>$/) : !1;
  }
  isStylingActive() {
    return this.commandActive("bold") || this.commandActive("italic") || this.commandActive("insertUnorderedList") || this.commandActive("insertOrderedList") || this.commandActive("inlineCode");
  }
  getAllowedFormattingOptions() {
    const { allowFormatting: t } = this.props;
    return Array.isArray(t) ? t : t ? Hg : [];
  }
  lastExtractedContent = B();
  extractEditorContent() {
    const { editorContentExtractor: t, sanitize: e } = this.props, { current: n } = this.editorRef, o = n?.innerHTML ?? "";
    if (!t)
      return Uo(o);
    if (o === this.lastExtractedContent.current)
      return this.lastExtractedContent.current;
    const r = t(n);
    return this.lastExtractedContent.current = Uo(
      e?.(r) ?? r
    ), this.lastExtractedContent.current;
  }
  canUndo = () => this.state.undoStack.length > 0;
  undo = () => {
    const { undoStack: t } = this.state;
    if (t.length > 0) {
      const e = t[t.length - 1];
      this.setHtml(e), this.setState({
        undoStack: t.slice(0, -1)
      });
    }
  };
  resetUndoStack = () => {
    this.setState({
      undoStack: []
    });
  };
  addCurrentContentToUndoStack = () => {
    this.setState({
      // To prevent undo stack from growing indefinitely, we only keep a finite amount
      undoStack: [...this.state.undoStack.slice(-50), this.getText()]
    });
  };
  render() {
    const {
      className: t,
      wrapperClassName: e,
      renderQuickResponse: n,
      quickResponsesApi: o,
      sendOnEnter: r,
      placeholder: a,
      allowInlineAttachments: l,
      allowAttachments: c,
      attachmentsDisabled: d,
      attachmentsDisabledTooltip: h,
      textInputDisabled: u,
      allowEmoji: p,
      attachmentsFields: m,
      attachments: g,
      isAttachmentsUploading: b,
      hideSendOnEnterToggle: x,
      editorWindow: C = window,
      languages: _,
      disabled: w,
      status: S,
      onError: y,
      icon: v,
      prefix: I,
      suffix: T,
      id: P,
      autocomplete: L,
      toolbarAddons: k
    } = this.props, { htmlOld: R, uiBlocker: O } = this.state, U = f(bt.root, t);
    return /* @__PURE__ */ s.jsx(io.Context.Provider, { value: this.editor, children: /* @__PURE__ */ s.jsx(
      At,
      {
        status: S,
        icon: v,
        prefix: I,
        suffix: T,
        disabled: w,
        className: f(bt.inputWrapper, e),
        children: /* @__PURE__ */ s.jsxs("div", { className: U, children: [
          /* @__PURE__ */ s.jsxs(
            wf,
            {
              className: bt.editorWrap,
              onAddInline: this.handleInlineUpload,
              onAddAttachment: this.handleAttachmentUpload,
              attachments: Array.isArray(g) ? g : [],
              allowInlineAttachments: l,
              allowAttachments: c,
              children: [
                /* @__PURE__ */ s.jsx(
                  "div",
                  {
                    id: P,
                    ref: this.editorRef,
                    onPaste: this.handlePaste,
                    onKeyDown: this.handleKeyDown,
                    onInput: this.onInput,
                    onKeyUp: this.handleKeyUp,
                    onBlur: this.handleBlur,
                    onFocus: this.handleFocus,
                    onMouseOver: this.handleMouseOver,
                    onClick: this.handleEditorClick,
                    className: f(bt.editor, {
                      [bt.editorDisabled]: u
                    }),
                    "data-testid": Yr,
                    contentEditable: !u
                  }
                ),
                !this.hasContent(R) && !!a && /* @__PURE__ */ s.jsx("span", { role: "presentation", className: bt.placeholder, children: a })
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs(zb, { className: bt.toolbar, children: [
            this.editor.allowFormatting.length > 0 && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              /* @__PURE__ */ s.jsx(
                Lb,
                {
                  isActive: this.isStylingActive(),
                  editor: this.editor,
                  editorWindow: C
                }
              ),
              this.editor.allowFormatting.includes("link") && /* @__PURE__ */ s.jsx(Xf, { editor: this.editor })
            ] }),
            l && /* @__PURE__ */ s.jsx(
              Et,
              {
                icon: "upload",
                onMouseDown: this.openFileBrowser,
                tooltip: `Insert inline image (${no(Xr[0].keybindings)})`
              }
            ),
            c && /* @__PURE__ */ s.jsx(
              ff,
              {
                dropdownRef: this.attachmentDropdownButtonRef,
                onAttachFiles: this.handleAttachmentUpload,
                attachments: Array.isArray(g) ? g : [],
                isAttachmentsUploading: b,
                onDetachFile: this.handleDetachAttachmentFile,
                editorWindow: C,
                editor: this.editor,
                disabled: d,
                disabledTooltip: h,
                fixed: !0,
                children: m
              }
            ),
            p && /* @__PURE__ */ s.jsx(Nf, { "data-tip": "Emojis", editor: this.editor, fixed: !0 }),
            !!o && !!n && /* @__PURE__ */ s.jsx(
              Ib,
              {
                languages: _,
                renderQuickResponse: n,
                quickResponsesApi: o,
                editor: this.editor,
                sanitize: this.props.sanitize,
                iconName: this.props.quickResponseIcon
              }
            ),
            L && L.hasAutocompleteSuggestionsFeature && /* @__PURE__ */ s.jsx(
              Et,
              {
                isActive: L.showAutocompleteSuggestions,
                onMouseDown: this.handleToggleAutocompleteSuggestions,
                icon: "autocomplete",
                tooltip: "Autocomplete suggestions"
              }
            ),
            k,
            !x && /* @__PURE__ */ s.jsx(
              Et,
              {
                isActive: r,
                onMouseDown: this.handleToggleSendOnEnter,
                icon: "enter",
                tooltip: "Send on Enter"
              }
            ),
            L ? /* @__PURE__ */ s.jsxs(
              "span",
              {
                className: f(bt.toolbarHint, {
                  [bt.toolbarHintVisible]: this.state.showHint,
                  [bt.toolbarHintHidden]: !this.state.showHint
                }),
                children: [
                  "Autocomplete",
                  " ",
                  L.showAutocompleteSuggestions ? "ON" : "OFF"
                ]
              }
            ) : null
          ] }),
          /* @__PURE__ */ s.jsx(
            "input",
            {
              tabIndex: -1,
              ref: this.fileInputRef,
              type: "file",
              className: bt.fileInput,
              onChange: this.handleFileSelect,
              multiple: !0
            }
          ),
          /* @__PURE__ */ s.jsx(Mb, { editor: this.editor, onError: y }),
          /* @__PURE__ */ s.jsx(sf, { editor: this.editor }),
          O && /* @__PURE__ */ s.jsx("div", { className: bt.uiBlocker, children: O })
        ] })
      }
    ) });
  }
}
const ex = "h-textarea--textarea__inputWrapper", nx = "h-textarea--textarea__input", Go = {
  inputWrapper: ex,
  input: nx
}, sx = "textarea", Qr = $(function(t, e) {
  const n = Y(null), {
    className: o,
    disabled: r,
    readOnly: a,
    name: l,
    prefix: c,
    suffix: d,
    icon: h,
    status: u,
    height: p = 0,
    style: m,
    autoGrow: g,
    ...b
  } = t, [x, C] = V(p), _ = {
    ...m,
    height: x ? `${x}px` : void 0
  }, w = F(() => {
    if (!n.current)
      return;
    const S = n.current.clientHeight, y = window.getComputedStyle(n.current), v = parseInt(y.lineHeight || "16");
    n.current.style.height = "auto";
    const I = n.current.scrollHeight + v, T = Math.max(
      p,
      Math.min(S, I)
    ), P = I > T ? I : T;
    n.current.style.height = `${P}px`, C(P);
  }, [p]);
  return J(() => {
    if (g)
      return w(), window.addEventListener("resize", w), () => {
        window.removeEventListener("resize", w);
      };
  }, [g, w]), /* @__PURE__ */ s.jsx(
    At,
    {
      className: Go.inputWrapper,
      status: u,
      disabled: r,
      prefix: c,
      suffix: d,
      icon: h,
      children: /* @__PURE__ */ s.jsx(
        "textarea",
        {
          "data-testid": sx,
          className: Go.input,
          dir: "auto",
          id: l,
          ...b,
          onChange: (S) => {
            b?.onChange?.(S), g && w();
          },
          ref: n,
          style: _,
          name: l,
          disabled: r,
          readOnly: a
        }
      )
    }
  );
}), ox = "h-fieldRichText--fieldRichText__editorContainer", rx = "h-fieldRichText--fieldRichText__fallbackTextArea", Yo = {
  editorContainer: ox,
  fallbackTextArea: rx
};
class Qk extends D {
  static defaultProps = {
    allowFormatting: !0
  };
  render() {
    const {
      className: t,
      input: e,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: n,
        labelFor: e.name,
        meta: o,
        required: r,
        helpIcon: l,
        disabled: a,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Re,
          {
            fallback: /* @__PURE__ */ s.jsx(
              Qr,
              {
                ...e,
                className: Yo.fallbackTextArea,
                disabled: a,
                value: e.value,
                onChange: (p) => e.onChange(p.target.value)
              }
            ),
            children: /* @__PURE__ */ s.jsx("div", { className: Yo.editorContainer, children: /* @__PURE__ */ s.jsx(
              io,
              {
                disabled: a,
                status: z.getStatus(o),
                ...e,
                ...u,
                hideSendOnEnterToggle: !0,
                onTriggerSend: E
              }
            ) })
          }
        )
      }
    );
  }
}
class Zk extends D {
  constructor(t) {
    super(t), this.handleSelect = this.handleSelect.bind(this), this.handleClear = this.handleClear.bind(this);
  }
  getSelectedItems() {
    const {
      input: { value: t },
      items: e
    } = this.props;
    return typeof t == "string" && e?.some((n) => n.id === t) ? [t] : Array.isArray(t) && t.length && e?.some((n) => t.some((o) => o === n.id)) ? t : [];
  }
  handleSelect(t) {
    const {
      input: { onChange: e }
    } = this.props;
    typeof e == "function" && e(t === null ? "" : t.id.toString());
  }
  handleClear() {
    const {
      input: { value: t },
      onClear: e
    } = this.props;
    typeof t == "string" && this.handleSelect(null), typeof e == "function" && e();
  }
  render() {
    const {
      className: t,
      input: e,
      meta: n,
      label: o,
      required: r,
      disabled: a,
      description: l,
      helpIcon: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: o,
        labelFor: e.name,
        meta: n,
        required: r,
        disabled: a,
        helpIcon: c,
        description: l,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Ne,
          {
            ...u,
            id: e.name,
            disabled: a,
            selectedItems: this.getSelectedItems(),
            onSelect: this.handleSelect,
            onClear: this.handleClear,
            status: z.getStatus(n)
          }
        )
      }
    );
  }
}
function Zr(i, t = "") {
  return Lt.toArray(i).reduce((e, n) => Dt(n) ? n.type === Wt ? [
    ...e,
    ...Zr(n.props.children, n.key)
  ] : [...e, { ...n, key: `${t}${n.key}` }] : e, []);
}
const es = (i) => q(() => Zr(i), [i]), ix = "h-selectionList--selectionList__root", ax = "h-selectionList--selectionList__disabled", Xo = {
  root: ix,
  disabled: ax
}, Ae = Li(
  () => kt({
    list: {
      isMultiple: !1,
      isActive: !1,
      isFocused: !1,
      isDisabled: !1
    },
    item: {
      isActive: !1,
      setActive: E,
      register: E,
      isSelected: () => !1,
      onSelect: E,
      isOnlyVisibleItem: !1
    }
  })
), ao = ({ defaultActiveItemIndex: i = 0 } = {
  defaultActiveItemIndex: 0
}) => {
  const [t, e] = V(!1), [n, o] = V(-1), [r, a] = V([]), [l, c] = V({}), d = F(
    ({
      isActivatable: g,
      isLastChild: b,
      isOnlyVisibleItem: x,
      keysTakenOverHandlingFromParent: C
    }, _) => {
      g !== void 0 && a((w) => {
        const S = g ? [...w, _].sort((y, v) => y - v) : w.filter((y) => y !== _);
        return b && o((y) => (S.includes(_) && !w.includes(_) || _ !== y) && S.includes(y) && _ !== S[i] ? y : S[i] ?? S[0] ?? y), S;
      }), x !== void 0 && e(x), C !== void 0 && c((w) => ({
        ...w,
        [_]: C
      }));
    },
    [i]
  ), h = F(
    (g) => "index" in g ? g.index : g.step === "first" ? r[0] : g.step === "last" ? r[r.length - 1] : r[(r.findIndex(
      (b) => b === n
    ) + g.step + r.length) % r.length],
    [r, n]
  ), u = F(
    (g) => {
      o(h(g));
    },
    [h]
  );
  J(() => {
    (n < 0 || n === void 0) && o(r[i]);
  }, [n, r, i]);
  const p = q(
    () => l[n] ?? [],
    [n, l]
  );
  return q(
    () => ({
      activeItemIndex: n,
      getActiveItemIndex: h,
      activatableItemIndices: r,
      setActiveItem: u,
      handleItemRegister: d,
      isOnlyActiveItemVisible: t,
      keysDelegatedHandlingToItem: p
    }),
    [
      r,
      n,
      h,
      d,
      t,
      p,
      u
    ]
  );
}, Qo = ({
  className: i,
  selectedValues: t = [],
  isActive: e,
  isDisabled: n,
  isMultiple: o = !1,
  onChange: r = E,
  equalityFn: a = Object.is,
  tabIndex: l = 0,
  defaultActiveItemIndex: c,
  children: d,
  ...h
}, u) => {
  const [p, m] = V(!1), [g, b] = V({ isActive: !!e, source: "parent" }), x = Ae(), {
    activeItemIndex: C,
    setActiveItem: _,
    handleItemRegister: w,
    isOnlyActiveItemVisible: S,
    keysDelegatedHandlingToItem: y
  } = ao({ defaultActiveItemIndex: c }), v = es(d), I = F(
    (k) => k !== void 0 && (t || []).some(
      (R) => a(R, k)
    ),
    [a, t]
  ), T = F(
    ({ value: k, meta: R }, O) => {
      _({ index: O }), k !== void 0 && r(o ? {
        selectedValues: I(k) ? t.filter(
          (U) => !a(U, k)
        ) : [...t, k],
        selectedItem: {
          isNode: R?.isNode,
          isSelected: !I(k),
          value: k
        },
        event: R?.event
      } : {
        selectedValues: [k],
        selectedItem: {
          isNode: R?.isNode,
          isSelected: !0,
          value: k
        },
        event: R?.event
      });
    },
    [
      a,
      I,
      o,
      r,
      t,
      _
    ]
  ), P = q(
    () => !n && (g.isActive || p),
    [n, g.isActive, p]
  ), L = (k) => {
    !P || y.includes(k.key) || (k.key === "Enter" ? k.preventDefault() : k.key === "Home" ? (_({ step: "first" }), k.preventDefault()) : k.key === "End" ? (_({ step: "last" }), k.preventDefault()) : k.key === "ArrowDown" ? (_({ step: 1 }), k.preventDefault()) : k.key === "ArrowUp" && (_({ step: -1 }), k.preventDefault()));
  };
  return J(() => {
    b({ isActive: !!e, source: "parent" });
  }, [e]), dn("keydown", L), /* @__PURE__ */ s.jsx(
    "ul",
    {
      ref: u,
      role: "listbox",
      tabIndex: n || e ? -1 : l,
      ...h,
      className: f(i, Xo.root, {
        [Xo.disabled]: n
      }),
      onFocus: () => m(!0),
      onBlur: () => m(!1),
      onMouseLeave: () => {
        g.source === "child" && b({ isActive: !1, source: "self" });
      },
      children: v.map(
        (k, R) => Dt(k) && (!S || R === C) && /* @__PURE__ */ s.jsx(
          x.Provider,
          {
            value: {
              list: {
                isFocused: p,
                isMultiple: o,
                isActive: g.isActive,
                isDisabled: n
              },
              item: {
                isActive: P && R === C,
                setActive: () => {
                  b({ isActive: !0, source: "child" }), _({ index: R });
                },
                register: (O) => w(O, R),
                isSelected: I,
                onSelect: (O) => T(O, R),
                isOnlyVisibleItem: S,
                isLastChild: R === v.length - 1
              }
            },
            children: k
          },
          R
        )
      )
    }
  );
}, Zo = ({ className: i, label: t, ...e }, n) => {
  const {
    item: { register: o, isLastChild: r }
  } = Xt(Ae());
  return Pe(() => {
    o({ isActivatable: !1, isLastChild: r });
  }), Jt(() => {
    o({ isActivatable: !1, isLastChild: r });
  }), /* @__PURE__ */ s.jsx(
    Yn,
    {
      ref: n,
      as: "li",
      color: "tertiary",
      padding: "200 250",
      ...e,
      children: /* @__PURE__ */ s.jsx(A.Paragraph, { as: "span", variant: "4", color: "secondary", children: t })
    }
  );
}, Jr = Object.assign($(Zo), {
  name: Zo.name
}), lx = "h-selectionList-subComponents-item--selectionListItem__root", cx = "h-selectionList-subComponents-item--selectionListItem__rootDisabled", dx = "h-selectionList-subComponents-item--selectionListItem__rootActive", hx = "h-selectionList-subComponents-item--selectionListItem__selectionState", ux = "h-selectionList-subComponents-item--selectionListItem__fixedSize", px = "h-selectionList-subComponents-item--selectionListItem__content", mx = "h-selectionList-subComponents-item--selectionListItem__contentDisabled", re = {
  root: lx,
  rootDisabled: cx,
  rootActive: dx,
  selectionState: hx,
  fixedSize: ux,
  content: px,
  contentDisabled: mx
}, Jo = ({
  value: i,
  isDisabled: t = !1,
  isIndeterminate: e = !1,
  className: n,
  contentClassName: o,
  noFixedSelectionStateSpace: r,
  onActiveStateChange: a,
  onSelectedStateChange: l,
  onSelect: c,
  children: d,
  ...h
}, u) => {
  const {
    list: {
      isMultiple: p,
      isDisabled: m,
      isActive: g,
      isFocused: b
    },
    item: {
      register: x,
      isSelected: C,
      onSelect: _,
      isActive: w,
      isNode: S = !1,
      isLastChild: y = !1,
      setActive: v
    }
  } = Xt(Ae()), I = C(i), T = q(
    () => !m && (g || b),
    [g, m, b]
  ), P = q(
    () => !t && w && T,
    [w, t, T]
  ), L = Y(null);
  Fe(
    u,
    () => L.current
  );
  const k = F(
    (W) => {
      !t && !m && (c?.({ value: i, meta: { target: W?.target } }), _({
        value: i,
        meta: {
          target: W?.target,
          event: W || void 0
        }
      }));
    },
    [t, m, c, _, i]
  ), R = F(
    (W) => {
      P && W.key === "Enter" && k(W);
    },
    [P, k]
  );
  J(() => {
    w && T && L.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }, [w]);
  const O = F(
    () => ({
      isActive: w,
      isSelected: I,
      isLastChild: y,
      isNode: S,
      value: i
    }),
    [w, y, S, I, i]
  ), U = on(w), ot = on(I);
  Zt(() => {
    w !== U && a?.(O()), I !== ot && l?.(O());
  }, [
    O,
    w,
    I,
    a,
    l,
    U,
    ot
  ]), dn("keydown", R), J(() => (x({ isActivatable: !t, isLastChild: y }), () => x({ isActivatable: !1, isLastChild: y })), [t]);
  const nt = !p && I || p && i !== void 0 || !r;
  return /* @__PURE__ */ s.jsxs(
    "li",
    {
      ref: L,
      role: "option",
      "aria-selected": I,
      "aria-disabled": t,
      onClick: k,
      onMouseMove: v,
      className: f(re.root, n, {
        [re.rootActive]: P,
        [re.rootDisabled]: t
      }),
      ...h,
      children: [
        nt && /* @__PURE__ */ s.jsxs(
          H,
          {
            className: f(re.selectionState, {
              [re.fixedSize]: !r
            }),
            children: [
              !p && I && /* @__PURE__ */ s.jsx(N, { name: "done" }),
              p && i !== void 0 && /* @__PURE__ */ s.jsx(
                un,
                {
                  checked: I,
                  indeterminate: !I && e,
                  disabled: t,
                  onChange: E,
                  tabIndex: -1
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ s.jsx(
          at,
          {
            className: f(re.content, o, {
              [re.contentDisabled]: t
            }),
            children: d
          }
        ),
        S && /* @__PURE__ */ s.jsx(N, { name: "angle-right" })
      ]
    }
  );
}, gx = Object.assign($(Jo), {
  name: Jo.name
}), fx = "h-selectionList-subComponents-list-backItem--selectionListBackItem__root", bx = "h-selectionList-subComponents-list-backItem--selectionListBackItem__rootActive", tr = {
  root: fx,
  rootActive: bx
}, er = ({
  className: i,
  content: t,
  onActiveStateChange: e,
  onSelected: n,
  ...o
}, r) => {
  const {
    list: {
      isDisabled: a,
      isActive: l,
      isFocused: c
    },
    item: { register: d, isActive: h, onSelect: u, setActive: p }
  } = Xt(Ae()), m = q(
    () => !a && (l || c),
    [l, a, c]
  ), g = q(
    () => h && m,
    [h, m]
  ), b = Y(null);
  Fe(
    r,
    () => b.current
  );
  const x = F(() => {
    u({}), n?.();
  }, [u, n]), C = F(
    (w) => {
      !g || a || w.key === "Enter" && x();
    },
    [x, g, a]
  );
  J(() => {
    h && m && b.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }, [h]);
  const _ = on(h);
  return Zt(() => {
    h !== _ && e?.({ isActive: h });
  }, [h, e, _]), dn("keydown", C), Pe(() => {
    d({ isActivatable: !0 });
  }), Jt(() => {
    d({ isActivatable: !1 });
  }), /* @__PURE__ */ s.jsx(
    "li",
    {
      ref: b,
      role: "navigation",
      className: f(tr.root, i, {
        [tr.rootActive]: g
      }),
      onClick: x,
      onMouseMove: p,
      ...o,
      children: t || /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(N, { name: "angle-left" }),
        /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "1", children: "Back" })
      ] })
    }
  );
}, ti = Object.assign(
  $(er),
  {
    name: er.name
  }
), xx = "h-selectionList-subComponents-list--selectionListList__list", yx = {
  list: xx
}, nr = ({
  parentItem: i,
  children: t,
  backItemProps: e = {},
  listProps: { className: n, ...o } = {},
  onActiveStateChange: r,
  ...a
}, l) => {
  const c = Ae(), d = Xt(c), {
    list: {
      isFocused: h,
      isActive: u,
      isDisabled: p
    },
    item: {
      isActive: m,
      onSelect: g,
      isOnlyVisibleItem: b,
      register: x,
      setActive: C,
      isLastChild: _ = !1
    }
  } = d, w = q(
    () => !p && (u || h),
    [u, p, h]
  ), S = es(t), {
    activeItemIndex: y,
    setActiveItem: v,
    handleItemRegister: I,
    isOnlyActiveItemVisible: T,
    keysDelegatedHandlingToItem: P
  } = ao({ defaultActiveItemIndex: 1 }), L = F(
    (W, rt) => {
      v({ index: rt }), g(W);
    },
    [g, v]
  ), k = (W) => {
    !w || !b || P.includes(W.key) || (W.key === "Home" ? (v({ step: "first" }), W.preventDefault()) : W.key === "End" ? (v({ step: "last" }), W.preventDefault()) : W.key === "ArrowDown" ? (v({ step: 1 }), W.preventDefault()) : W.key === "ArrowUp" && (v({ step: -1 }), W.preventDefault()));
  }, R = on(
    b
  );
  Zt(() => {
    b !== R && r?.({
      isActive: b,
      isLastChild: _
    });
  }, [
    b,
    r,
    R
  ]), J(() => {
    x(b ? {
      keysTakenOverHandlingFromParent: [
        "Home",
        "End",
        "ArrowDown",
        "ArrowUp"
      ]
    } : { keysTakenOverHandlingFromParent: [] });
  }, [b]), dn("keydown", k);
  const O = F(
    ({ value: W, meta: rt }) => {
      rt?.target instanceof HTMLInputElement && rt.target.type === "checkbox" ? g({ value: W, meta: { isNode: !0 } }) : x({ isOnlyVisibleItem: !0 });
    },
    // excluding `register` to avoid infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  ), U = F(() => {
    x({ isOnlyVisibleItem: !1 });
  }, []);
  J(() => {
    b || v({ index: -1 });
  }, [b, v]);
  const ot = q(
    () => ({
      ...d,
      item: {
        ...d.item,
        onSelect: O,
        isNode: !0
      }
    }),
    [O, d]
  ), nt = q(
    () => ({
      ...d,
      item: {
        ...d.item,
        onSelect: U,
        isActive: y === 0,
        setActive: () => {
          C(), v({ index: 0 });
        },
        register: (W) => I(W, 0)
      }
    }),
    [
      y,
      U,
      I,
      d,
      C,
      v
    ]
  );
  return b ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    !T && /* @__PURE__ */ s.jsx(c.Provider, { value: nt, children: /* @__PURE__ */ s.jsx(ti, { ...e }) }),
    /* @__PURE__ */ s.jsx("li", { ref: l, ...a, children: /* @__PURE__ */ s.jsx(
      "ul",
      {
        role: "listbox",
        className: f(yx.list, n),
        ...o,
        children: S.map((W, rt) => {
          const Tt = rt + 1;
          return Dt(W) && (!T || Tt === y) && /* @__PURE__ */ s.jsx(
            c.Provider,
            {
              value: {
                ...d,
                item: {
                  ...d.item,
                  isActive: m && Tt === y,
                  setActive: () => {
                    C(), v({ index: Tt });
                  },
                  register: (de) => I(de, Tt),
                  onSelect: (de) => L(de, Tt),
                  isOnlyVisibleItem: T,
                  isLastChild: rt === S.length - 1
                }
              },
              children: W
            },
            rt
          );
        })
      }
    ) })
  ] }) : /* @__PURE__ */ s.jsx(c.Provider, { value: ot, children: i });
}, _x = Object.assign($(nr), {
  name: nr.name
}), Cx = "h-selectionList-subComponents-section--selectionListSection__section", wx = {
  section: Cx
}, sr = ({
  title: i,
  children: t,
  listProps: { className: e, ...n } = {},
  onActiveStateChange: o,
  ...r
}, a) => {
  const l = Ae(), c = Xt(l), {
    list: {
      isFocused: d,
      isActive: h,
      isDisabled: u
    },
    item: {
      isActive: p,
      setActive: m,
      onSelect: g,
      register: b,
      isLastChild: x = !1
    }
  } = c, C = q(
    () => !u && (h || d),
    [h, u, d]
  ), _ = es(t), {
    activatableItemIndices: w,
    activeItemIndex: S,
    setActiveItem: y,
    handleItemRegister: v,
    keysDelegatedHandlingToItem: I
  } = ao(), T = F(
    (k, R) => {
      y({ index: R }), g(k);
    },
    [g, y]
  ), P = (k) => {
    !C || I.includes(k.key) || (k.key === "Home" ? y({ step: "first" }) : k.key === "End" && y({ step: "last" }), p ? k.key === "ArrowDown" && S !== w[w.length - 1] ? (y({ step: 1 }), k.preventDefault()) : k.key === "ArrowUp" && S !== w[0] && (y({ step: -1 }), k.preventDefault()) : k.key === "ArrowDown" ? y({ step: "first" }) : k.key === "ArrowUp" && y({ step: "last" }));
  }, L = on(p);
  return Zt(() => {
    p !== L && o?.({
      isActive: p,
      isLastChild: x
    });
  }, [p, o, L]), J(() => {
    const k = [];
    p && (S !== w[w.length - 1] && k.push("ArrowDown"), S !== w[0] && k.push("ArrowUp")), b({ keysTakenOverHandlingFromParent: k });
  }, [w, S, p]), Pe(() => b({ isActivatable: !0 })), Jt(() => b({ isActivatable: !1 })), dn("keydown", P), /* @__PURE__ */ s.jsx("li", { ref: a, ...r, children: /* @__PURE__ */ s.jsxs(
    "ul",
    {
      role: "group",
      className: f(wx.section, e),
      ...n,
      children: [
        /* @__PURE__ */ s.jsx(Jr, { label: i }),
        _.map(
          (k, R) => Dt(k) && /* @__PURE__ */ s.jsx(
            l.Provider,
            {
              value: {
                ...c,
                item: {
                  ...c.item,
                  isActive: p && R === S,
                  setActive: () => {
                    m(), y({ index: R });
                  },
                  register: (O) => v(O, R),
                  onSelect: (O) => T(O, R),
                  isLastChild: x && R === _.length - 1
                }
              },
              children: k
            },
            R
          )
        )
      ]
    }
  ) });
}, vx = Object.assign($(sr), {
  name: sr.name
}), Sx = Object.assign($(Qo), {
  name: Qo.name,
  Item: gx,
  BackItem: ti,
  Divider: Jr,
  Section: vx,
  List: _x
}), Ix = "h-inputSelectionList-chip--inputSelectionListChip__root", Dx = "h-inputSelectionList-chip--inputSelectionListChip__name", or = {
  root: Ix,
  name: Dx
}, Ss = ({
  onDelete: i,
  className: t,
  disabled: e,
  readOnly: n,
  ...o
}) => {
  const r = q(() => {
    if (!(!i || e || n))
      return (a) => {
        a.stopPropagation(), i();
      };
  }, [e, i, n]);
  return /* @__PURE__ */ s.jsx(
    je,
    {
      ...o,
      onDelete: r,
      className: f(or.root, t),
      tagNameClassName: or.name
    }
  );
}, kx = "h-inputSelectionList--inputSelectionList__root", Tx = "h-inputSelectionList--inputSelectionList__inputWrapper", jx = "h-inputSelectionList--inputSelectionList__inputWrapperChild", Nx = "h-inputSelectionList--inputSelectionList__rootHasWrapperIcon", Fx = "h-inputSelectionList--inputSelectionList__rootReadOnly", Px = "h-inputSelectionList--inputSelectionList__titleContainer", Rx = "h-inputSelectionList--inputSelectionList__filterInput", Ex = "h-inputSelectionList--inputSelectionList__placeholder", Lx = "h-inputSelectionList--inputSelectionList__titleBox", Ax = "h-inputSelectionList--inputSelectionList__iconContainer", $x = "h-inputSelectionList--inputSelectionList__iconButton", Ox = "h-inputSelectionList--inputSelectionList__dropdown", Bx = "h-inputSelectionList--inputSelectionList__hiddenItemsTooltip", Hx = "h-inputSelectionList--inputSelectionList__hiddenItemsChip", ct = {
  root: kx,
  inputWrapper: Tx,
  inputWrapperChild: jx,
  rootHasWrapperIcon: Nx,
  rootReadOnly: Fx,
  titleContainer: Px,
  filterInput: Rx,
  placeholder: Ex,
  titleBox: Lx,
  iconContainer: Ax,
  iconButton: $x,
  dropdown: Ox,
  hiddenItemsTooltip: Bx,
  hiddenItemsChip: Hx
}, Wx = "inputSelectionListTestId", rr = ({
  className: i,
  name: t,
  value: e,
  onChange: n,
  prefix: o,
  suffix: r,
  icon: a,
  status: l,
  placeholder: c,
  disabled: d,
  readOnly: h,
  children: u,
  filter: p,
  multiple: m,
  getItemTitleByValue: g,
  tabIndex: b,
  keepOpen: x,
  onToggleDropdown: C,
  onClick: _,
  onBlur: w,
  onKeyDown: S,
  limit: y = Number.POSITIVE_INFINITY,
  clearable: v = !1,
  equalityFn: I = Object.is,
  defaultActiveItemIndex: T,
  valueArrayToStringFn: P = JSON.stringify,
  rootClassName: L,
  dropdownProps: k,
  selectionListProps: R,
  slotBeforeList: O,
  slotAfterList: U,
  ...ot
}, nt) => {
  const W = Y(null), rt = Y(null), Tt = Y(null), de = Y(null), [Z, ni] = V(!1);
  Fe(
    nt,
    () => rt.current
  );
  const ss = q(
    () => p?.value !== void 0 && p.onChange !== void 0 && Z,
    [p, Z]
  ), si = q(() => {
    if (!e?.length)
      return c;
    if (!m) {
      const M = g(e[0]);
      return typeof M == "object" ? "" : M?.toString();
    }
    return "";
  }, [m, c, g, e]), oi = q(() => ss ? m && !!e?.length : !0, [m, ss, e?.length]), os = F(
    (M) => {
      !h && !d && n?.({
        selectedItem: {
          isSelected: !1,
          value: M
        },
        selectedValues: e?.filter((Be) => !I(Be, M)) ?? []
      });
    },
    [d, I, n, h, e]
  ), ri = q(() => {
    if (!e?.length)
      return /* @__PURE__ */ s.jsx(H, { alignItems: "center", className: ct.placeholder, children: c });
    if (m) {
      const M = y < e.length ? e.slice(0, y) : e, Be = y < e.length ? e.slice(y) : [];
      return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        M?.map((He, rs) => /* @__PURE__ */ s.jsx(
          Ss,
          {
            onDelete: () => {
              os(He);
            },
            disabled: d,
            readOnly: h,
            children: g(He)
          },
          rs
        )),
        !!Be.length && /* @__PURE__ */ s.jsx(
          st,
          {
            disabled: d,
            requireClick: !0,
            content: /* @__PURE__ */ s.jsx(
              H,
              {
                className: ct.hiddenItemsTooltip,
                gap: "100",
                flexWrap: "wrap",
                children: Be?.map((He, rs) => /* @__PURE__ */ s.jsx(
                  Ss,
                  {
                    onDelete: () => {
                      os(He);
                    },
                    disabled: d,
                    readOnly: h,
                    children: g(He)
                  },
                  rs
                ))
              }
            ),
            light: !0,
            children: /* @__PURE__ */ s.jsxs(
              Ss,
              {
                className: ct.hiddenItemsChip,
                disabled: d,
                children: [
                  "+ ",
                  Be.length
                ]
              }
            )
          }
        )
      ] });
    }
    return /* @__PURE__ */ s.jsx(at, { className: ct.titleBox, children: g(e[0]) });
  }, [
    e,
    m,
    g,
    c,
    y,
    d,
    h,
    os
  ]), ht = F(
    (M) => {
      (h || d) && M || (M !== Z && C?.(M), ni(M));
    },
    [d, Z, C, h]
  ), $e = F(
    ({ target: M }) => {
      de.current?.contains(M) || (W.current?.contains(M) && rt.current?.focus(), ht(!1));
    },
    [ht]
  ), Oe = F(
    (M) => {
      Ee(M.key) && Z && (ht(!1), rt.current?.focus());
    },
    [Z, ht]
  ), ii = F(
    (M) => {
      M.relatedTarget && W.current?.contains(M.relatedTarget) || (ht(!1), w?.(M));
    },
    [w, ht]
  ), ai = F(
    (M) => {
      Z || M.stopPropagation(), ht(!0), _?.(M);
    },
    [Z, _, ht]
  ), li = F(
    (M) => {
      Qn(M.key) && ht(!0), S?.(M);
    },
    [S, ht]
  ), ci = F(
    (M) => {
      M.stopPropagation(), ht(!Z), rt.current?.focus();
    },
    [Z, ht]
  ), di = F(
    (M) => {
      M.stopPropagation(), rt.current?.focus(), !d && !h && n?.({ selectedValues: [] });
    },
    [d, n, h]
  ), hi = F(
    (M) => {
      n?.(M), rt.current?.focus(), !x && !m ? ht(!1) : Tt.current?.focus();
    },
    [m, x, n, ht]
  );
  return J(() => (Z ? (window.addEventListener("click", $e), window.addEventListener("keydown", Oe)) : (window.removeEventListener("click", $e), window.removeEventListener("keydown", Oe)), () => {
    window.removeEventListener("click", $e), window.removeEventListener("keydown", Oe);
  }), [$e, Oe, Z]), J(() => {
    Z && Tt.current?.focus();
  }, [Z]), Jt(() => {
    window.removeEventListener("click", $e), window.removeEventListener("keydown", Oe);
  }), /* @__PURE__ */ s.jsxs(
    "div",
    {
      "data-testid": Wx,
      ref: W,
      className: f(ct.root, L, {
        [ct.rootHasWrapperIcon]: !!a,
        [ct.rootReadOnly]: h
      }),
      "aria-expanded": Z,
      "aria-haspopup": "listbox",
      role: "combobox",
      children: [
        /* @__PURE__ */ s.jsx(
          At,
          {
            ...ot,
            ref: rt,
            className: f(i, ct.inputWrapper),
            prefix: o,
            suffix: r,
            disabled: d,
            icon: a,
            active: Z,
            status: l,
            onClick: ai,
            onBlur: ii,
            onKeyDown: li,
            tabIndex: d ? -1 : b ?? 0,
            children: /* @__PURE__ */ s.jsxs(H, { className: ct.inputWrapperChild, children: [
              /* @__PURE__ */ s.jsxs(H, { gap: "100", flexWrap: "wrap", className: ct.titleContainer, children: [
                oi && ri,
                ss && /* @__PURE__ */ s.jsx(
                  "input",
                  {
                    ...p,
                    ref: Tt,
                    className: f(ct.filterInput, p?.className),
                    autoComplete: "off",
                    "aria-autocomplete": "list",
                    placeholder: si,
                    disabled: d || p?.disabled
                  }
                )
              ] }),
              /* @__PURE__ */ s.jsxs(H, { alignItems: "center", className: ct.iconContainer, children: [
                v && !d && !h && !!e?.length && /* @__PURE__ */ s.jsx(
                  K,
                  {
                    className: ct.iconButton,
                    variant: "tertiary",
                    icon: "close",
                    disabled: d,
                    onClick: di,
                    "aria-label": "Clear"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  K,
                  {
                    className: ct.iconButton,
                    variant: "tertiary",
                    icon: Z ? "angle-up" : "angle-down",
                    disabled: d,
                    onClick: ci,
                    "aria-label": Z ? "Close" : "Open"
                  }
                )
              ] })
            ] })
          }
        ),
        t && /* @__PURE__ */ s.jsx(
          "input",
          {
            type: "hidden",
            disabled: d,
            name: t,
            value: P(e)
          }
        ),
        /* @__PURE__ */ s.jsx(
          te,
          {
            isOpen: Z,
            ...k,
            className: f(k?.className, ct.dropdown),
            children: /* @__PURE__ */ s.jsx("div", { ref: de, style: { width: "100%" }, children: Z && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              O,
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              /* @__PURE__ */ s.jsx(
                Sx,
                {
                  ...R,
                  equalityFn: I,
                  defaultActiveItemIndex: T,
                  isActive: Z,
                  isMultiple: m,
                  selectedValues: e,
                  onChange: hi,
                  children: u
                }
              ),
              U
            ] }) })
          }
        )
      ]
    }
  );
}, Mx = Object.assign($(rr), {
  name: rr.name
}), Jk = ({
  className: i,
  input: { value: t, name: e, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  helpIcon: d,
  description: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => /* @__PURE__ */ s.jsx(
  z,
  {
    className: i,
    label: r,
    labelFor: e,
    meta: a,
    required: l,
    disabled: c,
    helpIcon: d,
    description: h,
    noLabel: u,
    noAlert: p,
    children: /* @__PURE__ */ s.jsx(
      Mx,
      {
        name: e,
        value: t || [],
        onChange: (g) => {
          n(g.selectedValues);
        },
        ...o,
        status: z.getStatus(a),
        disabled: c,
        required: l,
        ...m
      }
    )
  }
), zx = "h-slider--slider__rootWrapper", Vx = "h-slider--slider__rootWrapperNoAnnotations", Kx = "h-slider--slider__root", Ux = "h-slider--slider__rootDark", qx = "h-slider--slider__rootDisabled", Gx = "h-slider--slider__handle", Yx = "h-slider--slider__trackWrapper", Xx = "h-slider--slider__track", Qx = "h-slider--slider__highlight", Zx = "h-slider--slider__minValueIndicator", Jx = "h-slider--slider__maxValueIndicator", xt = {
  rootWrapper: zx,
  rootWrapperNoAnnotations: Vx,
  root: Kx,
  rootDark: Ux,
  rootDisabled: qx,
  handle: Gx,
  trackWrapper: Yx,
  track: Xx,
  highlight: Qx,
  minValueIndicator: Zx,
  maxValueIndicator: Jx
};
var Pt = /* @__PURE__ */ ((i) => (i.LowBoundIndicator = "input-slider-low-indicator", i.HighBoundIndicator = "input-slider-high-indicator", i.Handle = "input-slider-handle", i.Value = "input-slider-value", i.TrackBackground = "input-slider-tack-background", i.Track = "input-slider-track", i.Highlight = "input-slider-highlight", i))(Pt || {});
const ty = (i) => {
  i.preventDefault();
}, ey = (i, t, e) => typeof i != "number" && !Array.isArray(i) ? "" : typeof i == "number" ? /* @__PURE__ */ s.jsxs(A.Paragraph, { variant: "3", children: [
  t,
  i,
  e
] }) : /* @__PURE__ */ s.jsxs(A.Paragraph, { variant: "3", children: [
  t,
  i[0],
  e,
  " - ",
  t,
  i[1],
  e
] });
class ny extends D {
  static defaultProps = {
    min: 0,
    max: 100,
    dark: !1,
    highlightRange: null,
    formatValue: ey,
    hideAnnotations: !1
  };
  constructor(t) {
    super(t), this.state = {
      startX: 0,
      startVal: 0,
      sliderWidth: 0,
      currentIndex: null
    }, this.handleHandleGrab = this.handleHandleGrab.bind(this), this.handleHandleMove = this.handleHandleMove.bind(this), this.handleHandleDrop = this.handleHandleDrop.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSliderMouseDown = this.handleSliderMouseDown.bind(this), this.relativeValueToAbsoluteValue = this.relativeValueToAbsoluteValue.bind(this), this.absoluteValueToRelativeValue = this.absoluteValueToRelativeValue.bind(this);
  }
  sliderRef = B();
  isInterval(t) {
    return Array.isArray(t);
  }
  handleChange(t) {
    typeof t == "number" ? this.props.onChange?.(Math.round(t)) : this.props.onChange?.(
      t.map((e) => Math.round(e))
    );
  }
  /*
    This method handles grab on handle, and saves the index of the handle, so that
    when the event bubbles to the slider, the handler will know that we chose a specific handle
   */
  handleHandleGrab(t) {
    t.target instanceof Element && this.setState({
      currentIndex: parseInt(
        t.target.getAttribute("data-index") || "",
        10
      )
    });
  }
  handleHandleMove(t) {
    t.preventDefault();
    const { startVal: e, startX: n, sliderWidth: o, currentIndex: r } = this.state, a = e + (t.clientX - n) / o, l = this.getAbsoluteValue(a, r);
    this.handleChange(l);
  }
  handleHandleDrop() {
    window.removeEventListener("mousemove", this.handleHandleMove), window.removeEventListener("mouseup", this.handleHandleDrop), this.setState({ currentIndex: null });
  }
  handleKeyDown(t) {
    const { step: e = 1, value: n } = this.props;
    t.preventDefault();
    const o = this.isInterval(n) && t.target instanceof Element ? parseInt(t.target.getAttribute("data-index") || "", 10) : null;
    switch (t.key) {
      case "ArrowRight":
      case "ArrowUp":
        this.increment(e, o);
        break;
      case "ArrowLeft":
      case "ArrowDown":
        this.increment(-e, o);
        break;
    }
  }
  /*
    This method handles mouse down on the slider (both handles and track)
    this will move the handle to the click position and start a drag.
    If the slider is an interval slider it will move and grab the closest handle
   */
  handleSliderMouseDown(t) {
    if (!this.sliderRef.current) return;
    const { value: e } = this.props, { currentIndex: n } = this.state, o = this.sliderRef.current.getBoundingClientRect(), r = (t.clientX - o.left) / o.width;
    this.setState({
      startX: t.clientX,
      // save the current mouse x
      startVal: r,
      // save the current percentage
      sliderWidth: o.width
      // save the slider width
    });
    let a;
    if (this.isInterval(e)) {
      const l = n ?? this.findTheNearestHandle(r, e);
      this.setState({
        currentIndex: l
      }), a = this.getAbsoluteValue(r, l);
    } else
      a = this.getAbsoluteValue(r);
    this.handleChange(a), window.addEventListener("mousemove", this.handleHandleMove), window.addEventListener("mouseup", this.handleHandleDrop);
  }
  findTheNearestHandle(t, e) {
    const [n, o] = e.map(
      this.absoluteValueToRelativeValue
    );
    return t > o && t > n ? 1 : t < o && t < n ? 0 : Math.abs(n - t) > Math.abs(o - t) ? 1 : 0;
  }
  getAdjustedStep(t) {
    const { min: e, max: n } = this.props;
    return t / (n - e);
  }
  getAbsoluteValue(t, e) {
    const { value: n, step: o } = this.props;
    let r = An(t, 0, 1);
    if (o) {
      const h = this.getAdjustedStep(o);
      r = Math.round(r / h) * h;
    }
    if (!this.isInterval(n))
      return this.relativeValueToAbsoluteValue(r);
    const [a, l] = n;
    let c = this.relativeValueToAbsoluteValue(r);
    e === 0 && c > l ? c = l : e === 1 && c < a && (c = a);
    const d = [a, l];
    return typeof e == "number" && (d[e] = c), d;
  }
  /**
   * @param ratio Is a number between 0 and 1 and it represents the **relative**
   *   placement of the handle within the slider track.
   */
  relativeValueToAbsoluteValue(t) {
    const { min: e, max: n } = this.props, o = e + (n - e) * t;
    return An(o, e, n);
  }
  /**
   * @param value Is a number between 'min' and 'max' and it represents the
   *   **absolute** value that is derived from the relative placement of the
   *   handle.
   */
  absoluteValueToRelativeValue(t) {
    const { min: e, max: n } = this.props, o = (t - e) / (n - e);
    return An(o, 0, 1);
  }
  increment(t, e) {
    const { value: n } = this.props;
    let o;
    if (this.isInterval(n)) {
      const r = [...n];
      r[e ?? 0] = r[e ?? 0] + t, o = r;
    } else
      o = n + t;
    this.handleChange(o);
  }
  getTrackStyles() {
    const { value: t, min: e } = this.props, n = this.isInterval(t) ? this.absoluteValueToRelativeValue(t[1]) - this.absoluteValueToRelativeValue(t[0]) : this.absoluteValueToRelativeValue(t), o = this.isInterval(t) ? this.absoluteValueToRelativeValue(t[0]) : this.absoluteValueToRelativeValue(e);
    return {
      width: `${n * 100}%`,
      left: `${o * 100}%`
    };
  }
  getHandleStyles(t) {
    const { value: e } = this.props;
    return {
      left: `${(this.isInterval(e) ? this.absoluteValueToRelativeValue(e[t ?? 0]) : this.absoluteValueToRelativeValue(e)) * 100}%`
    };
  }
  getHighlightStyles() {
    const { highlightRange: t } = this.props;
    if (_t(t)) return {};
    const [e, n] = t.map(this.absoluteValueToRelativeValue);
    return {
      left: `${e * 100}%`,
      width: `${(n - e) * 100}%`
    };
  }
  render() {
    const {
      className: t,
      value: e,
      step: n,
      highlightRange: o,
      min: r,
      max: a,
      dark: l,
      disabled: c,
      onChange: d,
      formatValue: h,
      hideAnnotations: u,
      valuePrefix: p,
      valueSuffix: m,
      onBlur: g,
      onFocus: b,
      children: x,
      ...C
    } = this.props, _ = f(
      xt.root,
      { [xt.rootDark]: l },
      { [xt.rootDisabled]: c },
      t
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: f(xt.rootWrapper, {
          [xt.rootWrapperNoAnnotations]: u
        }),
        children: [
          /* @__PURE__ */ s.jsxs(
            "div",
            {
              ...C,
              className: _,
              ref: this.sliderRef,
              onMouseDown: this.handleSliderMouseDown,
              children: [
                /* @__PURE__ */ s.jsxs(
                  "div",
                  {
                    className: xt.trackWrapper,
                    "data-testid": Pt.TrackBackground,
                    children: [
                      !_t(o) && /* @__PURE__ */ s.jsx(
                        "div",
                        {
                          className: xt.highlight,
                          style: this.getHighlightStyles(),
                          "data-testid": Pt.Highlight
                        }
                      ),
                      /* @__PURE__ */ s.jsx(
                        "div",
                        {
                          className: xt.track,
                          style: this.getTrackStyles(),
                          "data-testid": Pt.Track
                        }
                      )
                    ]
                  }
                ),
                !this.isInterval(e) && /* @__PURE__ */ s.jsx(
                  "button",
                  {
                    tabIndex: 0,
                    role: "slider",
                    type: "button",
                    "aria-valuemin": r,
                    "aria-valuemax": a,
                    "aria-valuenow": e,
                    className: xt.handle,
                    onClick: ty,
                    onKeyDown: this.handleKeyDown,
                    style: this.getHandleStyles(),
                    "data-testid": Pt.Handle
                  }
                ),
                this.isInterval(e) && /* @__PURE__ */ s.jsxs(Wt, { children: [
                  /* @__PURE__ */ s.jsx(
                    "button",
                    {
                      tabIndex: 0,
                      type: "button",
                      "data-index": "0",
                      className: xt.handle,
                      onKeyDown: this.handleKeyDown,
                      style: this.getHandleStyles(0),
                      onMouseDown: this.handleHandleGrab,
                      "data-testid": Pt.Handle
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    "button",
                    {
                      tabIndex: 0,
                      type: "button",
                      "data-index": "1",
                      className: xt.handle,
                      onKeyDown: this.handleKeyDown,
                      style: this.getHandleStyles(1),
                      onMouseDown: this.handleHandleGrab,
                      "data-testid": Pt.Handle
                    }
                  )
                ] }),
                !u && /* @__PURE__ */ s.jsx(
                  "span",
                  {
                    "data-testid": Pt.LowBoundIndicator,
                    className: xt.minValueIndicator,
                    children: /* @__PURE__ */ s.jsxs(A.Paragraph, { variant: "4", as: "span", subdued: !0, children: [
                      p,
                      r,
                      m
                    ] })
                  }
                ),
                !u && /* @__PURE__ */ s.jsx(
                  "span",
                  {
                    className: xt.maxValueIndicator,
                    "data-testid": Pt.HighBoundIndicator,
                    children: /* @__PURE__ */ s.jsxs(A.Paragraph, { variant: "4", as: "span", subdued: !0, children: [
                      p,
                      a,
                      m
                    ] })
                  }
                )
              ]
            }
          ),
          !u && /* @__PURE__ */ s.jsx("div", { "data-testid": Pt.Value, children: h(e, p, m) })
        ]
      }
    );
  }
}
const Os = hn(ny, {
  fallback: null
}), sy = "h-fieldSlider--fieldSlider__root", oy = {
  root: sy
};
class tT extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this), this.handleBlur = this.handleBlur.bind(this);
  }
  handleChange(t) {
    const e = new Event("change");
    Object.defineProperty(e, "target", {
      writable: !0,
      value: { value: t, name: this.props.input.name }
    }), this.props.input.onChange(e);
  }
  /**
   * Redux form performs a value check when `blur` happens, so we need to make
   * sure the value is attached to the blur event otherwise it will be set to
   * null
   *
   * @see https://github.com/redux-form/redux-form/issues/2768
   */
  handleBlur(t) {
    const { input: e } = this.props, n = new FocusEvent(
      "blur",
      t
    );
    Object.defineProperty(n, "target", {
      writable: !0,
      value: { value: e.value, name: e.name }
    }), e.onBlur?.(n);
  }
  render() {
    const {
      className: t,
      input: e,
      meta: n,
      label: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props, p = f(oy.root, t);
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: p,
        label: o,
        meta: n,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Os,
          {
            ...e,
            onChange: this.handleChange,
            disabled: a,
            ...u
          }
        )
      }
    );
  }
}
const ry = "h-switch--switch__root", iy = "h-switch--switch__input", ay = "h-switch--switch__inner", ly = "h-switch--switch__pending", cy = "h-switch--switch__active", Ye = {
  root: ry,
  input: iy,
  inner: ay,
  pending: ly,
  active: cy
}, ir = {
  input: "Switch-input",
  label: "Switch-label"
};
class dy extends D {
  render() {
    const { id: t, className: e, variant: n, ...o } = this.props, r = t || `switch_${Math.random()}`;
    return /* @__PURE__ */ s.jsxs("div", { className: f(e, Ye.root), "data-testid": t, children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ...o,
          id: r,
          type: "checkbox",
          className: Ye.input,
          "data-testid": ir.input
        }
      ),
      /* @__PURE__ */ s.jsx(
        "label",
        {
          htmlFor: r,
          className: f(Ye.inner, {
            [Ye.active]: n === "active",
            [Ye.pending]: n === "pending"
          }),
          "data-testid": ir.label
        }
      )
    ] });
  }
}
class eT extends D {
  render() {
    const { input: t, ...e } = this.props, { ref: n, ...o } = t;
    return /* @__PURE__ */ s.jsx(dy, { ...o, ...e });
  }
}
class nT extends D {
  render() {
    const {
      className: t,
      input: e,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: n,
        labelFor: e.name,
        meta: o,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Qr,
          {
            status: z.getStatus(o),
            disabled: a,
            required: r,
            ...e,
            ...u
          }
        )
      }
    );
  }
}
const sT = ({
  className: i,
  input: { name: t, value: e, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  description: d,
  helpIcon: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => {
  const g = F(
    (b) => void n(b ?? ""),
    []
  );
  return /* @__PURE__ */ s.jsx(
    z,
    {
      className: i,
      description: d,
      disabled: c,
      helpIcon: h,
      label: r,
      labelFor: t,
      meta: a,
      noAlert: p,
      noLabel: u,
      required: l,
      children: /* @__PURE__ */ s.jsx(
        an,
        {
          selectedItems: e ? [e] : [],
          ...o,
          ...m,
          disabled: c,
          id: t,
          onSelect: g,
          status: z.getStatus(a)
        }
      )
    }
  );
}, oT = ({
  className: i,
  input: { name: t, value: e, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  description: d,
  helpIcon: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => {
  const g = F(
    (b) => void n({
      startTime: b.startTime ?? "",
      endTime: b.endTime ?? ""
    }),
    []
  );
  return /* @__PURE__ */ s.jsx(
    z,
    {
      className: i,
      description: d,
      disabled: c,
      helpIcon: h,
      label: r,
      labelFor: t,
      meta: a,
      noAlert: p,
      noLabel: u,
      required: l,
      children: /* @__PURE__ */ s.jsx(
        jm,
        {
          endTime: e.endTime,
          startTime: e.startTime,
          ...o,
          ...m,
          disabled: c,
          id: t,
          onSelect: g,
          status: z.getStatus(a)
        }
      )
    }
  );
}, hy = "h-inputColorPicker-indicator--inputColorPickerIndicator__root", uy = "h-inputColorPicker-indicator--inputColorPickerIndicator__rootAlpha", py = "h-inputColorPicker-indicator--inputColorPickerIndicator__indicator", my = "h-inputColorPicker-indicator--inputColorPickerIndicator__indicatorNoColor", jn = {
  root: hy,
  rootAlpha: uy,
  indicator: py,
  indicatorNoColor: my
}, gy = ({
  color: i,
  alpha: t,
  className: e,
  ...n
}) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ...n,
    className: f(jn.root, e, {
      [jn.rootAlpha]: t
    }),
    children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: f(jn.indicator, {
          [jn.indicatorNoColor]: !i
        }),
        style: { backgroundColor: i }
      }
    )
  }
), fy = "h-inputColorPicker--inputColorPicker__root", by = "h-inputColorPicker--inputColorPicker__inputContainer", xy = "h-inputColorPicker--inputColorPicker__input", yy = "h-inputColorPicker--inputColorPicker__rootReadOnly", _y = "h-inputColorPicker--inputColorPicker__iconContainer", Cy = "h-inputColorPicker--inputColorPicker__rootHasWrapperIcon", wy = "h-inputColorPicker--inputColorPicker__clearIcon", vy = "h-inputColorPicker--inputColorPicker__colorIndicator", qt = {
  root: fy,
  inputContainer: by,
  input: xy,
  rootReadOnly: yy,
  iconContainer: _y,
  rootHasWrapperIcon: Cy,
  clearIcon: wy,
  colorIndicator: vy
}, Sy = "inputColorPickerTestId", Iy = $(function({
  className: t,
  name: e = Math.floor(Math.random() * 1e8).toString(),
  value: n,
  onChange: o,
  dropdownProps: r,
  prefix: a,
  suffix: l,
  icon: c,
  status: d,
  placeholder: h,
  disabled: u,
  colorPickerProps: p,
  clearable: m,
  readOnly: g,
  children: b,
  ...x
}, C) {
  const _ = Y(null), w = Y(null), S = Y(null), [y, v] = V(!1);
  J(() => {
    y ? (window.addEventListener("click", T), window.addEventListener("keydown", P)) : (window.removeEventListener("click", T), window.removeEventListener("keydown", P)), y && I();
  }, [y]), Jt(() => {
    window.removeEventListener("click", T), window.removeEventListener("keydown", P);
  });
  const I = () => {
    S.current?.querySelector("input")?.focus();
  }, T = ({ target: U }) => {
    w.current?.contains(U) || v(!1);
  }, P = (U) => {
    Ee(U.key) && y && (U.stopPropagation(), v(!1));
  }, L = () => {
    g || v(!0);
  }, k = ({ target: U }) => {
    w.current?.contains(U) || v(!1);
  }, R = () => {
    g || v(!0);
  }, O = ({ key: U }) => {
    Qn(U) && v(!0);
  };
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      "data-testid": Sy,
      ref: w,
      className: f(qt.root, t, {
        [qt.rootHasWrapperIcon]: !!c,
        [qt.rootReadOnly]: g
      }),
      children: [
        /* @__PURE__ */ s.jsx(
          At,
          {
            prefix: a,
            suffix: l,
            disabled: u,
            icon: c,
            active: y,
            status: d,
            children: /* @__PURE__ */ s.jsxs("div", { className: qt.inputContainer, children: [
              /* @__PURE__ */ s.jsx(
                "input",
                {
                  ...x,
                  id: e,
                  name: e,
                  className: qt.input,
                  ref: _,
                  onClick: R,
                  onFocus: L,
                  onBlur: k,
                  onKeyDown: O,
                  disabled: u,
                  placeholder: h,
                  autoComplete: "off",
                  value: n,
                  onChange: Wn(n) ? void 0 : E,
                  readOnly: !0
                }
              ),
              /* @__PURE__ */ s.jsx("div", { className: qt.iconContainer, children: m && n && /* @__PURE__ */ s.jsx(
                K,
                {
                  className: qt.clearIcon,
                  variant: "tertiary",
                  icon: "close",
                  disabled: u,
                  onClick: () => o?.("")
                }
              ) }),
              /* @__PURE__ */ s.jsx(
                gy,
                {
                  className: qt.colorIndicator,
                  onClick: R,
                  color: n,
                  alpha: p?.alpha
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ s.jsx(te, { ...r, isOpen: y, children: /* @__PURE__ */ s.jsx("div", { ref: S, children: /* @__PURE__ */ s.jsx(
          Zn,
          {
            margin: "300",
            ...p,
            color: n,
            onChange: o ?? E,
            children: b
          }
        ) }) })
      ]
    }
  );
}), rT = ({
  className: i,
  input: { value: t, name: e, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  helpIcon: d,
  description: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => /* @__PURE__ */ s.jsx(
  z,
  {
    className: i,
    label: r,
    labelFor: e,
    meta: a,
    required: l,
    disabled: c,
    helpIcon: d,
    description: h,
    noLabel: u,
    noAlert: p,
    children: /* @__PURE__ */ s.jsx(
      Iy,
      {
        name: e,
        value: t,
        onChange: n,
        ...o,
        status: z.getStatus(a),
        disabled: c,
        required: l,
        ...m
      }
    )
  }
), Dy = "h-fieldAddonDropdown--fieldAddonDropdown__root", ky = "h-fieldAddonDropdown--fieldAddonDropdown__prefix", Ty = "h-fieldAddonDropdown--fieldAddonDropdown__suffix", jy = "h-fieldAddonDropdown--fieldAddonDropdown__angleDown", Nn = {
  root: Dy,
  prefix: ky,
  suffix: Ty,
  angleDown: jy
}, iT = ({
  className: i,
  noArrow: t,
  ...e
}) => Ms(e) ? null : /* @__PURE__ */ s.jsx(Fs.Consumer, { children: ({ position: n, disabled: o }) => /* @__PURE__ */ s.jsx(
  Js,
  {
    ..._r(e, "meta"),
    noStyle: !0,
    itemComponent: Or,
    children: /* @__PURE__ */ s.jsxs(
      "button",
      {
        className: f(
          Nn.root,
          {
            [Nn.prefix]: n === "prefix",
            [Nn.suffix]: n === "suffix"
          },
          i
        ),
        disabled: o || e.meta.disabled,
        type: "button",
        children: [
          /* @__PURE__ */ s.jsx("span", { children: e.meta.selectedValue }),
          !t && /* @__PURE__ */ s.jsx(
            N,
            {
              name: "angle-down",
              className: f("icon-vertical-fix", Nn.angleDown)
            }
          )
        ]
      }
    )
  }
) }), Ny = "h-countryFlag--countryFlag__flag", Fy = "h-countryFlag--countryFlag__ad", Py = "h-countryFlag--countryFlag__ae", Ry = "h-countryFlag--countryFlag__af", Ey = "h-countryFlag--countryFlag__ag", Ly = "h-countryFlag--countryFlag__ai", Ay = "h-countryFlag--countryFlag__al", $y = "h-countryFlag--countryFlag__am", Oy = "h-countryFlag--countryFlag__ao", By = "h-countryFlag--countryFlag__aq", Hy = "h-countryFlag--countryFlag__ar", Wy = "h-countryFlag--countryFlag__as", My = "h-countryFlag--countryFlag__at", zy = "h-countryFlag--countryFlag__au", Vy = "h-countryFlag--countryFlag__aw", Ky = "h-countryFlag--countryFlag__ax", Uy = "h-countryFlag--countryFlag__az", qy = "h-countryFlag--countryFlag__ba", Gy = "h-countryFlag--countryFlag__bb", Yy = "h-countryFlag--countryFlag__bd", Xy = "h-countryFlag--countryFlag__be", Qy = "h-countryFlag--countryFlag__bf", Zy = "h-countryFlag--countryFlag__bg", Jy = "h-countryFlag--countryFlag__bh", t_ = "h-countryFlag--countryFlag__bi", e_ = "h-countryFlag--countryFlag__bj", n_ = "h-countryFlag--countryFlag__bl", s_ = "h-countryFlag--countryFlag__bm", o_ = "h-countryFlag--countryFlag__bn", r_ = "h-countryFlag--countryFlag__bo", i_ = "h-countryFlag--countryFlag__bq", a_ = "h-countryFlag--countryFlag__br", l_ = "h-countryFlag--countryFlag__bs", c_ = "h-countryFlag--countryFlag__bt", d_ = "h-countryFlag--countryFlag__bv", h_ = "h-countryFlag--countryFlag__bw", u_ = "h-countryFlag--countryFlag__by", p_ = "h-countryFlag--countryFlag__bz", m_ = "h-countryFlag--countryFlag__ca", g_ = "h-countryFlag--countryFlag__cd", f_ = "h-countryFlag--countryFlag__cf", b_ = "h-countryFlag--countryFlag__cg", x_ = "h-countryFlag--countryFlag__ch", y_ = "h-countryFlag--countryFlag__ci", __ = "h-countryFlag--countryFlag__ck", C_ = "h-countryFlag--countryFlag__cl", w_ = "h-countryFlag--countryFlag__cm", v_ = "h-countryFlag--countryFlag__cn", S_ = "h-countryFlag--countryFlag__co", I_ = "h-countryFlag--countryFlag__cp", D_ = "h-countryFlag--countryFlag__cr", k_ = "h-countryFlag--countryFlag__cu", T_ = "h-countryFlag--countryFlag__cv", j_ = "h-countryFlag--countryFlag__cw", N_ = "h-countryFlag--countryFlag__cy", F_ = "h-countryFlag--countryFlag__cz", P_ = "h-countryFlag--countryFlag__de", R_ = "h-countryFlag--countryFlag__dj", E_ = "h-countryFlag--countryFlag__dk", L_ = "h-countryFlag--countryFlag__dm", A_ = "h-countryFlag--countryFlag__dz", $_ = "h-countryFlag--countryFlag__ec", O_ = "h-countryFlag--countryFlag__ee", B_ = "h-countryFlag--countryFlag__eg", H_ = "h-countryFlag--countryFlag__eh", W_ = "h-countryFlag--countryFlag__er", M_ = "h-countryFlag--countryFlag__es", z_ = "h-countryFlag--countryFlag__et", V_ = "h-countryFlag--countryFlag__eu", K_ = "h-countryFlag--countryFlag__fi", U_ = "h-countryFlag--countryFlag__fj", q_ = "h-countryFlag--countryFlag__fm", G_ = "h-countryFlag--countryFlag__fo", Y_ = "h-countryFlag--countryFlag__fr", X_ = "h-countryFlag--countryFlag__ga", Q_ = "h-countryFlag--countryFlag__gb", Z_ = "h-countryFlag--countryFlag__gd", J_ = "h-countryFlag--countryFlag__ge", tC = "h-countryFlag--countryFlag__gg", eC = "h-countryFlag--countryFlag__gh", nC = "h-countryFlag--countryFlag__gi", sC = "h-countryFlag--countryFlag__gl", oC = "h-countryFlag--countryFlag__gm", rC = "h-countryFlag--countryFlag__gn", iC = "h-countryFlag--countryFlag__gp", aC = "h-countryFlag--countryFlag__gq", lC = "h-countryFlag--countryFlag__gr", cC = "h-countryFlag--countryFlag__gt", dC = "h-countryFlag--countryFlag__gu", hC = "h-countryFlag--countryFlag__gw", uC = "h-countryFlag--countryFlag__gy", pC = "h-countryFlag--countryFlag__hk", mC = "h-countryFlag--countryFlag__hn", gC = "h-countryFlag--countryFlag__hr", fC = "h-countryFlag--countryFlag__ht", bC = "h-countryFlag--countryFlag__hu", xC = "h-countryFlag--countryFlag__id", yC = "h-countryFlag--countryFlag__ie", _C = "h-countryFlag--countryFlag__il", CC = "h-countryFlag--countryFlag__im", wC = "h-countryFlag--countryFlag__iq", vC = "h-countryFlag--countryFlag__ir", SC = "h-countryFlag--countryFlag__is", IC = "h-countryFlag--countryFlag__it", DC = "h-countryFlag--countryFlag__je", kC = "h-countryFlag--countryFlag__jm", TC = "h-countryFlag--countryFlag__jo", jC = "h-countryFlag--countryFlag__jp", NC = "h-countryFlag--countryFlag__ke", FC = "h-countryFlag--countryFlag__kg", PC = "h-countryFlag--countryFlag__kh", RC = "h-countryFlag--countryFlag__ki", EC = "h-countryFlag--countryFlag__km", LC = "h-countryFlag--countryFlag__kn", AC = "h-countryFlag--countryFlag__kp", $C = "h-countryFlag--countryFlag__kr", OC = "h-countryFlag--countryFlag__kw", BC = "h-countryFlag--countryFlag__ky", HC = "h-countryFlag--countryFlag__kz", WC = "h-countryFlag--countryFlag__la", MC = "h-countryFlag--countryFlag__lb", zC = "h-countryFlag--countryFlag__lc", VC = "h-countryFlag--countryFlag__li", KC = "h-countryFlag--countryFlag__lk", UC = "h-countryFlag--countryFlag__lr", qC = "h-countryFlag--countryFlag__ls", GC = "h-countryFlag--countryFlag__lt", YC = "h-countryFlag--countryFlag__lu", XC = "h-countryFlag--countryFlag__lv", QC = "h-countryFlag--countryFlag__ly", ZC = "h-countryFlag--countryFlag__ma", JC = "h-countryFlag--countryFlag__mc", tw = "h-countryFlag--countryFlag__md", ew = "h-countryFlag--countryFlag__me", nw = "h-countryFlag--countryFlag__mf", sw = "h-countryFlag--countryFlag__mg", ow = "h-countryFlag--countryFlag__mh", rw = "h-countryFlag--countryFlag__mk", iw = "h-countryFlag--countryFlag__ml", aw = "h-countryFlag--countryFlag__mm", lw = "h-countryFlag--countryFlag__mn", cw = "h-countryFlag--countryFlag__mo", dw = "h-countryFlag--countryFlag__mq", hw = "h-countryFlag--countryFlag__mr", uw = "h-countryFlag--countryFlag__ms", pw = "h-countryFlag--countryFlag__mt", mw = "h-countryFlag--countryFlag__mu", gw = "h-countryFlag--countryFlag__mv", fw = "h-countryFlag--countryFlag__mw", bw = "h-countryFlag--countryFlag__mx", xw = "h-countryFlag--countryFlag__my", yw = "h-countryFlag--countryFlag__mz", _w = "h-countryFlag--countryFlag__na", Cw = "h-countryFlag--countryFlag__nc", ww = "h-countryFlag--countryFlag__ne", vw = "h-countryFlag--countryFlag__ng", Sw = "h-countryFlag--countryFlag__ni", Iw = "h-countryFlag--countryFlag__nl", Dw = "h-countryFlag--countryFlag__no", kw = "h-countryFlag--countryFlag__np", Tw = "h-countryFlag--countryFlag__nq", jw = "h-countryFlag--countryFlag__nr", Nw = "h-countryFlag--countryFlag__nu", Fw = "h-countryFlag--countryFlag__nz", Pw = "h-countryFlag--countryFlag__om", Rw = "h-countryFlag--countryFlag__pa", Ew = "h-countryFlag--countryFlag__pe", Lw = "h-countryFlag--countryFlag__pf", Aw = "h-countryFlag--countryFlag__pg", $w = "h-countryFlag--countryFlag__ph", Ow = "h-countryFlag--countryFlag__pk", Bw = "h-countryFlag--countryFlag__pl", Hw = "h-countryFlag--countryFlag__pr", Ww = "h-countryFlag--countryFlag__ps", Mw = "h-countryFlag--countryFlag__pt", zw = "h-countryFlag--countryFlag__pw", Vw = "h-countryFlag--countryFlag__py", Kw = "h-countryFlag--countryFlag__qa", Uw = "h-countryFlag--countryFlag__re", qw = "h-countryFlag--countryFlag__ro", Gw = "h-countryFlag--countryFlag__rs", Yw = "h-countryFlag--countryFlag__ru", Xw = "h-countryFlag--countryFlag__rw", Qw = "h-countryFlag--countryFlag__sa", Zw = "h-countryFlag--countryFlag__sb", Jw = "h-countryFlag--countryFlag__sc", tv = "h-countryFlag--countryFlag__sd", ev = "h-countryFlag--countryFlag__se", nv = "h-countryFlag--countryFlag__sg", sv = "h-countryFlag--countryFlag__sh", ov = "h-countryFlag--countryFlag__si", rv = "h-countryFlag--countryFlag__sj", iv = "h-countryFlag--countryFlag__sk", av = "h-countryFlag--countryFlag__sl", lv = "h-countryFlag--countryFlag__sm", cv = "h-countryFlag--countryFlag__sn", dv = "h-countryFlag--countryFlag__so", hv = "h-countryFlag--countryFlag__sr", uv = "h-countryFlag--countryFlag__ss", pv = "h-countryFlag--countryFlag__st", mv = "h-countryFlag--countryFlag__sv", gv = "h-countryFlag--countryFlag__sx", fv = "h-countryFlag--countryFlag__sy", bv = "h-countryFlag--countryFlag__sz", xv = "h-countryFlag--countryFlag__tc", yv = "h-countryFlag--countryFlag__td", _v = "h-countryFlag--countryFlag__tg", Cv = "h-countryFlag--countryFlag__th", wv = "h-countryFlag--countryFlag__tj", vv = "h-countryFlag--countryFlag__tl", Sv = "h-countryFlag--countryFlag__tm", Iv = "h-countryFlag--countryFlag__tn", Dv = "h-countryFlag--countryFlag__to", kv = "h-countryFlag--countryFlag__tr", Tv = "h-countryFlag--countryFlag__tt", jv = "h-countryFlag--countryFlag__tv", Nv = "h-countryFlag--countryFlag__tw", Fv = "h-countryFlag--countryFlag__tz", Pv = "h-countryFlag--countryFlag__ua", Rv = "h-countryFlag--countryFlag__ug", Ev = "h-countryFlag--countryFlag__us", Lv = "h-countryFlag--countryFlag__uy", Av = "h-countryFlag--countryFlag__uz", $v = "h-countryFlag--countryFlag__va", Ov = "h-countryFlag--countryFlag__vc", Bv = "h-countryFlag--countryFlag__ve", Hv = "h-countryFlag--countryFlag__vg", Wv = "h-countryFlag--countryFlag__vi", Mv = "h-countryFlag--countryFlag__vn", zv = "h-countryFlag--countryFlag__vu", Vv = "h-countryFlag--countryFlag__ws", Kv = "h-countryFlag--countryFlag__ye", Uv = "h-countryFlag--countryFlag__yt", qv = "h-countryFlag--countryFlag__za", Gv = "h-countryFlag--countryFlag__zm", Yv = "h-countryFlag--countryFlag__zw", ar = {
  flag: Ny,
  ad: Fy,
  ae: Py,
  af: Ry,
  ag: Ey,
  ai: Ly,
  al: Ay,
  am: $y,
  ao: Oy,
  aq: By,
  ar: Hy,
  as: Wy,
  at: My,
  au: zy,
  aw: Vy,
  ax: Ky,
  az: Uy,
  ba: qy,
  bb: Gy,
  bd: Yy,
  be: Xy,
  bf: Qy,
  bg: Zy,
  bh: Jy,
  bi: t_,
  bj: e_,
  bl: n_,
  bm: s_,
  bn: o_,
  bo: r_,
  bq: i_,
  br: a_,
  bs: l_,
  bt: c_,
  bv: d_,
  bw: h_,
  by: u_,
  bz: p_,
  ca: m_,
  cd: g_,
  cf: f_,
  cg: b_,
  ch: x_,
  ci: y_,
  ck: __,
  cl: C_,
  cm: w_,
  cn: v_,
  co: S_,
  cp: I_,
  cr: D_,
  cu: k_,
  cv: T_,
  cw: j_,
  cy: N_,
  cz: F_,
  de: P_,
  dj: R_,
  dk: E_,
  dm: L_,
  do: "h-countryFlag--countryFlag__do",
  dz: A_,
  ec: $_,
  ee: O_,
  eg: B_,
  eh: H_,
  er: W_,
  es: M_,
  et: z_,
  eu: V_,
  fi: K_,
  fj: U_,
  fm: q_,
  fo: G_,
  fr: Y_,
  ga: X_,
  gb: Q_,
  gd: Z_,
  ge: J_,
  gg: tC,
  gh: eC,
  gi: nC,
  gl: sC,
  gm: oC,
  gn: rC,
  gp: iC,
  gq: aC,
  gr: lC,
  gt: cC,
  gu: dC,
  gw: hC,
  gy: uC,
  hk: pC,
  hn: mC,
  hr: gC,
  ht: fC,
  hu: bC,
  id: xC,
  ie: yC,
  il: _C,
  im: CC,
  in: "h-countryFlag--countryFlag__in",
  iq: wC,
  ir: vC,
  is: SC,
  it: IC,
  je: DC,
  jm: kC,
  jo: TC,
  jp: jC,
  ke: NC,
  kg: FC,
  kh: PC,
  ki: RC,
  km: EC,
  kn: LC,
  kp: AC,
  kr: $C,
  kw: OC,
  ky: BC,
  kz: HC,
  la: WC,
  lb: MC,
  lc: zC,
  li: VC,
  lk: KC,
  lr: UC,
  ls: qC,
  lt: GC,
  lu: YC,
  lv: XC,
  ly: QC,
  ma: ZC,
  mc: JC,
  md: tw,
  me: ew,
  mf: nw,
  mg: sw,
  mh: ow,
  mk: rw,
  ml: iw,
  mm: aw,
  mn: lw,
  mo: cw,
  mq: dw,
  mr: hw,
  ms: uw,
  mt: pw,
  mu: mw,
  mv: gw,
  mw: fw,
  mx: bw,
  my: xw,
  mz: yw,
  na: _w,
  nc: Cw,
  ne: ww,
  ng: vw,
  ni: Sw,
  nl: Iw,
  no: Dw,
  np: kw,
  nq: Tw,
  nr: jw,
  nu: Nw,
  nz: Fw,
  om: Pw,
  pa: Rw,
  pe: Ew,
  pf: Lw,
  pg: Aw,
  ph: $w,
  pk: Ow,
  pl: Bw,
  pr: Hw,
  ps: Ww,
  pt: Mw,
  pw: zw,
  py: Vw,
  qa: Kw,
  re: Uw,
  ro: qw,
  rs: Gw,
  ru: Yw,
  rw: Xw,
  sa: Qw,
  sb: Zw,
  sc: Jw,
  sd: tv,
  se: ev,
  sg: nv,
  sh: sv,
  si: ov,
  sj: rv,
  sk: iv,
  sl: av,
  sm: lv,
  sn: cv,
  so: dv,
  sr: hv,
  ss: uv,
  st: pv,
  sv: mv,
  sx: gv,
  sy: fv,
  sz: bv,
  tc: xv,
  td: yv,
  tg: _v,
  th: Cv,
  tj: wv,
  tl: vv,
  tm: Sv,
  tn: Iv,
  to: Dv,
  tr: kv,
  tt: Tv,
  tv: jv,
  tw: Nv,
  tz: Fv,
  ua: Pv,
  ug: Rv,
  us: Ev,
  uy: Lv,
  uz: Av,
  va: $v,
  vc: Ov,
  ve: Bv,
  vg: Hv,
  vi: Wv,
  vn: Mv,
  vu: zv,
  ws: Vv,
  ye: Kv,
  yt: Uv,
  za: qv,
  zm: Gv,
  zw: Yv
}, Xv = 127365, Qv = /^[a-z]{2}$/, Zv = (i) => Qv.test(i) ? String.fromCodePoint(
  ...i.split("").map((t) => Xv + t.charCodeAt(0))
) : "", aT = ({
  className: i,
  countryCode: t,
  size: e = 16
}) => navigator.userAgent.includes("Windows") ? /* @__PURE__ */ s.jsx(at, { style: { width: e, height: e }, children: /* @__PURE__ */ s.jsx(
  at,
  {
    className: f(ar.flag, ar[t], i),
    style: {
      width: 32,
      height: 32,
      transform: `scale(calc(${e} / 32))`
    }
  }
) }) : /* @__PURE__ */ s.jsx("span", { className: i, style: { fontSize: e }, children: Zv(t) }), lT = [
  "ad",
  "ae",
  "af",
  "ag",
  "ai",
  "al",
  "am",
  "ao",
  "ar",
  "as",
  "at",
  "au",
  "aw",
  "az",
  "ba",
  "bb",
  "bd",
  "be",
  "bf",
  "bg",
  "bh",
  "bi",
  "bj",
  "bm",
  "bn",
  "bo",
  "br",
  "bs",
  "bt",
  "bw",
  "by",
  "bz",
  "ca",
  "cd",
  "cf",
  "cg",
  "ch",
  "ci",
  "ck",
  "cl",
  "cm",
  "cn",
  "co",
  "cr",
  "cu",
  "cv",
  "cw",
  "cy",
  "cz",
  "de",
  "dj",
  "dk",
  "dm",
  "do",
  "dz",
  "ec",
  "ee",
  "eg",
  "er",
  "es",
  "et",
  "fi",
  "fj",
  "fk",
  "fm",
  "fo",
  "fr",
  "bl",
  "mf",
  "ga",
  "gb",
  "gd",
  "ge",
  "gf",
  "gh",
  "gi",
  "gl",
  "gm",
  "gn",
  "gp",
  "gq",
  "gr",
  "gt",
  "gu",
  "gw",
  "gy",
  "hk",
  "hn",
  "hr",
  "ht",
  "hu",
  "id",
  "ie",
  "il",
  "in",
  "io",
  "iq",
  "ir",
  "is",
  "it",
  "jm",
  "jo",
  "jp",
  "ke",
  "kg",
  "kh",
  "ki",
  "km",
  "kn",
  "kp",
  "kr",
  "kw",
  "ky",
  "kz",
  "la",
  "lb",
  "lc",
  "li",
  "lk",
  "lr",
  "ls",
  "lt",
  "lu",
  "lv",
  "ly",
  "ma",
  "mc",
  "md",
  "me",
  "mg",
  "mh",
  "mk",
  "ml",
  "mm",
  "mn",
  "mo",
  "mp",
  "mq",
  "mr",
  "ms",
  "mt",
  "mu",
  "mv",
  "mw",
  "mx",
  "my",
  "mz",
  "na",
  "nc",
  "ne",
  "nf",
  "ng",
  "ni",
  "nl",
  "bq",
  "no",
  "np",
  "nr",
  "nu",
  "nz",
  "om",
  "pa",
  "pe",
  "pf",
  "pg",
  "ph",
  "pk",
  "pl",
  "pm",
  "pr",
  "ps",
  "pt",
  "pw",
  "py",
  "qa",
  "re",
  "ro",
  "rs",
  "ru",
  "rw",
  "sa",
  "sb",
  "sc",
  "sd",
  "se",
  "sg",
  "sh",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sr",
  "ss",
  "st",
  "sv",
  "sx",
  "sy",
  "sz",
  "tc",
  "td",
  "tg",
  "th",
  "tj",
  "tk",
  "tl",
  "tm",
  "tn",
  "to",
  "tr",
  "tt",
  "tv",
  "tw",
  "tz",
  "ua",
  "ug",
  "us",
  "uy",
  "uz",
  "va",
  "vc",
  "ve",
  "vg",
  "vi",
  "vn",
  "vu",
  "wf",
  "ws",
  "ye",
  "za",
  "zm",
  "zw"
], Jv = "h-formGrid--formGrid__root", tS = {
  root: Jv
}, eS = "formGridTestId", cT = $(function({ className: t, children: e, ...n }, o) {
  const r = f(tS.root, t);
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-testid": eS,
      className: r,
      ...n,
      ref: o,
      children: e
    }
  );
}), nS = "h-formGrid-field--formField__root", sS = "h-formGrid-field--formField__rootSpan5", oS = "h-formGrid-field--formField__rootSpan4", rS = "h-formGrid-field--formField__rootSpan3", iS = "h-formGrid-field--formField__rootSpan2", aS = "h-formGrid-field--formField__rootSpan1", De = {
  root: nS,
  rootSpan5: sS,
  rootSpan4: oS,
  rootSpan3: rS,
  rootSpan2: iS,
  rootSpan1: aS
}, lS = "formFieldTestId", cS = {
  1: De.rootSpan1,
  2: De.rootSpan2,
  3: De.rootSpan3,
  4: De.rootSpan4,
  5: De.rootSpan5,
  6: void 0
};
class dT extends D {
  static defaultProps = {
    span: 6
  };
  render() {
    const { span: t, className: e, children: n, ...o } = this.props, r = f(
      De.root,
      e,
      cS[t]
    );
    return /* @__PURE__ */ s.jsx("div", { "data-testid": lS, className: r, ...o, children: n });
  }
}
const dS = "h-helperField--helperField__root", hS = "h-helperField--helperField__label", uS = "h-helperField--helperField__helpIcon", pS = "h-helperField--helperField__error", mS = "h-helperField--helperField__rootRequired", Xe = {
  root: dS,
  label: hS,
  helpIcon: uS,
  error: pS,
  rootRequired: mS
};
class hT extends D {
  render() {
    const {
      className: t,
      label: e,
      required: n,
      disabled: o,
      errorMessage: r,
      fieldId: a,
      children: l,
      helpIcon: c,
      ...d
    } = this.props, h = f(
      {
        [Xe.root]: !0,
        [Xe.rootRequired]: n
      },
      t
    );
    return /* @__PURE__ */ s.jsxs("div", { ...d, className: h, children: [
      !!e && /* @__PURE__ */ s.jsx(
        "label",
        {
          className: Xe.label,
          htmlFor: a,
          id: `${a}-label`,
          children: e
        }
      ),
      !!c?.text && /* @__PURE__ */ s.jsx(
        qs,
        {
          ...c,
          className: f(Xe.helpIcon, c?.className ?? "")
        }
      ),
      !!r && /* @__PURE__ */ s.jsx("p", { className: Xe.error, children: r }),
      l
    ] });
  }
}
const gS = "h-inputDuration--inputDuration__root", fS = {
  root: gS
}, Is = (i, t = [
  "hours",
  "minutes",
  "seconds"
]) => {
  const e = Math.floor(i / 1e3), n = {};
  let o = e;
  return t.includes("days") && (n.days = Math.floor(e / (24 * 3600)), o = e % (24 * 3600)), t.includes("hours") && (n.hours = Math.floor(o / 3600), o %= 3600), t.includes("minutes") && (n.minutes = Math.floor(o / 60), o %= 60), t.includes("seconds") && (n.seconds = o), n;
}, Ds = (i) => ((i.days ?? 0) * 86400 + (i.hours ?? 0) * 3600 + (i.minutes ?? 0) * 60 + (i.seconds ?? 0)) * 1e3, bS = [
  "hours",
  "minutes",
  "seconds"
], uT = $(
  function(t, e) {
    const n = Y(null);
    Fe(e, () => n.current);
    const {
      className: o,
      name: r = "input-duration",
      value: a = 0,
      required: l = !1,
      disabled: c = !1,
      readOnly: d = !1,
      inputParts: h = bS,
      status: u,
      onChange: p,
      onBlur: m
    } = t, [g, b] = V(
      () => Is(a, h)
    );
    J(() => {
      const S = Ds(g);
      if (a !== S) {
        const y = Is(a, h);
        b(y);
      }
    }, [a, h]);
    const x = F(
      (S, y) => {
        const v = Math.max(0, parseInt(y) || 0);
        if ((S === "minutes" || S === "seconds") && v > 60)
          return;
        const I = { ...g, [S]: v };
        b(I);
        const T = Ds(I);
        p?.(T);
      },
      [g, p]
    ), C = F(() => {
      const S = Ds(g), y = Is(
        S,
        h
      );
      b(y), m?.();
    }, [g, h, m]), _ = (S) => {
      const y = g[S] ?? 0, v = y === 0;
      return {
        type: "number",
        id: `${r}-${S}`,
        name: `${r}-${S}`,
        value: v ? "" : y,
        placeholder: v ? "0" : void 0,
        suffix: {
          type: "custom",
          value: S.charAt(0).toUpperCase() + S.slice(1)
        },
        min: 0,
        step: 1,
        required: l,
        disabled: c,
        readOnly: d,
        status: u,
        "aria-required": l,
        "aria-disabled": c,
        "aria-readonly": d,
        onBlur: C,
        onChange: (I) => x(S, I.target.value)
      };
    }, w = f(o, fS.root);
    return /* @__PURE__ */ s.jsxs("div", { ref: n, className: w, children: [
      h.includes("days") && /* @__PURE__ */ s.jsx(Yt, { ..._("days") }),
      h.includes("hours") && /* @__PURE__ */ s.jsx(Yt, { ..._("hours") }),
      h.includes("minutes") && /* @__PURE__ */ s.jsx(Yt, { ..._("minutes"), max: 60 }),
      h.includes("seconds") && /* @__PURE__ */ s.jsx(Yt, { ..._("seconds"), max: 60 })
    ] });
  }
), Qe = /* @__PURE__ */ new Map();
function xS({
  containerId: i,
  children: t
}) {
  const [e, n] = V(null), o = (a) => {
    const l = Qe.get(i);
    l !== void 0 && Qe.set(i, l + a);
  }, r = () => {
    const a = document.createElement("div");
    return a.id = i, a;
  };
  return J(() => {
    let a = document.getElementById(i);
    return a || (a = r(), document.body.appendChild(a), Qe.set(i, 0)), n(a), o(1), () => {
      o(-1), Qe.get(i) === 0 && a && (Qe.delete(i), a.remove());
    };
  }, [i]), e ? Ui.createPortal(t, e) : null;
}
const yS = "h-modal--modal__root", _S = "h-modal--modal__rootSkipAnimation", CS = "h-modal--modal__modalContainer", wS = "h-modal--modal__modalContent", vS = "h-modal--modal__rootDisplayed", SS = "h-modal--modal__rootOpened", IS = "h-modal--modal__modal", DS = "h-modal--modal__modalStacked", kS = "h-modal--modal__ghostPanel", TS = "h-modal--modal__ghostLabel", jt = {
  root: yS,
  rootSkipAnimation: _S,
  modalContainer: CS,
  modalContent: wS,
  rootDisplayed: vS,
  rootOpened: SS,
  modal: IS,
  modalStacked: DS,
  ghostPanel: kS,
  ghostLabel: TS
}, jS = kt(!1);
class NS extends D {
  rootRef;
  haskeydownEventListner;
  closeTimer;
  static defaultProps = {
    allowEscClose: !0,
    restoreFocus: !0,
    bringInFocusOnTab: !0
  };
  constructor(t) {
    super(t), this.rootRef = B(), this.closeTimer = null, this.state = {
      opened: !1,
      displayed: !1
    }, this.haskeydownEventListner = !1, this.animateOpening = this.animateOpening.bind(this), this.animateClosing = this.animateClosing.bind(this), this.onTransitionEnd = this.onTransitionEnd.bind(this), this.handleKey = this.handleKey.bind(this);
  }
  componentDidMount() {
    const { isOpen: t } = this.props;
    t && this.animateOpening();
  }
  componentDidUpdate(t) {
    const { isOpen: e, allowEscClose: n } = this.props, { isOpen: o } = t;
    n && !this.haskeydownEventListner && (window.addEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !0), e !== o && (e ? this.animateOpening() : this.animateClosing());
  }
  componentWillUnmount() {
    this.cancelAnimation(), this.removeKeyDownEventListener();
  }
  handleKey(t) {
    const { isOpen: e, onClose: n } = this.props;
    e && Ee(t.key) && (this.rootRef.current?.querySelector(
      '[role="menu"][aria-expanded="true"]'
    ) || (t.preventDefault(), t.stopPropagation(), this.animateClosing(), n(t)));
  }
  removeKeyDownEventListener = () => {
    window.removeEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !1;
  };
  cancelAnimation() {
    const { current: t } = this.rootRef;
    t && t.removeEventListener("transitionend", this.onTransitionEnd), this.closeTimer && (clearTimeout(this.closeTimer), this.closeTimer = null);
  }
  animateOpening() {
    const { skipAnimation: t } = this.props;
    t ? this.setState({ displayed: !0, opened: !0 }) : (this.setState({ displayed: !0 }), setTimeout(() => this.setState({ opened: !0 })));
  }
  animateClosing() {
    const { skipAnimation: t } = this.props;
    this.removeKeyDownEventListener(), t ? this.setState({ opened: !1, displayed: !1 }) : (this.rootRef.current && this.rootRef.current.addEventListener(
      "transitionend",
      this.onTransitionEnd
    ), this.setState({ opened: !1 }), this.closeIfNoTransitionOccurred());
  }
  closeIfNoTransitionOccurred() {
    this.closeTimer = setTimeout(() => {
      this.closeTimer && this.onTransitionEnd();
    }, 400);
  }
  onTransitionEnd() {
    this.setState({ displayed: !1 }), this.closeTimer && (clearTimeout(this.closeTimer), this.closeTimer = null), this.rootRef.current && this.rootRef.current.removeEventListener(
      "transitionend",
      this.onTransitionEnd
    );
  }
  render() {
    const {
      className: t,
      isOpen: e,
      children: n,
      onClose: o,
      allowClickOutside: r,
      allowEscClose: a,
      // Stops allowEscClose from being passed in with otherProps
      skipAnimation: l,
      wrapProps: c,
      autoFocus: d,
      restoreFocus: h,
      bringInFocusOnTab: u,
      ...p
    } = this.props, { displayed: m, opened: g } = this.state, b = f(jt.root, c?.className, {
      [jt.rootDisplayed]: m,
      [jt.rootOpened]: g,
      [jt.rootSkipAnimation]: l
    });
    return /* @__PURE__ */ s.jsx(xS, { containerId: "modal-container", children: /* @__PURE__ */ s.jsx("div", { ...c, className: b, children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: jt.modalContainer,
        ref: this.rootRef,
        ...r ? { onClick: o } : {},
        ...p,
        children: g && // fixes an issue with child-components that need to measure boundingClientRect
        /* @__PURE__ */ s.jsx(
          Sr,
          {
            containerRef: this.rootRef,
            autoFocus: d,
            restoreFocus: h,
            bringInFocusOnTab: u,
            children: /* @__PURE__ */ s.jsx("div", { className: jt.modalContent, children: /* @__PURE__ */ s.jsx(jS.Consumer, { children: (x) => /* @__PURE__ */ s.jsxs(
              "div",
              {
                className: f(jt.modal, t, {
                  [jt.modalStacked]: x
                }),
                onClick: (C) => r && C.stopPropagation(),
                children: [
                  x && /* @__PURE__ */ s.jsx(
                    "div",
                    {
                      role: "button",
                      tabIndex: -1,
                      className: jt.ghostPanel,
                      onClick: o,
                      children: /* @__PURE__ */ s.jsxs("span", { className: jt.ghostLabel, children: [
                        /* @__PURE__ */ s.jsx(N, { name: "arrow-left", size: 12 }),
                        "Go back"
                      ] })
                    }
                  ),
                  n
                ]
              }
            ) }) })
          }
        )
      }
    ) }) });
  }
}
const FS = "h-lightbox--lightbox__lightSource", PS = "h-lightbox--lightbox__closeButton", RS = "h-lightbox--lightbox__downloadButton", ES = "h-lightbox--lightbox__image", LS = "h-lightbox--lightbox__loadingContainer", AS = "h-lightbox--lightbox__navButton", $S = "h-lightbox--lightbox__navButtonPrevious", OS = "h-lightbox--lightbox__navButtonNext", BS = "h-lightbox--lightbox__counter", Nt = {
  lightSource: FS,
  closeButton: PS,
  downloadButton: RS,
  image: ES,
  loadingContainer: LS,
  navButton: AS,
  navButtonPrevious: $S,
  navButtonNext: OS,
  counter: BS
};
class pT extends D {
  render() {
    const {
      className: t,
      src: e,
      alt: n,
      isOpen: o,
      onClose: r,
      showNavigation: a = !1,
      currentIndex: l = 0,
      totalImages: c = 1,
      onPrevious: d,
      onNext: h,
      isLoading: u = !1
    } = this.props, p = c > 1;
    return /* @__PURE__ */ s.jsx(
      NS,
      {
        className: t,
        isOpen: o,
        allowClickOutside: !0,
        onClose: r,
        children: /* @__PURE__ */ s.jsxs("div", { className: Nt.lightSource, children: [
          u ? /* @__PURE__ */ s.jsx("div", { className: Nt.loadingContainer, children: /* @__PURE__ */ s.jsx(Gn, { size: 64 }) }) : e && /* @__PURE__ */ s.jsx(Vs, { className: Nt.image, alt: n, src: e }),
          r && /* @__PURE__ */ s.jsx(
            K,
            {
              onClick: r,
              icon: "close",
              variant: "secondary",
              className: Nt.closeButton
            }
          ),
          e && typeof e == "string" && /* @__PURE__ */ s.jsx(
            "a",
            {
              href: e,
              target: "_blank",
              download: !0,
              className: Nt.downloadButton,
              rel: "noreferrer",
              children: /* @__PURE__ */ s.jsx(
                N,
                {
                  name: "cloud-download",
                  className: f("icon-vertical-fix")
                }
              )
            }
          ),
          a && p && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx(
              K,
              {
                icon: "arrow-left",
                variant: "primary",
                size: "large",
                onClick: d,
                className: `${Nt.navButton} ${Nt.navButtonPrevious}`
              }
            ),
            /* @__PURE__ */ s.jsx(
              K,
              {
                icon: "arrow-right",
                variant: "primary",
                size: "large",
                onClick: h,
                className: `${Nt.navButton} ${Nt.navButtonNext}`
              }
            ),
            /* @__PURE__ */ s.jsxs("div", { className: Nt.counter, children: [
              l + 1,
              " / ",
              c
            ] })
          ] })
        ] })
      }
    );
  }
}
const HS = "h-list-items--item__root", WS = "h-list-items--item__rootWithHoverEffect", MS = "h-list-items--item__rootDense", zS = "h-list-items--item__rootLarge", VS = "h-list-items--item__contentLeft", KS = "h-list-items--item__contentRight", US = "h-list-items--item__titles", qS = "h-list-items--item__title", GS = "h-list-items--item__titleSecondary", YS = "h-list-items--item__arrow", Ft = {
  root: HS,
  rootWithHoverEffect: WS,
  rootDense: MS,
  rootLarge: zS,
  contentLeft: VS,
  contentRight: KS,
  titles: US,
  title: qS,
  titleSecondary: GS,
  arrow: YS
};
class ns extends D {
  static defaultProps = {
    variant: "dense",
    withHoverEffect: !0
  };
  renderTitle() {
    const { title: t, titleSecondary: e } = this.props;
    return t || e ? /* @__PURE__ */ s.jsxs("div", { className: Ft.titles, children: [
      !!t && /* @__PURE__ */ s.jsx(A.Paragraph, { as: "div", variant: "2", className: Ft.title, children: t }),
      !!e && /* @__PURE__ */ s.jsx(
        A.Paragraph,
        {
          as: "div",
          variant: "4",
          subdued: !0,
          className: Ft.titleSecondary,
          children: e
        }
      )
    ] }) : null;
  }
  renderContentLeft() {
    const { contentLeft: t } = this.props;
    return t ? /* @__PURE__ */ s.jsx("div", { className: Ft.contentLeft, children: t }) : null;
  }
  renderContentRight() {
    const { contentRight: t } = this.props;
    return t ? /* @__PURE__ */ s.jsx("div", { className: Ft.contentRight, children: t }) : null;
  }
  renderIcon() {
    const { isLink: t, contentRight: e } = this.props;
    return t && !e ? /* @__PURE__ */ s.jsx(
      N,
      {
        className: f(Ft.arrow, "icon-vertical-fix"),
        name: "angle-right",
        size: 24
      }
    ) : null;
  }
  renderContent() {
    return /* @__PURE__ */ s.jsxs(Wt, { children: [
      this.renderContentLeft(),
      this.renderTitle(),
      this.renderContentRight(),
      this.renderIcon()
    ] });
  }
  getChildrenWithFallback() {
    return this.props.children ?? this.renderContent();
  }
  render() {
    const {
      className: t,
      children: e,
      contentLeft: n,
      contentRight: o,
      title: r,
      titleSecondary: a,
      secondaryTitleBelow: l,
      isLink: c,
      variant: d,
      withHoverEffect: h,
      ...u
    } = this.props, p = f(Ft.root, t, {
      [Ft.rootDense]: d === "dense",
      [Ft.rootLarge]: d === "large",
      [Ft.rootWithHoverEffect]: h
    });
    return /* @__PURE__ */ s.jsx("li", { ...u, className: p, children: this.getChildrenWithFallback() });
  }
}
const XS = "h-list-items--keyValue__root", QS = {
  root: XS
};
class ZS extends D {
  static defaultProps = {
    hideIfValueIsEmpty: !0
  };
  isValueEmpty() {
    return !this.props.pair.value;
  }
  render() {
    const { hideIfValueIsEmpty: t, className: e, pair: n, ...o } = this.props, r = f(QS.root, e);
    return t && this.isValueEmpty() ? null : /* @__PURE__ */ s.jsx(
      ns,
      {
        ...o,
        className: r,
        title: /* @__PURE__ */ s.jsx(A.Paragraph, { as: "span", variant: "4", subdued: !0, children: n.key }),
        titleSecondary: /* @__PURE__ */ s.jsx(A.Paragraph, { as: "span", variant: "2", children: n.value }),
        "data-testid": "List-KeyValue"
      }
    );
  }
}
const JS = "h-list-items--text__root", tI = {
  root: JS
};
class eI extends D {
  render() {
    const { children: t, className: e, ...n } = this.props, o = f(tI.root, e);
    return /* @__PURE__ */ s.jsx(
      ns,
      {
        ...n,
        className: o,
        "data-testid": "List-Text",
        children: /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: t })
      }
    );
  }
}
const nI = "h-list-items--user__root", sI = "h-list-items--user__avatarWrapper", lr = {
  root: nI,
  avatarWrapper: sI
};
class oI extends D {
  getTitle() {
    const { user: t, title: e } = this.props;
    return e || t.display_name || t.name || t.phone_number || t.id;
  }
  getSubTitle() {
    const { user: t, titleSecondary: e } = this.props;
    return e || t.email;
  }
  render() {
    const { className: t, user: e, title: n, titleSecondary: o, ...r } = this.props, a = f(t, lr.root);
    return /* @__PURE__ */ s.jsx(
      ns,
      {
        className: a,
        contentLeft: /* @__PURE__ */ s.jsx("div", { className: lr.avatarWrapper, children: /* @__PURE__ */ s.jsx(vr, { user: e }) }),
        title: this.getTitle(),
        titleSecondary: this.getSubTitle(),
        "data-testid": "<List.User>",
        ...r
      }
    );
  }
}
const rI = "h-list--list__root", iI = {
  root: rI
};
class aI extends D {
  static Item = ns;
  static Text = eI;
  static User = oI;
  static KeyValue = ZS;
  render() {
    const { className: t, ...e } = this.props;
    return /* @__PURE__ */ s.jsx("ul", { ...e, className: f(iI.root, t) });
  }
}
const mT = hn(aI, {
  fallback: null
}), lI = () => {
  document.exitFullscreen && document.exitFullscreen();
}, cI = (i) => {
  i.requestFullscreen ? i.requestFullscreen() : i.mozRequestFullScreen ? i.mozRequestFullScreen() : i.webkitRequestFullscreen ? i.webkitRequestFullscreen() : i.msRequestFullscreen && i.msRequestFullscreen();
}, dI = (i) => document.fullscreenElement === i;
class hI extends Error {
  status;
  url;
  response;
  constructor(t) {
    super(`NetworkError ${t.status} ${t.url}`), this.status = t.status, this.url = t.url, this.response = t;
  }
}
const uI = {
  fetch: (i, ...t) => fetch(i, ...t).then((e) => {
    if (!(e.status >= 200 && e.status < 300))
      throw new hI(e);
    return e;
  })
}, pI = "h-mediaPlayer--mediaPlayer__root", mI = "h-mediaPlayer--mediaPlayer__controls", gI = "h-mediaPlayer--mediaPlayer__unstyled", fI = "h-mediaPlayer--mediaPlayer__rootFullScreen", bI = "h-mediaPlayer--mediaPlayer__rootHideControls", xI = "h-mediaPlayer--mediaPlayer__control", yI = "h-mediaPlayer--mediaPlayer__progress", _I = "h-mediaPlayer--mediaPlayer__progressSlider", CI = "h-mediaPlayer--mediaPlayer__volumeSlider", wI = "h-mediaPlayer--mediaPlayer__timestamp", vI = "h-mediaPlayer--mediaPlayer__videoWrapper", SI = "h-mediaPlayer--mediaPlayer__rootWaiting", II = "h-mediaPlayer--mediaPlayer__rootAudio", DI = "h-mediaPlayer--mediaPlayer__video", kI = "h-mediaPlayer--mediaPlayer__volume", TI = "h-mediaPlayer--mediaPlayer__volumeMuteControl", jI = "h-mediaPlayer--mediaPlayer__downloadLink", tt = {
  root: pI,
  controls: mI,
  unstyled: gI,
  rootFullScreen: fI,
  rootHideControls: bI,
  control: xI,
  progress: yI,
  progressSlider: _I,
  volumeSlider: CI,
  timestamp: wI,
  videoWrapper: vI,
  rootWaiting: SI,
  rootAudio: II,
  video: DI,
  volume: kI,
  volumeMuteControl: TI,
  downloadLink: jI
};
function NI(i) {
  const t = i >= 3600 ? 8 : 5;
  return Number.isNaN(i) || !Number.isFinite(i) ? "00:00" : new Date(i * 1e3).toISOString().substr(19 - t, t);
}
class gT extends D {
  intersectionObserver;
  static defaultProps = {
    headers: {}
  };
  constructor(t) {
    super(t), this.state = {
      src: void 0,
      playing: !1,
      actuallyPlaying: !1,
      duration: 0,
      time: 0,
      prevVolume: 1,
      volume: 100,
      isFullScreen: !1,
      hideControls: !1,
      isWaiting: !1,
      buffer: null,
      asyncStatus: null
    }, this.updateBuffer = this.updateBuffer.bind(this), this.updateProgress = this.updateProgress.bind(this), this.handleMute = this.handleMute.bind(this), this.handlePlaying = this.handlePlaying.bind(this), this.handleWaiting = this.handleWaiting.bind(this), this.handleEnded = this.handleEnded.bind(this), this.handleError = this.handleError.bind(this), this.seek = this.seek.bind(this), this.handleIntersection = this.handleIntersection.bind(this), this.handleTogglePlayClick = this.handleTogglePlayClick.bind(this), this.handleFullscreenToggle = this.handleFullscreenToggle.bind(this), this.handleFullscreenChange = this.handleFullscreenChange.bind(this), this.startHideControlCountdown = this.startHideControlCountdown.bind(this);
  }
  componentDidMount() {
    const { lazy: t } = this.props, { current: e } = this.playerRef;
    e && e.addEventListener("fullscreenchange", this.handleFullscreenChange), t ? this.createIntersectionObserver() : this.loadSrc();
  }
  componentDidUpdate(t, e) {
    const {
      mediaFile: { src: n }
    } = t, {
      lazy: o,
      mediaFile: { src: r }
    } = this.props;
    n !== r && (o ? this.setSrc() : this.loadSrc()), this.tryReloadPlayer(e);
  }
  componentWillUnmount() {
    const { current: t } = this.playerRef;
    t && t.removeEventListener(
      "fullscreenchange",
      this.handleFullscreenChange
    ), window.removeEventListener("mousemove", this.startHideControlCountdown), this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.controller.abort();
  }
  videoRef = B();
  playerRef = B();
  hideControlsTimeout = void 0;
  controller = new AbortController();
  loadSrc() {
    const {
      mediaFile: { src: t },
      isPrivateFile: e
    } = this.props;
    this.tryStopPlayer(), e ? this.fetchFile() : this.setSrc(t);
  }
  setSrc(t) {
    this.setState({
      src: t
    });
  }
  handleIntersection([t]) {
    const { src: e, asyncStatus: n } = this.state;
    !e && !(n === "loading") && t.isIntersecting && (this.loadSrc(), this.intersectionObserver?.disconnect());
  }
  createIntersectionObserver() {
    const { current: t } = this.playerRef;
    t && (this.intersectionObserver = new IntersectionObserver(
      this.handleIntersection,
      { threshold: 1 }
    ), this.intersectionObserver.observe(t));
  }
  tryStopPlayer() {
    const { current: t } = this.videoRef;
    if (!t)
      return;
    t.currentTime = 0;
    const { playing: e, actuallyPlaying: n } = this.state;
    e && n && (t.pause(), this.setState({ playing: !1, actuallyPlaying: !1 }));
  }
  tryReloadPlayer(t) {
    const { current: e } = this.videoRef;
    if (!e)
      return;
    const { src: n } = this.state;
    n !== t.src && e.load();
  }
  fetchFile(t) {
    const {
      mediaFile: { src: e },
      headers: n,
      filename: o
    } = this.props;
    this.setState({ asyncStatus: "loading" });
    const r = new Headers(n);
    uI.fetch(e, {
      headers: r,
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      signal: this.controller.signal
    }).then((a) => a.blob()).then((a) => {
      const l = window.URL.createObjectURL(a);
      t ? Ai.saveAs(
        a,
        o || decodeURIComponent(e.split("/").pop())
      ) : this.setSrc(l), this.setState({ asyncStatus: "succeeded" });
    }).catch((a) => {
      a && a.name === "AbortError" || (console.error("[MediaPlayer] fetchFile", a), this.setState({ asyncStatus: "failed" }));
    });
  }
  updateProgress() {
    const { current: t } = this.videoRef;
    t && this.setState({
      time: t.currentTime,
      duration: t.duration
    });
  }
  updateBuffer() {
    const { current: t } = this.videoRef, { time: e, duration: n } = this.state;
    if (t) {
      let o = null;
      const r = t.buffered;
      for (let a = 0; a < r.length; a += 1) {
        const l = r.start(a), c = r.end(a);
        l <= e && e <= c && (o = [l / n, c / n]);
      }
      this.setState({
        buffer: o
      });
    }
  }
  handleWaiting() {
    this.setState({
      isWaiting: !0
    });
  }
  handlePlaying() {
    this.setState({
      isWaiting: !1
    });
  }
  handleTogglePlayClick() {
    const { playing: t, actuallyPlaying: e } = this.state, { current: n } = this.videoRef;
    n && (t && e ? (n.pause(), this.setState({
      isWaiting: !1,
      playing: !1,
      actuallyPlaying: !1
    })) : t || (this.setState({
      isWaiting: !0,
      playing: !0,
      actuallyPlaying: !1
    }), n.play().then(() => {
      this.setState({ actuallyPlaying: !0 });
    })));
  }
  startHideControlCountdown() {
    this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.setState({
      hideControls: !1
    }), this.hideControlsTimeout = setTimeout(() => {
      this.setState({
        hideControls: !0
      });
    }, 2e3);
  }
  handleFullscreenChange() {
    const { current: t } = this.playerRef, e = dI(t);
    this.setState({
      isFullScreen: e
    }), e ? (this.startHideControlCountdown(), window.addEventListener("mousemove", this.startHideControlCountdown)) : (this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), window.removeEventListener("mousemove", this.startHideControlCountdown));
  }
  handleFullscreenToggle() {
    const { current: t } = this.playerRef, { isFullScreen: e } = this.state;
    t && (e ? lI() : cI(t));
  }
  handleEnded() {
    this.setState({
      playing: !1
    });
  }
  handleError() {
    this.props.onError && this.props.onError();
  }
  seek(t) {
    const { current: e } = this.videoRef, { duration: n } = this.state;
    e && t && !Number.isNaN(t) && (e.currentTime = n * t);
  }
  handleVolume = (t) => {
    const { current: e } = this.videoRef;
    !e || typeof t > "u" || !Number.isFinite(t) || this.setState({ volume: t }, () => {
      this.setPlayerVolume(t);
    });
  };
  handleMute() {
    const { current: t } = this.videoRef;
    if (!t)
      return;
    const { volume: e, prevVolume: n } = this.state, o = e === 0, r = o ? n : 0;
    this.setState(
      {
        volume: r,
        prevVolume: o ? n : e
      },
      () => {
        this.setPlayerVolume(r);
      }
    );
  }
  setPlayerVolume(t) {
    const { current: e } = this.videoRef;
    e && (e.volume = t / 100);
  }
  render() {
    const {
      className: t,
      mediaFile: { type: e },
      headers: n,
      isPrivateFile: o,
      width: r,
      controls: a,
      noControlsStyle: l,
      ...c
    } = this.props, {
      src: d,
      playing: h,
      duration: u,
      time: p,
      volume: m,
      hideControls: g,
      isFullScreen: b,
      isWaiting: x,
      buffer: C,
      asyncStatus: _
    } = this.state, w = a?.play ?? !0, S = a?.download ?? !0, y = a?.progress ?? !0, v = a?.volume ?? !0, I = a?.maximize ?? !0, T = w || S || y || v || I, P = typeof e == "string" && e.startsWith("audio"), L = !d || _ === "loading", k = b ? "primary" : "secondary", R = f(
      tt.root,
      {
        [tt.rootFullScreen]: b,
        [tt.rootHideControls]: g,
        [tt.rootWaiting]: h && x,
        [tt.rootAudio]: P
      },
      t
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...c,
        className: R,
        ref: this.playerRef,
        style: { width: r },
        children: [
          /* @__PURE__ */ s.jsx("div", { className: tt.videoWrapper, children: !!d && /* @__PURE__ */ s.jsx(
            "video",
            {
              className: tt.video,
              ref: this.videoRef,
              onDurationChange: this.updateProgress,
              onTimeUpdate: this.updateProgress,
              onWaiting: this.handleWaiting,
              onPlaying: this.handlePlaying,
              onProgress: this.updateBuffer,
              onEnded: this.handleEnded,
              onError: this.handleError,
              children: /* @__PURE__ */ s.jsx("source", { src: d })
            }
          ) }),
          T && /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: f(tt.controls, {
                [tt.unstyled]: l
              }),
              children: [
                w && /* @__PURE__ */ s.jsx(
                  K,
                  {
                    onClick: this.handleTogglePlayClick,
                    className: tt.control,
                    disabled: L,
                    icon: h ? "pause" : "play",
                    variant: k
                  }
                ),
                S && (o ? /* @__PURE__ */ s.jsx(
                  Q,
                  {
                    variant: k,
                    className: tt.control,
                    disabled: L,
                    children: /* @__PURE__ */ s.jsx(
                      "a",
                      {
                        href: d,
                        download: !0,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: tt.downloadLink,
                        children: /* @__PURE__ */ s.jsx(N, { name: "download" })
                      }
                    )
                  }
                ) : /* @__PURE__ */ s.jsx(
                  K,
                  {
                    icon: "download",
                    variant: k,
                    className: tt.control,
                    disabled: L,
                    onClick: () => this.fetchFile(!0)
                  }
                )),
                y && /* @__PURE__ */ s.jsxs("div", { className: tt.progress, children: [
                  /* @__PURE__ */ s.jsx(
                    Os,
                    {
                      hideAnnotations: !0,
                      className: tt.progressSlider,
                      min: 0,
                      max: u,
                      value: p,
                      onChange: (O) => !Array.isArray(O) && this.seek(O / u),
                      dark: b,
                      highlightRange: C?.map((O) => O * u)
                    }
                  ),
                  /* @__PURE__ */ s.jsx("span", { className: tt.timestamp, children: NI(u) })
                ] }),
                v && /* @__PURE__ */ s.jsxs("div", { className: tt.volume, children: [
                  /* @__PURE__ */ s.jsx(
                    N,
                    {
                      className: tt.volumeMuteControl,
                      name: m === 0 ? "volume-off" : "volume-up",
                      onClick: this.handleMute
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    Os,
                    {
                      hideAnnotations: !0,
                      className: tt.volumeSlider,
                      value: m,
                      onChange: (O) => !Array.isArray(O) && this.handleVolume(O),
                      dark: b
                    }
                  )
                ] }),
                I && !P && /* @__PURE__ */ s.jsx(
                  K,
                  {
                    variant: k,
                    onClick: this.handleFullscreenToggle,
                    className: tt.control,
                    icon: "expand"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
}
const FI = "h-modalBody--modalBody__root", PI = {
  root: FI
};
class fT extends D {
  render() {
    const { className: t, children: e, ...n } = this.props, o = f(
      {
        [PI.root]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: e });
  }
}
const RI = "h-modalFoot--modalFoot__root", EI = "h-modalFoot--modalFoot__confirm", LI = "h-modalFoot--modalFoot__confirmSecondary", AI = "h-modalFoot--modalFoot__cancel", Fn = {
  root: RI,
  confirm: EI,
  confirmSecondary: LI,
  cancel: AI
};
class $I extends D {
  static defaultProps;
  render() {
    const {
      className: t,
      confirmOnClick: e,
      confirmSecondaryOnClick: n,
      cancelOnClick: o,
      confirmName: r,
      confirmSecondaryName: a,
      cancelName: l,
      confirmProps: c,
      confirmSecondaryProps: d,
      cancelProps: h,
      children: u,
      ...p
    } = this.props, m = f(
      {
        [Fn.root]: !0
      },
      t
    ), g = f(
      {
        [Fn.cancel]: !0
      },
      h?.className
    ), b = f(
      {
        [Fn.confirm]: !0
      },
      c?.className
    ), x = f(
      {
        [Fn.confirmSecondary]: !0
      },
      d?.className
    );
    return /* @__PURE__ */ s.jsxs("div", { ...p, className: m, children: [
      u,
      n && /* @__PURE__ */ s.jsx(
        Q,
        {
          variant: "secondary",
          ...d,
          className: x,
          onClick: n,
          children: a
        }
      ),
      o && /* @__PURE__ */ s.jsx(
        Q,
        {
          variant: "tertiary",
          ...h,
          className: g,
          onClick: o,
          children: l
        }
      ),
      e && /* @__PURE__ */ s.jsx(
        Q,
        {
          variant: "primary",
          ...c,
          className: b,
          onClick: e,
          children: r
        }
      )
    ] });
  }
}
$I.defaultProps = {
  confirmName: "Save",
  cancelName: "Cancel",
  // eslint-disable-next-line react/default-props-match-prop-types
  confirmProps: {},
  // eslint-disable-next-line react/default-props-match-prop-types
  cancelProps: {}
};
const OI = "h-modalHead--modalHead__root", BI = "h-modalHead--modalHead__top", HI = "h-modalHead--modalHead__title", WI = "h-modalHead--modalHead__buttons", MI = "h-modalHead--modalHead__caption", Ze = {
  root: OI,
  top: BI,
  title: HI,
  buttons: WI,
  caption: MI
}, bT = ({
  className: i,
  title: t,
  children: e,
  onClose: n,
  secondaryButton: o,
  buttonsClassName: r,
  buttonsSlot: a,
  ...l
}) => {
  const c = f(
    {
      [Ze.root]: !0
    },
    i
  );
  return /* @__PURE__ */ s.jsxs("div", { ...l, className: c, children: [
    /* @__PURE__ */ s.jsxs("div", { className: Ze.top, children: [
      /* @__PURE__ */ s.jsx(A.Heading, { className: Ze.title, children: t }),
      /* @__PURE__ */ s.jsxs("div", { className: f(Ze.buttons, r), children: [
        a,
        typeof o?.onClick == "function" && /* @__PURE__ */ s.jsx(st, { content: o?.tooltipContent, children: /* @__PURE__ */ s.jsx(
          K,
          {
            icon: o?.icon,
            variant: "tertiary",
            onClick: o?.onClick
          }
        ) }),
        typeof n == "function" && /* @__PURE__ */ s.jsx(
          K,
          {
            icon: "close",
            iconSize: 24,
            variant: "tertiary",
            onClick: n
          }
        )
      ] })
    ] }),
    !!e && /* @__PURE__ */ s.jsx(
      A.Paragraph,
      {
        variant: "2",
        color: "secondary",
        className: Ze.caption,
        children: e
      }
    )
  ] });
}, zI = "h-page-body--pageBody__root", VI = {
  root: zI
}, KI = $(function({ children: t, className: e, ...n }, o) {
  return /* @__PURE__ */ s.jsx(
    mt.Row,
    {
      ...n,
      ref: o,
      className: f(VI.root, e),
      scrollable: !0,
      noMinHeight: !0,
      noHorizontalPadding: !0,
      noVerticalPadding: !0,
      children: t
    }
  );
}), UI = "h-page-head--pageHead__root", qI = {
  root: UI
}, GI = $(function({ className: t, title: e, controls: n, ...o }, r) {
  return /* @__PURE__ */ s.jsxs(
    mt.Row,
    {
      ...o,
      ref: r,
      as: "header",
      className: f(qI.root, t),
      slottable: !0,
      borderBottom: !0,
      children: [
        /* @__PURE__ */ s.jsx(mt.Slot, { placement: "start", children: /* @__PURE__ */ s.jsx(A.Heading, { variant: "heading-2", as: "h1", children: e }) }),
        n && /* @__PURE__ */ s.jsx(mt.Slot, { placement: "end", children: /* @__PURE__ */ s.jsx(H, { alignItems: "center", gap: "200", children: n }) })
      ]
    }
  );
}), YI = "h-page-section--pageSection__root", XI = "h-page-section--pageSection__head", QI = "h-page-section--pageSection__callout", ZI = "h-page-section--pageSection__content", Pn = {
  root: YI,
  head: XI,
  callout: QI,
  content: ZI
}, JI = $(function({
  children: t,
  className: e,
  title: n,
  titleMeta: o,
  controls: r,
  callout: a,
  ...l
}, c) {
  const d = !!(n || o || r);
  return /* @__PURE__ */ s.jsxs(
    mt.Row,
    {
      ...l,
      ref: c,
      as: "section",
      className: f(Pn.root, e),
      noMinHeight: !0,
      children: [
        d && /* @__PURE__ */ s.jsxs(
          mt.Row,
          {
            className: Pn.head,
            slottable: !0,
            noMinHeight: !0,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: [
              (n || o) && /* @__PURE__ */ s.jsx(mt.Slot, { placement: "start", noVerticalPadding: !0, children: /* @__PURE__ */ s.jsxs(H, { alignItems: "center", gap: "200", children: [
                n && /* @__PURE__ */ s.jsx(A.Heading, { variant: "heading-3", as: "h2", children: n }),
                o && /* @__PURE__ */ s.jsx(H, { alignItems: "center", gap: "200", children: o })
              ] }) }),
              r && /* @__PURE__ */ s.jsx(mt.Slot, { placement: "end", noVerticalPadding: !0, children: /* @__PURE__ */ s.jsx(H, { alignItems: "center", gap: "200", children: r }) })
            ]
          }
        ),
        a && /* @__PURE__ */ s.jsx(
          mt.Row,
          {
            className: Pn.callout,
            noMinHeight: !0,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: a
          }
        ),
        /* @__PURE__ */ s.jsx(
          mt.Row,
          {
            className: Pn.content,
            size: 1,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: t
          }
        )
      ]
    }
  );
}), tD = $(function({ children: t, className: e, ...n }, o) {
  return /* @__PURE__ */ s.jsx(
    mt.Row,
    {
      ...n,
      ref: o,
      className: e,
      borderBottom: !0,
      noVerticalPadding: !0,
      noMinHeight: !0,
      children: t
    }
  );
}), cr = ({ children: i, className: t, ...e }, n) => /* @__PURE__ */ s.jsx(ud, { ...e, ref: n, as: "article", className: t, children: /* @__PURE__ */ s.jsx(mt, { children: i }) }), xT = Object.assign($(cr), {
  name: cr.name,
  Head: GI,
  Body: KI,
  Section: JI,
  Tabs: tD
}), eD = "h-radio--radio__radio", nD = "h-radio--radio__radioDisabled", sD = "h-radio--radio__radioChecked", oD = "h-radio--radio__input", Rn = {
  radio: eD,
  radioDisabled: nD,
  radioChecked: sD,
  input: oD
}, yT = $(function(t, e) {
  const { id: n, checked: o, disabled: r, className: a, labelProps: l, ...c } = t, d = f(
    Rn.radio,
    { [Rn.radioChecked]: o },
    { [Rn.radioDisabled]: r },
    a
  ), h = n || `radio_${Math.random()}`;
  return /* @__PURE__ */ s.jsx(
    "label",
    {
      ...l,
      className: d,
      htmlFor: h,
      "data-testid": "radio",
      children: /* @__PURE__ */ s.jsx(
        "input",
        {
          ...c,
          ref: e,
          id: h,
          onChange: c.onChange || E,
          checked: o,
          disabled: r,
          type: "radio",
          className: Rn.input,
          "data-testid": "input"
        }
      )
    }
  );
}), rD = "h-reverseScroll--reverseScroll__root", iD = "h-reverseScroll--reverseScroll__column", aD = "h-reverseScroll--reverseScroll__row", lD = "h-reverseScroll--reverseScroll__scrollHandle", Je = {
  root: rD,
  column: iD,
  row: aD,
  scrollHandle: lD
}, cD = "reverse-scroll", _T = $(function({
  children: t,
  className: e,
  direction: n = "column",
  ...o
}, r) {
  const a = Y(null), l = Y(null), c = Y(null), d = es(t), h = q(
    () => d.reverse(),
    [d]
  ), u = (b) => c.current?.scrollIntoView(b), p = (b) => l.current?.scrollIntoView(b), m = (b) => a.current?.children[1]?.scrollIntoView(b), g = (b) => a.current?.children[a.current.children.length - 2]?.scrollIntoView(b);
  return Fe(r, () => ({
    rootElem: a.current,
    scrollToEnd: u,
    scrollToStart: p,
    scrollToFirstChild: g,
    scrollToLastChild: m
  })), /* @__PURE__ */ s.jsxs(
    "div",
    {
      ...o,
      "data-testid": cD,
      ref: a,
      className: f(e, Je.root, {
        [Je.row]: n === "row",
        [Je.column]: n === "column"
      }),
      children: [
        /* @__PURE__ */ s.jsx("div", { ref: c, className: Je.scrollHandle }),
        h,
        /* @__PURE__ */ s.jsx("div", { ref: l, className: Je.scrollHandle })
      ]
    }
  );
}), dD = "h-removableCard--removableCard__root", hD = "h-removableCard--removableCard__close", uD = "h-removableCard--removableCard__title", pD = "h-removableCard--removableCard__titleIcon", tn = {
  root: dD,
  close: hD,
  title: uD,
  titleIcon: pD
};
class CT extends D {
  render() {
    const { icon: t, title: e, children: n, onRemove: o, className: r, ...a } = this.props, l = f(
      {
        [tn.root]: tn.root
      },
      r
    );
    return /* @__PURE__ */ s.jsxs(
      at,
      {
        padding: "300",
        background: "neutral.100",
        borderRadius: !0,
        ...a,
        className: l,
        children: [
          /* @__PURE__ */ s.jsx(
            at,
            {
              as: "button",
              "aria-label": "Remove",
              className: tn.close,
              onClick: o,
              children: /* @__PURE__ */ s.jsx(N, { name: "close" })
            }
          ),
          /* @__PURE__ */ s.jsxs(
            H,
            {
              alignItems: "flex-start",
              justifyContent: "flex-start",
              className: tn.title,
              children: [
                t && /* @__PURE__ */ s.jsx(N, { name: t, className: tn.titleIcon }),
                e
              ]
            }
          ),
          /* @__PURE__ */ s.jsx(at, { margin: "300 0 0 0" }),
          n
        ]
      }
    );
  }
}
const dr = ({
  colorMode: i = "light"
}) => `<script>
  (function() {
    let lastHeight = null;

    function measureHeight() {
      const currentHeight = document.body.offsetHeight;
      if (currentHeight === lastHeight) return;
      lastHeight = currentHeight;
      window.parent.postMessage(
        {
          event: 'heightChange',
          value: currentHeight,
        },
        '*',
      );
    };

    function setColorMode() {
      const rootElement = document.documentElement;
      if (rootElement) {
        rootElement.setAttribute('data-color-mode', '${i}');
      }

      const style = document.createElement('style');
      style.innerHTML = 'html {color-scheme: ${i};}';
      document.head.appendChild(style);
    }

    document.body.style.padding = '0px';
    document.body.style.margin = '0px';
    document.body.style.display = 'inline-block';
    document.body.style.width = '100%';
    document.addEventListener('click', measureHeight);

    document.querySelectorAll('a').forEach(link => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });

    document.addEventListener('load', measureHeight, true);
    document.addEventListener('transitionend', measureHeight, true);

    new ResizeObserver(measureHeight).observe(document.body);

    measureHeight();
    setColorMode();
  })();
<\/script>`, mD = "h-sandboxIframe--sandboxIframe__frame", gD = {
  frame: mD
};
class ei extends D {
  frameRef;
  static defaultProps;
  constructor(t) {
    super(t), this.state = {
      iframeHeight: 0
    }, this.frameRef = B(), this.handlePostMessage = this.handlePostMessage.bind(this);
  }
  componentDidMount() {
    this.buildSandbox(), window.addEventListener("message", this.handlePostMessage);
  }
  componentDidUpdate(t) {
    const { content: e, headContent: n, colorMode: o } = this.props;
    (t.content !== e || t.headContent !== n || t.colorMode !== o) && this.buildSandbox();
  }
  componentWillUnmount() {
    window.removeEventListener("message", this.handlePostMessage);
  }
  static defaultSandboxParams = "allow-scripts allow-popups allow-forms";
  buildSandbox() {
    const { content: t, headContent: e = "", colorMode: n = "light" } = this.props, { current: o } = this.frameRef;
    if (o) {
      let r = "";
      t.indexOf("</body>") !== -1 ? r = t.replace(
        "</body>",
        `${dr({ colorMode: n })}</body>`
      ) : r = `<html><head><meta charset="utf-8" /><base target="_parent" />${e}</head><body>${t}${dr(
        { colorMode: n }
      )}</body></html>`, o.src = `data:text/html;base64,${window.btoa(
        unescape(encodeURIComponent(r))
      )}`;
    }
  }
  handlePostMessage(t) {
    const { current: e } = this.frameRef;
    if (e && t.source === e.contentWindow) {
      const { data: n } = t;
      typeof n == "object" && n !== null && n.event === "heightChange" && typeof n.value == "number" && this.setState({
        iframeHeight: n.value
      });
    }
  }
  render() {
    const {
      className: t,
      content: e,
      headContent: n,
      sandbox: o,
      colorMode: r,
      ...a
    } = this.props, { iframeHeight: l } = this.state, c = f({}, t);
    return /* @__PURE__ */ s.jsx("div", { ...a, className: c, children: /* @__PURE__ */ s.jsx(
      "iframe",
      {
        title: "message",
        sandbox: o ?? ei.defaultSandboxParams,
        allowFullScreen: !0,
        scrolling: "no",
        frameBorder: "no",
        style: { height: `${l}px` },
        className: gD.frame,
        ref: this.frameRef
      }
    ) });
  }
}
const fD = "h-scrollbar--scrollbar__track", bD = "h-scrollbar--scrollbar__handle", hr = {
  track: fD,
  handle: bD
};
class wT extends D {
  constructor(t) {
    super(t), this.state = {
      size: 0,
      progress: 0,
      offset: 0
    }, this.handleTrackClick = this.handleTrackClick.bind(this), this.handleHandleClick = this.handleHandleClick.bind(this), this.handleDrag = this.handleDrag.bind(this), this.handleDrop = this.handleDrop.bind(this);
  }
  componentDidMount() {
    const { container: t } = this.props;
    t.current && t.current.addEventListener("scroll", this.updateSize), window.addEventListener("resize", this.updateSize), this.updateSize();
  }
  componentWillUnmount() {
    const { container: t } = this.props;
    t.current && t.current.removeEventListener("scroll", this.updateSize), window.removeEventListener("resize", this.updateSize);
  }
  updateSize = () => {
    const { container: t } = this.props;
    if (t.current) {
      const { current: e } = t;
      this.setState({
        size: e.offsetHeight / e.scrollHeight,
        progress: e.scrollTop / e.scrollHeight
      });
    }
  };
  handleTrackClick(t) {
    const { container: e } = this.props, { size: n } = this.state;
    if (this.setState({
      offset: n / 2
    }), e.current) {
      const o = e.current.getBoundingClientRect();
      let r = (t.clientY - o.top) / e.current.offsetHeight - n / 2;
      r < 0 && (r = 0), r + n > 1 && (r = 1 - n), e.current.scrollTop = r * e.current.scrollHeight, window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
    }
  }
  handleHandleClick(t) {
    const { size: e } = this.state;
    if (t.stopPropagation(), !(t.target instanceof Element)) return;
    const n = t.target.getBoundingClientRect();
    this.setState({
      offset: (t.clientY - n.top) / n.height * e
    }), window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
  }
  handleDrag(t) {
    t.preventDefault();
    const { container: e } = this.props, { size: n, offset: o } = this.state;
    if (e.current) {
      const r = e.current.getBoundingClientRect();
      let a = (t.clientY - r.top) / e.current.offsetHeight - o;
      a < 0 && (a = 0), a + n > 1 && (a = 1 - n), e.current.scrollTop = a * e.current.scrollHeight;
    }
  }
  handleDrop() {
    window.removeEventListener("mousemove", this.handleDrag), window.removeEventListener("mouseup", this.handleDrop);
  }
  render() {
    const { className: t, thumbClassName: e, trackClassName: n, ...o } = this.props, { size: r, progress: a } = this.state, l = f(t);
    return /* @__PURE__ */ s.jsx("div", { ...o, className: l, children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: f(hr.track, n),
        onMouseDown: this.handleTrackClick,
        children: /* @__PURE__ */ s.jsx(
          "div",
          {
            className: f(hr.handle, e),
            onMouseDown: this.handleHandleClick,
            style: {
              height: `${r * 100}%`,
              top: `${a * 100}%`
            }
          }
        )
      }
    ) });
  }
}
const xD = "h-scrollShadow--scrollShadow__wrapper", yD = "h-scrollShadow--scrollShadow__content", ur = {
  wrapper: xD,
  content: yD
}, vT = ({
  className: i,
  children: t,
  ...e
}) => {
  const n = f(ur.wrapper, i);
  return /* @__PURE__ */ s.jsx("div", { className: n, ...e, children: /* @__PURE__ */ s.jsx("div", { className: ur.content, children: t }) });
}, _D = "h-searchInput--searchInput__root", CD = "h-searchInput--searchInput__input", wD = "h-searchInput--searchInput__inputButton", En = {
  root: _D,
  input: CD,
  inputButton: wD
}, vD = 275, pr = 300, ST = ({
  className: i,
  initialSearch: t,
  maxWidth: e = vD,
  placeholder: n,
  onChange: o,
  onSubmit: r,
  onToggle: a,
  ...l
}) => {
  const c = Y(null), [d, h] = V(!!t), [u, p] = V(!1), [m, g] = V(t ?? "");
  Vi(
    () => {
      u && (h(!1), p(!1), g(""));
    },
    pr,
    [u]
  ), Zt(() => {
    a?.(d), d && requestAnimationFrame(() => c.current?.focus());
  }, [d]);
  const b = F(() => {
    h(!0);
  }, []), x = F(() => {
    p(!0);
  }, []), C = F(
    (y) => {
      y.preventDefault(), r(m);
    },
    [r, m]
  ), _ = F(
    (y) => {
      const {
        target: { value: v }
      } = y;
      g(v), o?.(v);
    },
    [o]
  ), w = F(
    ({ key: y }) => {
      y === "Enter" && b();
    },
    [b]
  ), S = F(
    ({ key: y }) => {
      (y === "Esc" || y === "Escape") && x();
    },
    [x]
  );
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: f(En.root, i),
      style: {
        "--max-width": `${d && !u ? e : 32}px`,
        "--transition-delay": `${pr}ms`
      },
      ...l,
      children: d ? /* @__PURE__ */ s.jsx("form", { onSubmit: C, children: /* @__PURE__ */ s.jsx(
        Yt,
        {
          className: En.input,
          ref: c,
          onChange: _,
          placeholder: n ?? "Search...",
          type: "search",
          value: m,
          prefix: {
            type: "button",
            button: {
              icon: "search",
              onClick: C,
              className: En.inputButton
            }
          },
          suffix: {
            type: "button",
            button: {
              icon: "close",
              onClick: x,
              className: En.inputButton
            }
          },
          onKeyDown: S
        }
      ) }) : /* @__PURE__ */ s.jsx(
        K,
        {
          icon: "search",
          variant: "secondary",
          onClick: b,
          onKeyDown: w,
          "data-testid": "search-input-button"
        }
      )
    }
  );
}, SD = "h-selectOption--selectOption__root", ID = "h-selectOption--selectOption__checkbox", DD = "h-selectOption--selectOption__content", ks = {
  root: SD,
  checkbox: ID,
  content: DD
}, IT = (i) => {
  const t = f(ks.root);
  return /* @__PURE__ */ s.jsxs("label", { className: t, children: [
    /* @__PURE__ */ s.jsx(
      un,
      {
        ...i,
        className: f(ks.checkbox, i.className)
      }
    ),
    /* @__PURE__ */ s.jsx("div", { className: ks.content, children: i.name })
  ] });
}, kD = "h-simpleProgressBar--simpleProgressBar__container", TD = "h-simpleProgressBar--simpleProgressBar__progressBar", jD = "h-simpleProgressBar--simpleProgressBar__progressBarFill", Ts = {
  container: kD,
  progressBar: TD,
  progressBarFill: jD
}, ND = "simpleProgressBarId";
function DT({
  progress: i,
  base: t = 100,
  progressColor: e = "purple.500",
  backgroundColor: n = "neutral.200",
  tooltipContent: o,
  tooltipProps: r,
  ...a
}) {
  const [l, c] = V(0), d = 4;
  J(() => c(i), [i]);
  const h = t >= l ? l / t : 1, u = () => d / h, p = {
    backgroundColor: sn(n)
  }, m = {
    transform: `scaleX(${h})`,
    borderTopRightRadius: `${u()}px ${d}px`,
    borderBottomRightRadius: `${u()}px ${d}px`,
    backgroundColor: sn(e)
  };
  return /* @__PURE__ */ s.jsx(
    H,
    {
      "test-id": ND,
      "align-items": "center",
      "justify-content": "center",
      className: Ts.container,
      ...a,
      children: /* @__PURE__ */ s.jsx(
        st,
        {
          disabled: !o,
          content: o,
          wrap: "none",
          ...r,
          children: /* @__PURE__ */ s.jsx("div", { className: Ts.progressBar, style: p, children: /* @__PURE__ */ s.jsx(
            "div",
            {
              className: Ts.progressBarFill,
              style: m
            }
          ) })
        }
      )
    }
  );
}
const FD = "h-tabsWithContent--tabsWithContent__container", PD = "h-tabsWithContent--tabsWithContent__containerTop", RD = "h-tabsWithContent--tabsWithContent__containerLeft", ED = "h-tabsWithContent--tabsWithContent__containerRight", LD = "h-tabsWithContent--tabsWithContent__containerBottom", AD = "h-tabsWithContent--tabsWithContent__childrenContainer", Se = {
  container: FD,
  containerTop: PD,
  containerLeft: RD,
  containerRight: ED,
  containerBottom: LD,
  childrenContainer: AD
};
class Bs extends ft {
  static defaultProps = {
    tabsPlacement: "top"
  };
  constructor(t) {
    super(t), this.state = { activeTab: t.initiallySelectedTabId }, this.handleTabChange = this.handleTabChange.bind(this);
  }
  handleTabChange(t) {
    this.ensureTabIsValid(t) && (this.setState({ activeTab: t }), this.props.onChange?.(t));
  }
  ensureTabIsValid(t) {
    return this.props.tabs.some((e) => e.id === t);
  }
  getActiveChildIndex() {
    return this.props.tabs.findIndex(({ id: t }) => t === this.state.activeTab);
  }
  render() {
    const {
      className: t,
      tabsClassName: e,
      tabClassName: n,
      tabSelectedClassName: o,
      childrenWrapperClassName: r,
      tabs: a,
      children: l,
      tabsPlacement: c
    } = this.props, { activeTab: d } = this.state, h = Lt.toArray(l);
    if (h.length !== a.length) {
      const g = `${Bs.name}: Number of tabs don't match the number of children.`;
      console.warn(g);
    }
    const u = this.getActiveChildIndex();
    if (u === -1) {
      const g = `${Bs.name}: The selected tab does not exist in tabs array!`;
      console.warn(g);
    }
    const p = f(t, Se.container, {
      [Se.containerTop]: c === "top",
      [Se.containerLeft]: c === "left",
      [Se.containerBottom]: c === "bottom",
      [Se.containerRight]: c === "right"
    }), m = f(
      r,
      Se.childrenContainer
    );
    return /* @__PURE__ */ s.jsxs("section", { className: p, children: [
      /* @__PURE__ */ s.jsx(
        gb,
        {
          className: e,
          tabClassName: n,
          tabSelectedClassName: o,
          tabs: a,
          onChange: this.handleTabChange,
          selectedId: d,
          tabsPlacement: c
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: m, children: h[u] })
    ] });
  }
}
const $D = "h-tagsInput--tagsInput__root", OD = "h-tagsInput--tagsInput__wrapper", BD = "h-tagsInput--tagsInput__input", HD = "h-tagsInput--tagsInput__inputIsHidden", WD = "h-tagsInput--tagsInput__placeholder", MD = "h-tagsInput--tagsInput__placeholderText", zD = "h-tagsInput--tagsInput__iconBox", VD = "h-tagsInput--tagsInput__iconText", KD = "h-tagsInput--tagsInput__tag", UD = "h-tagsInput--tagsInput__tagIsActive", qD = "h-tagsInput--tagsInput__tagButton", GD = "h-tagsInput--tagsInput__divider", pt = {
  root: $D,
  wrapper: OD,
  input: BD,
  inputIsHidden: HD,
  placeholder: WD,
  placeholderText: MD,
  iconBox: zD,
  iconText: VD,
  tag: KD,
  tagIsActive: UD,
  tagButton: qD,
  divider: GD
};
function mr(i = [], t) {
  switch (t) {
    case "asc":
      return i.sort();
    case "desc":
      return i.sort().reverse();
    default:
      return i;
  }
}
const YD = 255, kT = ({
  className: i,
  disabled: t,
  limit: e,
  placeholder: n,
  selectedTags: o,
  sortDirection: r,
  onChange: a
}) => {
  const l = Y(null), c = Y(null), [d, h] = V(""), [u, p] = V(
    mr(o, r)
  ), [m, g] = V(""), [b, x] = V(!1);
  wr(l, () => x(!1)), Zt(() => a(u), [u, a]), Zt(() => {
    c.current && b && c.current.focus();
  }, [c.current, b]);
  const C = (I) => {
    h(I.target.value ?? "");
  }, _ = (I) => {
    const T = u.indexOf(m);
    switch (I.key) {
      // Creates a new tag from the given input text.
      case "Enter":
        !m && d && p((P) => {
          const L = Array.from(/* @__PURE__ */ new Set([...P, d]));
          return h(""), mr(L, r);
        });
        break;
      // If there is no input text left, it will select the last tag.
      // If there is already a tag selected, it will remove that from the list.
      case "Backspace":
        !m && d.length === 0 && g(u[u.length - 1]), m && (w(m), g(""));
        break;
      // If there is a tag selected, it will select the previous one.
      case "ArrowLeft":
        m && T > 0 && g(u[T - 1]);
        break;
      // If there is a tag selected, it will select the next one.
      case "ArrowRight":
        m && T < u.length - 1 && g(u[T + 1]);
        break;
      default:
        m && g("");
    }
  }, w = (I) => {
    p((T) => {
      const P = [...T];
      return P.splice(P.indexOf(I), 1), P;
    });
  }, S = b ? u.length : e || u.length, y = S < u.length, v = u.slice(0, S);
  return /* @__PURE__ */ s.jsx(
    At,
    {
      ref: l,
      className: f(pt.root, i),
      onClick: () => x(!0),
      disabled: t,
      children: /* @__PURE__ */ s.jsxs("div", { className: pt.wrapper, "data-testid": "tags-wrapper", children: [
        v.map((I, T, P) => {
          const L = !b && P.length > 1 && T === P.length - 1;
          return /* @__PURE__ */ s.jsxs(Wt, { children: [
            L && /* @__PURE__ */ s.jsx(
              A.Paragraph,
              {
                variant: "3",
                color: "secondary",
                className: pt.divider,
                children: "or"
              }
            ),
            /* @__PURE__ */ s.jsx(
              je,
              {
                className: f(pt.tag, {
                  [pt.tagIsActive]: I === m
                }),
                onDelete: () => w(I),
                "data-testid": "tag",
                children: I
              },
              I
            )
          ] }, I);
        }),
        !b && y && /* @__PURE__ */ s.jsxs(
          je,
          {
            className: f(pt.tag, pt.tagButton),
            "data-testid": "tag",
            children: [
              "+",
              u.length - S
            ]
          }
        ),
        !b && !u.length && !d && /* @__PURE__ */ s.jsx(H, { className: pt.placeholder, alignItems: "center", gap: "200", children: n ? /* @__PURE__ */ s.jsx(A.Paragraph, { className: pt.placeholderText, variant: "2", children: n }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          /* @__PURE__ */ s.jsx(A.Paragraph, { className: pt.placeholderText, variant: "2", children: "Type words or phrases and add with" }),
          /* @__PURE__ */ s.jsxs("div", { className: pt.iconBox, children: [
            /* @__PURE__ */ s.jsx(N, { name: "enter", color: "neutral.500" }),
            /* @__PURE__ */ s.jsx(A.Paragraph, { className: pt.iconText, children: "enter" })
          ] })
        ] }) }),
        /* @__PURE__ */ s.jsx(
          "input",
          {
            className: f(pt.input, {
              [pt.inputIsHidden]: !b
            }),
            onChange: C,
            onKeyDown: _,
            maxLength: YD,
            ref: c,
            type: "text",
            value: d,
            "data-testid": "tag-input"
          }
        )
      ] })
    }
  );
}, XD = "h-textWithHighlight--textWithHighlight__highlight", QD = {
  highlight: XD
}, ZD = ({
  text: i,
  highlight: t,
  className: e,
  highlightClassName: n,
  ignoreCase: o = !0
}) => {
  if (!t?.trim())
    return /* @__PURE__ */ s.jsx(s.Fragment, { children: i });
  const r = new RegExp(
    zs(t.trim()),
    o ? "ig" : "g"
  ), a = i.match(r), l = i.split(r);
  return /* @__PURE__ */ s.jsx("span", { className: e, children: l.map((c, d) => /* @__PURE__ */ s.jsxs("span", { children: [
    c,
    a?.[d] && /* @__PURE__ */ s.jsx("em", { className: f(QD.highlight, n), children: a[d] })
  ] }, d)) });
}, JD = qn(ZD);
JD.name = "TextWithHighlight";
const tk = "h-timestamp--timestamp__timestamp", ek = {
  timestamp: tk
}, nk = 1e4;
class TT extends ft {
  interval;
  static defaultProps = {
    refreshRate: nk
  };
  constructor(t) {
    super(t);
    const { relative: e, counter: n, initialFormat: o } = t;
    let r = o ?? "absolute";
    e ? r = "ago" : n && (r = "counter"), this.state = {
      format: r,
      pristine: !0
    }, this.handleClick = this.handleClick.bind(this), this.interval = null;
  }
  componentDidMount() {
    const { format: t } = this.state;
    (t === "ago" || t === "counter") && this.startTicker();
  }
  componentDidUpdate(t) {
    const { relative: e, initialFormat: n } = this.props, { pristine: o } = this.state;
    e !== t.relative && o && this.setState({
      format: e ? "ago" : "absolute"
    }), n && n !== t.initialFormat && this.setState({ format: n });
  }
  componentWillUnmount() {
    this.stopTicker();
  }
  startTicker() {
    this.interval = setInterval(() => {
      this.forceUpdate();
    }, this.props.refreshRate ?? 0);
  }
  stopTicker() {
    this.interval && clearInterval(this.interval);
  }
  handleClick(t) {
    const { onClick: e } = this.props, { format: n } = this.state;
    let o = this.state.format;
    n === "ago" ? (o = "full", this.stopTicker()) : n === "full" ? o = "absolute" : n === "absolute" && (o = "ago", this.startTicker()), this.setState({
      pristine: !1,
      format: o
    }), e?.(o, t);
  }
  getTimeString() {
    let { time: t } = this.props;
    const { isSecondsDisplayed: e, customFormatters: n } = this.props, { format: o } = this.state;
    let r = "";
    if (typeof t == "number") {
      const l = /* @__PURE__ */ new Date();
      l.setTime(t * 1e3), t = l;
    }
    const a = j(t).utc().local();
    if (o === "counter") {
      const l = j(t).utc(), d = j().utc().diff(l) / 1e3, h = Math.floor(d / 3600), u = Math.floor(h / 24), p = h % 24, m = h * 60 * 60, g = Math.floor((d - m) / 60), b = g * 60, x = Math.floor(
        d - m - b
      );
      r = [
        p.toString().padStart(2, "0"),
        g.toString().padStart(2, "0"),
        x.toString().padStart(2, "0")
      ].join(":"), u > 0 && (r = `${u} ${u === 1 ? "DAY" : "DAYS"} ${r}`);
    } else if (o === "full") {
      const l = n?.full ?? (e ? "MMM Do YYYY, hh:mm:ss A" : "lll");
      r = a.format(l);
    } else if (o === "absolute")
      if (j().diff(j(t), "hours") > 12) {
        const l = n?.absolute ?? `D MMMM LT${e ? "S" : ""}`;
        r = a.format(l);
      } else {
        const l = n?.absolute ?? `LT${e ? "S" : ""}`;
        r = a.format(l);
      }
    else
      r = su(a);
    return r;
  }
  render() {
    const {
      className: t,
      relative: e,
      time: n,
      refreshRate: o,
      counter: r,
      customFormatters: a,
      isSecondsDisplayed: l,
      initialFormat: c,
      onClick: d,
      ...h
    } = this.props, u = f(
      {
        [ek.timestamp]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsx(
      "span",
      {
        ...h,
        ...Xn(this.handleClick),
        className: u,
        children: this.getTimeString()
      }
    );
  }
}
const sk = "h-token--token__root", ok = "h-token--token__select", rk = "h-token--token__label", ik = "h-token--token__rootReadonly", ak = "h-token--token__rootPrimary", lk = "h-token--token__rootWithError", ck = "h-token--token__value", dk = "h-token--token__icon", Bt = {
  root: sk,
  select: ok,
  label: rk,
  rootReadonly: ik,
  rootPrimary: ak,
  rootWithError: lk,
  value: ck,
  icon: dk
};
class jT extends D {
  render() {
    const {
      onDelete: t,
      id: e,
      label: n,
      options: o,
      valueLabel: r,
      primary: a,
      input: l,
      meta: c,
      defaultOption: d,
      className: h,
      ...u
    } = this.props, p = f(
      {
        [Bt.root]: !0,
        [Bt.rootPrimary]: a,
        [Bt.rootWithError]: c?.error,
        [Bt.rootReadonly]: !o && !t
      },
      h
    );
    let m = r;
    if (!m && l && o && o.length) {
      const g = o.filter(({ value: b }) => l.value === b);
      g.length && (m = g[0].label);
    }
    return !m && d && (m = d), /* @__PURE__ */ s.jsxs("div", { ...u, className: p, children: [
      !!o && /* @__PURE__ */ s.jsxs("select", { ...l, className: Bt.select, id: e, children: [
        !!d && /* @__PURE__ */ s.jsx("option", { disabled: !0, hidden: !0, value: "", children: d }),
        o.map((g) => /* @__PURE__ */ s.jsx("option", { value: g.value, children: g.label }, g.value?.toString()))
      ] }),
      /* @__PURE__ */ s.jsxs("label", { className: Bt.label, htmlFor: e, children: [
        n,
        /* @__PURE__ */ s.jsx("span", { className: Bt.value, children: m }),
        !!o && /* @__PURE__ */ s.jsx(N, { className: Bt.icon, name: "angle-down" }),
        !!t && /* @__PURE__ */ s.jsx("span", { ...Xn(t), children: /* @__PURE__ */ s.jsx(N, { className: Bt.icon, name: "close", onClick: t }) })
      ] })
    ] });
  }
}
const hk = "h-skeleton--skeleton__root", uk = "h-skeleton--skeleton__rootAnimationPulse", pk = "h-skeleton--skeleton__rootAnimationWave", js = {
  root: hk,
  rootAnimationPulse: uk,
  rootAnimationWave: pk
};
function gr({ className: i, animation: t = "pulse", ...e }, n) {
  const o = f(
    {
      [js.root]: !0,
      [js.rootAnimationPulse]: t === "pulse",
      [js.rootAnimationWave]: t === "wave"
    },
    i
  );
  return /* @__PURE__ */ s.jsx(at, { className: o, ...e, ref: n });
}
const NT = Object.assign($(gr), {
  name: gr.name
}), mk = "h-breadcrumbs--breadcrumbs__root", gk = "h-breadcrumbs--breadcrumbs__list", fk = "h-breadcrumbs--breadcrumbs__item", bk = "h-breadcrumbs--breadcrumbs__separator", Ln = {
  root: mk,
  list: gk,
  item: fk,
  separator: bk
}, FT = $(function({
  className: t,
  children: e,
  as: n,
  separator: o = /* @__PURE__ */ s.jsx(N, { name: "angle-right" }),
  "aria-label": r = "breadcrumb",
  ...a
}, l) {
  const c = n ?? "nav", d = Lt.toArray(e).filter(Boolean);
  return /* @__PURE__ */ s.jsx(
    c,
    {
      ...a,
      ref: l,
      className: f(Ln.root, t),
      "aria-label": r,
      children: /* @__PURE__ */ s.jsx("ol", { className: Ln.list, children: d.map((h, u) => {
        const p = u === d.length - 1, m = typeof h == "string" || typeof h == "number" ? /* @__PURE__ */ s.jsx("span", { children: h }) : h;
        return /* @__PURE__ */ s.jsxs(Wt, { children: [
          /* @__PURE__ */ s.jsx(
            "li",
            {
              className: Ln.item,
              "aria-current": p ? "page" : void 0,
              children: m
            }
          ),
          !p && /* @__PURE__ */ s.jsx(
            "li",
            {
              className: Ln.separator,
              "data-testid": "breadcrumbs-separator",
              "aria-hidden": "true",
              children: o
            }
          )
        ] }, u);
      }) })
    }
  );
});
export {
  ef as AddonTriggerContext,
  nf as AddonTriggerEvents,
  Tk as Attachment,
  vr as Avatar,
  tp as AvatarSelectItem,
  Nk as Badge,
  Fk as Banner,
  at as Box,
  FT as Breadcrumbs,
  Q as Button,
  Pk as ButtonGroup,
  mo as ButtonList,
  Mk as CheckableAvatarSelectItem,
  Xs as CheckableBaseItem,
  Bk as CheckableSelectItem,
  Wk as CheckableTagSelectItem,
  un as Checkbox,
  _p as Chip,
  Ek as CollapseCard,
  Lk as Collapsible,
  Zn as ColorPicker,
  mt as Column,
  ud as Columns,
  Nd as CopyToClipboard,
  Ak as CopyToClipboardButton,
  aT as CountryFlag,
  $k as DataTable,
  Um as DatePicker,
  en as DatePickerOld,
  Om as DateRangePicker,
  cp as DeselectItem,
  Kk as Dialer,
  Yn as Divider,
  te as Dropdown,
  ce as DropdownButton,
  pn as DropdownButtonContext,
  Ys as DropdownInfinite,
  Po as DropdownItem,
  Js as DropdownSelect,
  Hr as DropdownSelectContainer,
  Uk as DropdownSelectMultiple,
  $i as EMOJIS,
  ET as EmojiPicker,
  mn as EmptySelectItem,
  sh as EmptyState,
  Re as ErrorBoundary,
  Da as ErrorBoundaryContext,
  iT as FieldAddonDropdown,
  ts as FieldAlert,
  qk as FieldButton,
  rT as FieldColorPicker,
  Gk as FieldDatePicker,
  Yk as FieldDateRangePicker,
  Gs as FieldLabel,
  Qk as FieldRichText,
  Zk as FieldSelect,
  Jk as FieldSelectionList,
  tT as FieldSlider,
  eT as FieldSwitch,
  Es as FieldText,
  nT as FieldTextarea,
  sT as FieldTimePicker,
  oT as FieldTimeRangePicker,
  z as FieldWrapper,
  H as FlexBox,
  Sr as FocusScope,
  dT as FormField,
  cT as FormGrid,
  qs as HelpIcon,
  hT as HelperField,
  N as Icon,
  K as IconButton,
  Vs as Image,
  Iy as InputColorPicker,
  Sg as InputDatePicker,
  ln as InputDateRangePicker,
  uT as InputDuration,
  io as InputRichText,
  Mx as InputSelectionList,
  Yt as InputText,
  At as InputWrapper,
  pT as Lightbox,
  mT as List,
  mT as ListV2,
  gT as MediaPlayer,
  NS as Modal,
  fT as ModalBody,
  $I as ModalFoot,
  bT as ModalHead,
  jS as ModalStackContext,
  kk as NavigationButton,
  xT as Page,
  Yd as Pagination,
  xS as Portal,
  $r as Presets,
  yT as Radio,
  CT as RemovableCard,
  _T as ReverseScroll,
  ei as SandboxIframe,
  vT as ScrollShadow,
  wT as Scrollbar,
  ST as SearchInput,
  Xp as Select,
  Or as SelectItem,
  IT as SelectOption,
  Sx as SelectionList,
  Rd as SimplePagination,
  DT as SimpleProgressBar,
  NT as Skeleton,
  Os as Slider,
  Gn as Spinner,
  dy as Switch,
  gt as Table,
  Jn as TableContext,
  gb as Tabs,
  Bs as TabsWithContent,
  je as Tag,
  Vk as TagDeselectItem,
  Hk as TagSelectItem,
  zk as TagSelectSuggestion,
  kT as TagsInput,
  A as Text,
  JD as TextWithHighlight,
  Qr as Textarea,
  an as TimePicker,
  jm as TimeRangePicker,
  TT as Timestamp,
  jT as Token,
  st as Tooltip,
  LT as addSvgIconsToDocument,
  el as badgeTestId,
  ld as colorPickerTestId,
  lT as countryCodes,
  Ok as datepickerDisableWeekends,
  AT as defaultElementType,
  no as formatShortcut,
  Hg as formattingOptions,
  Ae as getSelectionListContext,
  $T as iconMeta,
  qo as inputRichTextCommands,
  Wx as inputSelectionListTestId,
  cD as reverseScrollTestId,
  hn as withErrorBoundary
};
//# sourceMappingURL=index.js.map
